
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1cmSR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0df8a9af55fc0513$export$2e2bcd8739ae039);
let $0df8a9af55fc0513$var$NAME = 'versa';
let $0df8a9af55fc0513$var$VERSION = 1;
let $0df8a9af55fc0513$var$STORES = '[{"store":"default","indices":["id"]}]';
// If the db stops working, clear the browser's "site data" in its settings
const $0df8a9af55fc0513$var$exec = function(action_type, store_name, index_number, argument, resolve, reject) {
    let stores = JSON.parse(sessionStorage.db_stores || $0df8a9af55fc0513$var$STORES);
    let version = sessionStorage.db_version || $0df8a9af55fc0513$var$VERSION;
    let request = indexedDB.open(sessionStorage.db_name || $0df8a9af55fc0513$var$NAME, version);
    request.onblocked = (ev)=>{
        alert("Recarregue a p\xe1gina para atualizar a aplica\xe7\xe3o");
    };
    request.onerror = (ev)=>{
        reject(ev.target.error);
    };
    request.onupgradeneeded = (ev)=>{
        let db = ev.target.result;
        stores.forEach((entry)=>{
            if (db.objectStoreNames.contains(entry.store)) return;
            let store = db.createObjectStore(entry.store, {
                keyPath: entry.keys[0]
            });
            entry.keys.forEach((key, index)=>{
                let name = `${entry.store}-${index + 1}`;
                if (!store.indexNames.contains(name)) store.createIndex(name, key);
            });
        });
    };
    request.onsuccess = (ev)=>{
        let db = ev.target.result;
        if (!db.objectStoreNames.contains(store_name)) {
            reject(new Error(`Object store "${store_name}" n\xe3o encontrado. Recarregue a p\xe1gina (F5) para atualizar o banco local.`));
            return;
        }
        let transaction = db.transaction(store_name, /GET|LIST/.test(action_type) ? 'readonly' : 'readwrite');
        let store = transaction.objectStore(store_name);
        let entry = stores.find((entry)=>entry.store == store_name);
        let index = store.index(`${store_name}-${index_number}`);
        let request;
        let list = [];
        try {
            switch(action_type){
                case 'CLEAR':
                    store.clear();
                    break;
                case 'PUT':
                    (Array.isArray(argument) ? argument : []).forEach((entry)=>store.put(entry));
                    resolve();
                    break;
                case 'GET':
                    request = store.get(argument);
                    break;
                case 'DEL':
                    request = store.delete(argument);
                    break;
                case 'LIST':
                    request = (index || store).openCursor(argument);
                    break;
            }
        } catch (e) {
            reject(`${action_type} ${store_name} ${JSON.stringify(argument)} ${e.message}`);
            console.log(e);
        }
        if (request) request.onsuccess = (ev)=>{
            if (action_type != 'LIST') resolve(ev.target.result);
            else if (ev.target.result) {
                list.push(ev.target.result.value);
                ev.target.result.continue();
            } else resolve(list);
        };
        db.onerror = (ev)=>{
            reject(ev.target.error);
        };
    };
};
const $0df8a9af55fc0513$var$db = {
    define (stores, name, version) {
        sessionStorage.db_name = name;
        sessionStorage.db_version = version;
        sessionStorage.db_stores = JSON.stringify(stores);
    },
    init () {
        indexedDB.deleteDatabase($0df8a9af55fc0513$var$NAME);
    },
    clear (store) {
        $0df8a9af55fc0513$var$exec('CLEAR', store, 1);
    },
    set (store, array) {
        return new Promise(function(resolve, reject) {
            $0df8a9af55fc0513$var$exec('PUT', store, 1, array, resolve, reject);
        });
    },
    get (store, key, index = 2) {
        const invalid = key == null || Array.isArray(key) && key.some((v)=>v == null || typeof v === 'number' && isNaN(v));
        if (invalid) return Promise.resolve(undefined);
        return new Promise(function(resolve, reject) {
            $0df8a9af55fc0513$var$exec('GET', store, index, key, resolve, reject);
        });
    },
    list (store, range, index = 2) {
        return new Promise(function(resolve, reject) {
            $0df8a9af55fc0513$var$exec('LIST', store, index, range, resolve, reject);
        });
    },
    remove (store, key) {
        return new Promise(function(resolve, reject) {
            $0df8a9af55fc0513$var$exec('DEL', store, 1, key, resolve, reject);
        });
    }
};
var $0df8a9af55fc0513$export$2e2bcd8739ae039 = $0df8a9af55fc0513$var$db;

});

const $9da5ab8aba8aa3e3$var$DIALOGS = [];
const $9da5ab8aba8aa3e3$var$FOCUSABLE = function() {
    let a = ':not([disabled])'; // Disabled elements
    let b = ':not([tabIndex^="-"])'; // Negative tabIndex elements
    let c = ':not([type="hidden"])'; // Hidden input elements
    return [
        'a[href]' + b,
        'area[href]' + b,
        'input' + c + a + b,
        'select' + a + b,
        'textarea' + a + b,
        'button' + a + b,
        'iframe',
        '[tabIndex]' + b
    ].join(', ');
}();
const $9da5ab8aba8aa3e3$var$getFocusableElements = function(node) {
    return node.querySelectorAll($9da5ab8aba8aa3e3$var$FOCUSABLE);
};
const $9da5ab8aba8aa3e3$var$createNode = function(html) {
    let node = document.createElement('button');
    node.className = 'dialog';
    node.innerHTML = html;
    document.body.appendChild(node);
    return node;
};
const $9da5ab8aba8aa3e3$var$captureEvents = function(dialog) {
    [
        'keydown',
        'click'
    ].forEach((type)=>dialog.node.addEventListener(type, (ev)=>$9da5ab8aba8aa3e3$var$eventHandler.call(dialog, ev)));
};
const $9da5ab8aba8aa3e3$var$eventHandler = function(ev) {
    switch(ev.type){
        case 'keydown':
            $9da5ab8aba8aa3e3$var$trapFocus.call(this, ev);
            $9da5ab8aba8aa3e3$var$keyHandler.call(this, ev);
            break;
        case 'click':
            $9da5ab8aba8aa3e3$var$clickHandler.call(this, ev);
            break;
    }
};
const $9da5ab8aba8aa3e3$var$trapFocus = function(ev) {
    if (ev.key != 'Tab') return;
    let focusable_elements = $9da5ab8aba8aa3e3$var$getFocusableElements(this.node); // Get a fresh list everytime because new controls can be dinamically added to the dialog
    let first_focusable_element = focusable_elements[0];
    let last_focusable_element = focusable_elements[focusable_elements.length - 1];
    let current_focus = document.activeElement;
    if (ev.shiftKey) {
        if (current_focus == first_focusable_element) {
            ev.preventDefault(); // Prevent default action when we set the focus ourselves and let the system do its thing at all other times
            last_focusable_element.focus();
        }
    } else if (current_focus == last_focusable_element) {
        ev.preventDefault(); // Same here
        first_focusable_element.focus();
    }
};
const $9da5ab8aba8aa3e3$var$keyHandler = function(ev) {
    let is_key_expected = this.re_keys.test(ev.key);
    if (is_key_expected && this.callback) {
        let is_button = ev.target.nodeName == 'BUTTON' && ev.target.className != 'dialog'; // Ignore inputs on our "button" background of class "dialog"
        let is_enter = ev.key == 'Enter';
        if (is_enter) {
            ev.preventDefault(); // Prevent such actions from happening automatically
            if (is_button) $9da5ab8aba8aa3e3$var$clickHandler.call(this, ev);
            else this.callback.call(this, ev.key, ev.target);
        } else this.callback.call(this, ev.key, ev.target);
    }
};
const $9da5ab8aba8aa3e3$var$clickHandler = function(ev) {
    let matches = ev.target.className.match(this.re_clicks);
    if (matches && this.callback) {
        ev.preventDefault();
        this.callback.call(this, matches[1], ev.target);
    }
};
const $9da5ab8aba8aa3e3$var$dialog = {
    id: null,
    node: null,
    re_keys: /./,
    re_clicks: /\bbn_([^\b\s]+)\b/,
    callback: null,
    last_focus: null,
    create (html, callback, re_keys, re_clicks) {
        let dialog = Object.create(this);
        dialog.id = Symbol();
        dialog.callback = callback;
        dialog.re_keys = re_keys || dialog.re_keys;
        dialog.re_clicks = re_clicks || dialog.re_clicks;
        dialog.last_focus = document.activeElement;
        dialog.node = $9da5ab8aba8aa3e3$var$createNode(html);
        $9da5ab8aba8aa3e3$var$getFocusableElements(dialog.node)[0]?.focus();
        $9da5ab8aba8aa3e3$var$captureEvents(dialog);
        $9da5ab8aba8aa3e3$var$DIALOGS.push(dialog);
        return dialog;
    },
    destroy () {
        this.node.parentNode.removeChild(this.node);
        let index = $9da5ab8aba8aa3e3$var$DIALOGS.findIndex((dialog)=>dialog.id == this.id);
        if (index == $9da5ab8aba8aa3e3$var$DIALOGS.length - 1) this.last_focus.focus();
        else $9da5ab8aba8aa3e3$var$DIALOGS[index + 1].last_focus = this.last_focus; // The next dialog in the chain points to the removed link's previous focus
        $9da5ab8aba8aa3e3$var$DIALOGS.splice(index, 1);
    },
    getNode () {
        return this.node;
    }
};
var $9da5ab8aba8aa3e3$export$2e2bcd8739ae039 = $9da5ab8aba8aa3e3$var$dialog;


const $e7f9af3e6f2fd91b$var$makeHtml = function(args) {
    const loadingOnly = args.animation && !args.title && !args.text && !args.buttons;
    let html = `<div class="msgbox${loadingOnly ? ' msgbox--loading' : ''}">`;
    if (args.title) html += $e7f9af3e6f2fd91b$var$makeDiv('mb-title', args.title);
    if (args.animation) html += $e7f9af3e6f2fd91b$var$makeDiv('mb-icon mb-loading', '<div class="mb-spinner" role="status" aria-live="polite" aria-label="Carregando"></div><div class="mb-loading-text">Carregando...</div>');
    if (args.text) html += $e7f9af3e6f2fd91b$var$makeDiv('mb-text', args.text);
    if (args.buttons) html += $e7f9af3e6f2fd91b$var$makeButtons('button mtl', args.buttons);
    html += '</div>';
    return html;
};
const $e7f9af3e6f2fd91b$var$makeDiv = function(cls, html) {
    return `<div class="${cls}">${html}</div>`;
};
const $e7f9af3e6f2fd91b$var$makeButtons = function(cls, buttons) {
    return buttons.map((button)=>`<button class="${cls} ${button.cls}">${button.label}</button>`).join('\n');
};
const $e7f9af3e6f2fd91b$export$2e2bcd8739ae039 = function(args) {
    let dlg = (0, $9da5ab8aba8aa3e3$export$2e2bcd8739ae039).create($e7f9af3e6f2fd91b$var$makeHtml(args), args.callback, /Enter|Escape/);
    if (args.timeout) setTimeout(()=>dlg.destroy(), args.timeout);
    return {
        destroy: ()=>dlg.destroy()
    };
};
const $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b = function(text, title) {
    let mb = $e7f9af3e6f2fd91b$export$2e2bcd8739ae039({
        title: title,
        text: text,
        buttons: [
            {
                label: 'Continuar',
                cls: 'bn_Enter'
            }
        ],
        callback: ()=>mb.destroy()
    });
};
const $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8 = function(text, title, callback) {
    let mb = $e7f9af3e6f2fd91b$export$2e2bcd8739ae039({
        title: title,
        text: text,
        buttons: [
            {
                label: "N\xe3o",
                cls: 'bn_N'
            },
            {
                label: 'Sim',
                cls: 'bn_Y'
            }
        ],
        callback: (key)=>{
            mb.destroy();
            callback(key);
        }
    });
};


let $b5bb69350d42022c$var$_lastRejectAt = 0;
const $b5bb69350d42022c$var$REJECT_COOLDOWN_MS = 2500;
function $b5bb69350d42022c$var$_friendlyMessage(text, status) {
    if (status === 403) {
        try {
            const data = JSON.parse(text);
            if (data.method && data.path) {
                const hint = data.search_hint ? ` Use a busca em Sistema > Grupos e digite: "${data.search_hint}"` : '';
                return `Acesso negado. Falta permiss\xe3o para: ${data.method} ${data.path}.${hint} Pe\xe7a ao administrador para adicionar esse endpoint ao seu grupo.`;
            }
        } catch (e) {}
        return "Acesso negado. Seu usu\xe1rio n\xe3o tem permiss\xe3o para esta opera\xe7\xe3o. Tente sair e entrar novamente. Se o problema continuar, pe\xe7a ao administrador para verificar as permiss\xf5es do seu grupo. (Erro 403)";
    }
    if (status === 401 && text && (text.includes('desabilitado') || text.includes('bloqueado'))) return text;
    if (status === 401) return "Sess\xe3o expirada ou inv\xe1lida. Fa\xe7a login novamente. (Erro 401)";
    if (status === 404) return "Recurso n\xe3o encontrado. O item pode ter sido removido ou voc\xea n\xe3o tem acesso. (Erro 404)";
    if (status >= 500 && text) return `Erro no servidor (${status}): ${text}`;
    if (status >= 500) return "Erro tempor\xe1rio no servidor. Tente novamente em alguns instantes. Se persistir, contate o suporte. (Erro " + status + ')';
    if (text && (text.includes('autorizado') || text.includes('fetch') || text.includes('Failed to fetch'))) return "N\xe3o foi poss\xedvel conectar ao servidor. Verifique sua internet e se a API est\xe1 rodando. Em ambiente de desenvolvimento, execute: python seed_db.py (na pasta src/).";
    return text || 'Ocorreu um erro inesperado. Tente novamente ou contate o suporte.';
}
function $b5bb69350d42022c$var$notifyRejection(text, title = "Aten\xe7\xe3o", status) {
    const now = Date.now();
    if (now - $b5bb69350d42022c$var$_lastRejectAt < $b5bb69350d42022c$var$REJECT_COOLDOWN_MS) return;
    $b5bb69350d42022c$var$_lastRejectAt = now;
    const msg = $b5bb69350d42022c$var$_friendlyMessage(text, status);
    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(msg, title);
}
const $b5bb69350d42022c$var$http = async function(endpoint, ...args) {
    let mb, response;
    try {
        mb = (0, $e7f9af3e6f2fd91b$export$2e2bcd8739ae039)({
            animation: true
        });
        response = await endpoint(...args);
    } catch (e) {
        $b5bb69350d42022c$var$notifyRejection(e.message, "Aten\xe7\xe3o", null);
        console.log(e);
    } finally{
        mb.destroy();
    }
    if (!response) return;
    if (!response.ok) {
        const body = await response.text();
        $b5bb69350d42022c$var$notifyRejection(body || `${response.status} ${response.statusText}`, "Aten\xe7\xe3o", response.status);
        return;
    }
    const contentType = (response.headers.get('content-type') || '').split(';')[0].toLowerCase();
    if (contentType === 'application/json') {
        const raw = await response.text();
        if (!raw || !String(raw).trim()) return {
            message: 'Resposta JSON vazia do servidor.'
        };
        try {
            return JSON.parse(raw);
        } catch (e) {
            $b5bb69350d42022c$var$notifyRejection("Resposta inv\xe1lida do servidor (n\xe3o \xe9 JSON).", "Aten\xe7\xe3o", null);
            return null;
        }
    }
    const text = await response.text();
    const head = text.trimStart().toLowerCase();
    if (head.startsWith('<!doctype') || head.startsWith('<html')) {
        $b5bb69350d42022c$var$notifyRejection("O servidor devolveu a p\xe1gina do site (HTML) em vez de dados da API. Em ambientes com nginx na frente da API, inclua o caminho desta rota no bloco de proxy (ex.: packagings).", "Configura\xe7\xe3o / proxy", null);
        return;
    }
    if (text.length > 0) return text;
    return response.ok;
};
var $b5bb69350d42022c$export$2e2bcd8739ae039 = $b5bb69350d42022c$var$http;


// Script set-api-host.ps1 atualiza API_BASE; '' = same-origin quando servido pela API
const $73936c209f170d43$var$API_BASE = 'https://sessp.sialwms.com.br';
const $73936c209f170d43$var$AGENT_URL = 'http://localhost:9101';
const $73936c209f170d43$var$HOST = typeof window !== 'undefined' && window.location.port === '8001' ? '' : $73936c209f170d43$var$API_BASE;
function $73936c209f170d43$export$ffe95df7b31670e0() {
    return $73936c209f170d43$var$HOST;
}
const $73936c209f170d43$var$API = {
    call: (0, $b5bb69350d42022c$export$2e2bcd8739ae039),
    // AUTH
    async auth (username, password) {
        let endpoint = `${$73936c209f170d43$var$HOST}/auth`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: `username=${username}&password=${password}`
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async request_password (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/auth/requests`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reset_password (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/auth/resets`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // ENDPOINTS
    async list_endpoints (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_endpoint (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_endpoint (endpoint_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints/${endpoint_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_endpoint (endpoint_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints/${endpoint_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_endpoint (endpoint_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints/${endpoint_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // GROUPS
    async list_groups (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_group (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_group (group_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups/${group_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_group (group_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups/${group_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_group (group_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups/${group_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // USERS
    async list_users (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/users${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_user (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/users`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_user (user_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/users/${user_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_user (user_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/users/${user_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_user (user_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/users/${user_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // LOGS
    async list_logs (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/logs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_log (log_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/logs/${log_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INTEGRATION EVENTS (Central de integrações #MT-6531173)
    async list_integration_events (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_integration_event (integration_event_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/${integration_event_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_integration_event (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async integration_events_summary (hours = 24, stale_minutes = 12) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/summary?hours=${encodeURIComponent(hours)}&stale_minutes=${encodeURIComponent(stale_minutes)}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async post_integration_events_techhub_process (limit = 200) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-process?limit=${encodeURIComponent(limit)}`;
        let options = {
            method: 'POST',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async post_integration_events_techhub_flush_status (limit = 200) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-flush-status?limit=${encodeURIComponent(limit)}`;
        let options = {
            method: 'POST',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async post_integration_events_techhub_pull (body = {}) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-pull`;
        let options = {
            method: 'POST',
            body: JSON.stringify(body && typeof body === 'object' ? body : {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CITIES
    async list_cities (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/cities${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // COMPANIES
    async list_all_companies (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/all${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_companies (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_company (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_company (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // UNITS
    async list_units (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/units${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_unit (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/units`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_unit (company_id, unit_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/units/${unit_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_unit (company_id, unit_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/units/${unit_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_unit (company_id, unit_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/units/${unit_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CLASSES
    async list_classes (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/classes${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_class (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_class (company_id, class_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes/${class_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_class (company_id, class_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes/${class_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_class (company_id, class_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes/${class_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_class (company_id, class_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes/${class_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CATEGORIES
    async list_categories (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/categories${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_category (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/categories`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_category (company_id, category_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/categories/${category_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_category (company_id, category_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/categories/${category_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_category (company_id, category_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/categories/${category_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // MANUFACTURERS
    async list_manufacturers (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/manufacturers${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_manufacturer (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/manufacturers`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_manufacturer (company_id, manufacturer_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_manufacturer (company_id, manufacturer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_manufacturer (company_id, manufacturer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PRODUCTS
    async list_products (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/products${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_product (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_product (company_id, product_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_product (company_id, product_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_product (company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_product (company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PRODUCT PACKAGINGS
    async list_product_packagings (query = '') {
        // Sob /companies/… para ambientes em que nginx só proxeia prefixos já listados (ex.: AWS QA sem /packagings).
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/packagings${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_product_packagings_by_product (company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}/packagings`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** Conferência / coletor: GTIN cadastrado na embalagem → registro da embalagem (incl. product_id). */ async resolve_packaging_gtin (company_id, gtin) {
        const q = new URLSearchParams({
            gtin: String(gtin || '').trim()
        });
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/resolve-gtin?${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_product_packaging (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_product_packaging (company_id, packaging_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/${packaging_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_product_packaging (company_id, packaging_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/${packaging_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_product_packaging (company_id, packaging_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/${packaging_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_product_packaging (company_id, packaging_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/${packaging_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // WAREHOUSES
    async list_warehouses (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/warehouses${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_warehouse (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_warehouse (company_id, warehouse_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_warehouse (company_id, warehouse_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_warehouse (company_id, warehouse_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // LOCATIONS
    async list_locations (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/locations${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_location (company_id, warehouse_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_location (company_id, warehouse_id, location_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_location (company_id, warehouse_id, location_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_location (company_id, warehouse_id, location_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PAYMENT TERMS
    async list_payment_terms (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/payment-terms${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_payment_term (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/payment-terms`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_payment_term (company_id, payment_term_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_payment_term (company_id, payment_term_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_payment_term (company_id, payment_term_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PRICE LISTS
    async list_price_lists (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/price-lists${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_price_list (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/price-lists`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_price_list (company_id, price_list_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/price-lists/${price_list_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_price_list (company_id, price_list_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/price-lists/${price_list_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_price_list (company_id, price_list_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/price-lists/${price_list_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // SUPPLIERS
    async list_suppliers (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/suppliers${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_supplier (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/suppliers`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_supplier (company_id, supplier_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/suppliers/${supplier_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_supplier (company_id, supplier_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/suppliers/${supplier_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_supplier (company_id, supplier_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/suppliers/${supplier_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CUSTOMERS
    async list_customers (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/customers${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async count_customers_report (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/customers/count-report`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_customers_report (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/customers/print-report`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_customer (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_customer (company_id, customer_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_customer (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_customer (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CUSTOMER PRICES (tabela de preço por cliente)
    async customer_prices_template (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices/template`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_import (company_id, customer_id, csv_content) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices/import`;
        let options = {
            method: 'POST',
            body: JSON.stringify({
                csv: csv_content
            }),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_summary (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-prices-summary`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_list (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_replace (company_id, customer_id, prices) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
        let options = {
            method: 'PUT',
            body: JSON.stringify({
                prices: prices
            }),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_delete (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_price_get (company_id, customer_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/price?product_id=${product_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CARRIERS
    async list_carriers (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/carriers${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_carrier (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/carriers`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_carrier (company_id, carrier_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/carriers/${carrier_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_carrier (company_id, carrier_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/carriers/${carrier_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_carrier (company_id, carrier_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/carriers/${carrier_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // DEVICES
    async list_devices (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/devices${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_device (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/devices`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_device (company_id, device_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/devices/${device_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_device (company_id, device_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/devices/${device_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_device (company_id, device_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/devices/${device_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CFOPS
    async list_cfops (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/cfops${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_cfop (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/cfops`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_cfop (company_id, cfop_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/cfops/${cfop_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_cfop (company_id, cfop_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/cfops/${cfop_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_cfop (company_id, cfop_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/cfops/${cfop_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PROGRAMS
    async list_programs (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/programs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_programs_by_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_program (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_program (company_id, program_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs/${program_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_program (company_id, program_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs/${program_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_program (company_id, program_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs/${program_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // RECEIPT TYPES (tipo de recebimento — pedido de entrada)
    async list_receipt_types (query = '') {
        // Sob /companies/… para ambientes em que nginx só proxeia prefixos já listados (ex.: AWS QA sem /receipt-types).
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/receipt-types${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_receipt_types_by_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_receipt_type (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_receipt_type (company_id, receipt_type_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_receipt_type (company_id, receipt_type_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_receipt_type (company_id, receipt_type_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INPUT ORDERS
    async list_input_orders (query = '') {
        // Sob /companies/… para nginx AWS que só proxeia esse prefixo (mesmo padrão de receipt-types / packagings).
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/input-orders${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_input_order (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_input_order (company_id, input_order_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_input_order (company_id, input_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_input_order (company_id, input_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_pending_input_items (company_id, input_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}/pending`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_order_document (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/input-orders/print-order-document`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INPUTS
    async list_inputs (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_input (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_input (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_input (company_id, input_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_input (company_id, input_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async inventory_input (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/inventory`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async putaway_input (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/putaway`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reverse_input (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/reverse`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_inputs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-list`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_skus (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-skus`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_xml (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-xml`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_putaway (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-putaway`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_costs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-costs`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_conference (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-conference`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_details (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-details`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_labels (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/print-labels`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async import_xml (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/import-xml`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // LOTS
    async list_lots (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/lots${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_lot (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_lot (company_id, lot_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots/${lot_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_lot (company_id, lot_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots/${lot_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_lot (company_id, lot_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots/${lot_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // OUTPUT ORDERS
    async list_output_orders (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/output-orders${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_output_order (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_output_order (company_id, output_order_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_output_order (company_id, output_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_output_order (company_id, output_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_pending_output_items (company_id, output_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}/pending`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_pending_output_orders (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/output-orders/print-pending`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_output_order_document (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/output-orders/print-order-document`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async upload_output_order (company_id, formData) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/upload`;
        let options = {
            method: 'POST',
            body: formData,
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async upload_input_order (company_id, formData) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/upload`;
        let options = {
            method: 'POST',
            body: formData,
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async order_upload_template (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/order-upload/template`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // OUTPUTS
    async list_outputs (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_output (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_output (company_id, output_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_output (company_id, output_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_output (company_id, output_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_outputs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/create`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async close_outputs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/close`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async cancel_outputs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/cancel`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reverse_output (company_id, output_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/reverse`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_output_volumes (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/list-volumes`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_pick_control (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-pick-control`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_pallets_overturn (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-pallets-overturn`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_picklists (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-picklists`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_aviso_remessa (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-aviso-remessa`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_conference (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-conference`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_output_labels (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-labels`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async sendZplToAgent (zpl, printer, printerKey) {
        const endpoint = `${$73936c209f170d43$var$AGENT_URL}/print`;
        const payload = {
            zpl: zpl
        };
        if (printerKey) payload.printer_key = String(printerKey);
        if (printer && typeof printer === 'object') payload.printer = printer;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        };
        let response;
        try {
            response = await fetch(endpoint, options);
        } catch (e) {
            const msg = e && e.message ? String(e.message) : String(e);
            const netFail = /Failed to fetch|NetworkError|network|load failed|fetch/i.test(msg);
            throw new Error(netFail ? `Print Agent n\xe3o responde em ${$73936c209f170d43$var$AGENT_URL}. Neste PC, inicie o agente (pasta do print-agent: INICIAR.bat ou launch-print-agent.vbs) e tente de novo.` : `Falha ao contatar o Print Agent (${$73936c209f170d43$var$AGENT_URL}): ${msg}`);
        }
        if (!response.ok) {
            const text = await response.text();
            throw new Error(text || `Agente local (${$73936c209f170d43$var$AGENT_URL}) retornou ${response.status}. Verifique se o agente est\xe1 rodando.`);
        }
        return response;
    },
    // STOCKS
    async list_stocks (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_stock (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stocks`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_stock (company_id, stock_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stocks/${stock_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_stock (company_id, stock_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stocks/${stock_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_stock (company_id, stock_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stocks/${stock_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_stocks_by_input (company_id, input_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/stocks`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_stocks_by_product (company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}/stocks`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async move_stock (company_id, lot_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots/${lot_id}/move`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_stocks_by_sku (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-by-sku`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_stocks_by_lot (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-by-lot`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_stocks_by_location (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-by-location`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_lot_labels (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-lot-labels`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_stocks_csv (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/export`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // REPLENISHMENTS
    async list_replenishments (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/replenishments${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_replenishment (company_id, warehouse_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_replenishment (company_id, warehouse_id, replenishment_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_replenishment (company_id, warehouse_id, replenishment_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_replenishment (company_id, warehouse_id, replenishment_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async close_replenishments (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/replenishments/close`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_replenishment_orders (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/replenishments/print-orders`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INVENTORIES
    async list_inventories (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/inventories${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_inventory (company_id, warehouse_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_inventory (company_id, warehouse_id, inventory_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_inventory (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_inventory (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async check_inventory_item (company_id, warehouse_id, inventory_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/items`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async cancel_inventory (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/cancel`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async close_inventory (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/close`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_inventory_pending (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/print-pending`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_inventory_deviation (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/print-deviation`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // TRANSACTIONS
    async list_transactions (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/transactions${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_transaction (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/transactions`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_transaction (company_id, transaction_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/transactions/${transaction_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_transaction (company_id, transaction_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/transactions/${transaction_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_transaction (company_id, transaction_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/transactions/${transaction_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INVOICES
    async list_invoices (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_invoice (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoices`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_invoice (company_id, invoice_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoices/${invoice_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_invoice (company_id, invoice_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoices/${invoice_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_invoice (company_id, invoice_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoices/${invoice_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_invoices (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/create`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_invoices_xml (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/update-xml`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_archive (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/archive`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async inutilizar_invoices (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/inutilizar`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_iqvia (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/print-iqvia`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INVOICE LOTS
    async list_invoice_lots (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoice-lots${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_invoice_lot (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoice-lots`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_invoice_lot (company_id, invoice_lot_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_invoice_lot (company_id, invoice_lot_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_invoice_lot (company_id, invoice_lot_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_invoice_lots (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoice-lots/create`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async send_invoice_lots (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoice-lots/send`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async query_invoice_lots (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoice-lots/query`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // VERSION
    async version () {
        let endpoint = `${$73936c209f170d43$var$HOST}/version`;
        let response = await fetch(endpoint);
        return response;
    },
    // CENTRAL DE IMPORTAÇÃO
    async import_center_entities () {
        let endpoint = `${$73936c209f170d43$var$HOST}/import-center/entities`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        return fetch(endpoint, options);
    },
    async import_center_validate (formData) {
        let endpoint = `${$73936c209f170d43$var$HOST}/import-center/validate`;
        let options = {
            method: 'POST',
            body: formData,
            credentials: 'include'
        };
        return fetch(endpoint, options);
    },
    async import_center_import (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/import-center/import`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return fetch(endpoint, options);
    },
    async import_center_template (entity_key) {
        let endpoint = `${$73936c209f170d43$var$HOST}/import-center/template/${entity_key}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        return fetch(endpoint, options);
    }
};
var $73936c209f170d43$export$2e2bcd8739ae039 = $73936c209f170d43$var$API;


/*--------------------------------------------------------------------------
 * Define valor inicial do campo caso haja um atributo "value" no HTML
 -------------------------------------------------------------------------*/ const $604673ecc72d1005$var$setDefaultValueIfNoInternalValue = function(field, nodes) {
    let has_internal_value = field.getValue() !== undefined;
    let has_default_value = nodes[0]?.hasAttribute('value');
    if (!has_internal_value && has_default_value) field.setValue(nodes[0].getAttribute('value'));
};
/*--------------------------------------------------------------------------
 * Para input com list (datalist): resolve node.value (pode ser label) para o value da option
 -------------------------------------------------------------------------*/ const $604673ecc72d1005$var$resolveDatalistValue = function(node, node_value) {
    if (!node?.list?.options?.length || node_value == null || node_value === '') return node_value;
    const trimmed = String(node_value).trim();
    const option = Array.from(node.list.options).find((opt)=>opt.innerText && opt.innerText.trim() === trimmed);
    return option ? option.value : node_value;
};
/*--------------------------------------------------------------------------
 * Só invoca setValue() se o valor no elemento foi alterado
 -------------------------------------------------------------------------*/ const $604673ecc72d1005$var$setValueIfChanged = function(field, node) {
    let field_value = field.format(field.getValue());
    let field_has_value = Boolean(field_value);
    let node_value = node.value;
    let node_has_value = Boolean(node_value.length);
    // Em campo com datalist, o node mostra o label; manter/salvar o value (id) da option
    if (node.list) {
        node_value = $604673ecc72d1005$var$resolveDatalistValue(node, node_value) ?? node_value;
        // Se o input está vazio mas o campo já tem valor (id), opções podem ainda não ter carregado – não sobrescrever
        if (!node_has_value && field_has_value && (typeof field.getValue() === 'number' || typeof field.getValue() === 'string' && field.getValue().length > 0)) return void field.checkErrorState();
    }
    let is_update_needed = (field_has_value || node_has_value) && node_value != field_value;
    if (is_update_needed) {
        field.setValue(node_value);
        field.refresh();
    }
    field.checkErrorState(); // Clear error states also when the field is emptied
};
const $604673ecc72d1005$var$field = {
    /*--------------------------------------------------------------------------
	 * selector: seletor CSS do elemento na tela
	 * events: array de eventos DOM a capturar
	 * regex: expressão regular usada para validar e formatar o dado
	 * filter: expressão regular para remover caracteres antes da validação
	 * store_mask: máscara de formatação para armazenamento do dado
	 * display_mask: máscara de formatação para exibição do dado
	 -------------------------------------------------------------------------*/ selector: null,
    events: [
        'keydown',
        'change',
        'blur'
    ],
    regex: /^(.*)$/,
    filter: /[]/g,
    store_mask: '$1',
    display_mask: '$1',
    /*--------------------------------------------------------------------------
	 * Cria um clone de field com as propriedades e tipos especificados
	 * properties são aplicadas (assigned) diretamente no clone criado e
	 * types são novos objetos encadeados através de herança prototípica
	 -------------------------------------------------------------------------*/ create (properties, types) {
        let field = Object.assign(Object.create(this), properties);
        types?.forEach((type)=>{
            if (type) field = this.appendType.call(field, type);
            else console.error(properties, 'Undefined type');
        });
        return field;
    },
    /*--------------------------------------------------------------------------
	 * Retorna novo objeto encadeado com as propriedades do tipo especificado
	 -------------------------------------------------------------------------*/ appendType (type) {
        return Object.assign(Object.create(this), type);
    },
    /*--------------------------------------------------------------------------
	 * Remove os últimos objetos encadeados escalando os prototypes
	 -------------------------------------------------------------------------*/ scrapeTypes (count) {
        let proto, that = this;
        for(let i = 0; i < count; i++){
            proto = Object.getPrototypeOf(that);
            that = proto;
        }
        return that;
    },
    /*--------------------------------------------------------------------------
	 * Retorna um identificador baseado no form e no id/classe do elemento
	 -------------------------------------------------------------------------*/ getId () {
        if (!this.selector) return 'unknown.unknown';
        let node = document.querySelector(this.selector);
        if (!node) console.log('Selector not found:', this.selector, this);
        let node_id = node?.id || node?.className;
        let form_id = node?.form?.getAttribute?.('id') || node?.form?.className || ''; // getAttribute required
        return `${form_id}.${node_id}`;
    },
    /*--------------------------------------------------------------------------
	 * Retorna o nome do campo com base no atributo "name"
	 -------------------------------------------------------------------------*/ getName () {
        let node = document.querySelector(this.selector);
        return node?.getAttribute('name') || node?.id || node?.className;
    },
    /*--------------------------------------------------------------------------
	 * Retorna o texto do label associado ao elemento
	 -------------------------------------------------------------------------*/ getLabel () {
        let node = document.querySelector(this.selector);
        return node?.labels[0]?.innerText.trim() || node?.className || node?.id;
    },
    /*--------------------------------------------------------------------------
	 * Retorna o valor armazenado do campo ou um valor default
	 -------------------------------------------------------------------------*/ getValue (default_value) {
        let value = sessionStorage.getItem(this.getId()); // Return null if key doesn't exist
        return value ?? default_value;
    },
    /*--------------------------------------------------------------------------
	 * Armazena um novo valor
	 -------------------------------------------------------------------------*/ setValue (value) {
        value = this.format(value, this.store_mask);
        sessionStorage.setItem(this.getId(), value);
    },
    /*--------------------------------------------------------------------------
	 * Apaga o valor armazenado na sessionStorage
	 -------------------------------------------------------------------------*/ eraseValue () {
        sessionStorage.removeItem(this.getId());
    },
    /*--------------------------------------------------------------------------
	 * Informa se o dado contido no campo é válido ou inválido
	 * Não deve testar outros estados (por exemplo, se está vazio ou não)
	 -------------------------------------------------------------------------*/ checkValue (value = this.getValue()) {
        return this.regex.test(String(value ?? '').replace(this.filter, ''));
    },
    /*--------------------------------------------------------------------------
	 * Formata dados válidos conforme a máscara de exibição
	 -------------------------------------------------------------------------*/ format (value = this.getValue(), mask = this.display_mask) {
        value = String(value ?? '');
        return this.checkValue(value) ? value.replace(this.filter, '').replace(this.regex, typeof mask == 'function' ? mask.bind(this) : mask) : value;
    },
    /*--------------------------------------------------------------------------
	 * Exibe o valor armazenado de forma formatada no elemento
	 -------------------------------------------------------------------------*/ refresh () {
        let node = document.querySelector(this.selector);
        if (!node) return void console.error(this.selector, 'Not found');
        // input[type=file]: o valor só pode ser ''; o navegador não permite atribuir filename
        if (node.type === 'file') return;
        node.value = this.format();
    },
    /*--------------------------------------------------------------------------
	 * Define o estado de erro conforme se o campo:
	 * 	- Não estiver desabilitado
	 * 	- For requerido e estiver vazio
	 * 	- Estiver preenchido com um dado inválido
	 -------------------------------------------------------------------------*/ checkErrorState () {
        this.setErrorState(!this.isDisabled() && (this.isRequired() || !this.isEmpty()) && !this.checkValue());
    },
    /*--------------------------------------------------------------------------
	 * Liga ou desliga o flag de erro do campo
	 -------------------------------------------------------------------------*/ setErrorState (state) {
        let node = document.querySelector(this.selector);
        if (node && state) node.setAttribute('data-error', true);
        else if (node?.hasAttribute('data-error')) node.removeAttribute('data-error');
    },
    /*--------------------------------------------------------------------------
	 * Sincroniza o valor atual do elemento DOM para o armazenamento (sessionStorage).
	 * Deve ser chamado antes da validação ao submeter, para que o campo com foco seja considerado.
	 -------------------------------------------------------------------------*/ syncFromDom () {
        if (!this.selector) return;
        const node = document.querySelector(this.selector);
        if (node) $604673ecc72d1005$var$setValueIfChanged(this, node);
    },
    /*--------------------------------------------------------------------------
	 * Informa o estado do flag de erro do campo
	 -------------------------------------------------------------------------*/ getErrorState () {
        return document.querySelector(this.selector)?.hasAttribute('data-error') || false;
    },
    /*--------------------------------------------------------------------------
	 * Define o campo como readonly (não funciona para SELECT)
	 -------------------------------------------------------------------------*/ setReadOnly () {
        document.querySelectorAll(this.selector).forEach((node)=>{
            node.setAttribute('readonly', Number(node.getAttribute('readonly')) + 1);
        });
    },
    /*--------------------------------------------------------------------------
	 * Remove o atributo readonly do campo
	 -------------------------------------------------------------------------*/ setReadWrite () {
        document.querySelectorAll(this.selector).forEach((node)=>{
            let count = Number(node.getAttribute('readonly')) - 1;
            if (count > 0) node.setAttribute('readonly', count);
            else if (count == 0) node.removeAttribute('readonly');
        });
    },
    /*--------------------------------------------------------------------------
	 * Desabilita o campo para edição
	 -------------------------------------------------------------------------*/ disableInput () {
        document.querySelectorAll(this.selector).forEach((node)=>{
            node.setAttribute('disabled', Number(node.getAttribute('disabled')) + 1);
        });
    },
    /*--------------------------------------------------------------------------
	 * Habilita o campo para edição
	 -------------------------------------------------------------------------*/ enableInput () {
        document.querySelectorAll(this.selector).forEach((node)=>{
            let count = Number(node.getAttribute('disabled')) - 1;
            if (count > 0) node.setAttribute('disabled', count);
            else if (count == 0) node.removeAttribute('disabled');
        });
    },
    /*--------------------------------------------------------------------------
	 * Informa se o campo está vazio
	 -------------------------------------------------------------------------*/ isEmpty (value = this.getValue()) {
        return value === undefined || value === null || value === ''; // MUST NOT use !value
    },
    /*--------------------------------------------------------------------------
	 * Informa se o campo é mandatório
	 -------------------------------------------------------------------------*/ isRequired () {
        return document.querySelector(this.selector)?.hasAttribute('required') || false;
    },
    /*--------------------------------------------------------------------------
	 * Informa se o campo é readonly
	 -------------------------------------------------------------------------*/ isReadOnly () {
        return document.querySelector(this.selector)?.hasAttribute('readonly') || false;
    },
    /*--------------------------------------------------------------------------
	 * Informa se o campo está desabilitado
	 -------------------------------------------------------------------------*/ isDisabled () {
        return document.querySelector(this.selector)?.hasAttribute('disabled') || false;
    },
    /*--------------------------------------------------------------------------
	 * Inicializa o valor e inicia a monitoração do campo
	 -------------------------------------------------------------------------*/ captureEvents () {
        let nodes = document.querySelectorAll(this.selector);
        $604673ecc72d1005$var$setDefaultValueIfNoInternalValue(this, nodes);
        nodes.forEach((node)=>{
            this.events.forEach((event)=>{
                node.addEventListener(event, this.handleEvents.bind(this));
            });
        });
    },
    /*--------------------------------------------------------------------------
	 * Cria um clone do nó desassociando todos os eventos previamente capturados
	 * removeEventListener() não funciona por conta do bind() na captura
	 -------------------------------------------------------------------------*/ releaseEvents () {
        document.querySelectorAll(this.selector).forEach((node)=>{
            node.replaceWith(node.cloneNode(true));
        });
    },
    /*--------------------------------------------------------------------------
	 * Trata os eventos capturados
	 * Esta rotina padrão armazena o valor interno quando o elemento é alterado
	 -------------------------------------------------------------------------*/ handleEvents (ev) {
        switch(ev.type){
            case 'keydown':
                if (ev.key == 'Enter') $604673ecc72d1005$var$setValueIfChanged(this, ev.target);
                break;
            case 'blur':
            case 'change':
                $604673ecc72d1005$var$setValueIfChanged(this, ev.target);
                break;
            default:
                this.setValue(ev.target.value).refresh();
        }
    },
    /*--------------------------------------------------------------------------
	 * Invoca a função de mesmo nome no protótipo do objeto
	 *
	 * O exemplo abaixo invocará getValue() no protótipo do objeto que invocou 
	 * safeProtoCall():
	 *
	 * 		getValue(_this = this)
	 * 		{
	 * 			this.safeProtoCall(_this);
	 * 		}
	 *
	 * Isso permite que múltiplos tipos possam ser encadeados a um field:
	 *
	 * field  company_id  pubsub  datalist
	 * +---+  +--------+  +----+  +------+
	 * |   |--|        |--|    |--|      |
	 * +---+  +--------+  +----+  +------+
	 *            ^                   ^
	 *           this               _this		(exemplo)
	 *
	 * Cada tipo é um objeto encadeado no anterior com seus próprios métodos,
	 * mas que podem invocar métodos cadeia acima.
	 * 
	 * "this" não deve ser manipulado com call, apply, bind, pois senão não
	 * é mais possível identificar o protótipo do objeto em questão.
	 *
	 * "_this" deve ser passado como último argumento à função e deve apontar 
	 * para o último objeto da cadeia (o objeto completamente tipificado).
	 *
	 * Quando a chamada chega à raiz da cadeia, ou seja, a "field", 
	 * safeProtoCall() invoca o protótipo com "this" apontando para "_this", 
	 * de forma que as ações de field sejam aplicadas sobre o objeto no final 
	 * da cadeia. Para ser capaz de fazer essa transição, safeProtoCall() 
	 * precisa estar sempre no objeto logo acima de field (obviamente pode 
	 * estar adicionalmente em outras posições).
	 *
	 * Para identificar se chegamos à raiz, estamos testando se o objeto tem
	 * uma função própria chamada "safeProtoCall". Portanto, estamos assumindo
	 * que esta função não será overloaded em outros pontos da cadeia.
	 -------------------------------------------------------------------------*/ safeProtoCall (...args) {
        let proto, that = this;
        let caller = this.getCaller();
        while(true){
            proto = Object.getPrototypeOf(that);
            if (proto[caller] != this[caller]) break;
            that = proto;
        }
        let at_root = Object.hasOwn(Object.getPrototypeOf(proto), 'safeProtoCall');
        return proto[caller].call(at_root ? args.pop() : proto, ...args);
    },
    /*--------------------------------------------------------------------------
	 * Identifica a função está chamando safeProtoCall()
	 * Usa uma funcionalidade não-standard dos navegadores para obter a stack 
	 * trace. A resposta varia conforme o navegador.
	 -------------------------------------------------------------------------*/ getCaller () {
        let stack = new Error().stack.split('\n');
        if (navigator.userAgent.includes('Chrome')) return stack[3].match(/\.(\w+)\b/)[1];
        else if (navigator.userAgent.includes('Firefox')) return stack[2].match(/^(\w+)@/)[1];
        else throw new Error(`Unexpected User Agent: ${navigator.userAgent}`);
    }
};
var $604673ecc72d1005$export$2e2bcd8739ae039 = $604673ecc72d1005$var$field;


const $117338eb3d66ea8c$export$4a9440f82554b73e = 1; // setCursor() modes
const $117338eb3d66ea8c$export$de3ea91c1714c800 = 2;
const $117338eb3d66ea8c$export$ca00103691ff06e4 = 3;
const $117338eb3d66ea8c$export$f425698f5b896fd3 = 4;
const $117338eb3d66ea8c$var$setCursorHelper = function(field, where) {
    let node1 = document.querySelector(field.selector);
    let is_element_on_screen = node1 != null;
    if (!is_element_on_screen) return;
    let is_element_disabled = node1.hasAttribute('disabled');
    if (is_element_disabled) return;
    let is_element_hidden = node1.type == 'hidden';
    if (is_element_hidden) return;
    let is_multiple = node1.type && node1.type.match(/checkbox|radio/i);
    let is_mult_compatible = where == $117338eb3d66ea8c$export$4a9440f82554b73e || where == $117338eb3d66ea8c$export$f425698f5b896fd3;
    if (is_multiple && !is_mult_compatible) return;
    let is_not_input = node1.nodeName.match(/select|button/i);
    let is_text_compatible = where != $117338eb3d66ea8c$export$de3ea91c1714c800;
    if (is_not_input && !is_text_compatible) return;
    let is_error_requested = where == $117338eb3d66ea8c$export$f425698f5b896fd3;
    let is_error_flagged = field.getErrorState();
    if (is_error_requested && !is_error_flagged) return;
    let is_empty_requested = where === $117338eb3d66ea8c$export$ca00103691ff06e4;
    let is_value_empty = node1.value && node1.value.length == 0;
    if (is_empty_requested && !is_value_empty) return;
    if (node1.focus) node1.focus();
    if (node1.select) node1.select();
    return true;
};
const $117338eb3d66ea8c$var$forEachField = function(form, callback, field_criteria = {}) {
    let field_ids = Object.keys(form.fields);
    let first_index = field_criteria.initial_id ? field_ids.indexOf(field_criteria.initial_id) : 0;
    let last_index = field_ids.indexOf(field_criteria.final_id, first_index);
    if (last_index < 0) last_index = field_ids.length - 1;
    let skip_list = field_criteria.skip_list || [];
    for(let index = first_index; index <= last_index; index++){
        let in_skip_list = skip_list.indexOf(field_ids[index]) >= 0;
        if (in_skip_list) continue;
        let field_id = field_ids[index];
        let field = form.fields[field_id];
        let result = callback(field);
        if (result === true) break;
    }
};
const $117338eb3d66ea8c$export$2e2bcd8739ae039 = {
    selector: null,
    fields: null,
    callback: null,
    create (properties, fields, callback) {
        let form = Object.assign(Object.create(this), properties);
        form.fields = Object.create({});
        form.callback = callback;
        fields.forEach((entry)=>{
            form.insertOrUpdateField((0, $604673ecc72d1005$export$2e2bcd8739ae039).create(Object.assign(entry.properties, {
                form: form
            }), entry?.types));
        });
        return form;
    },
    insertOrUpdateField (field) {
        this.fields[field.getId()] = field;
    },
    deleteField (id) {
        delete this.fields[id];
    },
    getFieldById (id) {
        return this.fields[id];
    },
    getFieldByName (name) {
        let ids = Object.keys(this.fields);
        let idOrUndefined = ids.find((id)=>id.split('.')[1] == name);
        return this.fields[idOrUndefined];
    },
    getFieldBySelector (selector) {
        let ids = Object.keys(this.fields);
        let regex = new RegExp(`(^|\\b|\\s)${selector}(\\s|\\b|$)`); // Matches the entire word in the beginning, middle or end of string
        let idOrUndefined = ids.find((id)=>regex.test(this.fields[id].selector));
        return this.fields[idOrUndefined];
    },
    replaceFieldId (old_id, new_id) {
        if (old_id != new_id && this.fields[old_id] && !this.fields[new_id]) {
            this.fields[new_id] = this.fields[old_id];
            delete this.fields[old_id];
        }
    },
    captureFormEvents () {
        document.querySelector(this.selector).addEventListener('submit', this.submit.bind(this));
    },
    releaseFormEvents () {
        node = document.querySelector(this.selector);
        node.replaceWith(node.cloneNode(true));
    },
    captureFieldEvents (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.captureEvents(), field_criteria);
    },
    releaseFieldEvents (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.releaseEvents(), field_criteria);
    },
    setTabOrder (index = 1, field_criteria) {
        const callback = (field)=>{
            let node1 = document.querySelector(field.selector);
            if (node1) node1.tabIndex = index++;
        };
        $117338eb3d66ea8c$var$forEachField(this, callback, ffield_criteria);
    },
    setCursor (where, initial_field_id) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>$117338eb3d66ea8c$var$setCursorHelper(field, where), {
            'initial_id': initial_field_id
        });
    },
    setReadOnly (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.setReadOnly(), field_criteria);
    },
    setReadWrite (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.setReadWrite(), field_criteria);
    },
    disableInputs (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.disableInput(), field_criteria);
    },
    enableInputs (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.enableInput(), field_criteria);
    },
    refresh (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.refresh(), field_criteria);
    },
    getValues () {
        let json = {};
        const callback = (field)=>{
            if (!field.isEmpty()) json[field.getName()] = field.getValue();
        };
        $117338eb3d66ea8c$var$forEachField(this, callback);
        return json;
    },
    setValues (values) {
        const callback = (field_id)=>{
            let key = Object.keys(this.fields).find((key)=>new RegExp(`\\.${field_id}$`).test(key));
            let field = this.fields[key];
            field?.setValue.call(field, values[field_id]); // Some setValues() are overloaded, so let them handle this
        };
        Object.keys(values).forEach((field_id)=>callback(field_id));
    },
    eraseValues (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.eraseValue(), field_criteria);
    },
    checkErrorStates (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.checkErrorState(), field_criteria);
    },
    setErrorStates (state, field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.setErrorState(state), field_criteria);
    },
    init () {
        this.captureFormEvents();
        this.captureFieldEvents();
        this.refresh();
    },
    /** Sincroniza valores do DOM para o armazenamento antes da validação (ex.: campo com foco ao clicar Salvar). Só para formulário #carrier. */ syncFromDom () {
        const callback = (field)=>{
            if (field.selector && typeof field.syncFromDom === 'function') field.syncFromDom();
        };
        $117338eb3d66ea8c$var$forEachField(this, callback);
    },
    check () {
        const callback = (field)=>{
            if (!field.isDisabled() && field.isEmpty() && field.isRequired() || !field.isEmpty() && !field.checkValue()) {
                field.setErrorState(true);
                throw new Error(`Verificar ${field.getLabel()}`);
            }
        };
        Object.keys(this.fields).forEach((id)=>callback(this.fields[id]));
    },
    error (message) {
        this.checkErrorStates();
        this.setCursor($117338eb3d66ea8c$export$f425698f5b896fd3);
        alert(message);
    },
    submit (ev) {
        try {
            //ev?.preventDefault();
            this.check();
            this.callback?.(this.getValues());
        } catch (e) {
            this.error(e.message);
            console.log(e);
        }
    }
};


const $a2e5868bc3913d81$export$b38aa3fcbc4fc60a = /([^-\s#.'"]+)((?:-[A-Z]?\d+)*-[A-Z]?)(\d+)/; // Matches "#(name)(-0)" or '.(name)(-A0-A0)' for example
const $a2e5868bc3913d81$var$getColumns = function(form, selector) {
    let columns = [];
    document.querySelectorAll(`${selector} *`).forEach((node)=>{
        let column = $a2e5868bc3913d81$var$getColumn(form, node);
        if (column) columns.push(column);
    });
    if (columns.length == 0) throw new Error(`No indexed columns in ${selector}`);
    return columns;
};
const $a2e5868bc3913d81$var$getColumn = function(form, node) {
    let id = $a2e5868bc3913d81$var$getId(node);
    if (!id) return;
    let parts = id.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a);
    if (!parts || parts.length < 4) return;
    let field = form.getFieldByName(parts[0]);
    // Don't throw error because we can have indexed datalists in the form, which are not in the fields list
    // Update: datalists indexados são criados dinamicamente e não precisam/devem mais ser inseridos no HTML
    if (!field) throw new Error(`${parts[0]} not in the form`);
    return field ? {
        'field': field
    } : undefined;
};
const $a2e5868bc3913d81$var$getId = function(node) {
    return [
        node.id,
        node.className,
        node.name
    ].find((id)=>id && id.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a));
};
const $a2e5868bc3913d81$var$_appendRows = function(table, row_count, do_not_init) {
    let rows = document.querySelectorAll(table.selector);
    let first_row = rows[0];
    let last_row = rows[rows.length - 1];
    for(let i = 0; i < row_count; i++){
        let cloned_row = first_row.cloneNode(true); // true: clone all descendants too
        $a2e5868bc3913d81$var$incrementColumnsIndices(table, cloned_row);
        last_row = last_row.parentNode.insertBefore(cloned_row, last_row.nextSibling); // Update last_row for the next loop iteraction
        $a2e5868bc3913d81$var$insertFields(table, cloned_row, do_not_init);
    }
};
const $a2e5868bc3913d81$var$incrementColumnsIndices = function(table, cloned_row) {
    table.columns.forEach((column)=>{
        $a2e5868bc3913d81$var$incrementColumnIndices(table, cloned_row, column);
    });
};
const $a2e5868bc3913d81$var$incrementColumnIndices = function(table, cloned_row, column) {
    let new_node = $a2e5868bc3913d81$var$getColumnNode(cloned_row, column);
    let new_index = $a2e5868bc3913d81$var$addToIndex($a2e5868bc3913d81$var$getLastRowIndex(table, column), 1);
    $a2e5868bc3913d81$var$setIndex(new_node, new_index);
    if (new_node.nodeName == 'SELECT') new_node.selectedIndex = -1;
};
const $a2e5868bc3913d81$var$getColumnNode = function(row, column) {
    return $a2e5868bc3913d81$var$findElementIn(row, column.field.selector.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a)[1]); // "#form #field-0" --> "field"
};
const $a2e5868bc3913d81$var$findElementIn = function(node, selector) {
    return node.querySelector(`[id|="${selector}"],[class|="${selector}"],[name|="${selector}"],${selector}`); // Must match "field" and "field-0" but not "fields"
};
const $a2e5868bc3913d81$var$addToIndex = function(index_str, number) {
    if (!index_str) return;
    let new_index = String(Number(index_str) + number);
    let length = Math.max(new_index.length, index_str.length);
    return ('0000' + new_index).slice(-length);
};
const $a2e5868bc3913d81$var$getLastRowIndex = function(table, column) {
    let last_row = Array.from(document.querySelectorAll(table.selector)).pop();
    let node = $a2e5868bc3913d81$var$getColumnNode(last_row, column);
    return $a2e5868bc3913d81$var$getIndex(node);
};
const $a2e5868bc3913d81$var$getIndex = function(node) {
    return $a2e5868bc3913d81$var$getId(node)?.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a)?.at(-1); // Rows may point to non-indexed datalists
};
const $a2e5868bc3913d81$var$setIndex = function(node, index) {
    [
        'id',
        'class',
        'name',
        'list'
    ].forEach((attr_name)=>{
        let attr_value = node.getAttribute(attr_name);
        let is_attr_indexed = Boolean(attr_value?.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a));
        if (is_attr_indexed) node.setAttribute(attr_name, $a2e5868bc3913d81$export$77b8d1f921212127(attr_value, index));
        if (is_attr_indexed && attr_name == 'list') node.parentNode.querySelector(`#${attr_value}`)?.setAttribute('id', $a2e5868bc3913d81$export$77b8d1f921212127(attr_value, index)); // Fix the <datalist> id, if present
    });
};
const $a2e5868bc3913d81$export$77b8d1f921212127 = function(string, index) {
    return string.replace($a2e5868bc3913d81$export$b38aa3fcbc4fc60a, '$1$2' + index);
};
const $a2e5868bc3913d81$var$insertFields = function(table, cloned_row, do_not_init) {
    table.columns.forEach((column)=>{
        $a2e5868bc3913d81$var$insertField(table, cloned_row, column, do_not_init);
    });
};
const $a2e5868bc3913d81$var$insertField = function(table, cloned_row, column, do_not_init) {
    let new_index = $a2e5868bc3913d81$var$getIndex($a2e5868bc3913d81$var$getColumnNode(cloned_row, column));
    let new_selector = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, new_index);
    let new_field = column.field.create({
        selector: new_selector
    });
    table.form.insertOrUpdateField(new_field);
    if (!do_not_init) {
        new_field.eraseValue();
        new_field.setErrorState(false);
        new_field.captureEvents();
        new_field.refresh();
    }
};
const $a2e5868bc3913d81$var$_removeRows = function(table, indices_to_remove) {
    let rows = document.querySelectorAll(table.selector);
    let is_removing_all_rows = indices_to_remove.length == rows.length;
    if (is_removing_all_rows) indices_to_remove.pop(); // Always leave at least one row in the table
    $a2e5868bc3913d81$var$shiftRowsUp(table, rows, indices_to_remove); // Move values from rows below over rows-to-be-deleted, "compacting" the list
    $a2e5868bc3913d81$var$removeRowsAndFields(table, rows, indices_to_remove); // Remove excess rows listed in indices_to_remove after previous operation
};
const $a2e5868bc3913d81$var$shiftRowsUp = function(table, rows, indices_to_remove) {
    while(indices_to_remove.length){
        indices_to_remove.sort((a, b)=>a - b); // Sort in ascending order; List keeps changing and requires re-sorting;
        let to_index = indices_to_remove[0];
        let from_index = $a2e5868bc3913d81$var$findNextIndexNotRemoved(indices_to_remove, to_index, rows.length);
        let no_more_rows_to_move = from_index == rows.length;
        if (no_more_rows_to_move) break;
        $a2e5868bc3913d81$var$moveColumns(table, from_index, to_index);
        indices_to_remove.shift(); // Remove 'to' index from the list (refers to a regular row now)
        indices_to_remove.push(from_index); // Include 'from' index in the list (refers to a deleted row now)
    }
};
const $a2e5868bc3913d81$var$findNextIndexNotRemoved = function(indices, initial_index, row_count) {
    let current_index = initial_index, is_last_row, is_index_in_removed_list;
    do {
        current_index += 1;
        is_last_row = current_index == row_count;
        is_index_in_removed_list = indices.indexOf(current_index) != -1; // -1: not found
    }while (!is_last_row && is_index_in_removed_list);
    return current_index;
};
const $a2e5868bc3913d81$var$moveColumns = function(table, from_index, to_index) {
    table.columns.forEach((column)=>{
        $a2e5868bc3913d81$var$moveColumn(table, column, from_index, to_index);
    });
};
const $a2e5868bc3913d81$var$moveColumn = function(table, column, from_index, to_index) {
    let from_field_sel = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, from_index);
    let to_field_sel = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, to_index);
    let from_field = table.form.getFieldBySelector(from_field_sel);
    let to_field = table.form.getFieldBySelector(to_field_sel);
    let value = from_field.getValue();
    if (value) to_field.setValue(value);
    else to_field.eraseValue();
    to_field.refresh();
};
const $a2e5868bc3913d81$var$removeRowsAndFields = function(table, rows, indices_to_remove) {
    indices_to_remove.forEach((index)=>{
        table.columns.forEach((column)=>{
            let selector = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, index);
            let field = table.form.getFieldBySelector(selector);
            table.form.deleteField(field.getId());
        });
        rows[index]?.parentNode.removeChild(rows[index]); // Must be removed only AFTER the fields have been removed from the form
    });
};
const $a2e5868bc3913d81$var$_moveRow = function(table, from_index, count) {
    let rows = document.querySelectorAll(table.selector);
    let to_index = from_index + count;
    if (to_index < 0 || to_index >= rows.length) return false;
    let is_moving_down = count > 0;
    let from_node = rows[from_index];
    let to_node = is_moving_down ? rows[to_index].nextSibling : rows[to_index];
    rows[0].parentNode.insertBefore(from_node, to_node);
    $a2e5868bc3913d81$var$renameColumnsAndFields(table, from_index, to_index, count);
    return true;
};
const $a2e5868bc3913d81$var$renameColumnsAndFields = function(table, from_index, to_index, count) {
    let rows = document.querySelectorAll(table.selector);
    let first_index = from_index < to_index ? from_index : to_index;
    let last_index = from_index < to_index ? to_index : from_index;
    for(let i = first_index; i <= last_index; i++)table.columns.forEach((column)=>{
        let node = $a2e5868bc3913d81$var$getColumnNode(rows[i], column);
        let old_index = $a2e5868bc3913d81$var$getIndex(node);
        let new_index = $a2e5868bc3913d81$var$addToIndex(old_index, i == to_index ? count : Math.sign(count) * -1);
        let old_selector = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, old_index);
        let new_selector = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, new_index);
        let field = table.form.getFieldBySelector(old_selector);
        let old_id = field.getId();
        $a2e5868bc3913d81$var$setIndex(node, new_index);
        field.selector = new_selector;
        let new_id = field.getId();
        table.form.replaceFieldId(old_id, new_id + '_tmp'); // Create a temp id to avoid collisions (field-3 -> field-1 and field-1 exists)
    });
    $a2e5868bc3913d81$var$renameAndUpdate(table, rows, first_index, last_index);
};
const $a2e5868bc3913d81$var$renameAndUpdate = function(table, rows, first_index, last_index) {
    for(let i = first_index; i <= last_index; i++)table.columns.forEach((column)=>{
        let index = $a2e5868bc3913d81$var$getIndex($a2e5868bc3913d81$var$getColumnNode(rows[i], column));
        let field = table.form.getFieldBySelector($a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, index));
        let id = field.getId();
        table.form.replaceFieldId(id + '_tmp', id);
        let node = document.querySelector(field.selector);
        //field.setValue(node.type.match(/checkbox/i) ? node.checked : node.value);
        node.dispatchEvent(new Event('change'));
        node.dispatchEvent(new Event('blur'));
    });
};
const $a2e5868bc3913d81$export$2e2bcd8739ae039 = {
    form: null,
    selector: null,
    columns: null,
    create (form, row_selector) {
        let table = Object.create(this);
        table.selector = row_selector;
        table.form = form;
        table.columns = $a2e5868bc3913d81$var$getColumns(form, row_selector);
        return table;
    },
    appendRows (count, do_not_init) {
        $a2e5868bc3913d81$var$_appendRows(this, count, do_not_init);
    },
    removeRows (indices) {
        $a2e5868bc3913d81$var$_removeRows(this, indices);
    },
    moveRow (index, count) {
        return $a2e5868bc3913d81$var$_moveRow(this, index, count);
    }
};





const $814061363397c8d7$var$REGEX = /(.+)-(\d+)/;
const $814061363397c8d7$export$bffa455ba8c619a6 = function(record, property) {
    let copy = {
        ...record
    };
    let is_array = Array.isArray(copy[property]);
    (is_array ? copy[property] : [
        copy[property]
    ]).forEach((entry, index)=>{
        Object.keys(entry || {}).forEach((key)=>{
            let new_key = is_array ? `${key}-${index}` : `${property}_${key}`;
            copy[new_key] = entry[key];
        });
    });
    delete copy[property];
    return copy;
};
const $814061363397c8d7$export$a6d6ddd317ec07a4 = function(record, property) {
    let copy = {
        ...record
    };
    Object.keys(copy).forEach((key)=>{
        let match = key.match($814061363397c8d7$var$REGEX);
        if (match) {
            let index = Number(match[2]);
            if (!copy[property]) copy[property] = [];
            if (!copy[property][index]) copy[property][index] = {};
            copy[property][index][match[1]] = copy[key];
            delete copy[key];
        }
    });
    if (copy[property]) copy[property] = copy[property].filter((entry)=>entry);
    return copy;
};
const $814061363397c8d7$export$5eff2b09abd87cc4 = function(record) {
    let index = -1;
    Object.keys(record || {}).forEach((key)=>{
        let match = key.match($814061363397c8d7$var$REGEX);
        if (match?.[2] > index) index = Number(match[2]);
    });
    return index;
};
/* 
 * Recebe um array de registros e monta um array de <option> com base em uma 
 * propriedade para o valor e uma ou mais propriedades para os rótulos da opção:
 *
 * <option value="array[value]">array[label]</option>
 *
 * Opcionalmente pode indicar que uma das opções receba o atributo "selected".
 *
 * Também permite que o rótulo seja uma combinação de mais de uma propriedade,
 * como CNPJ + Nome, por exemplo. Também pode indicar rótulos alternativos:
 * caso algum deles esteja undefined, o(s) seguinte(s) será(ão) adotado(s).
 *
 * No caso de uma dessas propriedades ser um array (SKU do produto), esse array
 * será concatenado antes de ser incluído como rótulo da opção. O separador dos
 * elementos do array também poderá ser especificado (default é '').
 *
 * Se add_empty = true, um <option> vazio com valor -1 será incluído no início
 * da lista.
 */ const $814061363397c8d7$export$2c531902cb3b2ba = function(array, value, labels, separator = '', selected = -1, add_empty = false) {
    const is_selected = function(index) {
        return index == selected ? ' selected' : '';
    };
    const format = function(value) {
        return Array.isArray(value) ? value.join(separator) : value;
    };
    let options = array.map((entry, index)=>`<option value="${entry[value]}"${is_selected(index)}>${labels.map((label)=>format(entry[label])).join(' ').trim()}</option>`).join('\n');
    return (add_empty ? '<option value="-1"></option>' : '') + options;
};
const $814061363397c8d7$export$2e2bcd8739ae039 = {
    edit (descriptor, callback, current_data, autorow = true) {
        let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create(descriptor, async (updated_data)=>{
            if (!callback || await callback(updated_data, current_data)) fs.destroy();
        });
        fs.init = (()=>{
            fs.form.eraseValues(); // Must come before init()
            Object.getPrototypeOf(fs).init.call(fs, autorow);
            let extra_row = autorow ? 1 : 0;
            if (fs.hasTables()) {
                fs.setTableHeight(fs.getTableSize());
                fs.appendRows(Math.max($814061363397c8d7$export$5eff2b09abd87cc4(current_data), fs.getTableSize() - 1 - extra_row) + extra_row);
            }
            if (current_data) {
                fs.form.setValues(current_data);
                fs.form.refresh();
                // Dispara 'change' só em company_id para carregar opções (Programa, Categoria, Classes, etc.) sem passar valores inválidos a outros observers
                const company_id = current_data.company_id;
                if (company_id != null && company_id !== '') {
                    const field = fs.form.getFieldBySelector('#company_id');
                    if (field && typeof field.publish === 'function') field.publish('change', field, company_id);
                    // Refresh da form após opções (Programa, Categoria, etc.) carregarem para exibir labels em vez de vazio
                    setTimeout(()=>fs.form.refresh(), 150);
                }
                // Dispara 'change' nos campos UF para carregar lista de municípios (obs_load_options cities)
                [
                    'billing_address_state',
                    'delivery_address_state',
                    'address_state'
                ].forEach((name)=>{
                    const val = current_data[name];
                    if (val != null && val !== '') {
                        const field = fs.form.getFieldBySelector(`#${name}`);
                        if (field && typeof field.publish === 'function') field.publish('change', field, val);
                    }
                });
                setTimeout(()=>{
                    fs.form.refresh();
                    if (descriptor.form && typeof descriptor.form.afterEditSetValues === 'function') descriptor.form.afterEditSetValues(fs);
                }, 300);
            } else fs.form.refresh();
        })();
        return fs;
    }
};



var $1cmSR = parcelRequire("1cmSR");
const $7c7f18e63e55bfe1$export$9a00dee1beb8f576 = function(text) {
    if (text?.toLowerCase) {
        text = text.toLowerCase();
        text = text.replace(/(?:^|[^a-záéíóúâêôãõàüç])[a-záéíóúâêôãõàüç]/g, (a)=>a.toUpperCase());
        text = text.replace(/(^\w{1,3}\d?(?:\s|$)|(?<=\(.*)\b\w{2,3}\b(?=.*\)))/gi, (a)=>/Av|Al|Rua|Rod|Via|Est/i.test(a) ? a : a.toUpperCase()); // Siglas
        text = text.replace(/(\s(?:e|de|da|do|das|dos)\s)/gi, (a)=>a.toLowerCase()); // Conectores
        text = text.replace(/(\s(?:S\/A|S\/C|ME|EPP|EIRELI)\b)/gi, (a)=>a.toUpperCase()); // Empresas
        text = text.replace(/(\b(?:BR|AC|AL|AM|AP|BA|CE|DF|ES|GO|MA|MT|MS|MG)(?=.\d))/gi, (a)=>a.toUpperCase()); // Rodovias
        text = text.replace(/(\b(?:PA|PB|PR|PE|PI|RN|RS|RJ|RO|RR|SC|SP|SE|TO)(?=.\d))/gi, (a)=>a.toUpperCase());
        text = text.replace(/(\b(?:I|II|III|IV|V|VI|VII|VIII|IX|X|XI|XII|XIII|XIV)\b)/gi, (a)=>a.toUpperCase()); // Romanos
        text = text.replace(/(\b(?:XV|XVI|XVII|XVIII|XIX|XX|XXI|XXII|XXIII|XXIV|XXV)\b)/gi, (a)=>a.toUpperCase());
        text = text.replace(/(\d(?:ml|mcg|mg|g|kg|mm|cm|m|km)\b)/gi, (a)=>a.toLowerCase()); // Unidades
        text = text.replace(/(\d(?:l)\b)/gi, (a)=>a.toUpperCase()); // Unidades
        text = text.replace(/(\bPM\b)/gi, (a)=>a.toUpperCase()); // Diversos
    }
    return text;
};
const $7c7f18e63e55bfe1$export$2077e0241d6afd3c = function(number, places) {
    let scale = Math.pow(10, places); // 1, 10, 100, 1000 ...
    let scaled = number * scale; // 1.2359 * 100 = 123.59
    let trunc = Math.trunc(scaled); // 123.59 = 123
    let rest = scaled - trunc; // 123.59 - 123 = 0.59
    if (rest > 0) {
        let next_digit = Math.trunc(rest * 10); // 0.59 * 10 = 5.9 -> trunc(5.9) -> 5
        let zero_or_one = Math.floor(next_digit / 10 * 2); // 5 / 10 = 0.5 * 2 = 1 -> floor(1) -> 1
        trunc += zero_or_one; // 123 + 1 = 124
    }
    return trunc / scale; // 124 / 100 -> 1.24
};
const $7c7f18e63e55bfe1$export$da5f6eb3bb522cd = function(node) {
    let clone = node.cloneNode(true);
    node.replaceWith(clone);
    return clone;
};
const $7c7f18e63e55bfe1$export$a41585d0ab8307d6 = function(node, name) {
    for(; node && node.nodeName != '#document'; node = node.parentNode)if (node.nodeName == name.toUpperCase()) return node;
};
const $7c7f18e63e55bfe1$export$92a42bc44568c07 = function(node, attribute) {
    for(; node && node.nodeName != '#document'; node = node.parentNode)if (node.hasAttribute(attribute)) return node;
};
const $7c7f18e63e55bfe1$export$aa1a1894961eafab = function() {
    return Math.random().toString().slice(-4) + Date.now().toString().slice(-12);
};
const $7c7f18e63e55bfe1$export$30fb59293ffac91 = function() {
    return crypto.getRandomValues(new BigUint64Array(1))[0].toString(36);
};
const $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a = function(ids) {
    let split = {};
    ids.forEach((id)=>{
        if (!split[id[0]]) split[id[0]] = [];
        split[id[0]].push(id[1]);
    });
    return split;
};
const $7c7f18e63e55bfe1$export$fac44ee5b035f737 = function(data) {
    return JSON.stringify(data).replaceAll('"', "'");
};
const $7c7f18e63e55bfe1$export$98e6a39c04603d36 = function(text) {
    let result;
    try {
        result = JSON.parse(text.replaceAll("'", '"'));
    } catch (e) {
        result = text;
    }
    return result;
};
/** Converte lot_number para string sem notação científica (578E4, 3560D4 → 5780000, 3560000). */ const $7c7f18e63e55bfe1$export$d7959d098aba6524 = function(val) {
    if (val == null || val === undefined) return '';
    const s = typeof val === 'string' ? val.trim() : String(val);
    if (!s) return '';
    // Notação científica: dígitos + E ou D (locale EU) + expoente. Ex: 578E4, 3560D4. NÃO converte "25H10685D" (D no fim).
    if (/^\d+(\.\d+)?[eEdD][+-]?\d+$/.test(s)) {
        const n = parseFloat(s.replace(/d/i, 'e'));
        if (!isNaN(n) && isFinite(n)) return Number.isInteger(n) ? String(n) : n.toLocaleString('fullwide', {
            useGrouping: false,
            maximumFractionDigits: 0
        });
    }
    // Se contém E/e solto (sem regex acima), tenta converter
    if (/[eE]/.test(s)) {
        const n = parseFloat(s);
        if (!isNaN(n) && isFinite(n)) return Number.isInteger(n) ? String(n) : n.toLocaleString('fullwide', {
            useGrouping: false,
            maximumFractionDigits: 0
        });
    }
    // Se for número, evita notação científica em inteiros grandes
    if (typeof val === 'number') {
        const n = Number(val);
        if (isFinite(n) && (n >= 1e15 || n <= -1000000000000000 || n !== 0 && Math.abs(n) < 1e-6)) return n.toLocaleString('fullwide', {
            useGrouping: false,
            maximumFractionDigits: 0
        });
    }
    return s;
};


const $c643adc13e6018a8$var$listTablesFromIndexedFields = function(descriptor) {
    let tables = {};
    descriptor.fields.forEach((field)=>{
        let field_selector = field.properties.selector.match((0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a));
        if (!field_selector || field_selector.length < 4) return;
        let row_selector = $c643adc13e6018a8$var$makeRowSelector(field_selector[0]);
        if (!tables[row_selector]) tables[row_selector] = {
            table: null,
            fields: []
        };
        if (tables[row_selector].fields.indexOf(field_selector[0]) == -1) tables[row_selector].fields.push(field_selector[0]);
    });
    return tables;
};
const $c643adc13e6018a8$var$makeRowSelector = function(index) {
    let dashes = index.match(/-/g).length;
    let letters = index.match(/[A-Z]/g);
    return '.' + 'sub'.repeat(dashes - 1) + 'row' + (letters ? '-' + letters.join('') : '');
};
const $c643adc13e6018a8$var$interceptCallbacks = function(formset) {
    formset._init = formset.form.init;
    formset._check = formset.form.check;
    formset._error = formset.form.error;
    formset._submit = formset.form.submit;
    formset.form.init = $c643adc13e6018a8$var$formInit.bind(formset);
    formset.form.check = $c643adc13e6018a8$var$formCheck.bind(formset);
    formset.form.error = $c643adc13e6018a8$var$formError.bind(formset);
    formset.form.submit = $c643adc13e6018a8$var$formSubmit.bind(formset);
};
const $c643adc13e6018a8$var$formInit = function(autorow = true) {
    if (autorow) document.querySelector(this.form.selector).addEventListener('change', $c643adc13e6018a8$var$autoRow.bind(this));
    Object.keys(this.tables).forEach((selector)=>{
        this.tables[selector].table = (0, $a2e5868bc3913d81$export$2e2bcd8739ae039).create(this.form, selector);
    });
    this._init.call(this.form, this);
};
const $c643adc13e6018a8$var$autoRow = function(ev) {
    let root = this.dialog.getNode();
    let tables = Object.keys(this.tables);
    let table_selector;
    for(let node = ev.target; !table_selector && node != root; node = node.parentNode)table_selector = tables.find((table)=>table.substr(1) == node.className);
    let rows = root.querySelectorAll(table_selector);
    let in_last_row = rows[rows.length - 1]?.contains(ev.target);
    let is_checkbox = /checkbox|radio/.test(ev.target.getAttribute('type'));
    if (table_selector && in_last_row && !is_checkbox) this.appendRows(1, table_selector);
};
const $c643adc13e6018a8$var$formCheck = function() {
    this._check.call(this.form, this);
};
const $c643adc13e6018a8$var$formError = function(message) {
    this.form.setCursor((0, $117338eb3d66ea8c$export$f425698f5b896fd3));
    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(message, 'Dados Incorretos');
};
const $c643adc13e6018a8$var$formSubmit = function(ev) {
    // Formulário com submitHandler próprio (ex.: Transportadores) não usa validação/getValues genéricos
    if (typeof this.form.submitHandler === 'function') {
        try {
            this.form.submitHandler(this, ev);
        } catch (e) {
            $c643adc13e6018a8$var$formError.call(this, e.message);
            console.log(e);
        } finally{
            if (document.querySelector(this.form.selector)) $c643adc13e6018a8$var$enableAllEmptyRows.call(this);
        }
        return;
    }
    try {
        ev?.preventDefault();
        $c643adc13e6018a8$var$disableAllEmptyRows.call(this, [
            '#filter',
            '#stocks-report-form'
        ].includes(this.form.selector));
        $c643adc13e6018a8$var$formCheck.call(this);
        let data = this.form.getValues();
        this.callback?.call(this, data);
    } catch (e) {
        $c643adc13e6018a8$var$formError.call(this, e.message);
        console.log(e);
    } finally{
        if (document.querySelector(this.form.selector)) $c643adc13e6018a8$var$enableAllEmptyRows.call(this);
    }
};
const $c643adc13e6018a8$var$disableAllEmptyRows = function(allow_all_empty = false) {
    Object.keys(this.tables).forEach((selector)=>{
        $c643adc13e6018a8$var$disableEmptyRows(this.tables[selector], this.form, this.dialog.getNode().querySelectorAll(selector), allow_all_empty);
    });
};
const $c643adc13e6018a8$var$enableAllEmptyRows = function() {
    Object.keys(this.tables).forEach((selector)=>{
        $c643adc13e6018a8$var$enableEmptyRows(this.tables[selector], this.form, this.dialog.getNode().querySelectorAll(selector));
    });
};
const $c643adc13e6018a8$var$disableEmptyRows = function(table, form, rows, allow_all_empty) {
    let indices = [];
    rows.forEach((row, index)=>{
        if ($c643adc13e6018a8$var$isRowEmpty(table, form, index)) indices.push(index);
    });
    if (indices.length < rows.length || allow_all_empty) indices.forEach((index)=>$c643adc13e6018a8$var$disableRow(table, form, index));
};
const $c643adc13e6018a8$var$enableEmptyRows = function(table, form, rows) {
    rows.forEach((row, index)=>{
        if ($c643adc13e6018a8$var$isRowEmptyAndDisabled(table, form, index)) $c643adc13e6018a8$var$enableRow(table, form, index);
    });
};
const $c643adc13e6018a8$var$getEnabledRowsIndices = function(table, form, rows) {
    let indices = [];
    rows.forEach((row, index)=>{
        if (!$c643adc13e6018a8$var$isRowEmptyAndDisabled(table, form, index)) indices.push(index);
    });
    return indices;
};
const $c643adc13e6018a8$var$isRowEmpty = function(table, form, index) {
    return table.fields.every((selector)=>form.getFieldBySelector((0, $a2e5868bc3913d81$export$77b8d1f921212127)(selector, index)).isEmpty());
};
const $c643adc13e6018a8$var$isRowEmptyAndDisabled = function(table, form, index) {
    return table.fields.every((selector)=>{
        let field = form.getFieldBySelector((0, $a2e5868bc3913d81$export$77b8d1f921212127)(selector, index));
        return field.isEmpty() && field.isDisabled();
    });
};
const $c643adc13e6018a8$var$disableRow = function(table, form, index) {
    table.fields.forEach((selector)=>form.getFieldBySelector((0, $a2e5868bc3913d81$export$77b8d1f921212127)(selector, index)).disableInput());
};
const $c643adc13e6018a8$var$enableRow = function(table, form, index) {
    table.fields.forEach((selector)=>form.getFieldBySelector((0, $a2e5868bc3913d81$export$77b8d1f921212127)(selector, index)).enableInput());
};
const $c643adc13e6018a8$var$clearRow = function(table, form, index) {
    table.fields.forEach((selector)=>{
        let field = form.getFieldBySelector((0, $a2e5868bc3913d81$export$77b8d1f921212127)(selector, index));
        field.eraseValue();
        field.setErrorState(false);
        field.refresh();
    });
};
const $c643adc13e6018a8$var$dialogHandler = function(key, source) {
    let table = source.getAttribute('data-table') || '.row';
    switch(key){
        case 'Invert':
            this.invertSelection(table);
            break;
        case 'Clear':
            this.clearSelectedRows(table);
            break;
        case 'Insert':
            this.appendRows(1, table);
            break;
        case 'Remove':
            this.removeSelectedRows(table);
            break;
        case 'MoveUp':
            this.moveRows(-1, table);
            break;
        case 'MoveDn':
            this.moveRows(1, table);
            break;
        case 'Escape':
            this.dialog.destroy();
            break;
        case 'Enter':
            this.form.submit();
            break;
        default:
            this.handler?.call(this, key);
    }
};
const $c643adc13e6018a8$var$getCheckboxes = function(formset, table) {
    return formset.dialog.getNode().querySelectorAll((table ? `${table} ` : '') + 'INPUT[id^="checkbox-"]');
};
const $c643adc13e6018a8$var$getSelectedIndices = function(formset, table) {
    let indices = [];
    $c643adc13e6018a8$var$getCheckboxes(formset, table).forEach((checkbox, index)=>{
        if (checkbox.checked) indices.push(index);
    });
    return indices;
};
const $c643adc13e6018a8$export$cad72087bded938 = function(selector, options, value, labels, separator) {
    let node = document.querySelector(selector);
    if (!node) {
        console.log('Not found:', selector);
        return;
    }
    let list_name = node.getAttribute('list');
    let index = node.id.match((0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a));
    if (index) {
        list_name = (0, $a2e5868bc3913d81$export$77b8d1f921212127)(list_name || `${index[1]}_list-0`, index[3]);
        node.setAttribute('list', list_name);
    }
    let datalist = document.getElementById(list_name);
    if (!datalist) {
        datalist = document.createElement('datalist');
        datalist.setAttribute('id', list_name);
        let parent_node = index ? node.parentNode : (0, $7c7f18e63e55bfe1$export$a41585d0ab8307d6)(node, 'form');
        parent_node.insertBefore(datalist, parent_node.firstChild);
    }
    let is_static_list = options.length && Object.keys(options[0]).every((key)=>[
            'value',
            'label'
        ].includes(key));
    if (is_static_list) datalist.innerHTML = (0, $814061363397c8d7$export$2c531902cb3b2ba)(options, 'value', [
        'label'
    ]);
    else datalist.innerHTML = (0, $814061363397c8d7$export$2c531902cb3b2ba)(options, value || 'id', labels, separator);
};
const $c643adc13e6018a8$export$2e2bcd8739ae039 = {
    tables: {},
    dialog: null,
    form: null,
    callback: null,
    handler: null,
    create (descriptor, callback, handler) {
        let formset = Object.create(this);
        formset.tables = $c643adc13e6018a8$var$listTablesFromIndexedFields(descriptor);
        formset.dialog = (0, $9da5ab8aba8aa3e3$export$2e2bcd8739ae039).create(descriptor.html, $c643adc13e6018a8$var$dialogHandler.bind(formset));
        formset.form = (0, $117338eb3d66ea8c$export$2e2bcd8739ae039).create(descriptor.form, descriptor.fields, callback);
        formset.callback = callback;
        formset.handler = handler;
        $c643adc13e6018a8$var$interceptCallbacks(formset);
        return formset;
    },
    destroy () {
        this.dialog.destroy();
    },
    invertSelection (table = '.row') {
        $c643adc13e6018a8$var$getCheckboxes(this, table).forEach((checkbox)=>checkbox.click());
    },
    clearAllRows (table = '.row') {
        $c643adc13e6018a8$var$getCheckboxes(this, table).forEach((checkbox, index)=>$c643adc13e6018a8$var$clearRow(this.tables[table], this.form, index));
    },
    clearSelectedRows (table = '.row') {
        let indices = $c643adc13e6018a8$var$getSelectedIndices(this, table);
        indices.forEach((index)=>$c643adc13e6018a8$var$clearRow(this.tables[table], this.form, index));
    },
    appendRows (count, table = '.row') {
        this.tables[table].table.appendRows(count);
    },
    removeRows (indices, table = '.row') {
        this.tables[table].table.removeRows(indices);
    },
    removeSelectedRows (table = '.row') {
        let indices = $c643adc13e6018a8$var$getSelectedIndices(this, table);
        this.tables[table].table.removeRows(indices);
    },
    moveRows (count, table = '.row') {
        let indices = $c643adc13e6018a8$var$getSelectedIndices(this, table);
        if (count > 0) indices.reverse(); // If moving down, start moving the bottom rows first
        indices.every((index)=>this.tables[table].table.moveRow(index, count));
    },
    getEnabledRowsIndices (table = '.row') {
        return $c643adc13e6018a8$var$getEnabledRowsIndices(this.tables[table], this.form, this.dialog.getNode().querySelectorAll(table));
    },
    hasTables () {
        return Object.keys(this.tables).length > 0;
    },
    getTableSize (table = '.row') {
        return this.dialog.getNode().querySelector(table).getAttribute('data-size') || 6;
    },
    setTableHeight (rows, table = '.row') {
        let node = this.dialog.getNode().querySelector(`.form *:has(> table ${table})`);
        if (node) {
            node.style.minHeight = rows * 2.4 + 'rem';
            node.style.maxHeight = rows * 2.4 + 1.2 + 'rem';
        }
    },
    async loadList (datalist, store, options) {
        let node = document.querySelector(`${this.form.selector} ${datalist}`);
        if (!node) return;
        let data = await (0, $1cmSR.default).list(store, options?.range, options?.index);
        node.innerHTML = data ? (0, $814061363397c8d7$export$2c531902cb3b2ba)(data, options?.value ?? 'id', options?.labels ?? [
            'name'
        ], options?.separator) : '';
        this.form.refresh(); // Better to refresh after each load than have to await each individual load and then refresh once
    },
    init (autorow) {
        try {
            $c643adc13e6018a8$var$formInit.call(this, autorow);
        } catch (e) {
            alert(e.message);
            console.log(e);
        }
    },
    submit () {
        this.form.submit();
    }
};


// Types

function $ba016d80ddaca15b$export$2e2bcd8739ae039(...args) {
    return {
        _separator: args[0] || ';',
        getValue (default_value, _this = this) {
            return (0, $7c7f18e63e55bfe1$export$98e6a39c04603d36)(this.safeProtoCall(default_value, _this))?.map((entry)=>entry.trim());
        },
        setValue (value, _this = this) {
            this.safeProtoCall((0, $7c7f18e63e55bfe1$export$fac44ee5b035f737)(Array.isArray(value) ? value : value?.split(this._separator) || []), _this);
        },
        checkValue (value = this.getValue()) {
            return this.isEmpty() || value?.every((entry)=>Boolean(entry));
        },
        isEmpty (value = this.getValue()) {
            return !value || value.length == 1 && value[0] == '';
        },
        format (value = this.getValue(), mask = this.display_mask) {
            return Array.isArray(value) ? value.join(`${this._separator} `) : value || '';
        }
    };
}


function $c6be62c04ec8b9fb$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'click'
        ],
        getValue (default_value = 0, _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        isEmpty (value = this.getValue()) {
            return value == 0;
        },
        handleEvents (ev) {
            this.setValue(this.getValue() ^ 1);
            this.refresh();
        }
    };
}



function $c1695650808e6a21$export$2e2bcd8739ae039(...args) {
    return {
        setValue (value, _this = this) {
            if (value?.toUpperCase) value = value.toUpperCase();
            this.safeProtoCall(value, _this);
        }
    };
}


function $a3b288a4e8d304b7$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{5})(\d{3})$/,
        filter: /[\-]/g,
        store_mask: '$1$2',
        display_mask: '$1-$2'
    };
}


function $73c7be81b506e1d3$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{2})(\d{3})(\d{2})$/,
        filter: /[.]/g,
        store_mask: '$1$2$3',
        display_mask: '$1.$2.$3'
    };
}


function $7fda302dcbccda19$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        filter: /[./-]/g,
        store_mask: '$1$2$3$4$5',
        display_mask: '$1.$2.$3/$4-$5'
    };
}


function $bc7d8cd598cdbfe0$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        filter: /[-.]/g,
        store_mask: '$1$2$3$4',
        display_mask: '$1.$2.$3-$4'
    };
}


function $410b568e9a67c35a$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'change'
        ],
        getValue (default_value = document.querySelector(this.selector).hasAttribute('checked') ? 1 : 0, _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        setValue (value, _this = this) {
            this.safeProtoCall(value ? 1 : 0, _this);
        },
        isEmpty (value = this.getValue()) {
            return value == 0;
        },
        refresh () {
            let node = document.querySelector(this.selector);
            if (node) node.checked = this.getValue() != 0;
        },
        handleEvents (ev) {
            this.setValue(ev.target.checked ? 1 : 0);
        }
    };
}


function $cbae8b6ef4bb77e6$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'change'
        ],
        getValue (default_value = Array.from(document.querySelectorAll(this.selector + '[checked]')).map((node)=>node.value).join(','), _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        refresh () {
            let values = this.getValue().split(',');
            let nodes = document.querySelectorAll(this.selector);
            nodes.forEach((node)=>{
                node.checked = values.includes(node.value);
            });
        },
        handleEvents (ev) {
            let values = this.getValue().split(',');
            let index = values.findIndex((value)=>value == ev.target.value);
            if (index < 0) values.unshift(ev.target.value); // Add if not found
            else values.splice(index, 1); // Remove if found
            this.setValue(values.join(','));
        }
    };
}


const $728b723a7139bbbf$var$findOption = function(node, value) {
    return Array.from(node?.list?.options ?? []).find((option)=>option.value == value);
};
const $728b723a7139bbbf$var$normalizeForMatch = function(str) {
    return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
};
const $728b723a7139bbbf$var$optionMatchesTyped = function(option, typed) {
    if (!typed || !option?.innerText) return false;
    const nTyped = $728b723a7139bbbf$var$normalizeForMatch(typed);
    const nOption = $728b723a7139bbbf$var$normalizeForMatch(option.innerText);
    return nOption === nTyped || nOption.startsWith(nTyped) || nOption.includes(nTyped);
};
const $728b723a7139bbbf$var$isValidId = function(val) {
    if (val == null || val === '' || val === -1 || val === '-1') return false;
    const n = Number(val);
    return !isNaN(n) && n >= 0;
};
const $728b723a7139bbbf$var$setOption = function(node, callback) {
    let options = Array.from(node?.list?.options ?? []);
    let option = options.find(callback);
    // -2: invalid, -1: empty. Opcional + sem match: se lista vazia (ex: produto sem estoque), manter texto digitado (-2); senão tratar como vazio (-1)
    let new_value = option?.value ?? (node.value.length ? this.isRequired() ? -2 : options.length === 0 ? -2 : -1 : -1);
    let old_value = this.getValue() ?? -1;
    // Input vazio e campo tem id: só preservar se opções ainda não carregaram (não há option para old_value). Se há option, usuário pode ter limpado de propósito.
    if (new_value === -1 && !node.value.length && $728b723a7139bbbf$var$isValidId(old_value) && !$728b723a7139bbbf$var$findOption(node, old_value)) return void this.refresh();
    if (new_value != old_value) {
        this.setValue(new_value);
        this.checkErrorState();
    }
    this.refresh(); // Must be out here or it won't show properly when you clear the field and retype the old value
};
function $728b723a7139bbbf$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'input',
            'blur'
        ],
        checkValue (value = this.getValue()) {
            let node = document.querySelector(this.selector);
            if ($728b723a7139bbbf$var$findOption(node, value)) return true;
            // Campo opcional com id numérico válido: aceitar mesmo sem opção (ex.: lista ainda não carregou)
            if (!this.isRequired() && $728b723a7139bbbf$var$isValidId(value)) return true;
            // Campo opcional com valor inválido (-2): tratar como vazio para permitir avançar (usuário digitou algo que não está na lista)
            if (!this.isRequired() && (value == -2 || value == '-2')) return true;
            return false;
        },
        isEmpty (value = this.getValue()) {
            return !value || value == -1; // Leave the ==, value is string
        },
        refresh () {
            let node = document.querySelector(this.selector);
            if (!node || !node.list) return;
            let value = this.getValue();
            let option = $728b723a7139bbbf$var$findOption(node, value);
            if (option) node.value = option.innerText;
            else if (value != -2) // Opções ainda não carregaram: manter id como fallback em vez de vazio
            node.value = $728b723a7139bbbf$var$isValidId(value) ? String(value) : '';
        },
        handleEvents (ev) {
            switch(ev.type){
                case 'input':
                    if (!ev.inputType || ev.inputType == 'insertReplacementText') $728b723a7139bbbf$var$setOption.call(this, ev.target, (option)=>option.value == ev.target.value || option.innerText && option.innerText.trim() === String(ev.target.value).trim());
                    break;
                case 'blur':
                    let node = document.querySelector(this.selector);
                    if (node.value != $728b723a7139bbbf$var$findOption(node, this.getValue())?.innerText) $728b723a7139bbbf$var$setOption.call(this, ev.target, (option)=>ev.target.value.length && (ev.target.value == option.value || $728b723a7139bbbf$var$optionMatchesTyped(option, ev.target.value)));
                    break;
            }
        }
    };
}


function $0c9c948f6a5e1eb3$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(0?[1-9]|[1-2][0-9]|3[0-1])\/(0?[1-9]|1[0-2])\/(20[0-9][0-9])$|^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(.+))?$/,
        store_mask (match, ad, am, ay, by, bm, bd) {
            return new Date(ay ?? by, (am ?? bm) - 1, ad ?? bd).toISOString().substr(0, 10);
        },
        display_mask (match, ad, am, ay, by, bm, bd) {
            const d = new Date(ay ?? by, (am ?? bm) - 1, ad ?? bd);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return `${dd}-${mm}-${yyyy}`;
        }
    };
}


const $6592b17c40023188$var$dt = function(ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz) {
    return new Date(`${ay ?? by}-${am ?? bm}-${ad ?? bd}T${aH ?? bH}:${aM ?? bM}:${aS ?? bS ?? 0}${tz ?? ''}`);
};
function $6592b17c40023188$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(0?[1-9]|[1-2][0-9]|3[0-1])\/(0?[1-9]|1[0-2])\/(20[0-9][0-9])\s([0-1][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9]))?$|^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(.+)$/,
        store_mask (match, ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz) {
            return $6592b17c40023188$var$dt(ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz).toISOString();
        },
        display_mask (match, ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz) {
            const d = $6592b17c40023188$var$dt(ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            const h = String(d.getHours()).padStart(2, '0');
            const m = String(d.getMinutes()).padStart(2, '0');
            const s = String(d.getSeconds()).padStart(2, '0');
            return `${dd}-${mm}-${yyyy} ${h}:${m}:${s}`;
        }
    };
}


function $ff6c02d4f0df8745$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^([\w\-]+(?:\.[\w\-]+)*@[\w\-]+(?:\.[\w\-]+)+)$/i,
        setValue (value, _this = this) {
            this.safeProtoCall(value?.toLowerCase(), _this);
        }
    };
}


function $538a7387d2d871ea$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^((?:\/[a-z]+(?:-[a-z]+)*(?:\/\{[a-z_]*\})?)+)$/
    };
}


function $5e1493eb0305a487$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'change'
        ],
        refresh () {},
        handleEvents (ev) {
            let reader = new FileReader();
            reader.onloadend = ()=>{
                let result = reader.result;
                this.setValue(result.slice(result.indexOf(',') + 1));
            };
            reader.readAsDataURL(ev.target.files[0]);
        }
    };
}


function $ca1c79f4e173f347$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{8,14}|SEM GTIN)$/,
        filter: /[]/g
    };
}


function $c215c48c03ffee69$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{8,13})$/,
        filter: /[-.]/g,
        store_mask: '$1',
        display_mask: '$1'
    };
}


function $3111ab08af8d80d2$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^((?:1?\d{1,2}|2[0-4]\d|25[0-5])\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])\.(?:1?\d{1,2}|2[0-4]\d|25[0-5]))$/,
        filter: /[]/g
    };
}


function $1c8685a0a35fdb02$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\{(?:(\s*"\w+":\s*(?:\d+|"[\w-]+")\s*)(,\s*\"\w+":\s*(?:\d+|"[\w-]+")\s*)*)?\})$/
    };
}



var $1cmSR = parcelRequire("1cmSR");

function $b63c535296d208bd$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'move'
        ],
        _store: args[0],
        _target: args[1],
        _values: args[2]?.values || [
            'id'
        ],
        _labels: args[2]?.labels || [
            'name'
        ],
        _index: args[2]?.index,
        captureEvents (_this = this) {
            this.capture();
            this.safeProtoCall(_this);
        },
        getValue (default_value = '[]', _this = this) {
            return (0, $7c7f18e63e55bfe1$export$98e6a39c04603d36)(this.safeProtoCall(default_value, _this)).map((entry)=>entry.length == 1 ? entry[0] : entry);
        },
        setValue (values, _this = this) {
            return this.safeProtoCall((0, $7c7f18e63e55bfe1$export$fac44ee5b035f737)((values ?? []).map((entry)=>Array.isArray(entry) ? entry : [
                    entry
                ])), _this);
        },
        isEmpty (values = this.getValue()) {
            return (0, $7c7f18e63e55bfe1$export$98e6a39c04603d36)(values).length == 0;
        },
        async refresh () {
            let node = document.querySelector(`${this?.form.selector} ${this.selector}`);
            if (!node) return;
            node.innerHTML = (await Promise.all(this.getValue().map(async (key)=>{
                return await this.makeOption(await (0, $1cmSR.default).get(this._store, key, this._index));
            }))).join('\n');
        },
        async makeOption (data) {
            if (!data) return;
            let value = (0, $7c7f18e63e55bfe1$export$fac44ee5b035f737)(this._values.map((entry)=>data[entry]));
            let label = this._labels.map((entry)=>data[entry]).join(' ');
            return `<option value="${value}">${label}</option>`;
        },
        handleEvents (ev) {
            this.setValue(Array.from(ev.target.children).map((option)=>(0, $7c7f18e63e55bfe1$export$98e6a39c04603d36)(option.value)));
        },
        capture () {
            let node = document.querySelector(`${this?.form.selector} ${this.selector}`);
            node.parentNode.nextElementSibling.querySelectorAll('button').forEach((button)=>{
                button.addEventListener('click', this.move.bind(this));
            });
        },
        async fill () {
            let available = await (0, $1cmSR.default).list(this._store, undefined, this._index); // Must be the first operation to give time for the form to set its values
            let selected = (0, $7c7f18e63e55bfe1$export$98e6a39c04603d36)(this.form.getFieldBySelector(this.selector).getValue()).map((entry)=>String(entry));
            available = available.filter((entry)=>!selected.includes(String(this._values.map((key)=>entry[key])))); // Remove currently selected options from the available list
            let options = await Promise.all((available ?? []).map((entry)=>this.makeOption(entry)));
            document.querySelector(`${this?.form.selector} ${this._target}`).innerHTML = options.join('\n'); // Join prevent commas from being automatically inserted by JS
        },
        move (ev) {
            let selected = document.querySelector(`${this?.form.selector} ${this.selector}`);
            let available = document.querySelector(`${this?.form.selector} ${this._target}`);
            switch(ev.target.className){
                case 'bn_Left':
                    Array.from(available.selectedOptions).forEach((option)=>selected.appendChild(option));
                    break;
                case 'bn_Right':
                    Array.from(selected.selectedOptions).forEach((option)=>available.appendChild(option));
                    break;
            }
            selected.dispatchEvent(new CustomEvent('move'));
        }
    };
}


// Requires keymap.js
function $374af83299fa0b20$export$2e2bcd8739ae039(...args) {
    return {
        captureEvents (_this = this) {
            this.fill();
            this.safeProtoCall(_this);
        }
    };
}



function $5263fa1d5ed7aac5$export$2e2bcd8739ae039(...args) {
    return {
        setValue (value, _this = this) {
            let has_changed = !new RegExp(value, 'i').test(this.getValue());
            this.safeProtoCall(has_changed ? (0, $7c7f18e63e55bfe1$export$9a00dee1beb8f576)(value) : value, _this);
        }
    };
}


function $8b11f696e7bab70f$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{8})$/,
        filter: /[]/g
    };
}


function $691b0d282e4cd0d9$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^\s*(\d{1,9})(\s+\d{1,9})*\s*$/,
        store_mask (match) {
            return match.trim().replaceAll('  ', ' ');
        },
        display_mask (match, ...args) {
            return match.trim().replaceAll('  ', ' ');
        }
    };
}


function $f4ad198ec68f02f5$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})$/,
        filter: /[\s]/g,
        store_mask: '$1$2$3$4$5$6$7$8$9$10$11',
        display_mask: '$1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11'
    };
}


function $44e90f12875d728e$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{1,15})$/
    };
}


const $25a74ef8f667cbaa$var$masks = [
    /^(-?\d{1,3})(\d{3})?(\d{3})?(\.\d{1,20})?$|^(-?\d{1,3})(\.?\d{3})?(\.?\d{3})?(,\d{1,20})?$/,
    /^(-?\d{1,3})(\d{3})?(\d{3})?$|^(-?\d{1,3})(\.?\d{3})?(\.?\d{3})?$/,
    /^(\d{1,3})(\d{3})?(\d{3})?$|^(\d{1,3})(\.?\d{3})?(\.?\d{3})?$/
];
const $25a74ef8f667cbaa$var$store = function(g1, g2, g3, g4) {
    return g1 + (g2?.replace(this.ts, '') ?? '') + (g3?.replace(this.ts, '') ?? '') + (this.dp ? '.' + ((g4?.slice(1) ?? '') + '000000').slice(0, this.dp) : '');
};
const $25a74ef8f667cbaa$var$display = function(g1, g2, g3, g4) {
    return g1 + (g2 ? this.ts + g2.replace(/[.,]/, '') : '') + (g3 ? this.ts + g3.replace(/[.,]/, '') : '') + (this.dp ? this.ds + ((g4?.slice(1) ?? '') + '000000').slice(0, this.dp) : '');
};
function $25a74ef8f667cbaa$export$2e2bcd8739ae039(...args) {
    return {
        dp: args[0] ?? 0,
        ds: args[2] ?? ',',
        ts: args[3] ?? '.',
        regex: $25a74ef8f667cbaa$var$masks[args[1] ?? 0],
        store_mask (match, a1, a2, a3, a4, b1, b2, b3, b4) {
            return a1 ? $25a74ef8f667cbaa$var$store.call(this, a1, a2, a3, a4) : $25a74ef8f667cbaa$var$store.call(this, b1, b2, b3, b4);
        },
        display_mask (match, a1, a2, a3, a4, b1, b2, b3, b4) {
            return a1 ? $25a74ef8f667cbaa$var$display.call(this, a1, a2, a3, a4) : $25a74ef8f667cbaa$var$display.call(this, b1, b2, b3, b4);
        }
    };
}


let $dfd33cae850bb039$var$password;
function $dfd33cae850bb039$export$2e2bcd8739ae039(...args) {
    return {
        getValue (default_value) {
            const stored = $dfd33cae850bb039$var$password ?? default_value;
            if (stored !== undefined && stored !== null && stored !== '') return stored;
            // Senha só sincroniza em change/blur; se usuário submete sem sair do campo, ler do DOM
            const node = document.querySelector(this.selector);
            return node?.value ?? default_value;
        },
        setValue (value) {
            $dfd33cae850bb039$var$password = this.format(value, this.store_mask);
        }
    };
}


function $e576b042880c33f1$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^\+?(55)(1[1-9]|2[1247]|3[1234578]|4[1-9]|5[1345]|6[1-9]|7[134579]|8[1-9]|9[1-9])([2-9]\d{3,4})(\d{4})$/,
        filter: /[\(\)\-\s.]/g,
        store_mask: '$1$2$3$4',
        display_mask: '+$1 ($2) $3-$4'
    };
}


const $5d515fcf43788f0e$var$REGISTRY = {};
function $5d515fcf43788f0e$var$pubsub(target) {
    target.register = function(id, catalog = 'default') {
        if (!$5d515fcf43788f0e$var$REGISTRY[catalog]) $5d515fcf43788f0e$var$REGISTRY[catalog] = [];
        let index = $5d515fcf43788f0e$var$REGISTRY[catalog].findIndex((member)=>member.id == id);
        if (index < 0) index = $5d515fcf43788f0e$var$REGISTRY[catalog].length;
        $5d515fcf43788f0e$var$REGISTRY[catalog][index] = {
            'id': id,
            'member': this
        };
    };
    target.locate = function(id, catalog = 'default') {
        const escaped = String(id).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return $5d515fcf43788f0e$var$REGISTRY[catalog].find((member)=>new RegExp(`\\b${escaped}\\b`).test(member.id))?.member;
    };
    target.subscribe = function(events_array, callback, once = true) {
        if (typeof callback != 'function') throw new Error('Callback must be a function');
        events_array.forEach((ev)=>{
            if (!Object.hasOwn(this, 'subscribers')) this.subscribers = {};
            if (!this.subscribers[ev]) this.subscribers[ev] = [];
            if (!this.subscribers[ev].find((subscriber)=>subscriber.callback == callback)) this.subscribers[ev].push({
                callback: callback,
                once: once
            });
        });
    };
    target.unsubscribe = function(events_array, callback) {
        events_array.forEach((ev)=>{
            if (Object.hasOwn(this, 'subscribers') && this.subscribers[ev]) this.subscribers[ev].find((entry, index, array)=>{
                if (entry.callback == callback) array.splice(index, 1);
            });
        });
    };
    target.publish = function(event_name, ...args) {
        for(let index = 0; this.subscribers?.[event_name] && index < this.subscribers[event_name].length;){
            let entry = this.subscribers[event_name][index];
            setTimeout(()=>entry.callback(event_name, this, ...args), 0);
            if (entry.once) this.subscribers[event_name].splice(index, 1);
            else index++;
        }
    };
    return target;
}
var $5d515fcf43788f0e$export$2e2bcd8739ae039 = $5d515fcf43788f0e$var$pubsub;


function $4e674a4925cd65bb$export$2e2bcd8739ae039(...args) {
    return (0, $5d515fcf43788f0e$export$2e2bcd8739ae039)({
        captureEvents (_this = this) {
            _this.register(_this.getId()); // Need to be called with _this so pubsub registers the proper object 
            this.safeProtoCall(_this);
        },
        setValue (value, _this = this) {
            this.safeProtoCall(value, _this);
            _this.publish('change', value);
        }
    });
}


function $0b50ce47f660c06f$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'change'
        ],
        getValue (default_value = document.querySelector(this.selector + ' [checked]')?.value, _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        refresh () {
            let selected = this.getValue();
            let nodes = document.querySelectorAll(this.selector);
            nodes.forEach((node)=>{
                node.checked = node.value == selected;
            });
        },
        handleEvents (ev) {
            this.setValue(ev.target.value);
            this.refresh();
        }
    };
}


function $2c79fa51f8e681d4$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'change'
        ],
        getValue (default_value = document.querySelector(this.selector + ' [selected]')?.value ?? -1, _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        checkValue (value = this.getValue()) {
            return value != -1;
        },
        isEmpty (value = this.getValue()) {
            return value == -1;
        },
        refresh () {
            let node = document.querySelector(this.selector);
            if (!node) return;
            let value = this.getValue();
            let option = node.querySelector(`OPTION[value="${value}"]`);
            node.selectedIndex = option ? option.index : -1;
        },
        handleEvents (ev) {
            this.setValue(ev.target.value);
            this.refresh();
            this.checkErrorState();
        }
    };
}


function $ed60b42a52adaca6$export$2e2bcd8739ae039(...args) {
    return {
        display_mask (match) {
            return match.replaceAll('|', '\n');
        },
        setValue (value, _this = this) {
            this.safeProtoCall(value?.replaceAll('\n', '|'), _this);
        },
        handleEvents (ev, _this = this) {
            if (ev.type == 'keydown' && ev.key == 'Enter' && ev.ctrlKey) {
                let node = document.querySelector(this.selector);
                let cursor = node.selectionStart + 1;
                node.value = node.value.slice(0, node.selectionStart) + '\n' + node.value.slice(node.selectionEnd);
                node.setSelectionRange(cursor, cursor);
                ev.preventDefault();
                ev.stopPropagation();
            }
            this.safeProtoCall(ev, _this);
        }
    };
}


function $8a6cf87eb88dd049$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^([a-z]{3,10}(?:[_.][a-z]{3,10})?)$/i,
        setValue (value, _this = this) {
            this.safeProtoCall(value?.toLowerCase(), _this);
        }
    };
}



function $49ffe7e2640e6c04$export$2e2bcd8739ae039(...args) {
    return {
        // If source is indexed, index will be replaced by the index of the current selector.
        // Source can be a single string or an array of strings pointing to multiple sources
        _source: args[0],
        captureEvents (_this = this) {
            this.hook(); // Must come after register()
            this.safeProtoCall(_this);
        },
        hook () {
            let names = Array.isArray(this._source) ? this._source : [
                this._source
            ];
            names.forEach((name)=>{
                let id = this.makeId(name);
                let field = this.locate(id);
                if (!field) throw Error(`Not found: ${id}`);
                field.subscribe([
                    'change'
                ], this.actions.bind(this), false); // false: trigger always
            });
        },
        makeId (name) {
            let parts = this.getIdParts();
            let form = parts[1]; // 'form.'
            let index = parts[3]; // '-0'
            if (name.match((0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a))) name = (0, $a2e5868bc3913d81$export$77b8d1f921212127)(name, index.substr(1)); // 'name-0'
            return form + name; // 'form.name-0'
        },
        getIdParts () {
            return this.getId().match(/([^.]+\.)([^-]+)(-\d+)?/);
        },
        async preventMultiCalls (object, primary_callback, secondary_callback, ...args) {
            let is_datalist_indexed = (0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a).test(document.querySelector(this.selector).getAttribute('list'));
            let is_action_ongoing = Boolean(object._this);
            if (!is_datalist_indexed && is_action_ongoing) object._this.subscribe([
                'done'
            ], secondary_callback);
            else {
                object._this = this;
                await primary_callback(...args);
                if (!is_datalist_indexed) object._this.publish('done', ...args);
                object._this = null;
            }
        },
        actions () {
        // Tipos compostos (ex.: obs_load_options) sobrescrevem actions.
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");

function $820b09dd9a503dcf$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, key) {
            // key deve ser string não vazia ou número válido (IDBKeyRange não aceita null, undefined, array ou object)
            const valid = typeof key === 'string' && key !== '' || typeof key === 'number' && !isNaN(key) && key >= 0;
            if (!valid) return;
            let available = await (0, $1cmSR.default).list(this._store, IDBKeyRange.bound([
                key,
                ''
            ], [
                key,
                '\uffff'
            ]), this._index);
            let selected = (0, $7c7f18e63e55bfe1$export$98e6a39c04603d36)(this.form.getFieldBySelector(this.selector).getValue()).map((entry)=>String(entry));
            available = available.filter((entry)=>!selected.includes(String(this._values.map((key)=>entry[key]))));
            let options = await Promise.all((available ?? []).map((entry)=>this.makeOption(entry)));
            document.querySelector(`${this?.form.selector} ${this._target}`).innerHTML = options.join('\n');
        }
    };
}





var $1cmSR = parcelRequire("1cmSR");
function $9a739ce21637de64$export$2e2bcd8739ae039(...args) {
    let SHARED = {
        _this: null
    }; // Create a new object each time the function is called, ie when the type is being defined
    return {
        _store: args[0],
        _value: args[1]?.value || 'id',
        _labels: args[1]?.labels || [
            'name'
        ],
        _separator: args[1]?.sep,
        _filter: args[1]?.filter,
        _key: args[1]?.key,
        _range: args[1]?.range,
        _index: args[1]?.index,
        async actions (ev, publisher, key) {
            const action = async (keys)=>{
                let base_key = this._key ? [
                    ''
                ] : '';
                let top_key = this._key ? [
                    '\uffff'
                ] : '\uffff';
                let range = this._range ? IDBKeyRange.only([
                    ...keys
                ]) : IDBKeyRange.bound([
                    ...keys,
                    base_key
                ], [
                    ...keys,
                    top_key
                ]);
                let data = await (0, $1cmSR.default).list(this._store, range, this._index);
                if (this._filter) data = (data || []).filter(this._filter);
                (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, data, this._value, this._labels, this._separator);
                this.refresh();
            };
            let keys = [
                !isNaN(key) && !Array.isArray(key) ? Number(key) : key
            ];
            if (this._key) {
                if (this.getId().match((0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a)) && this._key.match((0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a))) this._key = (0, $a2e5868bc3913d81$export$77b8d1f921212127)(this._key, this.getId().match((0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a)).pop());
                let val = this.locate(this._key)?.getValue();
                // sessionStorage retorna strings; IndexedDB usa números em chaves compostas (company_id, etc.)
                keys.unshift(typeof val === 'string' && /^\d+$/.test(val) ? Number(val) : val);
            }
            // Só carrega se nenhuma chave for null/undefined/vazia (IDBKeyRange não aceita chaves inválidas)
            if (keys.length && keys.every((k)=>k != null && k !== '' && (typeof k === 'string' || typeof k === 'number' && !isNaN(k) && k >= 0))) this.preventMultiCalls(SHARED, action, ()=>this.refresh(), keys);
        }
    };
}



function $16a377ceff31a9ac$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: "N\xe3o"
            },
            {
                value: '1',
                label: 'Sim'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $040b19b92f93dc1d$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: ',',
                label: 'E'
            },
            {
                value: ';',
                label: 'Ou'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $0e8b2a0570db9b4e$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'eq',
                label: 'Igual a'
            },
            {
                value: 'ne',
                label: 'Diferente de'
            },
            {
                value: 'gt',
                label: 'Maior que'
            },
            {
                value: 'lt',
                label: 'Menor que'
            },
            {
                value: 'ge',
                label: 'Maior ou igual a'
            },
            {
                value: 'le',
                label: 'Menor ou igual a'
            },
            {
                value: 'si',
                label: 'Similar a'
            },
            {
                value: 'co',
                label: "Cont\xe9m"
            },
            {
                value: 'nc',
                label: "N\xe3o cont\xe9m"
            },
            {
                value: 'bw',
                label: 'Comece com'
            },
            {
                value: 'nb',
                label: "N\xe3o comece com"
            },
            {
                value: 'ew',
                label: 'Termine com'
            },
            {
                value: 'nd',
                label: "N\xe3o termine com"
            },
            {
                value: 'nu',
                label: "\xc9 nulo"
            },
            {
                value: 'nn',
                label: "N\xe3o \xe9 nulo"
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $730d3c6719ff7827$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1',
                label: "Produ\xe7\xe3o"
            },
            {
                value: '2',
                label: "Homologa\xe7\xe3o"
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $b537c438f09757c4$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'CIF'
            },
            {
                value: '1',
                label: 'FOB'
            },
            {
                value: '2',
                label: 'Terceiros'
            },
            {
                value: '3',
                label: "Pr\xf3prio/Remetente"
            },
            {
                value: '4',
                label: "Pr\xf3prio/Destinat\xe1rio"
            },
            {
                value: '9',
                label: 'Sem Transporte'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $7582832548ac84df$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1',
                label: 'Contribuinte'
            },
            {
                value: '2',
                label: 'Isento'
            },
            {
                value: '9',
                label: "N\xe3o Contribuinte"
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $8d2518aa0319bc23$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: '0: Nac'
            },
            {
                value: '1',
                label: '1: Imp Dir'
            },
            {
                value: '2',
                label: '2: Imp Adq Int'
            },
            {
                value: '3',
                label: '3: Nac c/Imp 40%-70%'
            },
            {
                value: '4',
                label: '4: Nac c/Ajustes'
            },
            {
                value: '5',
                label: '5: Nac c/Imp < 40%'
            },
            {
                value: '6',
                label: '6: Imp Dir CAMEX'
            },
            {
                value: '7',
                label: '7: Imp Adq Int CAMEX'
            },
            {
                value: '8',
                label: '8: Nac c/Imp > 70%'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $4fdbc437e912097f$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '01',
                label: 'Dinheiro'
            },
            {
                value: '03',
                label: "Cr\xe9dito"
            },
            {
                value: '04',
                label: "D\xe9bito"
            },
            {
                value: '15',
                label: 'Boleto'
            },
            {
                value: '16',
                label: "Dep\xf3sito"
            },
            {
                value: '17',
                label: 'Pix'
            },
            {
                value: '18',
                label: "Transfer\xeancia"
            },
            {
                value: '90',
                label: 'Sem Pagamento'
            },
            {
                value: '99',
                label: 'Outros'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $eaa7b296a57d850b$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'F',
                label: 'PF'
            },
            {
                value: 'J',
                label: 'PJ'
            },
            {
                value: 'G',
                label: 'OP'
            },
            {
                value: 'L',
                label: 'LOCAL'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $3f600b215d7c6f7e$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'Nenhum'
            },
            {
                value: '1',
                label: 'Presencial'
            },
            {
                value: '2',
                label: 'Internet'
            },
            {
                value: '3',
                label: 'Teleatendimento'
            },
            {
                value: '4',
                label: "Domic\xedlio"
            },
            {
                value: '5',
                label: 'Externo'
            },
            {
                value: '9',
                label: 'Outros'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $a3e4f853566e7a28$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'C',
                label: 'Caixa'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $2b0e90bfecbeac43$export$2e2bcd8739ae039(...args) {
    return {
        /*
		options: [
			{ value: 'AC', label: 'Acre' },
			{ value: 'AL', label: 'Alagoas' },
			{ value: 'AM', label: 'Amazonas' },
			{ value: 'AP', label: 'Amapá' },
			{ value: 'BA', label: 'Bahia' },
			{ value: 'CE', label: 'Ceará' },
			{ value: 'DF', label: 'Distrito Federal' },
			{ value: 'ES', label: 'Espírito Santo' },
			{ value: 'GO', label: 'Goiás' },
			{ value: 'MA', label: 'Maranhão' },
			{ value: 'MT', label: 'Mato Grosso' },
			{ value: 'MS', label: 'Mato Grosso do Sul' },
			{ value: 'MG', label: 'Minas Gerais' },
			{ value: 'PA', label: 'Pará' },
			{ value: 'PB', label: 'Paraíba' },
			{ value: 'PR', label: 'Paraná' },
			{ value: 'PE', label: 'Pernambuco' },
			{ value: 'PI', label: 'Piauí' },
			{ value: 'RN', label: 'Rio Grande do Norte' },
			{ value: 'RS', label: 'Rio Grande do Sul' },
			{ value: 'RJ', label: 'Rio de Janeiro' },
			{ value: 'RO', label: 'Rondônia' },
			{ value: 'RR', label: 'Roraima' },
			{ value: 'SC', label: 'Santa Catarina' },
			{ value: 'SP', label: 'São Paulo' },
			{ value: 'SE', label: 'Sergipe' },
			{ value: 'TO', label: 'Tocantins' },
		],
		*/ options: [
            {
                value: 'AC',
                label: 'AC'
            },
            {
                value: 'AL',
                label: 'AL'
            },
            {
                value: 'AM',
                label: 'AM'
            },
            {
                value: 'AP',
                label: 'AP'
            },
            {
                value: 'BA',
                label: 'BA'
            },
            {
                value: 'CE',
                label: 'CE'
            },
            {
                value: 'DF',
                label: 'DF'
            },
            {
                value: 'ES',
                label: 'ES'
            },
            {
                value: 'GO',
                label: 'GO'
            },
            {
                value: 'MA',
                label: 'MA'
            },
            {
                value: 'MT',
                label: 'MT'
            },
            {
                value: 'MS',
                label: 'MS'
            },
            {
                value: 'MG',
                label: 'MG'
            },
            {
                value: 'PA',
                label: 'PA'
            },
            {
                value: 'PB',
                label: 'PB'
            },
            {
                value: 'PR',
                label: 'PR'
            },
            {
                value: 'PE',
                label: 'PE'
            },
            {
                value: 'PI',
                label: 'PI'
            },
            {
                value: 'RN',
                label: 'RN'
            },
            {
                value: 'RS',
                label: 'RS'
            },
            {
                value: 'RJ',
                label: 'RJ'
            },
            {
                value: 'RO',
                label: 'RO'
            },
            {
                value: 'RR',
                label: 'RR'
            },
            {
                value: 'SC',
                label: 'SC'
            },
            {
                value: 'SP',
                label: 'SP'
            },
            {
                value: 'SE',
                label: 'SE'
            },
            {
                value: 'TO',
                label: 'TO'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}




var $beaf1c1fae4291ea$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#login .title
			{
				padding-bottom: var(--space-md);
				border-bottom: 1px solid var(--color-border);
			}
			#login label
			{
				display: block;
			}
			#login .tal { width: 70%; margin-left: auto; margin-right: auto; }
			#login #username,
			#login #password {
				width: 100%;
				box-sizing: border-box;
			}
			#login .login-logo-aws {
				display: none;
				margin-bottom: var(--space-md);
				text-align: center;
				padding: var(--space-sm) 0;
				width: 100%;
			}
			#login .login-logo-sial {
				display: block;
				margin-bottom: var(--space-md);
				text-align: center;
				padding: var(--space-sm) 0;
				width: 100%;
			}
			#login .login-logo-sial img {
				height: auto;
				max-height: 10rem;
				max-width: 100%;
				width: auto;
				object-fit: contain;
				background: transparent;
				display: block;
				margin: 0 auto;
			}
			#login .login-logo-aws img {
				height: auto;
				max-height: 7.5rem;
				max-width: 100%;
				width: auto;
				object-fit: contain;
				background: transparent;
				display: block;
				margin: 0 auto;
			}
		</style>
		<form id="login" class="form">
			<div id="login-logo-sial" class="login-logo-sial">
				<img src="/img/logo_sial_grey.png" alt="SIAL">
			</div>
			<div id="login-logo-aws" class="login-logo-aws">
				<img src="img/sessp.png" alt="Secretaria da Sa\xfade - Governo de SP">
			</div>
			<div class="title">
				Autentica\xe7\xe3o
				<span id="login-env-badge"></span>
			</div>
			<div class="tal mtl">
				<label>Usu\xe1rio
					<input id="username" name="username" type="text">
				</label>
				<label>Senha
					<input id="password" name="password" type="password">
				</label>
			</div>
			<div class="fsb mtl">
				<a class='bn_Link link'>Alterar a Senha</a>
				<button class='bn_Enter button'>Acessar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#login',
        init (formset) {
            this.setValues({
                'login.password': null
            });
            const badge = document.getElementById('login-env-badge');
            if (badge) {
                const h = window.location.hostname;
                const isQA = h === '54.207.230.11' || h === 'qa.sialwms.com.br';
                const isDev = h === 'localhost' && window.location.port === '8001';
                const baseStyle = 'margin-left: 0.5rem; padding: 0.15rem 0.5rem; border-radius: 4px; font-size: 0.75rem; font-weight: bold;';
                if (isQA) {
                    badge.textContent = 'AMBIENTE DE TESTE';
                    badge.style.cssText = baseStyle + ' background: #2196f3; color: #fff;';
                } else if (isDev) {
                    badge.textContent = 'AMBIENTE DEV';
                    badge.style.cssText = baseStyle + ' background: #ff9800; color: #000;';
                }
            }
            // Logo SIAL (sempre visível) e logo AWS/SESSP (apenas em ambientes específicos)
            const logoEl = document.getElementById('login-logo-sial');
            const logoAwsEl = document.getElementById('login-logo-aws');
            if (logoAwsEl) {
                const h = window.location.hostname;
                const isAws = h === '54.207.230.11' || h === '177.71.248.43' || h.includes('amazonaws') || h.includes('sial.ibl') || h.endsWith('sialwms.com.br');
                logoAwsEl.style.display = isAws ? 'block' : 'none';
            }
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#username'
            }
        },
        {
            properties: {
                selector: '#password'
            },
            types: [
                $dfd33cae850bb039$export$2e2bcd8739ae039()
            ]
        }
    ]
};



var $cecdd6f97dca9a20$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#request .title
			{
				padding-bottom: var(--space-md);
				border-bottom: 1px solid var(--color-border);
			}
			#request label
			{
				display: block;
			}
			#request #username	{ width: 14rem; }
			#request #channel 	{ width: 14rem; }
		</style>
		<form id="request" class="form">
			<div class="title">
				Atualiza\xe7\xe3o de Senha
			</div>
			<div class="tal mtl">
				<label>Informe seu usu\xe1rio
					<input id="username" name="username" type="text" required>
				</label>
				<label>Receber token via
					<select id="channel" name="channel" required>
						<option value="1">Email</option>
						<option value="2">WhatsApp</option>
					</select>
				</label>
			</div>
			<div class="mtl">
				<button class='bn_Escape button'>Voltar</button>
				<button class='bn_Enter button'>Enviar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#request'
    },
    fields: [
        {
            properties: {
                selector: '#username'
            }
        },
        {
            properties: {
                selector: '#channel'
            }
        }
    ]
};



const $ef33fadb70b8678b$var$handler = function(key) {
    switch(key){
        case 'Link':
            $ef33fadb70b8678b$var$auth.request();
            break;
    }
};
const $ef33fadb70b8678b$var$auth = {
    login (callback) {
        let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $beaf1c1fae4291ea$export$2e2bcd8739ae039), async (data)=>{
            if (await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).auth, data.username, data.password)) {
                sessionStorage.username = data.username;
                fs.destroy();
                callback?.();
            }
        }, $ef33fadb70b8678b$var$handler);
        fs.init();
    },
    logout () {
        (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)('Deseja sair?', "Confirma\xe7\xe3o", async (answer)=>{
            if (answer == 'Y') {
                delete sessionStorage.username;
                location.reload();
            }
        });
    },
    request () {
        let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $cecdd6f97dca9a20$export$2e2bcd8739ae039), async (data)=>{
            if (await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).request_password, data)) {
                fs.destroy();
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Verifique o link recebido', 'Sucesso');
            }
        });
        fs.init();
    }
};
var $ef33fadb70b8678b$export$2e2bcd8739ae039 = $ef33fadb70b8678b$var$auth;


const $a020c0121b2250d6$var$ROUTES = [];
const $a020c0121b2250d6$var$router = {
    init () {
        window.addEventListener('hashchange', this.route);
    },
    set (hash, callback) {
        let index = $a020c0121b2250d6$var$ROUTES.findIndex((route)=>route.hash == hash);
        $a020c0121b2250d6$var$ROUTES[index < 0 ? $a020c0121b2250d6$var$ROUTES.length : index] = {
            'hash': hash,
            'callback': callback
        };
    },
    route (ev) {
        let hash = ev?.newURL?.slice(ev.newURL.indexOf('#')) || ev || location.hash;
        $a020c0121b2250d6$var$ROUTES.filter((entry)=>entry.hash == hash).forEach((entry)=>entry.callback());
    }
};
var $a020c0121b2250d6$export$2e2bcd8739ae039 = $a020c0121b2250d6$var$router;



var $1cmSR = parcelRequire("1cmSR");
var $a6c3e59798a8ecf3$export$2e2bcd8739ae039 = (username)=>`<div id="header" class="fsb">
	<span>
		<img src="img/logo_h1.png">
		<img src="img/logo_h2.png">
	</span>
	<span>
		<ul class="menu">
			<li>Organiza\xe7\xe3o
				<ul>
					<li hash="#companies">Empresas</li>
					<li hash="#suppliers">Fornecedores</li>
					<li hash="#customers">Clientes</li>
					<li hash="#carriers">Transportadores</li>
					<li hash="#devices">Dispositivos</li>
				</ul>
			</li>
			<li>Cat\xe1logo
				<ul>
					<li hash="#units">Unidades&nbsp;de&nbsp;Medida</li>
					<li hash="#classes">Classes</li>
					<li hash="#categories">Categorias</li>
					<li hash="#manufacturers">Fabricantes</li>
					<li hash="#programs">Programas</li>
					<li hash="#products">Produtos&nbsp;e&nbsp;Classifica\xe7\xf5es</li>
					<li hash="#product-packagings">Embalagens&nbsp;de&nbsp;Produto</li>
				</ul>
			</li>
			<li>Armazenamento
				<ul>
					<li hash="#warehouses">Armaz\xe9ns</li>
					<li hash="#locations">Posi\xe7\xf5es</li>
					<li hash="#stocks">Estoques</li>
					<li hash="#transactions">Transa\xe7\xf5es</li>
					<li hash="#inventories">Invent\xe1rios</li>
					<li hash="#replenishments">Ressuprimentos</li>
				</ul>
			</li>
			<li>Movimenta\xe7\xe3o
				<ul>
					<li hash="#input-orders">Pedidos&nbsp;de&nbsp;Entrada</li>
					<li hash="#receipt-types">Tipos&nbsp;de&nbsp;Recebimento</li>
					<li hash="#output-orders">Pedidos&nbsp;de&nbsp;Sa\xedda</li>
					<li hash="#inputs">Entradas</li>
					<li hash="#lots">Lotes</li>
					<li hash="#outputs">Sa\xeddas</li>
				</ul>
			</li>
			<li>Comercial
				<ul>
					<li hash="#price-lists">Listas&nbsp;de&nbsp;Pre\xe7os</li>
					<li hash="#payment-terms">Condi\xe7\xf5es&nbsp;de&nbsp;Pagamento</li>
					<li hash="#cfops">CFOPs</li>
				</ul>
			</li>
			<li>Faturamento
				<ul>
					<li hash="#invoices">Notas&nbsp;Fiscais</li>
					<li hash="#invoice-lots">Lotes&nbsp;de&nbsp;Notas</li>
				</ul>
			</li>
			<li>Sistema
				<ul>
					<!-- <li hash="#endpoints">Endpoints&nbsp;da&nbsp;API</li> -->
					<li hash="#import-center">Central&nbsp;de&nbsp;Importa\xe7\xe3o</li>
					<li hash="#groups">Grupos&nbsp;e&nbsp;Permiss\xf5es</li>
					<li hash="#users">Usu\xe1rios&nbsp;e&nbsp;Associa\xe7\xf5es</li>
					<li hash="#logs">Auditoria&nbsp;de&nbsp;Eventos</li>
					<li hash="#integration-events">Central&nbsp;de&nbsp;Integra\xe7\xf5es</li>
					<li hash="#logout">Logout&nbsp;do&nbsp;Usu\xe1rio</li>
					<li hash="#about">Sobre o Sistema</li>
				</ul>
			</li>
		</ul>
		<div id="identification">
			Usu\xe1rio: ${username}
		</div>
	</span>
</div>
<div id="workarea">
</div>`;



var $8027b5f9052bcf5e$export$2e2bcd8739ae039 = '0.3.46';



/**
 * Changelog - todas as mudanças sem limite.
 * Formato: [modulo] [função] - {breve descrição}
 * Seções vazias: -----
 *
 * ⚠️ ANTES DE EDITAR: rodar no terminal: Get-Date -Format "dd/MM/yyyy"
 *    Usar a data retornada. Nunca confiar em data de contexto.
 */ var $36a7dfe577885f1c$export$2e2bcd8739ae039 = [
    {
        date: '27/03/2026',
        changes: [
            "[MIGRA\xc7\xc3O] 031 \u2014 colunas de par\xe2metros por empresa: invent\xe1rio (inv_allow_expired, inv_require_lot, inv_by_program, inv_class_blocking, inv_conference_tolerance) e embalagens/picking (pkg_use_hierarchy, pkg_unitarization_enabled, pkg_optimize_picking, pkg_allow_tertiary_break, pkg_allow_secondary_break, pkg_validate_gtin, pkg_rollback_legacy); tabela product_packagings + \xedndices \xfanicos (produto+c\xf3digo ativo, GTIN ativo)",
            "[MIGRA\xc7\xc3O] 032 \u2014 endpoints REST de embalagens (/packagings, CRUD por empresa/produto) e permiss\xf5es no grupo Administradores",
            "[EMPRESAS] Entidade Company \u2014 leitura/grava\xe7\xe3o dos par\xe2metros operacionais (invent\xe1rio + embalagens) alinhados \xe0 migra\xe7\xe3o 031",
            "[EMPRESAS] Service update/patch \u2014 PUT sem objeto address n\xe3o apaga endere\xe7o j\xe1 salvo (_COMPANY_ADDRESS_OMIT); front espelha omit de endere\xe7o ao salvar",
            "[EMPRESAS] Formul\xe1rio \u2014 fieldset Par\xe2metros Operacionais com toggles e toler\xe2ncia; bot\xe3o ? com textos de ajuda (invent\xe1rio, hierarquia, picking, GTIN, rollback legado)",
            "[PRODUTOS] Entidade Product \u2014 mensagens e documenta\xe7\xe3o em c\xf3digo: campos master_* tratados como medidas da embalagem terci\xe1ria (r\xf3tulos ES/ET na UI; schema/API mant\xe9m master_*)",
            "[PRODUTOS] Formul\xe1rio em abas com ajuda (?) por aba; painel Armazenagem com tabela embutida de embalagens do produto (fetch por produto, Atualizar lista); estilos pill/tabela rol\xe1vel",
            "[PRODUTOS] UX \u2014 Salvar com destaque verde; Inativar/desabilitar com estilo de a\xe7\xe3o destrutiva (vermelho) onde aplic\xe1vel",
            "[EMBALAGENS] Dom\xednio completo: entity ProductPackaging (n\xedveis P/S/T, fator, GTIN, qr_code, tertiary_capacity, padr\xe3o/inativo); repo com trigger set_serial_id, _ensure_id_sequence + setval para empresas antigas sem sequ\xeancia",
            "[EMBALAGENS] API routes product_packagings.py \u2014 list global, por produto, CRUD; servi\xe7o insert/update/patch/delete + insert_or_update para importa\xe7\xe3o e upsert por c\xf3digo",
            "[EMBALAGENS] Front \u2014 crud product-packagings, menu Cat\xe1logo > Embalagens de produto; IndexedDB store product_packagings; endpoint-function-groups inclui /packagings em Cat\xe1logo",
            "[EMBALAGENS] Form product-packagings \u2014 campos empresa/produto/c\xf3digo/n\xedvel/fator/cap. terci\xe1ria/GTIN/QR; hints de QR; checkboxes Padr\xe3o/Inativa",
            "[EMBALAGENS] Central de importa\xe7\xe3o \u2014 chave packagings; colunas Empresa_ID, Produto_ID, C\xf3digo, N\xedvel, Fator, GTIN, QR Code, Capacidade terci\xe1ria, Padr\xe3o, Inativo; valida\xe7\xe3o GTIN \xfanico e exist\xeancia de produto",
            "[SA\xcdDAS] Outputs service \u2014 inje\xe7\xe3o de product_packagings: plano de embalagem (_build_packaging_plan), regras de quebra/unitariza\xe7\xe3o por par\xe2metros da empresa; estat\xedsticas de pedido com coluna Embalagem sugerida (output-orders-output-stats)",
            "[TRANSPORTADORES] update/insert_or_update \u2014 omiss\xe3o de address no PUT n\xe3o zera endere\xe7o (_CARRIER_ADDRESS_OMIT), espelhando empresas",
            "[IMPORTA\xc7\xc3O] Central \u2014 ajuda (?) por passo, notify em vez de alert, bot\xf5es prim\xe1rios (Validar/Importar/Nova importa\xe7\xe3o) e Voltar neutro; CSV com separador ;",
            "[INTEGRA\xc7\xd5ES] TechHub-IBL \u2014 m\xf3dulo dedicado (webhook, pull invoices, process, status flush, push produtos/fatura-itens, health, mappings); tabelas inbox/outbox/local_origins; migra\xe7\xe3o 030 + eventos em integration_events; feature flags TECHHUB_IBL_* (#MT-E29D475, doc ENTREGA-MT-E29D475-TECHHUB-IBL.md)",
            "[INTEGRA\xc7\xd5ES] Hook after_request \u2014 mirror_authenticated_integration_request: tr\xe1fego de clientes tipo integra\xe7\xe3o (ex. python-requests) gravado em integration_events (desabilitar SIAL_MIRROR_INTEGRATION_EVENTS=0)",
            "[API/CONFIG] getSialApiHost em api.js para consumidores que precisam da base sem duplicar l\xf3gica de HOST",
            "[DEPLOY] PRD-VPN \u2014 deploy-evento-prd-vpn-segunda.ps1 e run-deploy-evento-prd-vpn-segunda.ps1 (pacote corre\xe7\xf5es \u2192 deploy-full; AWS/SESSP em fluxo separado)"
        ]
    },
    {
        date: '24/03/2026',
        changes: [
            "[INTEGRA\xc7\xd5ES] Central \u2014 tabela integration_events, GET/POST /integration-events, listagem leve sem JSONB pesado; seed + migra\xe7\xe3o 029; api list/select/insert (#MT-6531173)"
        ]
    },
    {
        date: '23/03/2026',
        changes: [
            "[TRANSPORTADORES] Cadastro \u2013 armazena NULL em cpf/cnpj quando o campo n\xe3o se aplica (PJ\u2192cpf NULL, PF\u2192cnpj NULL), evitando viola\xe7\xe3o da constraint carriers_cpf ao cadastrar m\xfaltiplos transportadores PJ",
            "[NF-E] Transportador \u2013 CNPJ/CPF enviados sem formata\xe7\xe3o (apenas d\xedgitos) para conformidade com o XSD da SEFAZ ([0-9]{14}/[0-9]{11})",
            "[PEDIDOS SA\xcdDA] Relat\xf3rio de Pend\xeancias \u2013 refatora\xe7\xe3o da query: agregar itens do pedido antes do JOIN com fornecido para evitar duplica\xe7\xe3o; Qtde Forn exclusivamente de output_items (Sa\xedda) e Qtde Solic de output_order_items (Espelho), alinhando relat\xf3rios",
            "[PEDIDOS SA\xcdDA] Relat\xf3rio de Pend\xeancias \u2013 corre\xe7\xe3o do fornecido quando pedido usa partial_sku e sa\xedda registra produto filho/variante (match por SKU al\xe9m de product_id)",
            "[PEDIDOS SA\xcdDA] Relat\xf3rio de Pend\xeancias \u2013 corre\xe7\xe3o array_length(partial_sku): garantir tipo text[] na CTE e verifica\xe7\xe3o NULL antes de chamar array_length",
            "[PEDIDOS SA\xcdDA] Relat\xf3rio de Pend\xeancias \u2013 considera apenas sa\xeddas conferidas (status >= Conferido) para Qtde Forn; alinha com AR (Solicitado \u2212 Enviado = Pend\xeancias)",
            '[UI] Indicador de carregamento \u2013 spinner circular azul + texto "Carregando..." (substitui favicon girando nas requisi\xe7\xf5es)',
            "[SA\xcdDAS] Aviso de Remessa \u2013 incluir n\xfamero do pedido SIAL na se\xe7\xe3o Transportadora (#MT-8BEF169)"
        ]
    },
    {
        date: '20/02/2025',
        changes: [
            '[PEDIDOS SA\xcdDA] Status 30 exibido como "Parcialmente atendido" (UI e relat\xf3rios); documenta\xe7\xe3o BI em doc/Analises/BI-PEDIDOS-SAIDA-PARCIAIS.md (status=30 + endpoint /pending para itens n\xe3o atendidos)',
            "[PEDIDOS SA\xcdDA] Espelho de Pedido \u2013 logo SIAL (logo_h1.png) no cabe\xe7alho do PDF quando a empresa n\xe3o possui logo cadastrado",
            '[NF-E] Local de Entrega \u2013 bloco "Informa\xe7\xf5es do local de Entrega" exibido apenas quando o endere\xe7o de entrega for diferente do endere\xe7o de faturamento (#MT-2932728)',
            "[TRANSPORTADORES] Cadastro \u2013 submit pr\xf3prio (submitHandler) sem depender de formset global; normaliza\xe7\xe3o Tipo (PJ\u2192J, PF\u2192F) e Tipo IE (Contribuinte\u21921, Isento\u21922, N\xe3o Contribuinte\u21929) para a API; rota aceita company_id por nick (LLT) com resolu\xe7\xe3o para UUID; seed_db.py --endpoints-only para atualizar permiss\xf5es do grupo Administradores"
        ],
        add: [
            "[SEED] Op\xe7\xe3o --endpoints-only em seed_db.py para inserir endpoints faltantes e atribuir ao grupo Administradores (corrige 403 em Transportadores e outros)"
        ],
        bugfix: [
            "[NF-E] Evita duplicar destinat\xe1rio e local de entrega na nota quando endere\xe7os s\xe3o iguais (#MT-2932728)",
            "[TRANSPORTADORES] 400 tipo/ie_type \u2013 envio de c\xf3digos (J, 1/2/9) em vez de labels (PJ, Contribuinte); auth aceita company nick na URL"
        ]
    },
    {
        date: '18/03/2026',
        changes: [
            "[PROTHEUS] Integra\xe7\xe3o SIAL \u2192 Protheus \u2013 envio de order_ids em lotes de 100 para API SIAL (evita Invalid request e restaura envio ao WS-DG3)"
        ],
        add: [
            "[INFRA] Deploy Protheus \u2013 script deploy-protheus-vpn.ps1 (SCP + build no servidor ou build local + ECR push, restart container em 10.10.0.203)"
        ],
        bugfix: [
            "[PROTHEUS] Dockerfile \u2013 chmod +x em src/entrypoint para container iniciar corretamente (permission denied)"
        ]
    },
    {
        date: '13/03/2026',
        changes: [
            "[SA\xcdDAS] Confer\xeancia \u2013 relat\xf3rio com layout igual ao picking (Dados Opera\xe7\xe3o, Depositante, Destinat\xe1rio, tabela itens Qt Req/Forn/OK/Falta/Sobra, rodap\xe9 conferente) (#MT-271C982)",
            "[ENTRADAS] Confer\xeancia \u2013 relat\xf3rio reformulado com mesmo layout da confer\xeancia de sa\xedda (#MT-271C982)",
            "[SA\xcdDAS] Derrubada de Pallets \u2013 numera\xe7\xe3o por pedido (pedido X - P\xe1gina N de M), rodap\xe9 Sistema SIAL (#MT-271C982)",
            "[DANFE] Layout Protheus \u2013 coluna por campo, descri\xe7\xe3o completa sem corte, Lote/Validade em linhas separadas, quebra de p\xe1gina em dados adicionais (#MT-765B153)",
            "[SA\xcdDAS] Etiquetas de expedi\xe7\xe3o \u2013 apenas sa\xeddas com status Conferida podem gerar etiquetas (#MT-7003556)",
            "[GRID] Checkbox n\xe3o persistente \u2013 desmarca ao recarregar p\xe1gina ou ao executar a\xe7\xe3o; evita itens marcados sem visualiza\xe7\xe3o (#MT-E231871)",
            "[PICKING/FEFO] Itens vencidos exclu\xeddos do motor \u2013 nunca participam da separa\xe7\xe3o; lotes a 30 dias do vencimento bloqueados automaticamente via batch (#MT-38B8742)"
        ],
        add: [
            "[BATCH] block_expiring_lots \u2013 bloqueia lotes vencidos ou a 30 dias do vencimento; rodar diariamente via cron"
        ],
        bugfix: [
            "[CONFER\xcaNCIA ENTRADA] unhashable type list \u2013 sku (TEXT[]) convertido para string antes de uso como chave (#MT-271C982)",
            "[CONFER\xcaNCIA SA\xcdDA] 403 \u2013 endpoint /outputs/print-conference adicionado \xe0 migra\xe7\xe3o 014",
            "[DERRUBADA PALLETS] location nulo \u2013 tratamento defensivo; endpoint na migra\xe7\xe3o 014"
        ]
    },
    {
        date: '12/03/2026',
        changes: [
            "[IMPORTA\xc7\xc3O] Planilha de clientes \u2013 colunas adicionais (endere\xe7o, Prazo_Entrega, Condicao_Pagto_ID, Lista_Precos_ID, Consumidor); suporte tipo L com c\xf3digo GSNet; linhas de instru\xe7\xe3o no template (#MT-F037963)",
            "[CLIENTES] Relat\xf3rio de Cadastro \u2013 menu Imprimir, filtros (Empresa, Estado, Tipo, Tipo IE, Consumidor), layout tipo AR com logo SIAL (#MT-A082998)",
            "[CLIENTES] Adequa\xe7\xe3o CNPJ para GSNet \u2013 tipo Local aceita c\xf3digo GSNet; Condi\xe7\xe3o de Pagamento opcional e readonly; payment_term_id nulo ao salvar; mesclagem de endere\xe7os billing/delivery (#MT-59A4923)",
            "[CADASTROS] Consulta CEP \u2013 ao sair do campo CEP (blur), busca ViaCEP e preenche logradouro, bairro, UF e munic\xedpio (Clientes, Empresas, Fornecedores, Transportadores)",
            "[CADASTROS] Campo Munic\xedpio \u2013 \xedndice expl\xedcito para carga de cidades por UF (persist\xeancia correta)"
        ],
        add: [],
        bugfix: []
    },
    {
        date: '11/03/2026',
        changes: [
            "[PEDIDOS SA\xcdDA] Upload de planilha \u2013 pedido criado com todos os itens (incl. sem estoque); relat\xf3rio mant\xe9m sem_estoque e pendentes apenas para informa\xe7\xe3o (#MT-25FE283)"
        ],
        add: [],
        bugfix: [
            "[CAT\xc1LOGO] PRODUTOS \u2013 filtro passa a injetar par\xe2metro na API (await em addFilter; preventDefault no form de filtro)"
        ]
    },
    {
        date: '10/03/2026',
        changes: [
            "[SA\xcdDAS] Modal Resultados \u2013 completo com Cliente, Pedido, Transportador, Programa, % atendimento, posi\xe7\xf5es e tabela de itens (SKU, Nome, Lote, Unidade, Solicitado, Atendido, %, Posi\xe7\xe3o)",
            "[SISTEMA] CENTRAL DE IMPORTA\xc7\xc3O \u2013 importa\xe7\xe3o completa: Clientes, Fornecedores, Transportadores, Fabricantes, Programas, Produtos, Posi\xe7\xf5es (CSV/XLSX, valida\xe7\xe3o, importa\xe7\xe3o)",
            "[FATURAMENTO] Relat\xf3rio IQVIA \u2013 campo data em texto (dd/mm/aaaa), per\xedodo data in\xedcio e data fim (opcional)",
            "[AUTH] Mensagem 403 \u2013 indica endpoint faltante (m\xe9todo + path) e termo de busca para Sistema > Grupos (search_hint em portugu\xeas)",
            '[SISTEMA] GRUPOS \u2013 \xedcones de inclus\xe3o/exclus\xe3o de endpoints e empresas substitu\xeddos por "\u2190 Incluir" e "Remover \u2192"',
            "[PEDIDOS SA\xcdDA/ENTRADA] Upload de planilha \u2013 colunas SKU, Quantidade, Pre\xe7o/Vlr; CSV ou XLSX; relat\xf3rio com SKU n\xe3o encontrado (vlr vazio), sem estoque e pendentes (#MT-25FE283)",
            "[PEDIDOS SA\xcdDA] Valor total do pedido passa a considerar desconto por item (pre\xe7o \xd7 (1 - % desc))",
            "[PEDIDOS SA\xcdDA] Coluna % Desconto na listagem: m\xe9dia ponderada dos itens quando header vazio; exibe 0,00 quando zero",
            "[TABELA PRE\xc7OS] Tabela por cliente: campo desconto geral no header vazio ao abrir (evita sobrescrever desconto por item ao salvar)",
            "[PEDIDOS SA\xcdDA] Formul\xe1rio: n\xe3o preenche pre\xe7o em linhas sem produto; desconto por item persistido ao salvar"
        ],
        add: [],
        bugfix: [
            "[PICKING] partial_sku vazio \u2013 pedidos com 90% estoque apareciam 0,3% atendimento; corre\xe7\xe3o SQL (LIKE s\xf3 quando partial_sku preenchido)",
            "[ESTOQUE] Tratamento de lotes em nota\xe7\xe3o cient\xedfica (E/D) em versa/misc.js e order_upload",
            "[PEDIDOS SA\xcdDA] obs_price: pre\xe7o 9.999 em linhas vazias \u2013 usar value como product_id s\xf3 quando mudan\xe7a veio do campo produto",
            "[PEDIDOS SA\xcdDA] Salvamento: ignorar itens sem product_id; envio correto de desconto (null quando vazio)",
            "[API] OutputOrder.set_items: c\xe1lculo de value e discount em Decimal (evita erro Decimal * float na listagem)"
        ]
    },
    {
        date: '09/03/2026',
        changes: [
            "[CAT\xc1LOGO] PRODUTOS \u2013 formul\xe1rio em abas (Dados, Armazenagem, Tributa\xe7\xe3o); campos Portaria 344 na aba Armazenagem",
            "[CAT\xc1LOGO] PRODUTOS \u2013 modal tamanho fixo; abas com estilo pill; Portaria 344, Embalagens e Classifica\xe7\xf5es em Armazenagem",
            "[API] Produtos: is_portaria_344, portaria_344_list | Pedidos de sa\xedda: book_observation (#MT-6C6F740)",
            "[FILTRO] Empresas - usar UUID como value no dropdown (em vez de nick); deduplicar op\xe7\xf5es",
            '[FILTRO] resolveFilterLabelsToIds - resolver labels para IDs antes das queries (company, warehouse, program, position)',
            "[LAYOUT] \xcdcone de loading - tamanho 25\xd725px"
        ],
        add: [],
        bugfix: [
            '[ESTOQUE] FILTRO EMPRESA - enviar UUID em vez de nome para API (corrige filtro "Maternidade - Amil 2")'
        ]
    },
    {
        date: '09/03/2026',
        changes: [
            "[ESTOQUES] Tela n\xe3o carrega mais automaticamente - usu\xe1rio deve clicar em Filtrar e Aplicar (ou aplicar filtros) para carregar dados",
            "[ESTOQUES] Relat\xf3rios (SKU, Lote, Posi\xe7\xe3o) - modal para definir filtros e formato (PDF/CSV) antes de gerar",
            "[ESTOQUES] Relat\xf3rios - exporta\xe7\xe3o em PDF e CSV"
        ],
        add: [],
        bugfix: []
    },
    {
        date: '08/03/2026',
        changes: [
            "[ESTOQUE] FILTRO POSI\xc7\xc3O - filtrar por Empresa e Armaz\xe9m, ordenar por endere\xe7o, recarregar locations ao alterar escopo (MT-596E375)",
            "[ESTOQUE] FILTRO POSI\xc7\xc3O - resolver label para warehouse_id:location_id; warehouse/company por nome (resolveFilterLabelsToIds)",
            "[LAYOUT] Grid - cor de hover nas c\xe9lulas da tabela alterada para #e9dbfd"
        ],
        add: [],
        bugfix: [
            "[ESTOQUE] FILTRO POSI\xc7\xc3O - posi\xe7\xf5es desordenadas e troca de valor ao selecionar; valor warehouse_id:location_id correto na API"
        ]
    },
    {
        date: '06/03/2026',
        changes: [
            "[LAYOUT] Tema claro - fundo branco, vari\xe1veis de cor (--color-primary, --color-box, etc.)",
            "[LOGIN] Logo SIAL (logo_sial_grey.png) na tela de autentica\xe7\xe3o",
            '[SOBRE] Logo MachadoTec ao lado do SIAL; texto "MachadoTec Software Solutions"',
            '[LOGOS] Atualizados logo_h1, logo_h2, logo_v, logo_sial, logo_machadotec (fundo branco)',
            "[RECUPERA\xc7\xc3O SENHA] Fluxo completo: POST /auth/requests, GET /auth/reset-form, POST /auth/resets",
            '[DEPLOY] deploy-full e deploy-recuperacao-senha-vpn - templates copiados para /home/sial/config/'
        ],
        add: [
            "[AUTH] Recupera\xe7\xe3o de senha - templates HTML e-mail/formul\xe1rio, logo no e-mail",
            "[DEPLOY] deploy-recuperacao-senha-vpn.ps1 - script dedicado para deploy da recupera\xe7\xe3o de senha"
        ],
        bugfix: [
            "[AUTH] KeyError reset_base_url - valida\xe7\xe3o e mensagem clara quando config [auth] incompleto",
            "[AUTH] Template n\xe3o encontrado - fallback para /config/ (mesmo dir do config.ini)"
        ]
    },
    {
        date: '03/03/2026',
        changes: [
            "[SA\xcdDAS] PICK LIST - novo layout (REFER\xcaNCIA, 3 blocos, QR, SKU destacado, cod. cliente, lote fab) - Chamado #MT-C120592",
            "[SA\xcdDAS] AVISO REMESSA - campo Observa\xe7\xf5es do pedido inclu\xeddo no documento - Chamado #MT-234E920"
        ],
        add: [
            '[TRANSPORTADORES] Modo local de entrega - flag para cadastro simplificado (CPF/CNPJ/IE opcionais, tipo LOCAL) - Chamado #MT-72C8316',
            "[FATURAMENTO] NOTAS FISCAIS - Opera\xe7\xf5es > Inutilizar NF (s\xe9rie, faixa, justificativa) - Chamado #MT-FE53820",
            '[FATURAMENTO] NOTAS FISCAIS - coluna Inutilizada exibe protocolo SEFAZ',
            "[FATURAMENTO] NOTAS FISCAIS - evento de Inutiliza\xe7\xe3o na tabela de protocolos do detalhe",
            "[NFE] NF-E ATIVO IMOBILIZADO - p\xe1gina /nfe-ativo-imobilizado (Chamado #MT-5EA7507)"
        ],
        bugfix: [
            "[FORMS] Carriers - corre\xe7\xe3o querySelector no init do formul\xe1rio",
            '[NFE] Faturamento - transporta sem CPF/CNPJ quando transportador em modo local de entrega'
        ]
    },
    {
        date: '02/03/2026',
        changes: [
            "[SA\xcdDAS] ETIQUETAS EXPEDI\xc7\xc3O - QR code ^FO600,420^BQN,4,4",
            "[SA\xcdDAS] PICKLIST - contador p\xe1gina individual por pedido (1/2, 2/2)",
            '[ESTOQUE] VIEW - colunas Nota Entrada e Fornecedor',
            "[SA\xcdDAS] VIEW - coluna Refer\xeancia e filtro",
            "[SA\xcdDAS] AVISO REMESSA - layout reformulado, itens em ordem alfab\xe9tica",
            "[NFE] CFOPS - opera\xe7\xf5es de fiel deposit\xe1rio (5905, 5906, 5907, etc.)"
        ],
        add: [
            "[MIGRA\xc7\xc3O] 016 - desabilitar armaz\xe9ns RVD-AMIL-1 e RVD-AMIL-2",
            '[ENTRADAS] ETIQUETAS - separador "FIM DE LOTE" entre lotes',
            "[ENTRADAS] RELAT\xd3RIO - Entrada Detalhada (NF, Data Entrada, SKU, Lote, Fab, Val)"
        ],
        bugfix: [
            "[API] INPUTS.inventory - program_id opcional (ColetorPWA confer\xeancia entrada)",
            '[API] OUTPUTS.update/patch - aceitar program_id e reference (ColetorPWA)',
            "[API] INPUTS.putaway - aceitar program_id (endere\xe7amento ColetorPWA/SIAL)",
            "[API] OUTPUTS print-picklists - fun\xe7\xe3o duplicada corrigida",
            "[API] OUTPUTS separa\xe7\xe3o - status n\xe3o vai mais para CONFERIDO ao finalizar"
        ]
    },
    {
        date: '25/02/2026',
        changes: [
            "[AVISO REMESSA] LAYOUT - assinatura na mesma p\xe1gina que a tabela"
        ],
        add: [],
        bugfix: [
            '[API] OUTPUTS - query com subselect para program_id (corrige ColetorPWA)',
            "[RELAT\xd3RIO CONFER\xcaNCIA] SQL - verified_user.nick \u2192 verified_user.name"
        ]
    },
    {
        date: '19/02/2026',
        changes: [
            "[SA\xcdDAS] PROGRAMA - coluna, filtro e detalhe",
            "[PEDIDOS SA\xcdDA] PROGRAMA - coluna e filtro",
            '[PEDIDOS ENTRADA] PROGRAMA - coluna, filtro e campo',
            '[ENTRADAS] PROGRAMA - coluna, filtro e detalhe',
            '[ESTOQUE] VIEW - detalhes e novas colunas (SKU, NCM, EAN, Programa)',
            '[ESTOQUE] MOD - somente consulta, sem Inserir',
            "[MOVIMENTA\xc7\xc3O] MOVE - Lote e posi\xe7\xe3o origem readonly"
        ],
        add: [
            "[MIGRA\xc7\xc3O] 013 - saneamento program_id com programa padr\xe3o",
            '[PEDIDOS] OUTPUT/INPUT - default programa no insert',
            "[CONFER\xcaNCIA] RELAT\xd3RIO - relat\xf3rio de confer\xeancia (esperado x conferido)",
            "[SOBRE] CHANGELOG - hist\xf3rico dos \xfaltimos 10 dias"
        ],
        bugfix: [
            "[COMPANIES] LIST_ALL - aceitar par\xe2metro include_disabled",
            "[SA\xcdDAS] ETIQUETAS - corre\xe7\xe3o na impress\xe3o de etiquetas de expedi\xe7\xe3o (volumes)",
            "[ENTRADAS] PRINT-CONFERENCE - permiss\xe3o de endpoint para relat\xf3rio de confer\xeancia",
            "[SA\xcdDAS] PRINT-AVISO-REMESSA - permiss\xe3o de endpoint para aviso de remessa"
        ]
    }
];


function $754162cf0396517c$var$formatChangelog(entries) {
    const MAX_DAYS = 10;
    const slice = entries.slice(0, MAX_DAYS);
    return slice.map((e)=>{
        const ch = e.changes && e.changes.length ? e.changes.join('\n') : '-----';
        const ad = e.add && e.add.length ? e.add.join('\n') : '-----';
        const bf = e.bugfix && e.bugfix.length ? e.bugfix.join('\n') : '-----';
        return `${e.date}\n\nCHANGES\n${ch}\n\nADD\n${ad}\n\nBUGFIX\n${bf}`;
    }).join("\n\n\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\n\n");
}
const $754162cf0396517c$var$about = async function() {
    let back = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).version);
    const logText = $754162cf0396517c$var$formatChangelog((0, $36a7dfe577885f1c$export$2e2bcd8739ae039));
    let html = `
		<style>
			#about .about-logos { display: flex; align-items: center; justify-content: center; gap: var(--space-lg); flex-wrap: wrap; }
			#about img.logo-sial { width: 200px; }
			#about img.logo-machadotec { width: 180px; height: auto; }
			#about .about-versions { margin-top: var(--space-md); margin-bottom: var(--space-md); }
			#about .about-changelog {
				margin-top: var(--space-md);
				margin-bottom: var(--space-md);
				max-height: 240px;
				overflow-y: auto;
				padding: var(--space-sm);
				background: var(--bg-secondary, #f8f9fa);
				border: 1px solid var(--border-color, #dee2e6);
				border-radius: 6px;
				font-family: 'Consolas', 'Monaco', monospace;
				font-size: 0.85rem;
				line-height: 1.5;
				white-space: pre-wrap;
				word-break: break-word;
			}
		</style>
		<div id="about" class="msgbox">
			<div class="about-logos">
				<img src="img/logo_v.png" class="logo-sial" alt="SIAL">
				<img src="img/logo_machadotec.png" class="logo-machadotec" alt="MachadoTec">
			</div>
			<div class="about-versions">
				Frontend: ${(0, $8027b5f9052bcf5e$export$2e2bcd8739ae039)}<br/>
				Backend: ${back}<br/>
				Desenvolvido para LLT Consultoria<br/>
				MachadoTec Software Solutions
			</div>
			<div class="about-changelog" readonly>${logText.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>
			<button class="bn_Enter button">Fechar</button>
		</div>`;
    let dlg = (0, $9da5ab8aba8aa3e3$export$2e2bcd8739ae039).create(html, ()=>dlg.destroy(), /Enter|Escape/);
};
var $754162cf0396517c$export$2e2bcd8739ae039 = $754162cf0396517c$var$about;




var $1cmSR = parcelRequire("1cmSR");

var $1cmSR = parcelRequire("1cmSR");

// Script set-api-host.ps1 atualiza API_BASE; '' = same-origin quando servido pela API
const $1a16108c946d67d2$var$API_BASE = 'https://sessp.sialwms.com.br';
const $1a16108c946d67d2$var$HOST = typeof window !== 'undefined' && window.location.port === '8001' ? '' : $1a16108c946d67d2$var$API_BASE;
//const HOST = 'https://api.mdutra.com:1604';	// Dev docker-compose
const $1a16108c946d67d2$var$API = {
    call: (0, $b5bb69350d42022c$export$2e2bcd8739ae039),
    // AUTH
    async auth (username, password) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/auth`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: `username=${username}&password=${password}`
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async request_password (data) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/auth/requests`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reset_password (data) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/auth/resets`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // ENDPOINTS
    async list_endpoints (query = '') {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/endpoints${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_endpoint (data) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/endpoints`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_endpoint (endpoint_id, data) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/endpoints/${endpoint_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_endpoint (endpoint_id) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/endpoints/${endpoint_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_endpoint (endpoint_id) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/endpoints/${endpoint_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // GROUPS
    async list_groups (query = '') {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/groups${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_group (data) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/groups`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_group (group_id, data) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/groups/${group_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_group (group_id) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/groups/${group_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_group (group_id) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/groups/${group_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // USERS
    async list_users (query = '') {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/users${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_user (data) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/users`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_user (user_id, data) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/users/${user_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_user (user_id) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/users/${user_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_user (user_id) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/users/${user_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // LOGS
    async list_logs (query = '') {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/logs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_log (log_id) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/logs/${log_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_integration_events (query = '') {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/integration-events${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_integration_event (integration_event_id) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/integration-events/${integration_event_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_integration_event (data) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/integration-events`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async integration_events_summary (hours = 24, stale_minutes = 12) {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/integration-events/summary?hours=${encodeURIComponent(hours)}&stale_minutes=${encodeURIComponent(stale_minutes)}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // VERSION
    async version () {
        let endpoint = `${$1a16108c946d67d2$var$HOST}/version`;
        let response = await fetch(endpoint);
        return response;
    }
};
var $1a16108c946d67d2$export$2e2bcd8739ae039 = $1a16108c946d67d2$var$API;










var $1cmSR = parcelRequire("1cmSR");


var $94dd3d467e908cbc$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#filter .parens
			{
				padding: var(--space-xs) var(--space-md);
				border: 2px outset var(--color-border);
				background-color: var(--color-box);
			}
			#filter .parens[value="1"]
			{
				border: 2px inset var(--color-border);
			}
			#filter td:nth-child(1)	{ width: 1rem;	}
			#filter td:nth-child(2)	{ width: 2rem;	}
			#filter td:nth-child(3)	{ width: 10rem;	}
			#filter td:nth-child(4)	{ width: 10rem;	}
			#filter td:nth-child(5)	{ width: 14rem;	}
			#filter td:nth-child(6)	{ width: 2rem;	}
			#filter td:nth-child(7)	{ width: 2rem;	}
		</style>
		<form id="filter" class="form" autocomplete="off">
			<datalist id="fields">
			</datalist>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th></th>
							<th>Campo</th>
							<th>Operador</th>
							<th>Dado</th>
							<th></th>
							<th>Conector</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox" title="Seletor de linha">
							</td>
							<td>
								<button id="open-0" class="bn_Open parens" title="Inicia subgrupo l\xf3gico">(</button>
							</td>
							<td>
								<input id="field-0" type="text" list="fields" title="Campo a avaliar">
							</td>
							<td>
								<input id="operator-0" type="text" list="operators" title="Operador a utilizar na avalia\xe7\xe3o">
							</td>
							<td>
								<input id="value-0" type="text">
							</td>
							<td>
								<button id="close-0" class="bn_Close parens" title="Encerra subgrupo l\xf3gico">)</button>
							</td>
							<td>
								<input id="connector-0" type="text" list="connectors" title="Conex\xe3o l\xf3gica com a pr\xf3xima linha">
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter linhas selecionadas">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class="bn_Escape button" title="Fechar sem altera\xe7\xf5es">Fechar</button>
					<button class="bn_Enter button" title="Aplicar novo filtro">Aplicar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#filter'
    },
    fields: [
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#open-0'
            },
            types: [
                $c6be62c04ec8b9fb$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#field-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#operator-0'
            },
            types: [
                $0e8b2a0570db9b4e$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#value-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#close-0'
            },
            types: [
                $c6be62c04ec8b9fb$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#connector-0'
            },
            types: [
                $040b19b92f93dc1d$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        }
    ]
};


const $d110a042ff114667$var$DATALIST = /(<datalist\s+id="fields"[^>]*>)(.*?)(<\/datalist>)/ims;
const $d110a042ff114667$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** Extrai company_id do formulário de filtro (resolve nick→id se necessário). Usado para escopar todos os campos filhos da empresa. */ const $d110a042ff114667$var$getCompanyIdFromFormData = async function(formData, top, companies = null) {
    companies = companies ?? await (0, $1cmSR.default).list('companies').catch(()=>[]);
    for(let i = 0; i < top; i++)if (formData[`field-${i}`] === 'company_id' && formData[`value-${i}`]) {
        const val = formData[`value-${i}`];
        if ($d110a042ff114667$var$UUID_REGEX.test(String(val))) return val;
        const c = companies.find((x)=>(x.nick || '') === val || (x.name || '') === val || String(x.nick || '') === val || String(x.name || '') === val);
        return c?.id ?? null;
    }
    return null;
};
// 'this' is not standard in these instances of formInit() and formCheck() as they point to the 'filter' object instead of a 'form' object.
// The formset creation requires a descriptor and such descriptor must be modified beforehand to point to our local 'init' and 'check' replacements.
// So these descriptor functions are bound to the 'filter' object which will then hold a pointer to the formset after its creation.
const $d110a042ff114667$var$formInit = function() {
    // MT-596E375: inscrever para carregar opções ao trocar campo ou ao alterar Empresa (para atualizar Armazém)
    const form_node = this.formset.form.node || document.querySelector('#filter');
    if (form_node) form_node.addEventListener('change', (ev)=>{
        const fieldMatch = ev.target?.id?.match(/^field-(\d+)$/);
        if (fieldMatch) {
            const field = this.formset.form.getFieldBySelector(ev.target.id);
            if (field) $d110a042ff114667$var$updateTypes.call(this, ev, {
                selector: ev.target.id
            }, field.getValue());
        } else {
            const valueMatch = ev.target?.id?.match(/^value-(\d+)$/);
            if (valueMatch) {
                const idx = valueMatch[1];
                const fieldEl = this.formset.form.getFieldBySelector?.('field-' + idx);
                const fn = fieldEl?.getValue?.();
                if (fn === 'company_id') {
                    // Empresa alterada: recarregar opções de TODOS os campos filhos (Armazém, Posição, Programa, etc.)
                    const formData = this.formset?.form?.getValues?.() || {};
                    const refreshAllCompanyScoped = ()=>{
                        const top = 10;
                        for(let i = 0; i < top; i++){
                            const f = this.formset.form.getFieldBySelector?.('field-' + i);
                            const fName = f?.getValue?.();
                            if (fName && fName !== 'company_id' && this.fields?.some((s)=>s.field === fName && s.store)) $d110a042ff114667$var$updateTypes.call(this, ev, {
                                selector: 'field-' + i
                            }, fName);
                        }
                    };
                    if (this.reloadLocations) this.reloadLocations(formData).then(refreshAllCompanyScoped).catch(()=>{});
                    else refreshAllCompanyScoped();
                } else if (fn === 'warehouse_id') {
                    // Armazém alterado: recarregar locations da API e opções de Posição
                    const formData = this.formset?.form?.getValues?.() || {};
                    if (this.reloadLocations) this.reloadLocations(formData).then(()=>{
                        const top = 10;
                        for(let i = 0; i < top; i++){
                            const f = this.formset.form.getFieldBySelector?.('field-' + i);
                            if (f?.getValue?.() === 'location_id') $d110a042ff114667$var$updateTypes.call(this, ev, {
                                selector: 'field-' + i
                            }, 'location_id');
                        }
                    }).catch(()=>{});
                    else {
                        const top = 10;
                        for(let i = 0; i < top; i++){
                            const f = this.formset.form.getFieldBySelector?.('field-' + i);
                            if (f?.getValue?.() === 'location_id') $d110a042ff114667$var$updateTypes.call(this, ev, {
                                selector: 'field-' + i
                            }, 'location_id');
                        }
                    }
                }
            }
        }
    });
    Object.getPrototypeOf(this.formset.form).init.call(this.formset.form, this.formset);
};
const $d110a042ff114667$var$activeFilterIndices = function(form, indices) {
    return indices.filter((i)=>{
        const f = form.getFieldBySelector(`field-${i}`);
        return f && !f.isDisabled() && !f.isEmpty();
    });
};
const $d110a042ff114667$var$formCheck = function() {
    let indices = this.formset.getEnabledRowsIndices();
    const active = $d110a042ff114667$var$activeFilterIndices(this.formset.form, indices);
    if (active.length === 0) {
        Object.getPrototypeOf(this.formset.form).check.call(this.formset.form, this.formset);
        return;
    }
    $d110a042ff114667$var$checkParens.call(this.formset.form, indices);
    $d110a042ff114667$var$checkValues.call(this.formset.form, active);
    $d110a042ff114667$var$checkConnectors.call(this.formset.form, active);
    Object.getPrototypeOf(this.formset.form).check.call(this.formset.form, this.formset);
};
const $d110a042ff114667$var$checkParens = function(indices) {
    let balance = 0;
    indices.forEach((index)=>{
        const openField = this.getFieldBySelector(`open-${index}`);
        const closeField = this.getFieldBySelector(`close-${index}`);
        balance += Number(openField?.getValue?.() ?? 0) || 0;
        balance -= Number(closeField?.getValue?.() ?? 0) || 0;
        if (balance < 0) throw new Error("Falta algum par\xeantese de abertura");
    });
    if (balance > 0) throw new Error("Falta algum par\xeantese de fechamento");
};
const $d110a042ff114667$var$checkValues = function(indices) {
    indices.forEach((index)=>{
        let field = this.getFieldBySelector(`field-${index}`);
        let operator = this.getFieldBySelector(`operator-${index}`);
        let value = this.getFieldBySelector(`value-${index}`);
        if (field.isDisabled() || field.isEmpty()) return;
        if (!operator.isDisabled() && operator.isEmpty()) $d110a042ff114667$var$setErrorState(operator, `Verificar operador da linha ${index + 1}`);
        if (!value.isDisabled() && (value.isEmpty() || !value.checkValue()) && ![
            'nu',
            'nn'
        ].includes(operator.getValue())) $d110a042ff114667$var$setErrorState(value, `Verificar dado da linha ${index + 1}`);
    });
};
const $d110a042ff114667$var$checkConnectors = function(activeIndices) {
    activeIndices.forEach((index, ai)=>{
        let field = this.getFieldBySelector(`connector-${index}`);
        let value = field.getValue();
        let is_last_active = ai === activeIndices.length - 1;
        if (!is_last_active && value != ',' && value != ';' || is_last_active && value !== undefined && value != '' && value != -1) $d110a042ff114667$var$setErrorState(field, `Verificar conector da linha ${index + 1}`);
    });
};
const $d110a042ff114667$var$setErrorState = function(field, message) {
    field.setErrorState(true);
    throw new Error(message);
};
const $d110a042ff114667$var$fmtLocAddr = (a)=>Array.isArray(a) ? a.join('-') : String(a ?? '');
const $d110a042ff114667$var$resolveFilterIdsToLabels = async function(data, fieldspecs) {
    if (!data || !fieldspecs) return data;
    const [companies, locations] = await Promise.all([
        (0, $1cmSR.default).list('companies').catch(()=>[]),
        (0, $1cmSR.default).list('locations').catch(()=>[])
    ]);
    const top = (0, $814061363397c8d7$export$5eff2b09abd87cc4)(data) + 1;
    const resolved = {
        ...data
    };
    const getCompanyId = ()=>{
        for(let j = 0; j < top; j++)if (data[`field-${j}`] === 'company_id') {
            const v = resolved[`value-${j}`] ?? data[`value-${j}`];
            return v && ($d110a042ff114667$var$UUID_REGEX.test(String(v)) ? v : companies.find((x)=>(x.nick || '') === v || (x.name || '') === v || String(x.nick || '') === v || String(x.name || '') === v)?.id);
        }
        return null;
    };
    for(let i = 0; i < top; i++){
        const field = data[`field-${i}`];
        const val = data[`value-${i}`];
        if (!field || val == null || val === '') continue;
        const spec = fieldspecs.find((s)=>s.field === field);
        if (spec?.store === 'companies' && $d110a042ff114667$var$UUID_REGEX.test(String(val))) {
            const c = companies.find((x)=>x.id === val || String(x.id) === val);
            if (c?.[spec.labels?.[0]]) resolved[`value-${i}`] = c[spec.labels[0]];
        } else if (spec?.store && spec.store !== 'companies' && spec.store !== 'locations' && spec.labels?.length && /^\d+$/.test(String(val))) {
            // Resolução genérica id→label para stores escopados por empresa
            const scope = getCompanyId();
            const opts = await (0, $1cmSR.default).list(spec.store).catch(()=>[]);
            const item = opts.find((o)=>(!scope || String(o.company_id) === String(scope)) && String(o.id) === String(val));
            if (item?.[spec.labels[0]]) resolved[`value-${i}`] = item[spec.labels[0]];
        } else if (spec?.store === 'locations' && field === 'location_id' && /^\d+:\d+$/.test(String(val))) {
            const [wh, id] = String(val).split(':');
            const loc = locations.find((l)=>String(l.warehouse_id) === wh && String(l.id) === id);
            if (loc) resolved[`value-${i}`] = `${loc.warehouse_id} - ${$d110a042ff114667$var$fmtLocAddr(loc.address)}`;
        }
    }
    return resolved;
};
const $d110a042ff114667$export$94031f41c18e0637 = async function(data, fieldspecs) {
    if (!data || !fieldspecs) return data;
    let companies = await (0, $1cmSR.default).list('companies').catch(()=>[]);
    // Se companies vazio mas há company_id com label para resolver, buscar da API (db pode estar vazio antes de loadBaseData)
    const needsCompanyResolve = (()=>{
        const top = (0, $814061363397c8d7$export$5eff2b09abd87cc4)(data) + 1;
        for(let i = 0; i < top; i++){
            const f = data[`field-${i}`], v = data[`value-${i}`];
            if (f && v != null && v !== '' && fieldspecs.some((s)=>s.field === f && s.store === 'companies') && !$d110a042ff114667$var$UUID_REGEX.test(String(v).trim())) return true;
        }
        return false;
    })();
    if (companies.length === 0 && needsCompanyResolve && (0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies) {
        companies = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, '').catch(()=>[]);
        if (companies.length) (0, $1cmSR.default).set('companies', companies);
    }
    const locations = await (0, $1cmSR.default).list('locations').catch(()=>[]);
    const top = (0, $814061363397c8d7$export$5eff2b09abd87cc4)(data) + 1;
    const resolved = {
        ...data
    };
    for(let i = 0; i < top; i++){
        const field = data[`field-${i}`];
        let val = data[`value-${i}`];
        if (!field || val == null || val === '') continue;
        val = String(val).trim();
        const spec = fieldspecs.find((s)=>s.field === field);
        if (spec?.store === 'companies' && !$d110a042ff114667$var$UUID_REGEX.test(val)) {
            const labelKey = spec.labels?.[0] || 'nick';
            const match = (x)=>(x[labelKey] || '') === val || String(x[labelKey] || '') === val || (x.name || '') === val || String(x.name || '') === val || (x.nick || '') === val || String(x.nick || '') === val;
            const c = companies.find(match);
            if (c?.id) resolved[`value-${i}`] = c.id;
        }
    }
    const getCompanyId = ()=>{
        for(let j = 0; j < top; j++)if (data[`field-${j}`] === 'company_id') {
            const v = resolved[`value-${j}`] ?? data[`value-${j}`];
            return v && ($d110a042ff114667$var$UUID_REGEX.test(String(v)) ? v : companies.find((x)=>(x.nick || '') === v || (x.name || '') === v || String(x.nick || '') === v || String(x.name || '') === v)?.id);
        }
        return null;
    };
    for(let i = 0; i < top; i++){
        const field = data[`field-${i}`];
        let val = data[`value-${i}`];
        if (!field || val == null || val === '') continue;
        val = String(val).trim();
        const spec = fieldspecs.find((s)=>s.field === field);
        if (spec?.store === 'locations' && field === 'location_id' && !/^\d+:\d+$/.test(val)) {
            // Label "warehouse_id - address" ou apenas "address"
            const match = val.match(/^(\d+)\s*-\s*(.+)$/);
            const wh = match ? match[1] : null;
            const addrPart = match ? match[2].trim() : val;
            const addrNorm = addrPart.replace(/\s+/g, '-').toUpperCase();
            const scopeCompany = getCompanyId();
            const loc = locations.find((l)=>{
                const a = $d110a042ff114667$var$fmtLocAddr(l.address ?? l.id);
                const addrMatch = a.replace(/\s+/g, '-').toUpperCase() === addrNorm || a.toUpperCase().includes(addrNorm);
                if (!addrMatch) return false;
                if (scopeCompany && String(l.company_id) !== String(scopeCompany)) return false;
                if (wh && String(l.warehouse_id) !== wh) return false;
                return true;
            });
            if (loc) resolved[`value-${i}`] = `${loc.warehouse_id}:${loc.id}`;
        } else if (spec?.store && spec.store !== 'companies' && spec.labels?.length && !/^\d+$/.test(val) && !/^\d+:\d+$/.test(val)) {
            // Resolução genérica para stores escopados por empresa (warehouses, programs, units, products, etc.)
            const scope = getCompanyId();
            const opts = await (0, $1cmSR.default).list(spec.store).catch(()=>[]);
            const labelKey = spec.labels[0];
            const item = opts.find((o)=>(!scope || String(o.company_id) === String(scope)) && ((o[labelKey] || '') === val || String(o[labelKey] || '') === val));
            if (item?.id != null) resolved[`value-${i}`] = item.id;
        }
    }
    return resolved;
};
const $d110a042ff114667$var$updateTypes = async function(ev, publisher, field_name) {
    let basespec = (0, $94dd3d467e908cbc$export$2e2bcd8739ae039).fields.find((field)=>field.properties.selector == '#value-0');
    let fieldspec = this.fields.find((entry)=>entry.field == field_name); // 'field_name' may be -1 when moving between rows
    let typed_field = (0, $604673ecc72d1005$export$2e2bcd8739ae039).create(basespec.properties, basespec.types.concat(fieldspec?.types || []));
    let index = publisher.selector.match((0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a))[3];
    let current_field = this.formset.form.getFieldBySelector((0, $a2e5868bc3913d81$export$77b8d1f921212127)('value-0', index));
    Object.assign(typed_field, {
        selector: current_field.selector
    });
    typed_field.releaseEvents();
    let node = document.querySelector(typed_field.selector);
    if (fieldspec?.placeholder) node.setAttribute('placeholder', fieldspec.placeholder);
    if (fieldspec?.title) node.setAttribute('title', fieldspec.title);
    if (fieldspec?.store) {
        let options = await (0, $1cmSR.default).list(fieldspec.store);
        // MT-596E375: filtrar por company_id/warehouse_id, ordenar por address, value = warehouse_id:location_id
        if (fieldspec.store === 'locations' && (fieldspec.field === 'location_id' || field_name === 'location_id')) {
            let companyId = null;
            let warehouseId = null;
            const formData = this.formset?.form?.getValues?.() || {};
            const topIdx = (0, $814061363397c8d7$export$5eff2b09abd87cc4)(formData) + 1;
            const [companies, warehouses] = await Promise.all([
                (0, $1cmSR.default).list('companies').catch(()=>[]),
                (0, $1cmSR.default).list('warehouses').catch(()=>[])
            ]);
            for(let i = 0; i < topIdx; i++){
                if (formData[`field-${i}`] === 'company_id' && formData[`value-${i}`]) {
                    const val = formData[`value-${i}`];
                    companyId = $d110a042ff114667$var$UUID_REGEX.test(String(val)) ? val : null;
                    if (!companyId) {
                        const c = companies.find((x)=>(x.nick || '') === val || (x.name || '') === val || String(x.nick || '') === val || String(x.name || '') === val);
                        companyId = c?.id;
                    }
                } else if (formData[`field-${i}`] === 'warehouse_id' && formData[`value-${i}`] != null && formData[`value-${i}`] !== '') {
                    const wval = formData[`value-${i}`];
                    warehouseId = /^\d+$/.test(String(wval)) ? typeof wval === 'number' ? wval : parseInt(wval, 10) : null;
                    if (warehouseId == null && companyId) {
                        const wh = warehouses.find((w)=>String(w.company_id) === String(companyId) && ((w.name || '') === wval || String(w.name || '') === wval));
                        if (wh) warehouseId = wh.id;
                    }
                }
            }
            options = options.map((loc)=>{
                const addr = $d110a042ff114667$var$fmtLocAddr(loc.address ?? loc.id);
                return {
                    ...loc,
                    _wh_loc: `${loc.warehouse_id}:${loc.id}`,
                    _label: `${loc.warehouse_id} - ${addr}`,
                    _addrSort: addr
                };
            });
            if (companyId) options = options.filter((l)=>String(l.company_id) === String(companyId));
            if (warehouseId != null) options = options.filter((l)=>Number(l.warehouse_id) === Number(warehouseId));
            options.sort((a, b)=>(a._addrSort || '').localeCompare(b._addrSort || '', undefined, {
                    numeric: true
                }));
            (0, $c643adc13e6018a8$export$cad72087bded938)(typed_field.selector, options, '_wh_loc', [
                '_label'
            ]);
        } else if (fieldspec.store !== 'companies' && fieldspec.store !== 'locations' && options.length > 0 && options[0].company_id != null) {
            // Stores escopados por empresa: warehouses, programs, units, classes, products, etc.
            const formData = this.formset?.form?.getValues?.() || {};
            const top = (0, $814061363397c8d7$export$5eff2b09abd87cc4)(formData) + 1;
            const companyId = await $d110a042ff114667$var$getCompanyIdFromFormData(formData, top);
            if (companyId) options = options.filter((o)=>String(o.company_id) === String(companyId));
            if (options.length > 0 && options[0].is_disabled != null) options = options.filter((o)=>!o.is_disabled);
            (0, $c643adc13e6018a8$export$cad72087bded938)(typed_field.selector, options, fieldspec.value || 'id', fieldspec.labels, fieldspec.separator);
        } else // Empresas: usar id como value (enviar UUID à API), nick como label (exibição)
        if (fieldspec.store === 'companies' && fieldspec.labels?.[0]) {
            const labelKey = fieldspec.labels[0];
            const seen = new Set();
            options = options.filter((o)=>{
                const k = o.id ?? '';
                if (seen.has(k)) return false;
                seen.add(k);
                return true;
            });
            (0, $c643adc13e6018a8$export$cad72087bded938)(typed_field.selector, options, 'id', [
                labelKey
            ]);
        } else (0, $c643adc13e6018a8$export$cad72087bded938)(typed_field.selector, options, fieldspec.value, fieldspec.labels, fieldspec.separator);
    } else node?.removeAttribute('list');
    typed_field.captureEvents();
    typed_field.refresh();
};
const $d110a042ff114667$var$LOCATIONS_FIELDS = [
    'company_id',
    'warehouse_id',
    'location_id'
];
const $d110a042ff114667$var$SCOPE_FIELDS = [
    'company_id',
    'warehouse_id'
];
const $d110a042ff114667$export$d73ee8ef04f5226a = function(data, allowedFields = null) {
    let expression = '';
    let top_index = (0, $814061363397c8d7$export$5eff2b09abd87cc4)(data) + 1;
    let wrapOrGroup = false;
    const willOutput = (i)=>{
        const f = data[`field-${i}`];
        const v = data[`value-${i}`];
        if (!f || v == null || v === '') return false;
        if (allowedFields && !allowedFields.includes(f)) return false;
        if (f === 'location_id') return typeof v === 'string' && /^\d+:\d+$/.test(v);
        return true;
    };
    for(let index = 0; index < top_index; index++){
        if (!willOutput(index)) continue;
        let open = data[`open-${index}`] == 1 ? '(' : '';
        let field = data[`field-${index}`];
        let operator = data[`operator-${index}`];
        let value = data[`value-${index}`];
        let close = data[`close-${index}`] == 1 ? ')' : '';
        let connector = data[`connector-${index}`];
        const hasNext = ()=>{
            for(let j = index + 1; j < top_index; j++)if (willOutput(j)) return true;
            return false;
        };
        const restContainsOr = ()=>{
            for(let j = index + 1; j < top_index; j++)if (willOutput(j) && data[`connector-${j}`] === ';') return true;
            return false;
        };
        // MT-596E375: location_id "warehouse_id:location_id" expande para warehouse_id e location_id (inteiros)
        if (field === 'location_id') {
            let [wh, loc] = String(value).split(':');
            expression += `${open}warehouse_id*${operator}*${wh},location_id*${operator}*${loc}${close}`;
        } else expression += `${open}${field}*${operator}*${value}${close}`;
        if (connector && connector !== -1 && hasNext()) {
            // Empresa/Armazém seguido de cláusulas com "Ou": forçar AND(escopo, OR(resto))
            if ($d110a042ff114667$var$SCOPE_FIELDS.includes(field) && restContainsOr() && !wrapOrGroup) {
                expression += ',(';
                wrapOrGroup = true;
            } else expression += connector;
        } else if (wrapOrGroup) {
            expression += ')';
            wrapOrGroup = false;
        }
    }
    if (wrapOrGroup) expression += ')';
    return expression;
};
const $d110a042ff114667$export$2e2bcd8739ae039 = {
    fields: null,
    formset: null,
    init (fields) {
        this.fields = fields;
        let options = (0, $814061363397c8d7$export$2c531902cb3b2ba)(fields, 'field', [
            'label'
        ]);
        (0, $94dd3d467e908cbc$export$2e2bcd8739ae039).html = (0, $94dd3d467e908cbc$export$2e2bcd8739ae039).html.replace($d110a042ff114667$var$DATALIST, '$1' + options + '$3');
    },
    edit (callback, current_data, options = {}) {
        this.reloadLocations = options.reloadLocations || null;
        (0, $94dd3d467e908cbc$export$2e2bcd8739ae039).form.init = $d110a042ff114667$var$formInit.bind(this);
        (0, $94dd3d467e908cbc$export$2e2bcd8739ae039).form.check = $d110a042ff114667$var$formCheck.bind(this);
        this.formset = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $94dd3d467e908cbc$export$2e2bcd8739ae039), async (updated_data)=>{
            this.formset.destroy();
            const resolved = await $d110a042ff114667$export$94031f41c18e0637(updated_data, this.fields);
            if (callback) await Promise.resolve(callback(resolved));
        });
        this.formset.init = (async ()=>{
            this.formset.form.eraseValues();
            Object.getPrototypeOf(this.formset).init.call(this.formset);
            let rows = Object.keys(current_data || {}).filter((key)=>key.startsWith('connector')).length;
            this.formset.appendRows(Math.max(rows, 4) + 1);
            if (current_data) {
                const forDisplay = await $d110a042ff114667$var$resolveFilterIdsToLabels(current_data, this.fields);
                this.formset.form.setValues(forDisplay);
            }
            this.formset.form.refresh();
        })();
    }
};
const $d110a042ff114667$export$f776883aa04b3f15 = (data)=>$d110a042ff114667$export$d73ee8ef04f5226a(data, $d110a042ff114667$var$LOCATIONS_FIELDS);




var $c9a703fc1a38021f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#columns
			{
				display: grid;
				grid-template-columns: 1fr 1fr;
			}
			#columns label:nth-child(odd)
			{
				text-align: left;
			}
			#columns label:nth-child(even)
			{
				text-align: right;
			}
			#setup input
			{
				display: inline-block;
			}
			#setup #sort_column { width: 12rem; margin-right: var(--space-lg); }
			#setup #page_length { width: 4rem; text-align: right; }
		</style>
		<form id="setup" class="form">
			<div class="fsb">
				<span>
					<label>Ordenar por&nbsp;
						<select id="sort_column" name="sort_column" required>
						</select>
					</label>
				</span>
				<span>
					<label class="blk tar">
						Ordem Ascendente
						<input class="sort_order" type="radio" name="sort_order" value="0">
					</label>
					<label class="blk">
						Ordem Descendente
						<input class="sort_order" type="radio" name="sort_order" value="1">
					</label>
				</span>
			</div>
			<fieldset>
				<legend>Colunas Vis\xedveis</legend>
				<div id="columns">
				</div>
			</fieldset>
			<div class="fsb">
				<label>
					Linhas&nbsp;por&nbsp;P\xe1gina&nbsp;
					<input id="page_length" name="page_length" type="number" min="1" max="500" required>
				</label>
				<label>
					Preservar Filtro Atual
					<input id="keep_filter" name="keep_filter" type="checkbox" checked>
				</label>
			</div>
			<div class="mtm">
				<button class="bn_Escape button" title="Fechar sem altera\xe7\xf5es">Fechar</button>
				<button class="bn_Enter button" title="Aplicar nova configura\xe7\xe3o">Aplicar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#setup'
    },
    fields: [
        {
            properties: {
                selector: '#sort_column'
            },
            types: [
                $2c79fa51f8e681d4$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '.sort_order'
            },
            types: [
                $0b50ce47f660c06f$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '.columns'
            },
            types: [
                $cbae8b6ef4bb77e6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#page_length'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#keep_filter'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $94884e046c5d00da$var$SELECT = /(<select[^>]*>)(.*?)(<\/select>)/ims;
const $94884e046c5d00da$var$COLUMNS = /(<div\s+id="columns"[^>]*>)(.*?)(<\/div>)/ims;
const $94884e046c5d00da$var$makeCheckboxes = function(array, value, label, cls) {
    let checkboxes = array.map((entry, index)=>`<label>
			${index % 2 ? entry[label] : ''}
			<input type="checkbox" class="${cls}" value="${entry[value]}" checked>
			${index % 2 ? '' : entry[label]}
		</label>`).join('\n');
    return checkboxes;
};
const $94884e046c5d00da$var$setup = {
    init (columns) {
        let options = (0, $814061363397c8d7$export$2c531902cb3b2ba)(columns, 'index', [
            'label'
        ]);
        let checkboxes = $94884e046c5d00da$var$makeCheckboxes(columns, 'index', 'label', 'columns');
        (0, $c9a703fc1a38021f$export$2e2bcd8739ae039).html = (0, $c9a703fc1a38021f$export$2e2bcd8739ae039).html.replace($94884e046c5d00da$var$SELECT, '$1' + options + '$3');
        (0, $c9a703fc1a38021f$export$2e2bcd8739ae039).html = (0, $c9a703fc1a38021f$export$2e2bcd8739ae039).html.replace($94884e046c5d00da$var$COLUMNS, '$1' + checkboxes + '$3');
    },
    edit (callback, current_data) {
        let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $c9a703fc1a38021f$export$2e2bcd8739ae039), (updated_data)=>{
            fs.destroy();
            callback?.(updated_data);
        });
        fs.init = (()=>{
            fs.form.setValues({
                'sort_column': current_data?.sort_column ?? 1,
                'sort_order': current_data?.sort_order ?? 1,
                'columns': current_data?.columns,
                'page_length': current_data?.page_length ?? 30,
                'keep_filter': current_data?.filter ?? 1
            });
            Object.getPrototypeOf(fs).init.call(fs);
        })();
    }
};
var $94884e046c5d00da$export$2e2bcd8739ae039 = $94884e046c5d00da$var$setup;



var $1cmSR = parcelRequire("1cmSR");


const $037bce58a5e51361$var$_selectionCache = Object.create(null);
const $037bce58a5e51361$var$grid = {
    id: null,
    view: null,
    node: null,
    visible: [],
    init (id, view, node) {
        this.id = id;
        this.view = view;
        this.node = node;
    },
    async render (records = []) {
        if (this.id) delete $037bce58a5e51361$var$_selectionCache[this.id];
        const list = Array.isArray(records) ? records : [];
        this.node.innerHTML = await this.view.call(this, list);
        this.node.querySelector('.view').addEventListener('click', this.flipState.bind(this));
    },
    setVisible (indices) {
        this.visible = indices;
    },
    clearSelection () {
        if (this.id) delete $037bce58a5e51361$var$_selectionCache[this.id];
        this.node?.querySelectorAll('.view input[type="checkbox"]').forEach((node)=>{
            node.checked = false;
        });
    },
    getSelection () {
        return $037bce58a5e51361$var$_selectionCache[this.id] || [];
    },
    setSelection (selection) {
        if (this.id) $037bce58a5e51361$var$_selectionCache[this.id] = selection;
    },
    isChecked (id) {
        return this.getSelection().includes(id) ? ' checked' : '';
    },
    flipState (ev) {
        if (ev.target.nodeName != 'INPUT' || ev.target.type != 'checkbox') return;
        ev.stopPropagation();
        if (ev.target.parentNode.nodeName == 'TH') {
            const table = ev.target.closest('.view');
            const rows = table?.querySelectorAll('tbody tr[data-id]') || [];
            const allIds = Array.from(rows).map((r)=>r.getAttribute('data-id'));
            const selection = this.getSelection();
            const allSelected = allIds.length > 0 && allIds.every((id)=>selection.includes(id));
            const headCb = table?.querySelector('thead input[type="checkbox"]');
            if (allSelected) {
                this.clearSelection();
                if (headCb) headCb.checked = false;
            } else {
                this.setSelection([
                    ...allIds
                ]);
                table?.querySelectorAll('tbody input[type="checkbox"]').forEach((cb)=>{
                    cb.checked = true;
                });
                if (headCb) headCb.checked = true;
            }
            return;
        }
        let id = (0, $7c7f18e63e55bfe1$export$92a42bc44568c07)(ev.target, 'data-id').getAttribute('data-id');
        let selection = this.getSelection();
        if (ev.target.checked) selection.push(id);
        else selection.splice(selection.indexOf(id), 1);
        this.setSelection(selection);
    },
    async key (store, keys, labels = 'name', separator = ' ') {
        if (!keys || Array.isArray(keys) && (keys.length === 0 || keys.some((v)=>v == null || v === ''))) return;
        let entry = await (0, $1cmSR.default).get(store, keys);
        if (!entry) return;
        return (Array.isArray(labels) ? labels : [
            labels
        ]).map((label)=>entry[label]).join(separator);
    },
    option (object, value) {
        return object.options.find((entry)=>entry.value == value)?.label;
    },
    // TODO: Usar o campo já inicializado para o filtro para formatar o dado ao invés de ficar criando um novo a cada ocorrência
    // Dá erro de "Selector not found" quando sendo criado
    format (type, value) {
        return (0, $604673ecc72d1005$export$2e2bcd8739ae039).create({}, [
            type
        ]).format(value);
    }
};
var $037bce58a5e51361$export$2e2bcd8739ae039 = $037bce58a5e51361$var$grid;




var $9347e9db44a76bf8$export$2e2bcd8739ae039 = (options)=>`<ul class="menu submenu">
	${options.map((option)=>`<li hash="${option.hash}">${option.label}</li>`).join('')}
</ul>`;


var $1c095ea81a245880$export$2e2bcd8739ae039 = (module_name, operations = [], reports = [])=>`<div class="crud fsb fac">
	<ul class="menu submenu">
		<li hash="#insert" title="Inserir"><img src="img/insert.svg"><span>Inserir</span></li>
		<li hash="#filter" title="Filtrar"><img src="img/filter.svg"><span>Filtrar</span></li>
		<li title="Menu de Opera\xe7\xf5es"><img src="img/operations.svg"><span>Opera\xe7\xf5es</span>
			${(0, $9347e9db44a76bf8$export$2e2bcd8739ae039)(operations)}
		</li>
		<li title="Menu de Relat\xf3rios"><img src="img/reports.svg"><span>Imprimir</span>
			${(0, $9347e9db44a76bf8$export$2e2bcd8739ae039)(reports)}
		</li>
		<!--
		<li hash="#export" title="Exportar Registros"><img src="img/export.svg"><span>Exportar</span></li>
		<li hash="#import" title="Importar Registros"><img src="img/import.svg"><span>Importar</span></li>
		-->
		<li hash="#setup" title="Configurar P\xe1gina"><img src="img/setup.svg"><span>Configurar</span></li>
		<li hash="#first" title="Primeira P\xe1gina"><img src="img/first.svg"><span>Primeira</span></li>
		<li hash="#previous" title="P\xe1gina Anterior"><img src="img/previous.svg"><span>Anterior</span></li>
		<li hash="#reload" title="Recarregar P\xe1gina"><img src="img/reload.svg"><span>Atual</span></li>
		<li hash="#next" title="Pr\xf3xima P\xe1gina"><img src="img/next.svg"><span>Pr\xf3xima</span></li>
		<li hash="#last" title="\xdaltima P\xe1gina"><img src="img/last.svg"><span>\xdaltima</span></li>
	</ul>
	<span id="module_name">
		${module_name}
	</span>
	<span id="page_info">
		P\xe1gina&nbsp;<span id="page">&hellip;</span>
	</span>
</div>
<div id="grid">
</div>`;



var $35c39d8de2c7fb54$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#import #file
			{ 
				margin-top: var(--space-lg);	
			}
		</style>
		<form id="import" class="msgbox form">
			<div class="title">
				Importa\xe7\xe3o
			</div>
			<div>
				<input id="file" type="file" accept=".xlsx, application/vnd.ms-excel" required>
			</div>
			<div class="mtl">
				<button class='bn_Escape button'>Fechar</button>
				<button class='bn_Enter button'>Enviar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#import'
    },
    fields: [
        {
            properties: {
                selector: '#file'
            },
            types: [
                $5e1493eb0305a487$export$2e2bcd8739ae039()
            ]
        }
    ]
};


const $623d474b3f9ce8b0$var$crud = {
    module_name: null,
    target_node: null,
    fieldspecs: null,
    record_form: null,
    record_count: 0,
    page_count: 0,
    page_number: 1,
    page_length: 30,
    sort_column: 1,
    sort_order: 1,
    filter: {},
    filterExplicitlyApplied: false,
    create (properties) {
        return Object.assign(Object.create(this), properties);
    },
    async run (module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, options = {}) {
        try {
            this.fieldspecs = fieldspecs;
            this.record_form = record_form;
            this.module_name = module_name;
            this.target_node = (0, $7c7f18e63e55bfe1$export$da5f6eb3bb522cd)(target_node);
            this.target_node.innerHTML = (0, $1c095ea81a245880$export$2e2bcd8739ae039)(label, operations, reports);
            (0, $d110a042ff114667$export$2e2bcd8739ae039).init(fieldspecs);
            (0, $94884e046c5d00da$export$2e2bcd8739ae039).init(fieldspecs);
            (0, $037bce58a5e51361$export$2e2bcd8739ae039).init(module_name + '.grid', grid_view, this.target_node.querySelector('#grid'));
            this.target_node.addEventListener('click', this.handleEvents.bind(this));
            this.applySetup(this.loadSetup());
            this.setMenuRoutes();
            await this.loadBaseData();
            // Resolver labels→IDs após loadBaseData (db.list('companies') precisa estar populado)
            if (this.filter && Object.keys(this.filter).some((k)=>/^field-\d+$/.test(k))) this.filter = await (0, $d110a042ff114667$export$94031f41c18e0637)(this.filter, this.fieldspecs);
            if (!options.skipInitialLoad) await this.loadPage();
        } catch (e) {
            (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e.message, 'Falha');
            console.log(e);
        }
    },
    handleEvents (ev) {
        let submenu, header, record;
        if (submenu = (0, $7c7f18e63e55bfe1$export$92a42bc44568c07)(ev.target, 'hash')) (0, $a020c0121b2250d6$export$2e2bcd8739ae039).route(submenu.getAttribute('hash'));
        else if (header = (0, $7c7f18e63e55bfe1$export$92a42bc44568c07)(ev.target, 'data-index')) this.sortPage(header.getAttribute('data-index'));
        else if (record = (0, $7c7f18e63e55bfe1$export$92a42bc44568c07)(ev.target, 'data-id')) this.loadRecord(record.getAttribute('data-id')).then((data)=>this.editRecord.call(this, data));
    },
    setMenuRoutes () {
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#insert', this.insertRecord.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#filter', this.editFilter.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#setup', this.editSetup.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export', this.exportFileDialog.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#import', this.importFileDialog.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#first', this.goToFirstPage.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#previous', this.goToPrevPage.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#reload', this.reloadPage.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#next', this.goToNextPage.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#last', this.goToLastPage.bind(this));
    },
    async addFilter (params) {
        let f = this.filter;
        if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) f = await (0, $d110a042ff114667$export$94031f41c18e0637)(f, this.fieldspecs);
        const filter = (0, $d110a042ff114667$export$d73ee8ef04f5226a)(f);
        if (filter) params.append('filter', filter);
    },
    async addFilterForLocations (params) {
        let f = this.filter;
        if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) f = await (0, $d110a042ff114667$export$94031f41c18e0637)(f, this.fieldspecs);
        const expr = (0, $d110a042ff114667$export$f776883aa04b3f15)(f);
        if (expr) params.append('filter', expr);
    },
    addSort (params) {
        params.append('sort', this.sort_column * (this.sort_order ? -1 : 1));
    },
    computeRecencySort () {
        const fs = this.fieldspecs || [];
        const pick = (name)=>fs.find((s)=>s.field === name)?.index;
        const col = pick('created_on') ?? pick('updated_on') ?? pick('id') ?? pick('location_id') ?? fs[0]?.index ?? 1;
        return {
            sort_column: col,
            sort_order: 1
        };
    },
    addLimit (params, limit) {
        params.append('limit', limit ?? this.page_length);
    },
    async addListLimit (params) {
        let lim = this.page_length;
        if (this.filterExplicitlyApplied) {
            let f = this.filter;
            if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) f = await (0, $d110a042ff114667$export$94031f41c18e0637)(f, this.fieldspecs);
            if (!(0, $d110a042ff114667$export$d73ee8ef04f5226a)(f)) lim = 0;
        }
        params.append('limit', lim);
    },
    addOffset (params) {
        params.append('offset', (this.page_number - 1) * this.page_length);
    },
    addCount (params) {
        params.append('group', 'count');
    },
    queryAll () {
        let params = new URLSearchParams();
        this.addLimit(params, 0);
        return '?' + params.toString();
    },
    async queryPage () {
        let params = new URLSearchParams();
        await this.addFilter(params);
        this.addSort(params);
        await this.addListLimit(params);
        this.addOffset(params);
        return '?' + params.toString();
    },
    async queryFiltered () {
        let params = new URLSearchParams();
        await this.addFilter(params);
        this.addSort(params);
        this.addLimit(params, 0);
        return '?' + params.toString();
    },
    async queryFilteredForLocations () {
        let params = new URLSearchParams();
        await this.addFilterForLocations(params);
        params.append('sort', '4');
        params.append('limit', '0');
        return '?' + params.toString();
    },
    async queryCount () {
        let params = new URLSearchParams();
        await this.addFilter(params);
        this.addLimit(params, 0);
        this.addCount(params);
        return '?' + params.toString();
    },
    async loadBaseData () {
        (0, $1a16108c946d67d2$export$2e2bcd8739ae039).call((0, $1a16108c946d67d2$export$2e2bcd8739ae039).list_something, this.queryAll()).then((data)=>(0, $1cmSR.default).set('something', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
    },
    async queryData (query) {
        return await (0, $1a16108c946d67d2$export$2e2bcd8739ae039).call((0, $1a16108c946d67d2$export$2e2bcd8739ae039).list_records, query);
    },
    async queryFilteredData () {
        return await this.queryData(await this.queryFiltered());
    },
    async loadPage (page) {
        if (page) this.page_number = Number(page);
        // Garantir que labels (ex: nick da empresa) sejam convertidos em IDs antes da API
        if (this.filter && Object.keys(this.filter).some((k)=>/^field-\d+$/.test(k))) this.filter = await (0, $d110a042ff114667$export$94031f41c18e0637)(this.filter, this.fieldspecs);
        const count = await this.queryData(await this.queryCount());
        this.record_count = typeof count === 'number' ? count : 0;
        let unrestricted = false;
        if (this.filterExplicitlyApplied) {
            const expr = (0, $d110a042ff114667$export$d73ee8ef04f5226a)(this.filter);
            unrestricted = !expr;
        }
        if (unrestricted) this.page_number = 1;
        this.page_count = unrestricted ? 1 : Math.max(0, Math.ceil(this.record_count / this.page_length));
        document.getElementById('page').innerText = this.record_count === 0 ? '0/0' : `${this.page_number}/${this.page_count}`;
        const records = await this.queryData(await this.queryPage());
        await (0, $037bce58a5e51361$export$2e2bcd8739ae039).render(Array.isArray(records) ? records : []);
    },
    sortPage (column) {
        if (this.sort_column == column) this.sort_order = this.sort_order ^ 1;
        else {
            this.sort_column = column;
            this.sort_order = 1;
        }
        this.loadPage();
    },
    insertRecord () {
        this.editRecord();
    },
    async loadRecord (id) {
        let _record1 = await (0, $1a16108c946d67d2$export$2e2bcd8739ae039).call((0, $1a16108c946d67d2$export$2e2bcd8739ae039).select_record, ...JSON.parse(id));
        return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record1, 'items');
    },
    editRecord (data) {
        (0, $814061363397c8d7$export$2e2bcd8739ae039).edit(this.record_form, this.saveRecordWrapper.bind(this), data);
    },
    async saveRecordWrapper (data, old_data) {
        let success = await this.saveRecord(data, old_data);
        this.loadPage();
        return success;
    },
    async saveRecord (data, old_data) {
        data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'items');
        if (old_data) return await (0, $1a16108c946d67d2$export$2e2bcd8739ae039).call((0, $1a16108c946d67d2$export$2e2bcd8739ae039).update_record, data.company_id, data.id, _record);
        else return await (0, $1a16108c946d67d2$export$2e2bcd8739ae039).call((0, $1a16108c946d67d2$export$2e2bcd8739ae039).insert_record, data.company_id, _record);
    },
    editFilter () {
        (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter);
    },
    async applyFilter (data) {
        this.filter = data;
        this.filterExplicitlyApplied = true;
        await this.loadPage(1);
    },
    loadSetup () {
        return JSON.parse(localStorage.getItem(this.module_name + '.setup') || '{}');
    },
    editSetup () {
        (0, $94884e046c5d00da$export$2e2bcd8739ae039).edit(this.saveSetup.bind(this), this.loadSetup());
    },
    saveSetup (data) {
        if (data.keep_filter) data.filter = this.filter;
        localStorage.setItem(this.module_name + '.setup', JSON.stringify(data));
        this.applySetup(data);
        this.loadPage();
    },
    applySetup (data) {
        const rec = this.computeRecencySort();
        this.sort_column = rec.sort_column;
        this.sort_order = 1;
        this.page_length = Number(data.page_length ?? this.page_length);
        this.filter = data.filter ?? this.filter;
        let _default = this.default_columns || '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25';
        let columns = (data.columns || _default).split(',').map((column)=>Number(column));
        (0, $037bce58a5e51361$export$2e2bcd8739ae039).setVisible(this.fieldspecs.map((field)=>columns.includes(field.index) ? 1 : 0));
    },
    async exportFile () {
        let ids = await this.getSelectedIds([
            'company_id',
            'id'
        ]);
        return await (0, $1a16108c946d67d2$export$2e2bcd8739ae039).call((0, $1a16108c946d67d2$export$2e2bcd8739ae039).export_endpoint);
    },
    exportFileDialog () {
        (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Exportar ${this.getSelection().length || this.record_count} registros?`, "Exporta\xe7\xe3o", async (answer)=>{
            if (answer == 'Y') {
                let data = await this.exportFile();
                this.clearGridSelection();
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`<a href="data:application/vnd.ms-excel;base64,${encodeURI(data.file)}" download="export.xlsx">Clique aqui para obter o arquivo</a>`, 'Download');
            }
        });
    },
    async importFile (data) {
        return await (0, $1a16108c946d67d2$export$2e2bcd8739ae039).call((0, $1a16108c946d67d2$export$2e2bcd8739ae039).import_endpoint, {
            file: data.file
        });
    },
    importFileDialog () {
        let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $35c39d8de2c7fb54$export$2e2bcd8739ae039), async (data)=>{
            let response = await this.importFile(data);
            if (response?.text) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(response.text);
            fs.destroy();
        });
        fs.init = (()=>{
            Object.getPrototypeOf(fs).init.call(fs);
            fs.form.eraseValues();
            fs.form.refresh();
        })();
    },
    goToPage (page) {
        if (page > 0 && page <= this.page_count) this.loadPage(page);
    },
    goToFirstPage () {
        if (this.page_number != 1) this.goToPage(1);
    },
    goToPrevPage () {
        this.goToPage(this.page_number - 1);
    },
    reloadPage () {
        this.goToPage(this.page_number);
    },
    goToNextPage () {
        this.goToPage(this.page_number + 1);
    },
    goToLastPage () {
        if (this.page_number != this.page_count) this.goToPage(this.page_count);
    },
    getSelection () {
        return (0, $037bce58a5e51361$export$2e2bcd8739ae039).getSelection().map((entry)=>JSON.parse(entry));
    },
    clearGridSelection () {
        (0, $037bce58a5e51361$export$2e2bcd8739ae039).clearSelection();
    },
    getCount () {
        return this.getSelection().length || this.record_count;
    },
    getListOf (array, properties) {
        return array.map((entry)=>Array.isArray(properties) ? properties.map((property)=>entry[property]) : entry[properties]);
    },
    async getSelectedIds (properties) {
        let ids = this.getSelection();
        return ids.length ? ids : this.getListOf(await this.queryFilteredData(), properties);
    }
};
var $623d474b3f9ce8b0$export$2e2bcd8739ae039 = $623d474b3f9ce8b0$var$crud;




// Types
function $58102435e51228d8$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{13}|ISENTO)$/,
        filter: /[]/g
    };
}








/**
 * Tipo condicional: CNPJ (14 dígitos) ou código GSNet (alfanumérico, 1-10 chars).
 * Quando #type === 'L' (Local), valida como código GSNet.
 * Caso contrário, valida como CNPJ.
 * Usado no cadastro de clientes para atender SESSP/GSNet (MT-59A4923).
 */ const $7df6175fce9b618d$var$CNPJ_REGEX = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;
const $7df6175fce9b618d$var$GSNET_REGEX = /^[A-Za-z0-9]{1,10}$/;
function $7df6175fce9b618d$export$2e2bcd8739ae039(formSelector = '#customer') {
    return {
        regex: /^([A-Za-z0-9]{1,10}|(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}))$/,
        filter: /[.\/\-\s]/g,
        store_mask (match, p1) {
            return p1 || '';
        },
        display_mask: '$1',
        checkValue (value = this.getValue()) {
            const form = document.querySelector(formSelector);
            const typeEl = form?.querySelector('#type');
            const type = (typeEl?.value ?? '').trim().toUpperCase();
            const isLocal = type === 'L' || type === 'LOCAL';
            const cleaned = String(value ?? '').replace(this.filter, '').trim();
            if (isLocal) return cleaned.length > 0 && $7df6175fce9b618d$var$GSNET_REGEX.test(cleaned);
            return $7df6175fce9b618d$var$CNPJ_REGEX.test(cleaned);
        },
        format (value = this.getValue(), mask = this.display_mask) {
            if (value == null || value === '') return '';
            const form = document.querySelector(formSelector);
            const typeEl = form?.querySelector('#type');
            const type = (typeEl?.value ?? '').trim().toUpperCase();
            const isLocal = type === 'L' || type === 'LOCAL';
            const cleaned = String(value).replace(this.filter, '').trim();
            if (isLocal) return this.checkValue(value) ? cleaned : '';
            return this.checkValue(value) ? cleaned.replace($7df6175fce9b618d$var$CNPJ_REGEX, '$1.$2.$3/$4-$5') : '';
        }
    };
}








/** Número de empenho: AAAA + NE + sequência (ex.: 2025NE02173). Vazio é permitido. */ function $01514eb1e21db7c4$export$2e2bcd8739ae039() {
    return {
        regex: /^$|^\d{4}NE\d+$/i,
        filter: /\s+/g
    };
}











function $bba672065f562b52$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^((?:[0-9A-Z]{1,2})(?:[,-][0-9A-Z]{1,2})*)$/,
        getValue (default_value, _this = this) {
            return this.safeProtoCall(default_value, _this)?.split(/[,-]/);
        },
        store_mask (match) {
            return match.split(/[,-]/).join(',');
        },
        display_mask (match, ...args) {
            return match.split(',').join('-');
        }
    };
}













function $1fc4b4ad289a0aae$export$2e2bcd8739ae039(...args) {
    const lengths = Array.isArray(args[0]) ? args[0] : args.filter(Number.isInteger);
    const pattern = lengths.length > 1 ? lengths.map((n)=>`[A-NP-Z0-9]{${n}}`).join('|') : `[A-NP-Z0-9]{${lengths[0] || args[0]}}`;
    return {
        type: 'sku',
        regex: new RegExp(`^(${pattern})$`),
        filter: /[]/g
    };
}





/**
 * Observer: ao sair do campo CEP (blur), consulta ViaCEP (base dos Correios)
 * e preenche logradouro, bairro, UF e município. O município é resolvido
 * via IndexedDB ou API quando não houver cache local.
 */ 
var $1cmSR = parcelRequire("1cmSR");



const $b99c2345a91aed9b$var$VIACEP_URL = 'https://viacep.com.br/ws';
function $b99c2345a91aed9b$export$2e2bcd8739ae039() {
    return {
        events: [
            'blur'
        ],
        async handleEvents (ev) {
            if (ev.type !== 'blur') return;
            const node = document.querySelector(this.selector);
            if (!node?.form) return;
            const cep = (node.value || '').replace(/\D/g, '');
            if (cep.length !== 8) return;
            const m = this.selector?.match(/#(\w+)_zipcode$/);
            const pre = m ? m[1] : 'address';
            const streetEl = node.form.querySelector(`#${pre}_street`);
            const districtEl = node.form.querySelector(`#${pre}_district`);
            const stateEl = node.form.querySelector(`#${pre}_state`);
            const cityEl = node.form.querySelector(`#${pre}_city_id`);
            try {
                const res = await fetch(`${$b99c2345a91aed9b$var$VIACEP_URL}/${cep}/json/`);
                const data = await res.json();
                if (data?.erro) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("CEP n\xe3o encontrado na base dos Correios.", 'Consulta CEP');
                    return;
                }
                if (streetEl) streetEl.value = data.logradouro || '';
                if (districtEl) districtEl.value = data.bairro || '';
                if (stateEl) {
                    stateEl.value = data.uf || '';
                    stateEl.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
                if (cityEl && data.localidade && data.uf) await $b99c2345a91aed9b$var$_resolveAndSetCity(this.form, cityEl, data.localidade, data.uf, pre);
            } catch (_) {}
        }
    };
}
async function $b99c2345a91aed9b$var$_resolveAndSetCity(form, cityEl, cityName, uf, prefix) {
    if (!form || !cityEl) return;
    const u = String(uf || '').trim().toUpperCase().slice(0, 2);
    const norm = (s)=>String(s || '').toLowerCase().trim();
    const target = norm(cityName);
    let cities = await (0, $1cmSR.default).list('cities', IDBKeyRange.bound([
        u,
        ''
    ], [
        u,
        '\uffff'
    ]), 2).catch(()=>[]);
    if (!cities?.length && u.length >= 2) {
        const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_cities, `?filter=state*eq*${encodeURIComponent(u)}&limit=500`);
        cities = Array.isArray(data) ? data : [];
    }
    const city = (cities || []).find((c)=>norm(c?.city) === target);
    if (city) {
        (0, $c643adc13e6018a8$export$cad72087bded938)(`#${prefix}_city_id`, cities, 'id', [
            'city'
        ]);
        const cityField = form.getFieldBySelector?.(`#${prefix}_city_id`);
        if (cityField) {
            cityField.setValue(city.city);
            cityField.refresh?.();
        } else if (cityEl) cityEl.value = city.city;
    } else if (cityName) cityEl.value = cityName;
}




var $1cmSR = parcelRequire("1cmSR");

/** CFOPs do cadastro: Entrada → 1/2/3xxx; Saída e Ativo → 5/6/7xxx. */ function $f361d28f145f8e93$var$cfopMatchesIoType(code, ioType) {
    const s = String(code || '').trim();
    if (s.length < 1) return false;
    const f = s[0];
    if (ioType === 'I') return f === '1' || f === '2' || f === '3';
    if (ioType === 'O' || ioType === 'A') return f === '5' || f === '6' || f === '7';
    return true;
}
function $f361d28f145f8e93$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        captureEvents (_this = this) {
            this.hook();
            this.safeProtoCall(_this);
        },
        hook () {
            [
                'company_id',
                'io_type'
            ].forEach((name)=>{
                const id = this.makeId(name);
                const field = this.locate(id);
                if (!field) throw new Error(`obs_cfops_invoice: campo n\xe3o encontrado: ${id}`);
                field.subscribe([
                    'change'
                ], this.actions.bind(this), false);
            });
        },
        makeId (name) {
            const parts = this.getIdParts();
            const form = parts[1];
            const index = parts[3];
            if (name.match((0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a)) && index) name = (0, $a2e5868bc3913d81$export$77b8d1f921212127)(name, index.substr(1));
            return form + name;
        },
        getIdParts () {
            return this.getId().match(/([^.]+\.)([^-]+)(-\d+)?/);
        },
        async preventMultiCalls (object, primary_callback, secondary_callback) {
            const listAttr = document.querySelector(this.selector)?.getAttribute('list');
            const is_datalist_indexed = Boolean(listAttr && (0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a).test(listAttr));
            const is_action_ongoing = Boolean(object._this);
            if (!is_datalist_indexed && is_action_ongoing) object._this.subscribe([
                'done'
            ], secondary_callback);
            else {
                object._this = this;
                await primary_callback();
                if (!is_datalist_indexed) object._this.publish('done');
                object._this = null;
            }
        },
        async actions () {
            const run = async ()=>{
                let cid = this.locate('company_id')?.getValue?.();
                if (typeof cid === 'string' && /^\d+$/.test(cid)) cid = Number(cid);
                const io = this.locate('io_type')?.getValue?.() || 'O';
                if (!cid) {
                    (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, [], 'code', [
                        'code',
                        'description'
                    ], ': ');
                    this.refresh();
                    return;
                }
                const range = IDBKeyRange.bound([
                    cid,
                    ''
                ], [
                    cid,
                    '\uffff'
                ]);
                let data = await (0, $1cmSR.default).list('cfops', range, 2);
                data = (data || []).filter((r)=>!r.is_disabled);
                data = data.filter((r)=>$f361d28f145f8e93$var$cfopMatchesIoType(r.code, io));
                (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, data, 'code', [
                    'code',
                    'description'
                ], ': ');
                this.refresh();
            };
            await this.preventMultiCalls(SHARED, run, ()=>this.refresh());
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");
function $89a9d177dbffd6c2$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, customer_id) {
            if (!this.isEmpty()) return;
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !customer_id || customer_id < 0) return;
            let customer = await (0, $1cmSR.default).get('customers', [
                company_id,
                Number(customer_id)
            ]);
            if (!customer || !customer['price_list_id']) return;
            let price_list = await (0, $1cmSR.default).get('price_lists', [
                company_id,
                customer['price_list_id']
            ]);
            if (!price_list || !price_list['discount']) return;
            this.setValue(price_list['discount']);
            this.refresh();
        }
    };
}



/**
 * Ao digitar no campo município, refaz a busca com q= (aceita sem acento: julio = júlio).
 * Requer obs_load_cities e observer(stateField). stateField = 'billing_address_state' ou 'delivery_address_state'.
 */ 
/**
 * Carrega cidades da API quando o campo UF (state) muda.
 * Aceita parâmetro q para busca sem acentos (julio = júlio).
 * Uso: types.observer('billing_address_state'), types.obs_load_cities() e types.obs_filter_cities(stateField).
 */ 

const $e0cb16d31f76baa7$var$CITIES_CACHE = {};
function $e0cb16d31f76baa7$export$8723790a11912be0(uf, q) {
    const u = String(uf || '').trim().toUpperCase().slice(0, 2);
    if (!u || u.length < 2) return Promise.resolve([]);
    let query = `?filter=state*eq*${encodeURIComponent(u)}&limit=500`;
    if (q && String(q).trim()) query += `&q=${encodeURIComponent(String(q).trim())}`;
    return (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_cities, query).then((d)=>Array.isArray(d) ? d : []);
}
function $e0cb16d31f76baa7$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        async actions (ev, publisher, state) {
            const action = async (uf)=>{
                const u = String(uf || '').trim().toUpperCase().slice(0, 2);
                if (!u || u.length < 2) {
                    (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, [], 'id', [
                        'city'
                    ]);
                    this.refresh?.();
                    return;
                }
                const data = await $e0cb16d31f76baa7$export$8723790a11912be0(u, '');
                (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, data, 'id', [
                    'city'
                ]);
                this.refresh?.();
            };
            const uf = String(state ?? '').trim().toUpperCase().slice(0, 2);
            if (uf.length >= 2) this.preventMultiCalls(SHARED, action, ()=>this.refresh?.(), uf);
            else action(uf);
        }
    };
}


let $201d7a75379b20b7$var$debounceTimer = null;
const $201d7a75379b20b7$var$DEBOUNCE_MS = 200;
function $201d7a75379b20b7$export$2e2bcd8739ae039(stateField) {
    return {
        _source: stateField,
        events: [
            'input'
        ],
        handleEvents (ev) {
            if (ev.type !== 'input') return;
            const node = document.querySelector(this.selector);
            if (!node?.form) return;
            const stateEl = node.form.querySelector(`#${stateField}`);
            const uf = stateEl?.value ? String(stateEl.value).trim().toUpperCase().slice(0, 2) : '';
            const q = (node.value || '').trim();
            clearTimeout($201d7a75379b20b7$var$debounceTimer);
            $201d7a75379b20b7$var$debounceTimer = setTimeout(async ()=>{
                const data = await (0, $e0cb16d31f76baa7$export$8723790a11912be0)(uf, q);
                (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, data, 'id', [
                    'city'
                ]);
                // Não chamar refresh() quando o valor atual já é um city_id (7 dígitos): evita apagar a seleção que o usuário acabou de fazer
                const currentVal = (node.value || '').trim();
                if (!/^\d{7}$/.test(currentVal)) this.refresh?.();
            }, $201d7a75379b20b7$var$DEBOUNCE_MS);
        }
    };
}






function $de971e0b3c51812e$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        async actions (ev, publisher, key) {
            const action = async ()=>{
                const company_id = this.locate('company_id')?.getValue();
                const product_id = key != null && key !== '' && !isNaN(key) ? Number(key) : null;
                this.setValue('');
                this.refresh();
                const gtinField = this.locate(this.makeId('packaging_gtin-0'));
                if (gtinField) {
                    gtinField.setValue('');
                    gtinField.refresh();
                }
                if (!company_id || product_id == null || isNaN(product_id) || product_id < 0) {
                    (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, [], 'id', [
                        'code',
                        'factor'
                    ], " \xb7 ");
                    this.refresh();
                    return;
                }
                const list = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_product_packagings_by_product, company_id, product_id);
                const opts = Array.isArray(list) ? list : [];
                (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, opts, 'id', [
                    'code',
                    'factor',
                    'gtin'
                ], " \xb7 ");
                this.refresh();
            };
            await this.preventMultiCalls(SHARED, action, ()=>this.refresh(), []);
        }
    };
}





function $78c0baa046d6948e$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        captureEvents (_this = this) {
            this.safeProtoCall(_this);
            this.subscribe([
                'change'
            ], this._onPackagingGtinChange.bind(this), false);
        },
        async preventMultiCalls (object, primary_callback, secondary_callback, ...args) {
            const el = document.querySelector(this.selector);
            const is_datalist_indexed = el && (0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a).test(el.getAttribute('list') || '');
            const is_action_ongoing = Boolean(object._this);
            if (!is_datalist_indexed && is_action_ongoing) object._this.subscribe([
                'done'
            ], secondary_callback);
            else {
                object._this = this;
                await primary_callback(...args);
                if (!is_datalist_indexed) object._this.publish('done', ...args);
                object._this = null;
            }
        },
        async _onPackagingGtinChange (_event_name, _publisher, value) {
            const action = async ()=>{
                const raw = (value != null && value !== '' ? String(value) : this.getValue() || '').trim();
                if (!raw) return;
                const company_id = this.locate('company_id')?.getValue();
                if (!company_id) return;
                const pack = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).resolve_packaging_gtin, company_id, raw);
                if (!pack) return;
                const prodSel = this.makeId('product_id-0');
                const pidField = this.locate(prodSel);
                const cur = pidField?.getValue();
                if (cur != null && cur !== '' && Number(cur) !== Number(pack.product_id)) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Este GTIN pertence a outro produto. Ajuste o produto ou o c\xf3digo bipado.", "Confer\xeancia");
                    return;
                }
                if (pidField && (cur == null || cur === '')) {
                    pidField.setValue(pack.product_id);
                    pidField.refresh();
                }
                const ppack = this.locate(this.makeId('product_packaging_id-0'));
                if (ppack) {
                    ppack.setValue(pack.id);
                    ppack.refresh();
                }
            };
            await this.preventMultiCalls(SHARED, action, ()=>this.refresh(), []);
        },
        makeId (name) {
            const parts = this.getId().match(/([^.]+\.)([^-]+)(-\d+)?/);
            const form = parts[1];
            const index = parts[3];
            if (name.match((0, $a2e5868bc3913d81$export$b38aa3fcbc4fc60a))) name = (0, $a2e5868bc3913d81$export$77b8d1f921212127)(name, index.substr(1));
            return form + name;
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");
function $d799b5dade42e782$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, lot_id) {
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !lot_id || lot_id < 0) return;
            let lot = await (0, $1cmSR.default).get('lots', [
                company_id,
                Number(lot_id)
            ], 1);
            if (!lot) return;
            if (this.isEmpty()) {
                this.setValue(lot.lot_number);
                this.refresh();
            }
            let product = await (0, $1cmSR.default).get('products', [
                company_id,
                lot.product_id
            ]);
            if (!product) return;
            let sku = this.locate(this.makeId('sku-0'));
            if (sku.isEmpty()) {
                sku.setValue(product.sku.join(''));
                sku.refresh();
            }
            let productName = this.locate(this.makeId('product_name-0'));
            if (productName && productName.isEmpty()) {
                productName.setValue(product.name || '');
                productName.refresh();
            }
            let expiration = this.locate(this.makeId('expiration_date-0'));
            if (expiration && expiration.isEmpty() && lot.expiration_date) {
                const ed = String(lot.expiration_date);
                expiration.setValue(ed.length >= 10 ? ed.slice(0, 10) : ed);
                expiration.refresh();
            }
        }
    };
}




var $1cmSR = parcelRequire("1cmSR");
function $a3bd40443322c074$export$2e2bcd8739ae039(...args) {
    let SHARED = {
        _this: null
    };
    return {
        _customerIsLocal: false,
        isRequired () {
            const pm = this.locate?.('payment_method')?.getValue?.();
            if (pm === '90' || pm === 90) return false; // Sem Pagamento → Condição opcional
            if (this._customerIsLocal) return false; // Cliente tipo Local (entrega) → Condição opcional
            return document.querySelector(this.selector)?.hasAttribute('required') ?? true;
        },
        async actions (ev, publisher, value) {
            switch(publisher.selector){
                case '#company_id':
                    await this.loadPaymentTerms(value);
                    break;
                case '#customer_id':
                    await this.setPaymentTerm(value);
                    break;
            }
        },
        async loadPaymentTerms (company_id) {
            const action = async (company_id)=>{
                let payment_terms = await (0, $1cmSR.default).list('payment_terms', IDBKeyRange.bound([
                    company_id,
                    ''
                ], [
                    company_id,
                    '\uffff'
                ]));
                (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, payment_terms, 'id', [
                    'name'
                ]);
                this.refresh();
            };
            if (typeof company_id == 'string') this.preventMultiCalls(SHARED, action, ()=>this.refresh(), company_id);
        },
        async setPaymentTerm (customer_id) {
            let company_id = this.locate('company_id')?.getValue?.();
            const el = document.querySelector(this.selector);
            if (!company_id || company_id < 0 || !customer_id || customer_id === '' || customer_id < 0) {
                this._customerIsLocal = false;
                if (el) {
                    el.removeAttribute('readonly');
                    el.setAttribute('required', '');
                }
                return;
            }
            let customer = await (0, $1cmSR.default).get('customers', [
                company_id,
                Number(customer_id)
            ]);
            const isLocal = customer?.type === 'L' || customer?.type?.toUpperCase?.() === 'L';
            if (isLocal) {
                this._customerIsLocal = true;
                this.setValue?.('');
                this.refresh?.();
                this.locate?.('payment_method')?.setValue?.('90');
                this.locate?.('payment_method')?.refresh?.();
                if (el) {
                    el.setAttribute('readonly', '');
                    el.removeAttribute('required');
                }
                this.checkErrorState?.();
                return;
            }
            this._customerIsLocal = false;
            if (el) {
                el.removeAttribute('readonly');
                el.setAttribute('required', '');
            }
            // Sempre preenche com o valor do cadastro do cliente (permite alterar manualmente depois)
            if (customer?.payment_term_id != null && customer.payment_term_id !== '') {
                this.setValue(customer.payment_term_id);
                this.refresh();
            }
            this.checkErrorState?.();
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");

function $72c559d121507028$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, value) {
            let company_id = this.locate('company_id')?.getValue?.();
            let customer_id = this.locate('customer_id')?.getValue?.();
            let product_id = this.locate(this.makeId('product_id-0'))?.getValue?.();
            // Só usa value como product_id quando a mudança veio do campo produto (evita usar customer_id em linhas vazias)
            const isProductChange = publisher && String(publisher.selector || '').includes('product_id');
            if (!product_id && isProductChange && value != null && !isNaN(Number(value)) && Number(value) >= 0) product_id = value;
            product_id = Number(product_id);
            if (!company_id || !customer_id || !product_id || product_id <= 0) return;
            // Resolve customer_id (pode ser id numérico ou label)
            let cid = Number(customer_id);
            if (isNaN(cid) || cid < 0) {
                let custField = this.locate('customer_id');
                let node = custField ? document.querySelector(custField.selector) : null;
                let opt = node?.list ? Array.from(node.list.options || []).find((o)=>o.innerText?.trim() === String(customer_id).trim() || o.value == customer_id) : null;
                cid = opt ? Number(opt.value) : -1;
            }
            if (isNaN(cid) || cid < 0) return;
            customer_id = cid;
            // 1) Tabela de preço por cliente (customer_prices)
            let unit_price = null;
            let discount = null;
            try {
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).customer_price_get, company_id, customer_id, product_id);
                if (resp && typeof resp.unit_price === 'number') {
                    unit_price = resp.unit_price;
                    if (resp.discount != null && !isNaN(Number(resp.discount))) discount = Number(resp.discount);
                }
            } catch (_) {}
            // 2) Fallback: lista de preço do cliente (price_list_id)
            if (unit_price == null) {
                let customer = await (0, $1cmSR.default).get('customers', [
                    company_id,
                    customer_id
                ]);
                if (!customer || !customer['price_list_id']) return;
                let price_list = await (0, $1cmSR.default).get('price_lists', [
                    company_id,
                    customer['price_list_id']
                ]);
                if (!price_list || !price_list.prices) return;
                let price = price_list.prices.find((p)=>p.product_id == product_id);
                if (!price) return;
                unit_price = price.unit_price;
                if (price.discount != null) discount = Number(price.discount);
            }
            if (unit_price != null) {
                this.setValue(unit_price);
                this.refresh();
                let discountField = this.locate(this.makeId('discount-0'));
                if (discount != null && discountField) {
                    discountField.setValue(discount);
                    discountField.refresh();
                }
            }
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");

function $e247330830b80775$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, category_id) {
            let company_id = this.locate('company_id').getValue();
            const catId = category_id != null && category_id !== '' ? Number(category_id) : null;
            if (!company_id || company_id === '' || catId == null || catId < 0) return;
            let category = await (0, $1cmSR.default).get('categories', [
                company_id,
                catId
            ], 1);
            if (!category || !category.attributes) return;
            const attr = category.attributes[0];
            const lengths = attr.lengths && attr.lengths.length ? attr.lengths : [
                attr.length
            ];
            this.form.fields[this.getId()].releaseEvents();
            this.form.fields[this.getId()] = (this?.type == 'sku' ? this.scrapeTypes(1) : this).appendType($1fc4b4ad289a0aae$export$2e2bcd8739ae039(lengths));
            this.form.fields[this.getId()].captureEvents();
            this.form.fields[this.getId()].refresh();
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");
const $e270bdf959c5d325$var$clearRow = function(row) {
    row.querySelectorAll('TD').forEach((column)=>column.parentNode.removeChild(column));
// Precisa destruir eventuais campos que existam no form também
};
const $e270bdf959c5d325$var$appendColumn = function(row, properties) {
    let td = document.createElement('TD');
    let input = document.createElement('INPUT');
    Object.keys(properties).forEach((key)=>{
        if (key == 'required' && properties[key]) input.setAttribute(key, '');
        else input[key] = properties[key];
    });
    td.appendChild(input);
    row.appendChild(td);
// Precisa criar um campo no form também e vincular ao id do elemento criado
// Atribuir algum tipo ao campo criado?
};
function $e270bdf959c5d325$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, category_id) {
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !category_id || category_id < 0) return;
            let category = await (0, $1cmSR.default).get('categories', [
                company_id,
                Number(category_id)
            ], 1);
            if (!category || !category.attributes) return;
            let sku = document.querySelector(`${args[0]} TR`);
            let taxons = document.querySelector(`${args[1]} TR`);
            if (!sku || !taxons) return;
            $e270bdf959c5d325$var$clearRow(sku);
            $e270bdf959c5d325$var$clearRow(taxons);
            category.attributes.forEach((attribute, index)=>{
                $e270bdf959c5d325$var$appendColumn(sku, {
                    id: args[0].slice(1),
                    type: 'text',
                    size: attribute.length,
                    title: attribute.name,
                    required: !attribute.is_optional
                });
                $e270bdf959c5d325$var$appendColumn(taxons, {
                    id: args[1].slice(1),
                    type: 'text',
                    size: 1,
                    title: attribute.name,
                    required: !attribute.is_optional
                });
            //appendColumn(sku, { id: `${args[0].slice(1)}${index}`, type: 'text', size: attribute.length, title: attribute.name, required: !attribute.is_optional });
            //appendColumn(taxons, { id: `${args[1].slice(1)}${index}`, type: 'text', size: 1, title: attribute.name, required: !attribute.is_optional });
            });
        /*
			if (this.isEmpty())
			{
				this.setValue(lot.lot_number);
				this.refresh();
			}
			let product = await db.get('products', [company_id, lot.product_id]);
			if (!product)
				return;
			let sku = this.locate(this.makeId('sku-0'));
			if (sku.isEmpty())
			{
				sku.setValue(product.sku.join(''));
				sku.refresh();
			}
			*/ }
    };
}


/** Aceita tamanho único (ex: 6) ou múltiplos separados por vírgula (ex: 5,6,10) ou range (ex: 1-12). */ function $6f5d856b9353a912$export$2e2bcd8739ae039() {
    return {
        regex: /^(\d+)([\s,]\s*\d+)*$|^(\d+)\s*-\s*(\d+)$/,
        filter: /[\s]/g,
        store_mask: '$&',
        display_mask: '$&'
    };
}



function $d0e5a3fdd77559d6$export$2e2bcd8739ae039(...args) {
    let SHARED = {
        _this: null
    };
    return {
        async actions (ev, publisher, product_id) {
            let node = document.querySelector(this.selector);
            if (!node) return;
            node.setAttribute('placeholder', '');
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !product_id || product_id < 0) return;
            let stocks = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_stocks_by_product, company_id, product_id);
            if (!stocks) return;
            let quantity = stocks.reduce((accumulator, entry)=>accumulator + entry.quantity_available, 0);
            node.setAttribute('placeholder', quantity);
        }
    };
}




var $1cmSR = parcelRequire("1cmSR");
function $f7ae7d91f57919c4$export$2e2bcd8739ae039(...args) {
    let SHARED = {
        _this: null
    };
    return {
        _unit: args[0] ? 'purchasing_unit_id' : 'selling_unit_id',
        async actions (ev, publisher, value) {
            switch(true){
                case /^#company_id/.test(publisher.selector):
                    await this.loadUnits(value);
                    break;
                case /^#product_id/.test(publisher.selector):
                    await this.setUnit(value);
                    break;
            }
        },
        async loadUnits (company_id) {
            const action = async (company_id)=>{
                let units = await (0, $1cmSR.default).list('units', IDBKeyRange.bound([
                    company_id,
                    ''
                ], [
                    company_id,
                    '\uffff'
                ]));
                (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, units, 'id', [
                    'name'
                ]);
                this.refresh();
            };
            if (typeof company_id == 'string') this.preventMultiCalls(SHARED, action, ()=>this.refresh(), company_id);
        },
        async setUnit (product_id) {
            if (!this.isEmpty()) return;
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !product_id || product_id < 0) return;
            let product = await (0, $1cmSR.default).get('products', [
                company_id,
                Number(product_id)
            ]);
            if (!product) return;
            let unit = await (0, $1cmSR.default).get('units', [
                company_id,
                product[this._unit]
            ]);
            if (!unit) return;
            this.setValue(unit['id']);
            this.refresh();
            this.checkErrorState();
        }
    };
}




function $c064992517a328df$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1202',
                label: "1202: Devolu\xe7\xe3o de venda no estado"
            },
            {
                value: '2202',
                label: "2202: Devolu\xe7\xe3o de venda outros estados"
            },
            {
                value: '1411',
                label: "1411: Devolu\xe7\xe3o de venda sujeita ao ICMS-ST no estado"
            },
            {
                value: '2411',
                label: "2411: Devolu\xe7\xe3o de venda sujeita ao ICMS-ST outros estados"
            },
            {
                value: '1949',
                label: "1949: Outra entrada de mercadoria n\xe3o especificada no estado"
            },
            {
                value: '2949',
                label: "2949: Outra entrada de mercadoria n\xe3o especificada outros estados"
            },
            {
                value: '5102',
                label: '5102: Venda de mercadoria no estado'
            },
            {
                value: '6102',
                label: '6102: Venda de mercadoria outros estados'
            },
            {
                value: '6108',
                label: "6108: Venda de mercadoria a n\xe3o contribuinte outros estados"
            },
            {
                value: '5202',
                label: "5202: Devolu\xe7\xe3o de compra no estado"
            },
            {
                value: '6202',
                label: "6202: Devolu\xe7\xe3o de compra outros estados"
            },
            {
                value: '5405',
                label: '5405: Venda de mercadoria sujeita ao ICMS-ST no estado'
            },
            {
                value: '5411',
                label: "5411: Devolu\xe7\xe3o de compra sujeita ao ICMS-ST no estado"
            },
            {
                value: '6411',
                label: "6411: Devolu\xe7\xe3o de compra sujeita ao ICMS-ST outros estados"
            },
            {
                value: '5910',
                label: "5910: Remessa em bonifica\xe7\xe3o, doa\xe7\xe3o ou brinde no estado"
            },
            {
                value: '6910',
                label: "6910: Remessa em bonifica\xe7\xe3o doa\xe7\xe3o ou brinde outros estados"
            },
            {
                value: '5911',
                label: "5911: Remessa de amostra gr\xe1tis no estado"
            },
            {
                value: '6911',
                label: "6911: Remessa de amostra gr\xe1tis outros estados"
            },
            {
                value: '5927',
                label: "5927: Baixa de estoque decorrente de perda, roubo ou deteriora\xe7\xe3o"
            },
            {
                value: '5949',
                label: "5949: Outra sa\xedda de mercadoria ou servi\xe7o n\xe3o especificado"
            },
            {
                value: '5119',
                label: '5119: Venda de mercadoria entregue por conta e ordem do adquirente'
            },
            {
                value: '6120',
                label: "6120: Venda de mercadoria entregue pelo vendedor em venda \xe0 ordem"
            },
            {
                value: '5923',
                label: '5923: Remessa de mercadoria por conta e ordem de terceiros no estado'
            },
            {
                value: '6923',
                label: '6923: Remessa de mercadoria por conta e ordem de terceiros outros estados'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}




function $6fc24243d89a5cc8$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            //{ value: '1', label: 'Simples' },
            {
                value: '3',
                label: 'Normal'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $409d889ae18b953b$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'P',
                label: 'Impressora'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}





function $c1af72f481ddf4d0$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'GET',
                label: 'GET'
            },
            {
                value: 'PUT',
                label: 'PUT'
            },
            {
                value: 'POST',
                label: 'POST'
            },
            {
                value: 'PATCH',
                label: 'PATCH'
            },
            {
                value: 'DELETE',
                label: 'DELETE'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}




function $b23279d219d3efdd$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1',
                label: "Autoriza\xe7\xe3o"
            },
            {
                value: '2',
                label: "Corre\xe7\xe3o"
            },
            {
                value: '3',
                label: 'Cancelamento'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $79f43e37b9b6ec01$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Criado'
            },
            {
                value: '20',
                label: 'Aprovado'
            },
            {
                value: '30',
                label: 'Pendente'
            },
            {
                value: '40',
                label: "Conclu\xeddo"
            },
            {
                value: '50',
                label: 'Cancelado'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $2d17d508d4f555c6$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Criada'
            },
            {
                value: '14',
                label: 'Faturando'
            },
            {
                value: '16',
                label: 'Faturada'
            },
            {
                value: '20',
                label: 'Recebendo'
            },
            {
                value: '30',
                label: 'Recebida'
            },
            {
                value: '40',
                label: 'Conferindo'
            },
            {
                value: '50',
                label: 'Conferida'
            },
            {
                value: '60',
                label: "Endere\xe7ando"
            },
            {
                value: '70',
                label: "Conclu\xedda"
            },
            {
                value: '80',
                label: 'Cancelada'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $d0f482af46bfd35e$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Iniciado'
            },
            {
                value: '20',
                label: 'Encerrado'
            },
            {
                value: '30',
                label: 'Cancelado'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $7090be8ac1a98b2f$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1',
                label: 'FEFO'
            },
            {
                value: '2',
                label: 'FIFO'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $759a03b3eb0eafb9$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'I',
                label: 'Entrada'
            },
            {
                value: 'O',
                label: "Sa\xedda"
            },
            {
                value: 'A',
                label: 'Ativo Imobilizado'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $6d521c92c25435df$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: "Sem restri\xe7\xe3o de SKUs"
            },
            {
                value: '1',
                label: 'Lotes distintos do SKU'
            },
            {
                value: '2',
                label: 'Apenas mesmo lote'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $2372640607a5ee0b$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'Livre'
            },
            {
                value: '1',
                label: 'Em uso'
            },
            {
                value: '2',
                label: 'Entrada Bloqueada'
            },
            {
                value: '3',
                label: 'Entrada Bloqueada'
            },
            {
                value: '4',
                label: "Sa\xedda Bloqueada"
            },
            {
                value: '5',
                label: "Sa\xedda Bloqueada"
            },
            {
                value: '6',
                label: 'Toda Bloqueada'
            },
            {
                value: '7',
                label: 'Toda Bloqueada'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $84a270a7f3d1546a$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'Pendente'
            },
            {
                value: '1',
                label: 'Verificado'
            },
            {
                value: '3',
                label: 'Etiquetado'
            },
            {
                value: '5',
                label: 'Armazenado'
            },
            {
                value: '7',
                label: 'Armazenado'
            },
            {
                value: '8',
                label: 'Bloqueado'
            },
            {
                value: '9',
                label: 'Bloqueado'
            },
            {
                value: '11',
                label: 'Bloqueado'
            },
            {
                value: '15',
                label: 'Bloqueado'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}




function $e3d776cc66101a71$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'I',
                label: 'Entrada'
            },
            {
                value: 'O',
                label: "Sa\xedda"
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}




function $05cf4050e889bf62$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Criado'
            },
            {
                value: '20',
                label: 'Aprovado'
            },
            {
                value: '30',
                label: 'Parcialmente atendido'
            },
            {
                value: '35',
                label: 'Sem estoque'
            },
            {
                value: '40',
                label: "Conclu\xeddo"
            },
            {
                value: '50',
                label: 'Processando'
            },
            {
                value: '60',
                label: 'Cancelado'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $f08968bc7ef228cb$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Criada'
            },
            {
                value: '20',
                label: 'Separando'
            },
            {
                value: '30',
                label: 'Separada'
            },
            {
                value: '40',
                label: 'Conferindo'
            },
            {
                value: '50',
                label: 'Unpick'
            },
            {
                value: '60',
                label: 'Conferida'
            },
            {
                value: '65',
                label: 'Faturando'
            },
            {
                value: '70',
                label: 'Faturada'
            },
            {
                value: '80',
                label: 'Despachando'
            },
            {
                value: '90',
                label: "Conclu\xedda"
            },
            {
                value: '100',
                label: 'Cancelada'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}






function $c539c39a88864005$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'Livre'
            },
            {
                value: '10',
                label: 'Bloqueado'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



function $bdd84d0eadfe1c66$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'I',
                label: 'Entrada'
            },
            {
                value: 'O',
                label: "Sa\xedda"
            },
            {
                value: 'L',
                label: "Posi\xe7\xe3o"
            },
            {
                value: 'R',
                label: 'Reserva'
            },
            {
                value: 'B',
                label: 'Bloqueio'
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}




function $67779c32de42857b$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'M',
                label: "Multiplica\xe7\xe3o"
            },
            {
                value: 'D',
                label: "Divis\xe3o"
            }
        ],
        captureEvents (_this = this) {
            (0, $c643adc13e6018a8$export$cad72087bded938)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}





async function $62f41054efe4ec85$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; }
			.view td:nth-child(3)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: right; }
			.view td:nth-child(12)	{ text-align: right; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Apelido</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">CNPJ</th>
					<th data-index="5" data-visible="${this.visible[4]}">IE</th>
					<th data-index="6" data-visible="${this.visible[5]}">Tipo IE</th>
					<th data-index="8" data-visible="${this.visible[6]}">Fone</th>
					<th data-index="10" data-visible="${this.visible[7]}">Invent\xe1rio</th>
					<th data-index="11" data-visible="${this.visible[8]}">CRT</th>
					<th data-index="12" data-visible="${this.visible[9]}">PIS</th>
					<th data-index="13" data-visible="${this.visible[10]}">COFINS</th>
					<th data-index="14" data-visible="${this.visible[11]}">Tributos</th>
					<th data-index="15" data-visible="${this.visible[12]}">S\xe9rie</th>
					<th data-index="16" data-visible="${this.visible[13]}">Autorizados</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${record.nick}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[3]}'>${this.format($7fda302dcbccda19$export$2e2bcd8739ae039(), record.cnpj)}</td>
					<td data-visible='${this.visible[4]}'>${this.format($c215c48c03ffee69$export$2e2bcd8739ae039(), record.ie)}</td>
					<td data-visible='${this.visible[5]}'>${this.option($7582832548ac84df$export$2e2bcd8739ae039(), record.ie_type)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($e576b042880c33f1$export$2e2bcd8739ae039(), record.phone)}</td>
					<td data-visible='${this.visible[7]}'>${this.option($7090be8ac1a98b2f$export$2e2bcd8739ae039(), record.inventory_strategy)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($6fc24243d89a5cc8$export$2e2bcd8739ae039(), record.crt)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.pis)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.cofins)}</td>
					<td data-visible='${this.visible[11]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.estimated_taxes)}</td>
					<td data-visible='${this.visible[12]}'>${record.invoice_series}</td>
					<td data-visible='${this.visible[13]}'>${this.format($ba016d80ddaca15b$export$2e2bcd8739ae039(), record.authorized_parties)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




const $367c2691d157ba2f$var$COMPANY_PARAMS_HELP_HTML = `
<div class="company-params-help-body">
<h4>Invent\xe1rio \u{2014} Permite vencido</h4>
<p>Quando marcado, o sistema pode considerar lotes com validade vencida nas opera\xe7\xf5es de invent\xe1rio desta empresa (caso contr\xe1rio, tende a trat\xe1-los como ineleg\xedveis). Use com alinhamento \xe0 pol\xedtica fiscal e operacional do depositante.</p>
<h4>Invent\xe1rio \u{2014} Exige lote</h4>
<p>Exige identifica\xe7\xe3o de lote nas rotinas de invent\xe1rio: posi\xe7\xf5es e contagens precisam estar vinculadas a um lote v\xe1lido, reduzindo movimenta\xe7\xe3o \u{201C}sem lote\u{201D}.</p>
<h4>Invent\xe1rio \u{2014} Por programa</h4>
<p>O invent\xe1rio passa a respeitar o programa (ex.: aloca\xe7\xe3o por programa de medicamentos): saldos e contagens s\xe3o avaliados no contexto do programa do lote/produto, n\xe3o apenas por SKU e posi\xe7\xe3o.</p>
<h4>Invent\xe1rio \u{2014} Bloqueio por classe</h4>
<p>Aplica restri\xe7\xf5es ligadas \xe0 classe do produto (ex.: classes que exigem tratamento diferenciado no invent\xe1rio ou na confer\xeancia). Complementa regras j\xe1 existentes de produto/classe.</p>
<h4>Invent\xe1rio \u{2014} Toler\xe2ncia confer\xeancia</h4>
<p>Valor inteiro de toler\xe2ncia usado nas regras de confer\xeancia de invent\xe1rio para esta empresa (margem aceit\xe1vel antes de apontar diverg\xeancia). Zero desativa toler\xe2ncia adicional; ajuste conforme acordo operacional.</p>
<h4>Embalagens \u{2014} Hierarquia de embalagens</h4>
<p>Ativa o modelo de embalagens em n\xedveis (prim\xe1ria, secund\xe1ria, terci\xe1ria) cadastradas no produto. Sem isso, o SIAL permanece no comportamento legado (uma unidade de venda / embalagem simples).</p>
<h4>Embalagens \u{2014} Unitariza\xe7\xe3o</h4>
<p>Permite que o picking/opera\xe7\xe3o utilize a <strong>embalagem prim\xe1ria</strong> (unidade fracionada) quando aplic\xe1vel. S\xf3 faz sentido com hierarquia ativa e cadastro correto dos fatores. Clientes legados costumam deixar desmarcado.</p>
<h4>Embalagens \u{2014} Picking otimizado</h4>
<p>O motor de separa\xe7\xe3o tende a escolher combina\xe7\xf5es de embalagem que <strong>minimizem quebra</strong> de fardos/caixas (ex.: priorizar m\xfaltiplos da embalagem maior). Depende de cadastro de embalagens e, quando aplic\xe1vel, capacidade terci\xe1ria.</p>
<h4>Embalagens \u{2014} Quebra terci\xe1ria / secund\xe1ria</h4>
<p><strong>Terci\xe1ria:</strong> autoriza \u{201C}abrir\u{201D} o fardo/paletiza\xe7\xe3o para atender quantidades que n\xe3o fecham m\xfaltiplo da terci\xe1ria.<br>
<strong>Secund\xe1ria:</strong> idem para o n\xedvel da caixa/fechamento secund\xe1rio. Se desmarcado e o pedido exigir fra\xe7\xe3o, o atendimento pode ficar bloqueado ou reduzido conforme a regra de picking.</p>
<h4>Embalagens \u{2014} Valida GTIN (embalagem)</h4>
<p>Passa a validar o GTIN informado nas embalagens cadastradas (confer\xeancia com c\xf3digo de barras / evita diverg\xeancia entre EAN do produto e o da embalagem).</p>
<h4>Embalagens \u{2014} Rollback legado</h4>
<p>For\xe7a caminhos de processamento compat\xedveis com o fluxo anterior do sistema, ignorando extens\xf5es novas de embalagem/picking quando definido pela pol\xedtica de migra\xe7\xe3o ou conting\xeancia.</p>
</div>`;
var $367c2691d157ba2f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#company #id					{ width: 20rem;		}
			#company #nick					{ width: 10rem; 	}
			#company #name					{ width: 25rem; 	}
			#company #cnpj					{ width: 10rem;		}
			#company #ie					{ width: 10rem;		}
			#company #ie_type				{ width: 10rem;		}
			#company #iest					{ width: 10rem;		}
			#company #phone					{ width: 10rem;		}
			#company #address_street		{ width: 30rem;		}
			#company #address_number		{ width: 5rem;		}
			#company #address_complement	{ width: 20rem;		}
			#company #address_district		{ width: 25rem;		}
			#company #address_state			{ width: 3.5rem;	}
			#company #address_city_id		{ width: 20rem;		}
			#company #address_zipcode		{ width: 6rem;		}
			#company #inventory_strategy	{ width: 6rem;		}
			#company #crt					{ width: 6rem;		}
			#company #pis					{ width: 4rem; text-align: right;	}
			#company #cofins				{ width: 4rem; text-align: right;	}
			#company #estimated_taxes		{ width: 4rem; text-align: right;	}
			#company #invoice_series		{ width: 4rem; text-align: right;	}
			#company #authorized_parties	{ width: 25rem; 	}
			#company #logo					{ width: 14rem; 	}
			#company #fiscal_modality		{ width: 10rem;		}
			#company #custody_warehouse_cnpj{ width: 12rem;		}
			#company #custody_emit_name			{ width: 28rem; }
			#company #custody_emit_ie			{ width: 12rem; }
			#company #custody_emit_phone		{ width: 10rem; }
			#company #custody_emit_crt			{ width: 6rem; }
			#company #custody_emit_address_street		{ width: 28rem; }
			#company #custody_emit_address_number		{ width: 5rem; }
			#company #custody_emit_address_complement	{ width: 18rem; }
			#company #custody_emit_address_district		{ width: 22rem; }
			#company #custody_emit_address_state			{ width: 3.5rem; }
			#company #custody_emit_address_city_id		{ width: 20rem; }
			#company #custody_emit_address_zipcode		{ width: 6rem; }
			#company #custody_emit_nfe_block { display: none; margin-top: 0.75rem; padding: 0.5rem 0; border-top: 1px solid #e5e7eb; }
			#company #custody_emit_nfe_block .custody-emit-title { font-size: 0.78rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: #374151; margin: 0 0 0.5rem 0; }
			#company #inv_conference_tolerance { width: 5rem; text-align: right; }
			#company .company-params-fieldset { min-width: 0; }
			#company .param-block { margin-top: 0.85rem; }
			#company .param-block:first-of-type { margin-top: 0.35rem; }
			#company .param-block-title {
				margin: 0 0 0.5rem 0;
				font-size: 0.75rem;
				font-weight: 700;
				letter-spacing: 0.04em;
				color: #374151;
				text-transform: uppercase;
			}
			#company .param-grid {
				display: grid;
				grid-template-columns: repeat(2, minmax(0, 1fr));
				gap: 0.35rem 1rem;
				align-items: center;
			}
			@media (min-width: 520px) {
				#company .param-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
			}
			#company label.param-check {
				display: grid;
				grid-template-columns: 1.0625rem minmax(0, 1fr);
				column-gap: 0.5rem;
				align-items: center;
				min-height: 1.65rem;
				min-width: 0;
			}
			#company label.param-check input[type="checkbox"] {
				width: 1.0625rem;
				height: 1.0625rem;
				margin: 0;
			}
			#company label.param-check .param-check-text {
				line-height: 1.3;
				font-size: 0.875rem;
			}
			#company label.param-num {
				display: inline-flex;
				align-items: center;
				gap: 0.5rem;
				flex-wrap: wrap;
			}
			#company .param-num-label {
				font-size: 0.875rem;
				white-space: nowrap;
			}
			#company .param-grid .param-num.param-num--row {
				grid-column: 1 / -1;
				margin-bottom: 0.15rem;
			}
			#company .company-params-legend {
				display: flex;
				align-items: center;
				gap: 0.45rem;
				flex-wrap: wrap;
				padding: 0;
				margin: 0 0 0.15rem 0;
				font-size: inherit;
				font-weight: inherit;
			}
			#company .company-params-help {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 1.35rem;
				height: 1.35rem;
				padding: 0;
				border: 1px solid #9ca3af;
				border-radius: 999px;
				background: #f3f4f6;
				color: #374151;
				font-size: 0.85rem;
				font-weight: 700;
				line-height: 1;
				cursor: pointer;
			}
			#company .company-params-help:hover {
				background: #e5e7eb;
			}
			#company .company-params-help:focus {
				outline: 2px solid #2563eb;
				outline-offset: 2px;
			}
		</style>
		<style>
			.company-params-help-body { max-height: 65vh; overflow-y: auto; text-align: left; }
			.company-params-help-body h4 {
				margin: 0.85rem 0 0.25rem 0;
				font-size: 0.78rem;
				font-weight: 700;
				text-transform: uppercase;
				letter-spacing: 0.03em;
				color: #1f2937;
			}
			.company-params-help-body h4:first-child { margin-top: 0; }
			.company-params-help-body p {
				margin: 0;
				font-size: 0.875rem;
				line-height: 1.45;
				color: #374151;
			}
		</style>
		<form id="company" class="form" autocomplete="off">
			<datalist id="strategies">
			</datalist>
			<datalist id="regimes">
			</datalist>
			<datalist id="cities">
			</datalist>
			<datalist id="states">
			</datalist>
			<div class="fsb">
				<label title="Identificador da empresa">Empresa
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome curto da empresa">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
				<label title="Nome ou raz\xe3o social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div>
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="N\xfamero do CNPJ">CNPJ<sup>*</sup>
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="N\xfamero da Inscri\xe7\xe3o Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscri\xe7\xe3o Estadual">Tipo IE<sup>*</sup>
					<input id="ie_type" type="text" list="ie_types" required>
				</label>
				<label class="file"><a id="download" download="logo.png">Logotipo</a>
					<input id="logo" type="file" accept=".png, image/x-png" title="Logotipo para emiss\xe3o da NFe (~128x128 pixels)">
				</label>
				<!--
				<label title="Inscri\xe7\xe3o Estadual do Substituto Tribut\xe1rio">IEST
					<input id="iest" type="text">
				</label>
				-->
			</div>
			<div class="fsb">
				<input type="hidden" id="address_id">
				<label title="Logradouro">Logradouro
					<input id="address_street" type="text">
				</label>
				<label title="N\xfamero">N\xfamero
					<input id="address_number" type="text">
				</label>
				<label title="Complemento">Complemento
					<input id="address_complement" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Bairro">Bairro
					<input id="address_district" type="text">
				</label>
				<label title="Unidade Federativa">UF
					<input id="address_state" type="text" list="states">
				</label>
				<label title="Munic\xedpio">Munic\xedpio
					<input id="address_city_id" type="text" list="cities">
				</label>
				<label title="CEP">CEP
					<input id="address_zipcode" type="text" placeholder="00000-000">
				</label>
			</div>
			<div class="fsb">
				<label title="Estrat\xe9gia de invent\xe1rio">Invent\xe1rio<sup>*</sup>
					<input id="inventory_strategy" type="text" list="strategies" required>
				</label>
				<label title="C\xf3digo de Regime Tribut\xe1rio">CRT<sup>*</sup>
					<input id="crt" type="text" list="regimes" required>
				</label>
				<label title="Al\xedquota de PIS">PIS<sup>*</sup>
					<input id="pis" type="text" placeholder="0,00" required>
				</label>
				<label title="Al\xedquota de COFINS">COFINS<sup>*</sup>
					<input id="cofins" type="text" placeholder="0,00" required>
				</label>
				<label title="Percentual estimado de tributos federais, estaduais e municipais">Tributos
					<input id="estimated_taxes" type="text" placeholder="0,00">
				</label>
				<label title="S\xe9rie da NFe">S\xe9rie<sup>*</sup>
					<input id="invoice_series" type="text" placeholder="0" required>
				</label>
				<label title="CPF ou CNPJ das pessoas autorizadas a acessar o XML da NFe">Autorizados
					<input id="authorized_parties" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Modalidade fiscal: normal ou fiel deposit\xe1rio">Modalidade Fiscal
					<select id="fiscal_modality">
						<option value="0">Normal</option>
						<option value="1">Fiel deposit\xe1rio</option>
					</select>
				</label>
				<span id="custody_row">
					<label title="CNPJ do armazenador (obrigat\xf3rio quando fiel deposit\xe1rio)">CNPJ armazenador
						<input id="custody_warehouse_cnpj" type="text" placeholder="00.000.000/0000-00">
					</label>
				</span>
			</div>
			<div id="custody_emit_nfe_block">
				<p class="custody-emit-title">Emitente na NF-e (armazenador \u{2014} mesmo CNPJ do certificado A1)</p>
				<p style="font-size:0.8rem;color:#6b7280;margin:0 0 0.5rem 0;">Preencha com os dados cadastrais desse CNPJ na SEFAZ. O depositante continua no cadastro principal acima.</p>
				<div class="fsb">
					<label title="Raz\xe3o social que consta na SEFAZ para o CNPJ armazenador">Raz\xe3o social emitente NF-e<sup>*</sup>
						<input id="custody_emit_name" type="text" placeholder="Nome do armazenador">
					</label>
					<label title="IE v\xe1lida para o CNPJ armazenador (ou ISENTO)">IE emitente NF-e<sup>*</sup>
						<input id="custody_emit_ie" type="text" placeholder="IE ou ISENTO">
					</label>
					<label title="Telefone do emitente (opcional)">Fone emitente
						<input id="custody_emit_phone" type="text" placeholder="+55 (11) 0000-0000">
					</label>
					<label title="CRT do emitente (vazio = mesmo CRT da empresa)">CRT emitente
						<input id="custody_emit_crt" type="text" list="regimes" placeholder="igual empresa">
					</label>
				</div>
				<div class="fsb">
					<input type="hidden" id="custody_emit_address_id">
					<label>Logradouro emitente
						<input id="custody_emit_address_street" type="text">
					</label>
					<label>N\xfamero
						<input id="custody_emit_address_number" type="text">
					</label>
					<label>Complemento
						<input id="custody_emit_address_complement" type="text">
					</label>
				</div>
				<div class="fsb">
					<label>Bairro
						<input id="custody_emit_address_district" type="text">
					</label>
					<label>UF
						<input id="custody_emit_address_state" type="text" list="states">
					</label>
					<label>Munic\xedpio
						<input id="custody_emit_address_city_id" type="text" list="cities">
					</label>
					<label>CEP
						<input id="custody_emit_address_zipcode" type="text" placeholder="00000-000">
					</label>
				</div>
			</div>
			<fieldset class="mtm company-params-fieldset">
				<legend class="company-params-legend">
					<span>Par\xe2metros Operacionais</span>
					<button type="button" class="company-params-help" id="company_params_help" title="Ajuda: significado de cada par\xe2metro" aria-label="Ajuda sobre par\xe2metros operacionais">?</button>
				</legend>
				<div class="param-block">
					<h4 class="param-block-title">Invent\xe1rio</h4>
					<div class="param-grid">
						<label class="param-num param-num--row" title="Toler\xe2ncia de confer\xeancia do invent\xe1rio">
							<span class="param-num-label">Toler\xe2ncia confer\xeancia</span>
							<input id="inv_conference_tolerance" type="text" placeholder="0">
						</label>
						<label class="param-check" title="Permite invent\xe1rio com lote vencido"><input id="inv_allow_expired" type="checkbox"> <span class="param-check-text">Permite vencido</span></label>
						<label class="param-check" title="Exige lote nas opera\xe7\xf5es de invent\xe1rio"><input id="inv_require_lot" type="checkbox"> <span class="param-check-text">Exige lote</span></label>
						<label class="param-check" title="Controla invent\xe1rio por programa"><input id="inv_by_program" type="checkbox"> <span class="param-check-text">Por programa</span></label>
						<label class="param-check" title="Aplica bloqueios por classe no invent\xe1rio"><input id="inv_class_blocking" type="checkbox"> <span class="param-check-text">Bloqueio por classe</span></label>
					</div>
				</div>
				<div class="param-block">
					<h4 class="param-block-title">Embalagens e picking</h4>
					<div class="param-grid">
						<label class="param-check" title="Ativa hierarquia de embalagens no cliente"><input id="pkg_use_hierarchy" type="checkbox"> <span class="param-check-text">Hierarquia de embalagens</span></label>
						<label class="param-check" title="Permite atendimento unit\xe1rio (prim\xe1ria)"><input id="pkg_unitarization_enabled" type="checkbox"> <span class="param-check-text">Unitariza\xe7\xe3o</span></label>
						<label class="param-check" title="Motor de picking otimiza escolha de embalagem"><input id="pkg_optimize_picking" type="checkbox"> <span class="param-check-text">Picking otimizado</span></label>
						<label class="param-check" title="Permite quebrar embalagem terci\xe1ria"><input id="pkg_allow_tertiary_break" type="checkbox"> <span class="param-check-text">Quebra terci\xe1ria</span></label>
						<label class="param-check" title="Permite quebrar embalagem secund\xe1ria"><input id="pkg_allow_secondary_break" type="checkbox"> <span class="param-check-text">Quebra secund\xe1ria</span></label>
						<label class="param-check" title="Valida GTIN por embalagem"><input id="pkg_validate_gtin" type="checkbox"> <span class="param-check-text">Valida GTIN (embalagem)</span></label>
						<label class="param-check" title="For\xe7a uso do fluxo legado (rollback)"><input id="pkg_rollback_legacy" type="checkbox"> <span class="param-check-text">Rollback legado</span></label>
					</div>
				</div>
			</fieldset>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#company',
        init (formset) {
            this.getFieldByName('logo').subscribe([
                'change'
            ], this.enableDownload.bind(formset), false); // once = false
            Object.getPrototypeOf(this).init.call(this);
            const fiscalEl = document.querySelector('#fiscal_modality');
            const custodyRow = document.querySelector('#custody_row');
            const custodyEmitBlock = document.querySelector('#custody_emit_nfe_block');
            const toggleCustody = ()=>{
                const show = fiscalEl?.value === '1';
                if (custodyRow) custodyRow.style.display = show ? '' : 'none';
                if (custodyEmitBlock) custodyEmitBlock.style.display = show ? 'block' : 'none';
            };
            fiscalEl?.addEventListener('change', toggleCustody);
            if (typeof formset.subscribe === 'function') formset.subscribe([
                'open'
            ], ()=>setTimeout(toggleCustody, 0));
            setTimeout(toggleCustody, 0);
            const helpBtn = document.querySelector('#company_params_help');
            helpBtn?.addEventListener('click', (ev)=>{
                ev.preventDefault();
                let mb;
                mb = (0, $e7f9af3e6f2fd91b$export$2e2bcd8739ae039)({
                    title: "Ajuda \u2014 Par\xe2metros operacionais",
                    text: $367c2691d157ba2f$var$COMPANY_PARAMS_HELP_HTML,
                    buttons: [
                        {
                            label: 'Fechar',
                            cls: 'bn_Enter'
                        }
                    ],
                    callback: ()=>mb.destroy()
                });
            });
        },
        enableDownload (ev, publisher, value) {
            if (value) {
                let anchor = document.querySelector('#download');
                anchor.setAttribute('href', `data:image/x-png;base64,${value}`);
                anchor.removeAttribute('disabled');
            }
        }
    },
    fields: [
        {
            properties: {
                selector: '#id'
            },
            types: []
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#cnpj'
            },
            types: [
                $7fda302dcbccda19$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ie'
            },
            types: [
                $c215c48c03ffee69$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $7582832548ac84df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        //{ properties: { selector: '#iest' }, types: [] },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_street'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_number'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_complement'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_district'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_state'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $2b0e90bfecbeac43$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_city_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('address_state'),
                $9a739ce21637de64$export$2e2bcd8739ae039('cities', {
                    labels: [
                        'city'
                    ],
                    index: 2
                })
            ]
        },
        {
            properties: {
                selector: '#address_zipcode'
            },
            types: [
                $a3b288a4e8d304b7$export$2e2bcd8739ae039(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#inventory_strategy'
            },
            types: [
                $7090be8ac1a98b2f$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#crt'
            },
            types: [
                $6fc24243d89a5cc8$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#pis'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#cofins'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#estimated_taxes'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#invoice_series'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#authorized_parties'
            },
            types: [
                $ba016d80ddaca15b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#logo'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $5e1493eb0305a487$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#fiscal_modality'
            },
            types: []
        },
        {
            properties: {
                selector: '#custody_warehouse_cnpj'
            },
            types: [
                $7fda302dcbccda19$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_ie'
            },
            types: []
        },
        {
            properties: {
                selector: '#custody_emit_phone'
            },
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_crt'
            },
            types: [
                $6fc24243d89a5cc8$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#custody_emit_address_street'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_number'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_complement'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_district'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_state'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $2b0e90bfecbeac43$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_city_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('custody_emit_address_state'),
                $9a739ce21637de64$export$2e2bcd8739ae039('cities', {
                    labels: [
                        'city'
                    ],
                    index: 2
                })
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_zipcode'
            },
            types: [
                $a3b288a4e8d304b7$export$2e2bcd8739ae039(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#inv_allow_expired'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#inv_require_lot'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#inv_by_program'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#inv_class_blocking'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#inv_conference_tolerance'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#pkg_use_hierarchy'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#pkg_unitarization_enabled'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#pkg_optimize_picking'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#pkg_allow_tertiary_break'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#pkg_allow_secondary_break'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#pkg_validate_gtin'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#pkg_rollback_legacy'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $4e09ec6288da1fd7$var$companies = function() {
    let companies_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_cities, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cities', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            // /companies filtra por grupos do usuário; empresa nova não tem binding e sumiria da lista.
            // Tela de cadastro de empresas lista todas as ativas (igual GET /companies/all).
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_all_companies, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_company, ...JSON.parse(id));
            _record = (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'address');
            if (_record.address_city_id) _record['address_state'] = (await (0, $1cmSR.default).get('cities', _record.address_city_id))?.state;
            _record = (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'custody_emit_address');
            if (_record.custody_emit_address_city_id) _record['custody_emit_address_state'] = (await (0, $1cmSR.default).get('cities', _record.custody_emit_address_city_id))?.state;
            return _record;
        },
        async saveRecord (data, old_data) {
            const sel = '#company';
            const normalize = (s)=>(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
            const resolveCityId = async (state, cityVal)=>{
                if (!state || cityVal == null || cityVal === '') return cityVal;
                const v = String(cityVal).trim();
                if (/^\d{7}$/.test(v)) return v;
                const range = IDBKeyRange.bound([
                    state,
                    ''
                ], [
                    state,
                    '\uffff'
                ]);
                const cities = await (0, $1cmSR.default).list('cities', range, 2).catch(()=>[]);
                const c = (cities || []).find((x)=>normalize(x?.city || '') === normalize(v));
                return c ? c.id : cityVal;
            };
            const getAddr = (suffix)=>{
                const el = document.querySelector(`${sel} #address_${suffix}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getEmitAddr = (suffix)=>{
                const el = document.querySelector(`${sel} #custody_emit_address_${suffix}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getZipFromDom = ()=>getAddr('zipcode').replace(/\D/g, '');
            const street = (data.address_street || getAddr('street')).trim();
            const number = (data.address_number || getAddr('number')).trim();
            const complement = (data.address_complement || getAddr('complement')).trim() || null;
            const district = (data.address_district || getAddr('district')).trim();
            const zipcode = data.address_zipcode && String(data.address_zipcode).replace(/\D/g, '') || getZipFromDom();
            const state = (data.address_state || getAddr('state')).toUpperCase().trim().slice(0, 2);
            let cityId = data.address_city_id != null && data.address_city_id !== '' ? data.address_city_id : getAddr('city_id');
            if (state && cityId) cityId = await resolveCityId(state, cityId);
            const rawAddrId = data.address_id;
            const addressIdNum = rawAddrId != null && rawAddrId !== '' && !Number.isNaN(Number(rawAddrId)) ? Number(rawAddrId) : null;
            const emitStreet = (data.custody_emit_address_street || getEmitAddr('street')).trim();
            const emitNumber = (data.custody_emit_address_number || getEmitAddr('number')).trim();
            const emitComplement = (data.custody_emit_address_complement || getEmitAddr('complement')).trim() || null;
            const emitDistrict = (data.custody_emit_address_district || getEmitAddr('district')).trim();
            const emitZip = data.custody_emit_address_zipcode && String(data.custody_emit_address_zipcode).replace(/\D/g, '') || getEmitAddr('zipcode').replace(/\D/g, '');
            const emitState = (data.custody_emit_address_state || getEmitAddr('state')).toUpperCase().trim().slice(0, 2);
            let emitCityId = data.custody_emit_address_city_id != null && data.custody_emit_address_city_id !== '' ? data.custody_emit_address_city_id : getEmitAddr('city_id');
            if (emitState && emitCityId) emitCityId = await resolveCityId(emitState, emitCityId);
            const rawEmitAddrId = data.custody_emit_address_id;
            const emitAddrIdNum = rawEmitAddrId != null && rawEmitAddrId !== '' && !Number.isNaN(Number(rawEmitAddrId)) ? Number(rawEmitAddrId) : null;
            let _record = {
                nick: data.nick,
                name: data.name,
                cnpj: data.cnpj,
                ie: data.ie,
                ie_type: data.ie_type,
                phone: data.phone,
                inventory_strategy: data.inventory_strategy,
                crt: data.crt,
                pis: Number(data.pis),
                cofins: Number(data.cofins),
                estimated_taxes: Number(data.estimated_taxes),
                invoice_series: Number(data.invoice_series),
                authorized_parties: data.authorized_parties,
                logo: data.logo,
                fiscal_modality: data.fiscal_modality || '0',
                custody_warehouse_cnpj: data.fiscal_modality === '1' ? data.custody_warehouse_cnpj || null : null,
                custody_emit_name: data.fiscal_modality === '1' ? (data.custody_emit_name || '').trim() || null : null,
                custody_emit_ie: data.fiscal_modality === '1' ? (data.custody_emit_ie || '').trim() || null : null,
                custody_emit_phone: data.fiscal_modality === '1' ? (data.custody_emit_phone || '').trim() || null : null,
                custody_emit_crt: data.fiscal_modality === '1' ? (data.custody_emit_crt || '').trim() || null : null,
                inv_allow_expired: data.inv_allow_expired == '1',
                inv_require_lot: data.inv_require_lot == '1',
                inv_by_program: data.inv_by_program == '1',
                inv_class_blocking: data.inv_class_blocking == '1',
                inv_conference_tolerance: Number(data.inv_conference_tolerance || 0),
                pkg_use_hierarchy: data.pkg_use_hierarchy == '1',
                pkg_unitarization_enabled: data.pkg_unitarization_enabled == '1',
                pkg_optimize_picking: data.pkg_optimize_picking == '1',
                pkg_allow_tertiary_break: data.pkg_allow_tertiary_break == '1',
                pkg_allow_secondary_break: data.pkg_allow_secondary_break == '1',
                pkg_validate_gtin: data.pkg_validate_gtin == '1',
                pkg_rollback_legacy: data.pkg_rollback_legacy == '1'
            };
            if (addressIdNum || street || number || district || zipcode || cityId) _record['address'] = {
                id: addressIdNum,
                street: street || null,
                number: number || null,
                complement: complement,
                district: district || null,
                zipcode: zipcode || null,
                city_id: cityId || null
            };
            if (data.fiscal_modality === '1') _record['custody_emit_address'] = emitAddrIdNum || emitStreet || emitNumber || emitDistrict || emitZip || emitCityId ? {
                id: emitAddrIdNum,
                street: emitStreet || null,
                number: emitNumber || null,
                complement: emitComplement,
                district: emitDistrict || null,
                zipcode: emitZip || null,
                city_id: emitCityId || null
            } : null;
            else _record['custody_emit_address'] = null;
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_company, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_company, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Identificador da empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'nick',
            label: 'Apelido',
            types: [],
            placeholder: '',
            title: 'Nome curto da empresa'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome ou raz\xe3o social"
        },
        {
            index: 4,
            field: 'cnpj',
            label: 'CNPJ',
            types: [
                $7fda302dcbccda19$export$2e2bcd8739ae039()
            ],
            placeholder: '00.000.000/0000-00',
            title: "N\xfamero do CNPJ"
        },
        {
            index: 5,
            field: 'ie',
            label: 'IE',
            types: [
                $c215c48c03ffee69$export$2e2bcd8739ae039()
            ],
            placeholder: '000.000.000',
            title: "Inscri\xe7\xe3o Estadual"
        },
        {
            index: 6,
            field: 'ie_type',
            label: 'Tipo IE',
            types: [
                $7582832548ac84df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Tipo de Inscri\xe7\xe3o Estadual"
        },
        //{ index: 7, field: 'iest', label: 'IEST', types: [], placeholder: '', title: 'Inscrição Estadual do Substituto Tributário' },
        {
            index: 8,
            field: 'phone',
            label: 'Fone',
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone'
        },
        {
            index: 10,
            field: 'inventory_strategy',
            label: "Invent\xe1rio",
            types: [
                $7090be8ac1a98b2f$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Estrat\xe9gia de invent\xe1rio"
        },
        {
            index: 11,
            field: 'crt',
            label: 'CRT',
            types: [
                $6fc24243d89a5cc8$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "C\xf3digo de Regime Tribut\xe1rio"
        },
        {
            index: 12,
            field: 'pis',
            label: 'PIS',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: "Al\xedquota de PIS"
        },
        {
            index: 13,
            field: 'cofins',
            label: 'COFINS',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: "Al\xedquota de COFINS"
        },
        {
            index: 14,
            field: 'estimated_taxes',
            label: 'Tributos',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Percentual estimado de tributos federais, estaduais e municipais'
        },
        {
            index: 15,
            field: 'invoice_series',
            label: "S\xe9rie",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "S\xe9rie da NFe"
        },
        {
            index: 16,
            field: 'authorized_parties',
            label: 'Autorizados',
            types: [
                $ba016d80ddaca15b$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'CPF ou CNPJ das pessoas autorizadas a acessar o XML da NFe'
        },
        {
            index: 17,
            field: 'fiscal_modality',
            label: 'Modalidade',
            types: [],
            placeholder: '',
            title: "Modalidade fiscal: Normal ou Fiel deposit\xe1rio"
        },
        {
            index: 18,
            field: 'custody_warehouse_cnpj',
            label: 'CNPJ armazenador',
            types: [
                $7fda302dcbccda19$export$2e2bcd8739ae039()
            ],
            placeholder: '00.000.000/0000-00',
            title: "CNPJ que armazena (quando fiel deposit\xe1rio)"
        }
    ];
    companies_crud.run('companies', 'Empresas', document.getElementById('workarea'), (0, $62f41054efe4ec85$export$2e2bcd8739ae039), (0, $367c2691d157ba2f$export$2e2bcd8739ae039), fieldspecs);
};
var $4e09ec6288da1fd7$export$2e2bcd8739ae039 = $4e09ec6288da1fd7$var$companies;




var $1cmSR = parcelRequire("1cmSR");




async function $0c33a9bef52e4642$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; 	}
			.view td:nth-child(4)	{ text-align: center;	}
			.view td:nth-child(5)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: left; }
			.view td:nth-child(10)	{ text-align: left; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; max-width: 15rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Fornecedor</th>
					<th data-index="3" data-visible="${this.visible[2]}">Tipo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Apelido</th>
					<th data-index="5" data-visible="${this.visible[4]}">Nome</th>
					<th data-index="6" data-visible="${this.visible[5]}">CPF</th>
					<th data-index="7" data-visible="${this.visible[6]}">CNPJ</th>
					<th data-index="8" data-visible="${this.visible[7]}">IE</th>
					<th data-index="9" data-visible="${this.visible[8]}">Tipo IE</th>
					<th data-index="10" data-visible="${this.visible[9]}">Fone</th>
					<th data-index="11" data-visible="${this.visible[10]}">Email</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${this.option($eaa7b296a57d850b$export$2e2bcd8739ae039(), record.type)}</td>
					<td data-visible='${this.visible[3]}'>${record.nick}</td>
					<td data-visible='${this.visible[4]}'>${record.name}</td>
					<td data-visible='${this.visible[5]}'>${this.format($bc7d8cd598cdbfe0$export$2e2bcd8739ae039(), record.cpf)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($7fda302dcbccda19$export$2e2bcd8739ae039(), record.cnpj)}</td>
					<td data-visible='${this.visible[7]}'>${this.format($c215c48c03ffee69$export$2e2bcd8739ae039(), record.ie)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($7582832548ac84df$export$2e2bcd8739ae039(), record.ie_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($e576b042880c33f1$export$2e2bcd8739ae039(), record.phone)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($ff6c02d4f0df8745$export$2e2bcd8739ae039(), record.email)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




var $ab5683342c6e6a5e$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#supplier #company_id			{ width: 10rem;		}
			#supplier #id					{ width: 5rem; text-align: right;	}
			#supplier #type					{ width: 4rem;		}
			#supplier #nick					{ width: 28rem;		}
			#supplier #name					{ width: 28rem; 	}
			#supplier #email				{ width: 20rem;		}
			#supplier #cpf					{ width: 8rem;		}
			#supplier #cnpj					{ width: 10rem; 	}
			#supplier #ie					{ width: 8rem; 		}
			#supplier #ie_type				{ width: 10rem;		}
			#supplier #phone				{ width: 10rem;		}
			#supplier #address_street		{ width: 26rem;		}
			#supplier #address_number		{ width: 6rem;		}
			#supplier #address_complement	{ width: 15rem;		}
			#supplier #address_district		{ width: 20rem;		}
			#supplier #address_state		{ width: 3.5rem;	}
			#supplier #address_city_id		{ width: 17rem;		}
			#supplier #address_zipcode		{ width: 6rem;		}
		</style>
		<form id="supplier" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do fornecedor">Fornecedor
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jur\xeddica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Nome curto do fornecedor">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome ou raz\xe3o social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="N\xfamero do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="N\xfamero do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="N\xfamero da Inscri\xe7\xe3o Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscri\xe7\xe3o Estadual">Tipo IE<sup>*</sup>
					<input id="ie_type" type="text" list="ie_types" required>
				</label>
			</div>
			<div class="fsb">
				<input type="hidden" id="address_id">
				<label title="Nome da rua ou avenida">Logradouro
					<input id="address_street" type="text">
				</label>
				<label title="N\xfamero">N\xfamero
					<input id="address_number" type="text">
				</label>
				<label title="Complemento">Complemento
					<input id="address_complement" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Bairro">Bairro
					<input id="address_district" type="text">
				</label>
				<label title="Unidade Federativa">UF
					<input id="address_state" type="text" list="states">
				</label>
				<label title="Munic\xedpio">Munic\xedpio
					<input id="address_city_id" type="text" list="cities">
				</label>
				<label title="CEP">CEP
					<input id="address_zipcode" type="text" placeholder="00000-000">
				</label>
			</div>
			<div class="fsb">
				<span class="cep-hint" style="font-size:0.85em;color:var(--color-muted,#666);">Digite o CEP e saia do campo para preencher automaticamente (logradouro, bairro, UF, munic\xedpio).</span>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#supplier',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $eaa7b296a57d850b$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#cpf'
            },
            types: [
                $bc7d8cd598cdbfe0$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#cnpj'
            },
            types: [
                $7fda302dcbccda19$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ie'
            },
            types: [
                $c215c48c03ffee69$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $7582832548ac84df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#email'
            },
            types: [
                $ff6c02d4f0df8745$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_street'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_number'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_complement'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_district'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_state'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $2b0e90bfecbeac43$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_city_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('address_state')
            ]
        },
        {
            properties: {
                selector: '#address_zipcode'
            },
            types: [
                $a3b288a4e8d304b7$export$2e2bcd8739ae039(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $b8958290655d6aea$var$suppliers = function() {
    let suppliers_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_cities, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cities', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_suppliers, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_supplier, ...JSON.parse(id));
            _record = (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'address');
            if (_record.address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.address_city_id);
                if (c) {
                    _record['address_state'] = c.state;
                    _record['address_city_id'] = c.city;
                }
            }
            return _record;
        },
        async saveRecord (data, old_data) {
            const sel = '#supplier';
            const normalize = (s)=>(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
            const resolveCityId = async (state, cityVal)=>{
                if (!state || cityVal == null || cityVal === '') return cityVal;
                const v = String(cityVal).trim();
                if (/^\d{7}$/.test(v)) return v;
                const range = IDBKeyRange.bound([
                    state,
                    ''
                ], [
                    state,
                    '\uffff'
                ]);
                const cities = await (0, $1cmSR.default).list('cities', range, 2).catch(()=>[]);
                const c = (cities || []).find((x)=>normalize(x?.city || '') === normalize(v));
                return c ? c.id : cityVal;
            };
            const getAddr = (suffix)=>{
                const el = document.querySelector(`${sel} #address_${suffix}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getZipFromDom = ()=>getAddr('zipcode').replace(/\D/g, '');
            const street = (data.address_street || getAddr('street')).trim();
            const number = (data.address_number || getAddr('number')).trim();
            const complement = (data.address_complement || getAddr('complement')).trim() || null;
            const district = (data.address_district || getAddr('district')).trim();
            const zipcode = data.address_zipcode && String(data.address_zipcode).replace(/\D/g, '') || getZipFromDom();
            const state = (data.address_state || getAddr('state')).toUpperCase().trim().slice(0, 2);
            let cityId = data.address_city_id != null && data.address_city_id !== '' ? data.address_city_id : getAddr('city_id');
            if (state && cityId) cityId = await resolveCityId(state, cityId);
            let _record = {
                type: data.type,
                nick: data.nick,
                name: data.name,
                cpf: data.cpf,
                cnpj: data.cnpj,
                ie: data.ie,
                ie_type: data.ie_type,
                phone: data.phone,
                email: data.email
            };
            if (data.address_id || street || number || district || zipcode || cityId) _record['address'] = {
                id: data.address_id ? Number(data.address_id) : null,
                street: street || null,
                number: number || null,
                complement: complement,
                district: district || null,
                zipcode: zipcode || null,
                city_id: cityId || null
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_supplier, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_supplier, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Fornecedor',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do fornecedor'
        },
        {
            index: 3,
            field: 'type',
            label: 'Tipo',
            types: [
                $eaa7b296a57d850b$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Tipo de personalidade jur\xeddica"
        },
        {
            index: 4,
            field: 'nick',
            label: 'Apelido',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome curto do fornecedor'
        },
        {
            index: 5,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome ou raz\xe3o social"
        },
        {
            index: 6,
            field: 'cpf',
            label: 'CPF',
            types: [
                $bc7d8cd598cdbfe0$export$2e2bcd8739ae039()
            ],
            placeholder: '000.000.000-00',
            title: "N\xfamero do CPF"
        },
        {
            index: 7,
            field: 'cnpj',
            label: 'CNPJ',
            types: [
                $7fda302dcbccda19$export$2e2bcd8739ae039()
            ],
            placeholder: '00.000.000/0000-00',
            title: "N\xfamero do CNPJ"
        },
        {
            index: 8,
            field: 'ie',
            label: 'IE',
            types: [
                $c215c48c03ffee69$export$2e2bcd8739ae039()
            ],
            placeholder: '000.000.000',
            title: "Inscri\xe7\xe3o Estadual"
        },
        {
            index: 9,
            field: 'ie_type',
            label: 'Tipo IE',
            types: [
                $7582832548ac84df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Tipo de Inscri\xe7\xe3o Estadual"
        },
        {
            index: 10,
            field: 'phone',
            label: 'Fone',
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone'
        },
        {
            index: 11,
            field: 'email',
            label: 'Email',
            types: [
                $ff6c02d4f0df8745$export$2e2bcd8739ae039()
            ],
            placeholder: 'abc@xyz.com',
            title: 'Email'
        }
    ];
    suppliers_crud.run('suppliers', 'Fornecedores', document.getElementById('workarea'), (0, $0c33a9bef52e4642$export$2e2bcd8739ae039), (0, $ab5683342c6e6a5e$export$2e2bcd8739ae039), fieldspecs);
};
var $b8958290655d6aea$export$2e2bcd8739ae039 = $b8958290655d6aea$var$suppliers;




var $1cmSR = parcelRequire("1cmSR");






const $f657162cc87f545e$var$show = function(b64pdf) {
    let _window = window.open();
    if (_window) _window.document.write(`<iframe width="100%" height="100%" src="data:application/pdf;base64,${b64pdf}"></iframe>`);
    else (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`<a href="data:application/pdf;base64,${b64pdf}" download="report.pdf">Clique aqui para obter o relat\xf3rio</a>`, 'Download');
};
var $f657162cc87f545e$export$2e2bcd8739ae039 = $f657162cc87f545e$var$show;



async function $f6400b2fd5d9b801$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; 	}
			.view td:nth-child(4)	{ text-align: center;	}
			.view td:nth-child(5)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: left; }
			.view td:nth-child(10)	{ text-align: left; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; max-width: 15rem; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: left; }
			.view td:nth-child(15)	{ text-align: left; }
			.view td:nth-child(16)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Cliente</th>
					<th data-index="3" data-visible="${this.visible[2]}">Tipo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Apelido</th>
					<th data-index="5" data-visible="${this.visible[4]}">Nome</th>
					<th data-index="6" data-visible="${this.visible[5]}">CPF</th>
					<th data-index="7" data-visible="${this.visible[6]}">CNPJ</th>
					<th data-index="8" data-visible="${this.visible[7]}">IE</th>
					<th data-index="9" data-visible="${this.visible[8]}">Tipo IE</th>
					<th data-index="10" data-visible="${this.visible[9]}">Fone</th>
					<th data-index="11" data-visible="${this.visible[10]}">Email</th>
					<th data-index="14" data-visible="${this.visible[11]}">Prazo Entrega</th>
					<th data-index="15" data-visible="${this.visible[12]}">Condi\xe7\xe3o Pagto</th>
					<th data-index="16" data-visible="${this.visible[13]}">Lista Pre\xe7os</th>
					<th data-index="17" data-visible="${this.visible[14]}">Consumidor</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${this.option($eaa7b296a57d850b$export$2e2bcd8739ae039(), record.type)}</td>
					<td data-visible='${this.visible[3]}'>${record.nick}</td>
					<td data-visible='${this.visible[4]}'>${record.name}</td>
					<td data-visible='${this.visible[5]}'>${this.format($bc7d8cd598cdbfe0$export$2e2bcd8739ae039(), record.cpf)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($7fda302dcbccda19$export$2e2bcd8739ae039(), record.cnpj)}</td>
					<td data-visible='${this.visible[7]}'>${this.format($c215c48c03ffee69$export$2e2bcd8739ae039(), record.ie)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($7582832548ac84df$export$2e2bcd8739ae039(), record.ie_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($e576b042880c33f1$export$2e2bcd8739ae039(), record.phone)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($ff6c02d4f0df8745$export$2e2bcd8739ae039(), record.email)}</td>
					<td data-visible='${this.visible[11]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0), record.delivery_term)}</td>
					<td data-visible='${this.visible[12]}'>${await this.key('payment_terms', [
            record.payment_term_id
        ]) ?? ''}</td>
					<td data-visible='${this.visible[13]}'>${await this.key('price_lists', [
            record.price_list_id
        ]) ?? ''}</td>
					<td data-visible='${this.visible[14]}'>${this.option($16a377ceff31a9ac$export$2e2bcd8739ae039(), record.is_end_consumer)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




var $5090ba71e405782b$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#customer #company_id					{ width: 10rem;		}
			#customer #id							{ width: 5rem; text-align: right;	}
			#customer #payment_term_id				{ width: 11rem; 	}
			#customer #price_list_id				{ width: 11rem; 	}
			#customer #delivery_term				{ width: 4rem; 		}
			#customer #type							{ width: 4rem;		}
			#customer #nick							{ width: 18rem;		}
			#customer #name							{ width: 20rem; 	}
			#customer #email						{ width: 15rem;		}
			#customer #phone						{ width: 10rem;		}
			#customer #cpf							{ width: 10rem;		}
			#customer #cnpj							{ width: 11rem; 	}
			#customer #ie							{ width: 10rem; 	}
			#customer #ie_type						{ width: 11rem;		}
			#customer #billing_address_street		{ width: 20rem;		}
			#customer #billing_address_number		{ width: 5rem;		}
			#customer #billing_address_complement	{ width: 10rem;		}
			#customer #billing_address_district		{ width: 15rem;		}
			#customer #billing_address_state		{ width: 3.5rem;	}
			#customer #billing_address_city_id		{ width: 15rem;		}
			#customer #billing_address_zipcode		{ width: 6rem;		}
			#customer #delivery_address_street		{ width: 20rem;		}
			#customer #delivery_address_number		{ width: 5rem;		}
			#customer #delivery_address_complement	{ width: 10rem;		}
			#customer #delivery_address_district	{ width: 15rem;		}
			#customer #delivery_address_state		{ width: 3.5rem;	}
			#customer #delivery_address_city_id		{ width: 15rem;		}
			#customer #delivery_address_zipcode		{ width: 6rem;		}
			#customer fieldset						{ display: inline-block; }
			#customer .addr-hint					{ min-height: 2rem; align-items: center; }
			#customer .cep-hint					{ font-size: 0.85em; color: var(--muted, #666); }
		</style>
		<form id="customer" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="billing_cities">
			</datalist>
			<datalist id="delivery_cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do cliente">Cliente
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jur\xeddica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Condi\xe7\xe3o de pagamento padr\xe3o">Condi\xe7\xe3o de Pagto
					<input id="payment_term_id" type="text" list="payment_terms">
				</label>
				<label title="Lista de pre\xe7os vinculada ao cliente">Lista de Pre\xe7os
					<input id="price_list_id" type="text" list="price_lists">
				</label>
				<label title="Prazo de entrega em dias">Prazo<sup>*</sup>
					<input id="delivery_term" type="text" placeholder="0" required>
				</label>
				<label title="Cliente \xe9 consumidor final?">Consumidor
					<input id="is_end_consumer" type="checkbox" checked>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome curto do cliente">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
				<label title="Nome ou raz\xe3o social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="N\xfamero do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="N\xfamero do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="N\xfamero da Inscri\xe7\xe3o Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscri\xe7\xe3o Estadual">Tipo IE
					<input id="ie_type" type="text" list="ie_types">
				</label>
			</div>
			<div class="fsb">
				<fieldset>
					<legend>Endere\xe7o de Faturamento</legend>
					<div class="fsb addr-hint">
						<label title="Usar o mesmo endere\xe7o de entrega para faturamento" style="display:flex;align-items:center;gap:0.5rem;">
							<input id="same_billing_delivery" type="checkbox"> Mesmo endere\xe7o de entrega
						</label>
					</div>
					<input type="hidden" id="billing_address_id">
					<div class="fsb">
						<label title="Nome da rua ou avenida">Logradouro
							<input id="billing_address_street" type="text">
						</label>
						<label title="N\xfamero">N\xfamero
							<input id="billing_address_number" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Complemento">Complemento
							<input id="billing_address_complement" type="text">
						</label>
						<label title="Bairro">Bairro
							<input id="billing_address_district" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Unidade Federativa">UF
							<input id="billing_address_state" type="text" list="states">
						</label>
						<label title="Munic\xedpio (ou digite CEP antes para preencher automaticamente)">Munic\xedpio
							<input id="billing_address_city_id" type="text" list="billing_cities">
						</label>
						<label title="CEP: digite e saia do campo para buscar nos Correios">CEP
							<input id="billing_address_zipcode" type="text" placeholder="00000-000">
						</label>
					</div>
				</fieldset>
				<fieldset>
					<legend>Endere\xe7o de Entrega</legend>
					<div class="fsb addr-hint">
						<span class="cep-hint" title="Consulta ViaCEP (base dos Correios)">Digite o CEP e saia do campo para preencher automaticamente</span>
					</div>
					<input type="hidden" id="delivery_address_id">
					<div class="fsb">
						<label title="Nome da rua ou avenida">Logradouro
							<input id="delivery_address_street" type="text">
						</label>
						<label title="N\xfamero">N\xfamero
							<input id="delivery_address_number" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Complemento">Complemento
							<input id="delivery_address_complement" type="text">
						</label>
						<label title="Bairro">Bairro
							<input id="delivery_address_district" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Unidade Federativa">UF
							<input id="delivery_address_state" type="text" list="states">
						</label>
						<label title="Munic\xedpio (ou digite CEP antes para preencher automaticamente)">Munic\xedpio
							<input id="delivery_address_city_id" type="text" list="delivery_cities">
						</label>
						<label title="CEP: digite e saia do campo para buscar nos Correios">CEP
							<input id="delivery_address_zipcode" type="text" placeholder="00000-000">
						</label>
					</div>
				</fieldset>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#customer',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const sel = formset.form.selector;
            const typeEl = document.querySelector(`${sel} #type`);
            const cnpjEl = document.querySelector(`${sel} #cnpj`);
            const cnpjLabel = cnpjEl?.closest('label');
            const toggleCnpjForTypeL = ()=>{
                if (!typeEl || !cnpjEl) return;
                const isLocal = typeEl.value?.trim() === 'L';
                cnpjEl.placeholder = isLocal ? "C\xf3d. GSNet (ex.: 1233)" : '00.000.000/0000-00';
                cnpjEl.title = isLocal ? "C\xf3digo GSNet (alfanum\xe9rico, at\xe9 10 caracteres)" : "N\xfamero do CNPJ";
                if (cnpjLabel) cnpjLabel.title = cnpjEl.title;
            };
            const ieTypeEl = document.querySelector(`${sel} #ie_type`);
            const toggleIeTypeRequired = ()=>{
                const isLocal = typeEl?.value?.trim().toUpperCase() === 'L' || typeEl?.value?.trim().toUpperCase() === 'LOCAL';
                if (ieTypeEl) ieTypeEl.required = !isLocal;
            };
            const ptEl = document.querySelector(`${sel} #payment_term_id`);
            const togglePaymentTermForTypeL = ()=>{
                if (!ptEl) return;
                const isLocal = typeEl?.value?.trim().toUpperCase() === 'L' || typeEl?.value?.trim().toUpperCase() === 'LOCAL';
                if (isLocal) {
                    ptEl.value = '';
                    ptEl.setAttribute('readonly', '');
                } else ptEl.removeAttribute('readonly');
            };
            typeEl?.addEventListener('change', ()=>{
                toggleCnpjForTypeL();
                toggleIeTypeRequired();
                togglePaymentTermForTypeL();
            });
            formset.subscribe?.([
                'open'
            ], ()=>{
                setTimeout(toggleCnpjForTypeL, 0);
                setTimeout(toggleIeTypeRequired, 0);
                setTimeout(togglePaymentTermForTypeL, 0);
                setTimeout(()=>{
                    [
                        'billing_address_state',
                        'delivery_address_state'
                    ].forEach((name)=>{
                        const el = document.querySelector(`${sel} #${name}`);
                        if (el?.value) el.dispatchEvent(new Event('change', {
                            bubbles: true
                        }));
                    });
                    if (sameAddrCb?.checked) copyDeliveryToBilling();
                }, 200);
            });
            setTimeout(toggleCnpjForTypeL, 0);
            setTimeout(toggleIeTypeRequired, 0);
            setTimeout(togglePaymentTermForTypeL, 0);
            const sameAddrCb = document.querySelector(`${sel} #same_billing_delivery`);
            const copyDeliveryToBilling = ()=>{
                if (!sameAddrCb?.checked) return;
                [
                    'street',
                    'number',
                    'complement',
                    'district',
                    'state',
                    'city_id',
                    'zipcode'
                ].forEach((f)=>{
                    const src = document.querySelector(`${sel} #delivery_address_${f === 'state' ? 'state' : f === 'city_id' ? 'city_id' : f}`);
                    const dst = document.querySelector(`${sel} #billing_address_${f === 'state' ? 'state' : f === 'city_id' ? 'city_id' : f}`);
                    if (src && dst) {
                        dst.value = src.value;
                        dst.dispatchEvent(new Event('change', {
                            bubbles: true
                        }));
                    }
                });
            };
            sameAddrCb?.addEventListener('change', copyDeliveryToBilling);
            [
                'street',
                'number',
                'complement',
                'district',
                'state',
                'city_id',
                'zipcode'
            ].forEach((suffix)=>{
                const f = suffix === 'state' ? 'state' : suffix === 'city_id' ? 'city_id' : suffix;
                document.querySelector(`${sel} #delivery_address_${f}`)?.addEventListener('blur', copyDeliveryToBilling);
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $eaa7b296a57d850b$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#cpf'
            },
            types: [
                $bc7d8cd598cdbfe0$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#cnpj'
            },
            types: [
                $7df6175fce9b618d$export$2e2bcd8739ae039('#customer')
            ]
        },
        {
            properties: {
                selector: '#ie'
            },
            types: [
                $c215c48c03ffee69$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $7582832548ac84df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#email'
            },
            types: [
                $ff6c02d4f0df8745$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#billing_address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#billing_address_street'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#billing_address_number'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#billing_address_complement'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#billing_address_district'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#billing_address_state'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $2b0e90bfecbeac43$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#billing_address_city_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('billing_address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('billing_address_state')
            ]
        },
        {
            properties: {
                selector: '#billing_address_zipcode'
            },
            types: [
                $a3b288a4e8d304b7$export$2e2bcd8739ae039(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#delivery_address_street'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_number'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_complement'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_district'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_state'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $2b0e90bfecbeac43$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_city_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('delivery_address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('delivery_address_state')
            ]
        },
        {
            properties: {
                selector: '#delivery_address_zipcode'
            },
            types: [
                $a3b288a4e8d304b7$export$2e2bcd8739ae039(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#delivery_term'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0)
            ]
        },
        {
            properties: {
                selector: '#payment_term_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('payment_terms')
            ]
        },
        {
            properties: {
                selector: '#price_list_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('price_lists')
            ]
        },
        {
            properties: {
                selector: '#is_end_consumer'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};




var $01cf9ca6533f8dd0$export$2e2bcd8739ae039 = {
    html: `
		<form id="customers-print-report" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="person_types"></datalist>
			<datalist id="ie_types"></datalist>
			<datalist id="states"></datalist>
			<p class="fss">Filtros opcionais. Deixe em branco para imprimir todos os clientes.</p>
			<div class="fsb">
				<label>Empresa
					<input id="company_id" type="text" list="companies">
				</label>
				<label>Estado (UF)
					<input id="billing_state" type="text" list="states" placeholder="ex: SP">
				</label>
				<label>Tipo
					<input id="type" type="text" list="person_types" placeholder="F, J ou L">
				</label>
			</div>
			<div class="fsb">
				<label>Tipo IE
					<input id="ie_type" type="text" list="ie_types">
				</label>
				<label>Consumidor
					<select id="is_end_consumer">
						<option value="">Todos</option>
						<option value="1">Sim</option>
						<option value="0">N\xe3o</option>
					</select>
				</label>
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
						<option value="xlsx">Excel</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span id="count-msg" class="fss" style="color:#666;"></span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#customers-print-report',
        init (formset) {
            const sel = formset.form?.selector || '#customers-print-report';
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            const optPerson = $eaa7b296a57d850b$export$2e2bcd8739ae039();
            if (optPerson?.options) (0, $c643adc13e6018a8$export$cad72087bded938)(`${sel} #type`, optPerson.options, 'value', [
                'label'
            ]);
            const optIe = $7582832548ac84df$export$2e2bcd8739ae039();
            if (optIe?.options) (0, $c643adc13e6018a8$export$cad72087bded938)(`${sel} #ie_type`, optIe.options, 'value', [
                'label'
            ]);
            const optUf = $2b0e90bfecbeac43$export$2e2bcd8739ae039();
            if (optUf?.options) (0, $c643adc13e6018a8$export$cad72087bded938)(`${sel} #billing_state`, optUf.options, 'value', [
                'label'
            ]);
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#billing_state'
            },
            types: [
                $2b0e90bfecbeac43$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_end_consumer'
            },
            types: []
        },
        {
            properties: {
                selector: '#format'
            },
            types: []
        },
        {
            properties: {
                selector: '#count-msg'
            },
            types: []
        }
    ]
};



const $814cf36e1b964bdf$var$customers = function() {
    let customers_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_payment_terms, this.queryAll()).then((data)=>(0, $1cmSR.default).set('payment_terms', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_price_lists, this.queryAll()).then((data)=>(0, $1cmSR.default).set('price_lists', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_cities, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cities', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_customers, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_customer, ...JSON.parse(id));
            _record = (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'billing_address');
            _record = (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'delivery_address');
            if (_record.billing_address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.billing_address_city_id);
                if (c) {
                    _record['billing_address_state'] = c.state;
                    _record['billing_address_city_id'] = c.city;
                }
            }
            if (_record.delivery_address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.delivery_address_city_id);
                if (c) {
                    _record['delivery_address_state'] = c.state;
                    _record['delivery_address_city_id'] = c.city;
                }
            }
            return _record;
        },
        async saveRecord (data, old_data) {
            const sel = '#customer';
            const normalize = (s)=>(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
            const resolveCityId = async (state, cityVal)=>{
                if (!state || cityVal == null || cityVal === '') return cityVal;
                const v = String(cityVal).trim();
                if (/^\d+$/.test(v)) return v;
                const range = IDBKeyRange.bound([
                    state,
                    ''
                ], [
                    state,
                    '\uffff'
                ]);
                const cities = await (0, $1cmSR.default).list('cities', range, 2).catch(()=>[]);
                const c = (cities || []).find((x)=>normalize(x?.city || '') === normalize(v));
                return c ? c.id : cityVal;
            };
            const getStateFromDom = (prefix)=>{
                const el = document.querySelector(`${sel} #${prefix}_address_state`);
                return el?.value ? String(el.value).trim().toUpperCase().slice(0, 2) : '';
            };
            const ensureAddress = (addr, copyFrom)=>{
                const base = copyFrom || {};
                const o = {
                    id: addr?.id ?? base.id,
                    street: String(addr?.street ?? base.street ?? '').trim(),
                    number: String(addr?.number ?? base.number ?? '').trim(),
                    complement: String(addr?.complement ?? base.complement ?? '').trim() || null,
                    district: String(addr?.district ?? base.district ?? '').trim(),
                    zipcode: String(addr?.zipcode ?? base.zipcode ?? '').replace(/\D/g, ''),
                    city_id: addr?.city_id ?? base.city_id ?? null,
                    state: String(addr?.state ?? base.state ?? '').trim().toUpperCase().slice(0, 2) || null
                };
                if (!o.state && o.city_id && !/^\d{7}$/.test(String(o.city_id))) o.state = getStateFromDom('delivery') || getStateFromDom('billing');
                const hasData = o.street || o.number || o.district || o.zipcode || o.city_id;
                if (!hasData) return null;
                if (o.id != null) o.id = Number(o.id);
                return o;
            };
            const sameAddress = document.querySelector(`${sel} #same_billing_delivery`)?.checked;
            if (data.billing_address_state && data.billing_address_city_id) data.billing_address_city_id = await resolveCityId(data.billing_address_state, data.billing_address_city_id);
            if (data.delivery_address_state && data.delivery_address_city_id) data.delivery_address_city_id = await resolveCityId(data.delivery_address_state, data.delivery_address_city_id);
            const getZipFromDom = (prefix)=>{
                const el = document.querySelector(`${sel} #${prefix}_address_zipcode`);
                return el?.value ? String(el.value).replace(/\D/g, '') : '';
            };
            Object.keys(data).forEach((key)=>{
                let parts = key.match(/^((?:billing|delivery)_address)_(\w+)$/);
                if (!parts) return;
                if (!data[parts[1]]) data[parts[1]] = {};
                data[parts[1]][parts[2]] = data[key];
                delete data[key];
            });
            let billing = data.billing_address || {};
            let delivery = data.delivery_address || {};
            if (!delivery.zipcode || String(delivery.zipcode).replace(/\D/g, '') === '') delivery.zipcode = getZipFromDom('delivery');
            if (!billing.zipcode || String(billing.zipcode).replace(/\D/g, '') === '') billing.zipcode = document.querySelector(`${sel} #same_billing_delivery`)?.checked ? getZipFromDom('delivery') : getZipFromDom('billing');
            if (sameAddress) {
                const keys = [
                    'street',
                    'number',
                    'complement',
                    'district',
                    'zipcode',
                    'city_id',
                    'state'
                ];
                const merged = {};
                keys.forEach((k)=>{
                    const vb = delivery?.[k];
                    const va = billing?.[k];
                    merged[k] = vb != null && String(vb).trim() !== '' ? vb : va != null && String(va).trim() !== '' ? va : va ?? vb;
                });
                merged.id = billing?.id ?? delivery?.id;
                billing = merged;
                delivery = merged;
            }
            const billAddr = ensureAddress(billing);
            const delAddr = ensureAddress(delivery);
            data.billing_address = billAddr;
            data.delivery_address = delAddr;
            let company_id = data.company_id;
            let id = data.id;
            delete data['company_id'];
            delete data['id'];
            data.delivery_term = Number(data.delivery_term);
            const isLocal = data.type === 'L' || data.type?.toUpperCase?.() === 'L';
            const pt = Number(data.payment_term_id);
            data.payment_term_id = isLocal || !data.payment_term_id || data.payment_term_id === '' || isNaN(pt) || pt < 1 ? null : pt;
            const pl = Number(data.price_list_id);
            data.price_list_id = !data.price_list_id || data.price_list_id === '' || isNaN(pl) || pl < 1 ? null : pl;
            data.is_end_consumer = data.is_end_consumer == '1'; // Can be: undefined, '0', '1'
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_customer, company_id, id, data);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_customer, company_id, data);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Cliente',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do cliente'
        },
        {
            index: 3,
            field: 'type',
            label: 'Tipo',
            types: [
                $eaa7b296a57d850b$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Tipo de personalidade jur\xeddica"
        },
        {
            index: 4,
            field: 'nick',
            label: 'Apelido',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome curto do cliente'
        },
        {
            index: 5,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome ou raz\xe3o social"
        },
        {
            index: 6,
            field: 'cpf',
            label: 'CPF',
            types: [
                $bc7d8cd598cdbfe0$export$2e2bcd8739ae039()
            ],
            placeholder: '000.000.000-00',
            title: "N\xfamero do CPF"
        },
        {
            index: 7,
            field: 'cnpj',
            label: 'CNPJ',
            types: [
                $7fda302dcbccda19$export$2e2bcd8739ae039()
            ],
            placeholder: '00.000.000/0000-00',
            title: "N\xfamero do CNPJ"
        },
        {
            index: 8,
            field: 'ie',
            label: 'IE',
            types: [
                $c215c48c03ffee69$export$2e2bcd8739ae039()
            ],
            placeholder: '000.000.000',
            title: "Inscri\xe7\xe3o Estadual"
        },
        {
            index: 9,
            field: 'ie_type',
            label: 'Tipo IE',
            types: [
                $7582832548ac84df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Tipo de Inscri\xe7\xe3o Estadual"
        },
        {
            index: 10,
            field: 'phone',
            label: 'Fone',
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone'
        },
        {
            index: 11,
            field: 'email',
            label: 'Email',
            types: [
                $ff6c02d4f0df8745$export$2e2bcd8739ae039()
            ],
            placeholder: 'abc@xyz.com',
            title: 'Email'
        },
        {
            index: 14,
            field: 'delivery_term',
            label: 'Prazo Entrega',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '',
            title: 'Prazo de entrega em dias'
        },
        {
            index: 15,
            field: 'payment_term_id',
            label: "Condi\xe7\xe3o Pagto",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Condi\xe7\xe3o de pagamento",
            store: 'payment_terms',
            labels: [
                'name'
            ]
        },
        {
            index: 16,
            field: 'price_list_id',
            label: "Lista Pre\xe7os",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Lista de pre\xe7os vinculada ao cliente",
            store: 'price_lists',
            labels: [
                'name'
            ]
        },
        {
            index: 17,
            field: 'is_end_consumer',
            label: 'Consumidor',
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Indicador de consumidor final'
        }
    ];
    let reports = [
        {
            hash: '#print-customers-report',
            label: "Relat\xf3rio&nbsp;de&nbsp;Clientes"
        }
    ];
    async function buildFilter(data) {
        const parts = [];
        if (data.company_id) {
            const c = await (0, $1cmSR.default).get('companies', data.company_id) || await (0, $1cmSR.default).get('companies', [
                data.company_id
            ]);
            const id = c?.id ?? data.company_id;
            if (id) parts.push(`company_id*eq*${id}`);
        }
        if (data.billing_state) parts.push(`billing_state*eq*${String(data.billing_state).trim().toUpperCase().slice(0, 2)}`);
        if (data.type) parts.push(`type*eq*${String(data.type).trim().toUpperCase().slice(0, 1)}`);
        if (data.ie_type) parts.push(`ie_type*eq*${data.ie_type}`);
        if (data.is_end_consumer !== '' && data.is_end_consumer != null) parts.push(`is_end_consumer*eq*${data.is_end_consumer}`);
        return parts.join(',');
    }
    async function updateCountMsg(formData) {
        const filter = await buildFilter(formData || {});
        const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).count_customers_report, {
            filter: filter
        });
        const count = typeof resp === 'number' ? resp : parseInt(resp, 10) || 0;
        const el = document.querySelector('#count-msg');
        if (el) el.textContent = `${count} registro(s) ser\xe3o impressos.`;
    }
    function downloadFile(base64Content, filename, mimeType) {
        const bin = atob(base64Content);
        const arr = new Uint8Array(bin.length);
        for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
        const blob = new Blob([
            arr
        ], {
            type: mimeType
        });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename || 'relatorio';
        a.click();
        URL.revokeObjectURL(a.href);
    }
    async function doPrint(data) {
        try {
            const filter = await buildFilter(data);
            const format = (data.format || 'pdf').toLowerCase();
            const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_customers_report, {
                filter: filter,
                format: format
            });
            if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            else if (resp?.csv) {
                downloadFile(resp.csv, resp.filename || 'clientes.csv', 'text/csv;charset=utf-8');
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Download iniciado.', 'Sucesso');
            } else if (resp?.xlsx) {
                downloadFile(resp.xlsx, resp.filename || 'clientes.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Download iniciado.', 'Sucesso');
            } else (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Nenhum dado para o relat\xf3rio.", 'Aviso');
        } catch (e) {
            (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || String(e), 'Erro');
        }
    }
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-customers-report', ()=>{
        const dlg = (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $01cf9ca6533f8dd0$export$2e2bcd8739ae039), async (data)=>{
            await doPrint(data);
            dlg.destroy();
        }, {}, false);
        const fs = dlg;
        const formEl = document.querySelector((0, $01cf9ca6533f8dd0$export$2e2bcd8739ae039).form.selector);
        if (formEl) {
            formEl.addEventListener('change', ()=>updateCountMsg(fs.form?.getValues?.()));
            formEl.addEventListener('input', ()=>updateCountMsg(fs.form?.getValues?.()));
        }
        setTimeout(()=>updateCountMsg(fs.form?.getValues?.()), 200);
    });
    customers_crud.run('customers', 'Clientes', document.getElementById('workarea'), (0, $f6400b2fd5d9b801$export$2e2bcd8739ae039), (0, $5090ba71e405782b$export$2e2bcd8739ae039), fieldspecs, [], reports);
};
var $814cf36e1b964bdf$export$2e2bcd8739ae039 = $814cf36e1b964bdf$var$customers;




var $1cmSR = parcelRequire("1cmSR");




async function $26658b175da0a4f4$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; 	}
			.view td:nth-child(4)	{ text-align: center;	}
			.view td:nth-child(5)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: left; }
			.view td:nth-child(10)	{ text-align: left; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; max-width: 15rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Transportador</th>
					<th data-index="3" data-visible="${this.visible[2]}">Tipo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Apelido</th>
					<th data-index="5" data-visible="${this.visible[4]}">Nome</th>
					<th data-index="6" data-visible="${this.visible[5]}">CPF</th>
					<th data-index="7" data-visible="${this.visible[6]}">CNPJ</th>
					<th data-index="8" data-visible="${this.visible[7]}">IE</th>
					<th data-index="9" data-visible="${this.visible[8]}">Tipo IE</th>
					<th data-index="10" data-visible="${this.visible[9]}">Fone</th>
					<th data-index="11" data-visible="${this.visible[10]}">Email</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${this.option($eaa7b296a57d850b$export$2e2bcd8739ae039(), record.type)}</td>
					<td data-visible='${this.visible[3]}'>${record.nick}</td>
					<td data-visible='${this.visible[4]}'>${record.name}</td>
					<td data-visible='${this.visible[5]}'>${this.format($bc7d8cd598cdbfe0$export$2e2bcd8739ae039(), record.cpf)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($7fda302dcbccda19$export$2e2bcd8739ae039(), record.cnpj)}</td>
					<td data-visible='${this.visible[7]}'>${this.format($c215c48c03ffee69$export$2e2bcd8739ae039(), record.ie)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($7582832548ac84df$export$2e2bcd8739ae039(), record.ie_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($e576b042880c33f1$export$2e2bcd8739ae039(), record.phone)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($ff6c02d4f0df8745$export$2e2bcd8739ae039(), record.email)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




var $0ab567b2ed7663d6$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#carrier #company_id			{ width: 10rem;		}
			#carrier #id					{ width: 5rem; text-align: right;	}
			#carrier #type					{ width: 4rem;		}
			#carrier #nick					{ width: 28rem;		}
			#carrier #name					{ width: 28rem; 	}
			#carrier #email					{ width: 20rem;		}
			#carrier #cpf					{ width: 8rem;		}
			#carrier #cnpj					{ width: 10rem; 	}
			#carrier #ie					{ width: 8rem; 		}
			#carrier #ie_type				{ width: 10rem;		}
			#carrier #phone					{ width: 10rem;		}
			#carrier #address_street		{ width: 26rem;		}
			#carrier #address_number		{ width: 6rem;		}
			#carrier #address_complement	{ width: 15rem;		}
			#carrier #address_district		{ width: 20rem;		}
			#carrier #address_state			{ width: 3.5rem;	}
			#carrier #address_city_id		{ width: 17rem;		}
			#carrier #address_zipcode		{ width: 6rem;		}
		</style>
		<form id="carrier" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do transportador">Transp
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jur\xeddica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Nome curto do transportador">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome ou raz\xe3o social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb" id="local_delivery_row">
				<label title="Cadastro simplificado para local de entrega (ex.: departamento)">Modo local de entrega
					<input id="is_local_delivery" type="checkbox" title="Desabilita CPF, CNPJ, IE e Tipo IE; usa Tipo LOCAL">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="N\xfamero do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="N\xfamero do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="N\xfamero da Inscri\xe7\xe3o Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscri\xe7\xe3o Estadual">Tipo IE<sup>*</sup>
					<input id="ie_type" type="text" list="ie_types" required>
				</label>
			</div>
			<div class="fsb">
				<input type="hidden" id="address_id">
				<label title="Nome da rua ou avenida">Logradouro
					<input id="address_street" type="text">
				</label>
				<label title="N\xfamero">N\xfamero
					<input id="address_number" type="text">
				</label>
				<label title="Complemento">Complemento
					<input id="address_complement" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Bairro">Bairro
					<input id="address_district" type="text">
				</label>
				<label title="Unidade Federativa">UF
					<input id="address_state" type="text" list="states">
				</label>
				<label title="Munic\xedpio">Munic\xedpio
					<input id="address_city_id" type="text" list="cities">
				</label>
				<label title="CEP">CEP
					<input id="address_zipcode" type="text" placeholder="00000-000">
				</label>
			</div>
			<div class="fsb">
				<span class="cep-hint" style="font-size:0.85em;color:var(--color-muted,#666);">Digite o CEP e saia do campo para preencher automaticamente (logradouro, bairro, UF, munic\xedpio).</span>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#carrier',
        /** Submit autocontido: lê DOM, valida e chama callback. Não usa formCheck/getValues do formset (evita impacto no resto do sistema). */ submitHandler (formset, ev) {
            ev?.preventDefault();
            const root = document.querySelector('#carrier');
            if (!root) return;
            const val = (id)=>(root.querySelector(`#${id}`)?.value ?? '').trim();
            const chk = root.querySelector('#is_local_delivery');
            const isLocal = !!chk?.checked;
            let typeRaw = (root.querySelector('#type')?.value ?? '').trim().toUpperCase();
            // API espera um caractere: J (PJ), F (PF), G (OP), L (LOCAL)
            const typeMap = {
                'PJ': 'J',
                'PF': 'F',
                'G': 'G',
                'GV': 'G',
                'OP': 'G',
                'L': 'L',
                'LOCAL': 'L'
            };
            const type = isLocal ? 'L' : typeMap[typeRaw] || typeRaw;
            // API espera ie_type como char: 1=Contribuinte, 2=Isento, 9=Não Contribuinte
            let ieTypeRaw = val('ie_type');
            const ieTypeNorm = (s)=>(s || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
            const ieTypeMap = {
                'CONTRIBUINTE': '1',
                'ISENTO': '2',
                'NAO CONTRIBUINTE': '9'
            };
            const ieType = isLocal ? '' : ieTypeMap[ieTypeNorm(ieTypeRaw)] || (/^[129]$/.test(ieTypeRaw) ? ieTypeRaw : ieTypeRaw);
            const data = {
                company_id: val('company_id'),
                id: val('id'),
                type: type,
                nick: val('nick'),
                name: val('name'),
                email: val('email'),
                phone: val('phone'),
                cpf: val('cpf'),
                cnpj: val('cnpj'),
                ie: val('ie'),
                ie_type: ieType,
                address_id: val('address_id'),
                address_street: val('address_street'),
                address_number: val('address_number'),
                address_complement: val('address_complement'),
                address_district: val('address_district'),
                address_state: val('address_state'),
                address_city_id: val('address_city_id'),
                address_zipcode: val('address_zipcode'),
                is_local_delivery: isLocal
            };
            if (!data.company_id) throw new Error('Verificar Empresa*');
            if (!data.type) throw new Error('Verificar Tipo*');
            if (!data.nick) throw new Error('Verificar Apelido*');
            if (!data.name) throw new Error('Verificar Nome*');
            if (!isLocal && !/^[129]$/.test(data.ie_type)) throw new Error('Verificar Tipo IE*');
            formset.callback?.call(formset, data);
        },
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const sel = formset.form.selector;
            const chk = document.querySelector(`${sel} #is_local_delivery`);
            const typeEl = document.querySelector(`${sel} #type`);
            const cpfEl = document.querySelector(`${sel} #cpf`);
            const cnpjEl = document.querySelector(`${sel} #cnpj`);
            const ieEl = document.querySelector(`${sel} #ie`);
            const ieTypeEl = document.querySelector(`${sel} #ie_type`);
            const toggleLocal = ()=>{
                if (!chk) return;
                const on = chk.checked;
                const type = (typeEl?.value || '').trim().toUpperCase();
                if (on) {
                    [
                        cpfEl,
                        cnpjEl,
                        ieEl,
                        ieTypeEl
                    ].forEach((el)=>{
                        if (el) {
                            el.disabled = true;
                            el.required = false;
                            el.value = '';
                        }
                    });
                    if (typeEl) {
                        typeEl.value = 'L';
                        typeEl.disabled = true;
                    }
                } else {
                    if (typeEl) typeEl.disabled = false;
                    // PJ/G: exige CNPJ e IE; PF: exige CPF; não exigir CPF para PJ
                    const isPF = type === 'F';
                    const isPJ = type === 'J' || type === 'G';
                    if (cpfEl) {
                        cpfEl.disabled = !isPF;
                        cpfEl.required = isPF;
                        if (!isPF) cpfEl.value = '';
                    }
                    if (cnpjEl) {
                        cnpjEl.disabled = isPF;
                        cnpjEl.required = isPJ;
                        if (isPF) cnpjEl.value = '';
                    }
                    if (ieEl) {
                        ieEl.disabled = false;
                        ieEl.required = true;
                    }
                    if (ieTypeEl) {
                        ieTypeEl.disabled = false;
                        ieTypeEl.required = true;
                    }
                }
            };
            chk?.addEventListener('change', toggleLocal);
            // Atualiza o valor armazenado do campo checkbox quando alteramos chk.checked no código (sem disparar 'change')
            const syncCheckboxStorage = ()=>{
                const field = formset.form.getFieldBySelector?.('#is_local_delivery');
                if (field && typeof field.setValue === 'function') field.setValue(chk?.checked ? 1 : 0);
            };
            formset.subscribe && formset.subscribe([
                'open'
            ], ()=>{
                setTimeout(()=>{
                    // Só marcar "Modo local" se o tipo for L; caso contrário desmarcar (ex.: novo registro ou PJ)
                    const type = (typeEl?.value || '').trim().toUpperCase();
                    if (type === 'L') chk.checked = true;
                    else chk.checked = false;
                    syncCheckboxStorage();
                    toggleLocal();
                }, 0);
            });
            // Ao mudar o tipo: se escolheu PJ/PF/G, desmarcar "Modo local" e atualizar valor armazenado
            typeEl?.addEventListener('change', ()=>{
                const type = (typeEl?.value || '').trim().toUpperCase();
                if (type && type !== 'L' && chk) {
                    chk.checked = false;
                    syncCheckboxStorage();
                }
                toggleLocal();
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $eaa7b296a57d850b$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#cpf'
            },
            types: [
                $bc7d8cd598cdbfe0$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#cnpj'
            },
            types: [
                $7fda302dcbccda19$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ie'
            },
            types: [
                $c215c48c03ffee69$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $7582832548ac84df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#email'
            },
            types: [
                $ff6c02d4f0df8745$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_street'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_number'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_complement'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_district'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_state'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $2b0e90bfecbeac43$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address_city_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('address_state')
            ]
        },
        {
            properties: {
                selector: '#address_zipcode'
            },
            types: [
                $a3b288a4e8d304b7$export$2e2bcd8739ae039(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_local_delivery'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $bf6317b83db2cd5d$var$carriers = function() {
    let carriers_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_cities, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cities', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_carriers, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_carrier, ...JSON.parse(id));
            _record = (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'address');
            if (_record.address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.address_city_id);
                if (c) {
                    _record['address_state'] = c.state;
                    _record['address_city_id'] = c.city;
                }
            }
            return _record;
        },
        async saveRecord (data, old_data) {
            const sel = '#carrier';
            const normalize = (s)=>(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
            const resolveCityId = async (state, cityVal)=>{
                if (!state || cityVal == null || cityVal === '') return cityVal;
                const v = String(cityVal).trim();
                if (/^\d{7}$/.test(v)) return v;
                const range = IDBKeyRange.bound([
                    state,
                    ''
                ], [
                    state,
                    '\uffff'
                ]);
                const cities = await (0, $1cmSR.default).list('cities', range, 2).catch(()=>[]);
                const c = (cities || []).find((x)=>normalize(x?.city || '') === normalize(v));
                return c ? c.id : cityVal;
            };
            const getAddr = (suffix)=>{
                const el = document.querySelector(`${sel} #address_${suffix}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getField = (id)=>{
                const el = document.querySelector(`${sel} #${id}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getZipFromDom = ()=>getAddr('zipcode').replace(/\D/g, '');
            // Garante valores do formulário: se data vier vazio, lê do DOM (formset às vezes não serializa todos os campos)
            const street = (data.address_street || getAddr('street')).trim();
            const number = (data.address_number || getAddr('number')).trim();
            const complement = (data.address_complement || getAddr('complement')).trim() || null;
            const district = (data.address_district || getAddr('district')).trim();
            const zipcode = data.address_zipcode && String(data.address_zipcode).replace(/\D/g, '') || getZipFromDom();
            const state = (data.address_state || getAddr('state')).toUpperCase().trim().slice(0, 2);
            let cityId = data.address_city_id != null && data.address_city_id !== '' ? data.address_city_id : getAddr('city_id');
            if (state && cityId) cityId = await resolveCityId(state, cityId);
            // Checkbox: preferir estado do DOM (evita valor antigo no storage ao desmarcar ao trocar para PJ)
            const chkNode = document.querySelector(`${sel} #is_local_delivery`);
            const isLocal = chkNode ? !!chkNode.checked : !!data.is_local_delivery;
            // API espera type como um char (J,F,G,L) e ie_type como char (1,2,9)
            const typeNorm = (t)=>{
                const m = {
                    'PJ': 'J',
                    'PF': 'F',
                    'G': 'G',
                    'L': 'L',
                    'LOCAL': 'L'
                };
                return m[t] || t;
            };
            const ieTypeNorm = (v)=>{
                const m = {
                    'Contribuinte': '1',
                    'Isento': '2',
                    "N\xe3o Contribuinte": '9',
                    'Nao Contribuinte': '9'
                };
                return m[v] || (/^[129]$/.test(v) ? v : v);
            };
            let _record = {
                type: isLocal ? 'L' : typeNorm(data.type),
                nick: data.nick,
                name: data.name,
                cpf: isLocal ? null : data.cpf || getField('cpf') || null,
                cnpj: isLocal ? null : data.cnpj || getField('cnpj') || null,
                ie: isLocal ? null : data.ie,
                ie_type: isLocal ? null : ieTypeNorm(data.ie_type),
                phone: data.phone,
                email: data.email,
                is_local_delivery: isLocal
            };
            if (data.address_id || street || number || district || zipcode || cityId) _record['address'] = {
                id: data.address_id ? Number(data.address_id) : null,
                street: street || null,
                number: number || null,
                complement: complement,
                district: district || null,
                zipcode: zipcode || null,
                city_id: cityId || null
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_carrier, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_carrier, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Transportador',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do transportador'
        },
        {
            index: 3,
            field: 'type',
            label: 'Tipo',
            types: [
                $eaa7b296a57d850b$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Tipo de personalidade jur\xeddica"
        },
        {
            index: 4,
            field: 'nick',
            label: 'Apelido',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome curto do transportador'
        },
        {
            index: 5,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome ou raz\xe3o social"
        },
        {
            index: 6,
            field: 'cpf',
            label: 'CPF',
            types: [
                $bc7d8cd598cdbfe0$export$2e2bcd8739ae039()
            ],
            placeholder: '000.000.000-00',
            title: "N\xfamero do CPF"
        },
        {
            index: 7,
            field: 'cnpj',
            label: 'CNPJ',
            types: [
                $7fda302dcbccda19$export$2e2bcd8739ae039()
            ],
            placeholder: '00.000.000/0000-00',
            title: "N\xfamero do CNPJ"
        },
        {
            index: 8,
            field: 'ie',
            label: 'IE',
            types: [
                $c215c48c03ffee69$export$2e2bcd8739ae039()
            ],
            placeholder: '000.000.000',
            title: "Inscri\xe7\xe3o Estadual"
        },
        {
            index: 9,
            field: 'ie_type',
            label: 'Tipo IE',
            types: [
                $7582832548ac84df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Tipo de Inscri\xe7\xe3o Estadual"
        },
        {
            index: 10,
            field: 'phone',
            label: 'Fone',
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone'
        },
        {
            index: 11,
            field: 'email',
            label: 'Email',
            types: [
                $ff6c02d4f0df8745$export$2e2bcd8739ae039()
            ],
            placeholder: 'abc@xyz.com',
            title: 'Email'
        }
    ];
    carriers_crud.run('carriers', 'Transportadores', document.getElementById('workarea'), (0, $26658b175da0a4f4$export$2e2bcd8739ae039), (0, $0ab567b2ed7663d6$export$2e2bcd8739ae039), fieldspecs);
};
var $bf6317b83db2cd5d$export$2e2bcd8739ae039 = $bf6317b83db2cd5d$var$carriers;




var $1cmSR = parcelRequire("1cmSR");



async function $cf36881544852bc3$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: right; }
			.view td:nth-child(8)	{ text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Dispositivo</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">Tipo</th>
					<th data-index="5" data-visible="${this.visible[4]}">Endere\xe7o</th>
					<th data-index="6" data-visible="${this.visible[5]}">Porta</th>
					<th data-index="7" data-visible="${this.visible[6]}">Timeout</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[3]}'>${this.option($409d889ae18b953b$export$2e2bcd8739ae039(), record.type) || ''}</td>
					<td data-visible='${this.visible[4]}'>${this.format($3111ab08af8d80d2$export$2e2bcd8739ae039(), record.address)}</td>
					<td data-visible='${this.visible[5]}'>${record.port}</td>
					<td data-visible='${this.visible[6]}'>${record.timeout}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $8ab7139e29dfa662$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#device #company_id		{ width: 10rem;		}
			#device #id				{ width: 5rem; text-align: right;	}
			#device #name			{ width: 20rem; 	}
			#device #type			{ width: 10rem;		}
			#device #address		{ width: 10rem;		}
			#device #port			{ width: 7rem; text-align: right;	}
			#device #timeout		{ width: 7rem; text-align: right;	}
		</style>
		<form id="device" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do dispositivo">Dispositivo
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do dispositivo">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div>
				<label title="Tipo de dispositivo">Tipo<sup>*</sup>
					<input id="type" type="text" list="types" required>
				</label>
				<label title="Endere\xe7o IP do dispositivo">Endere\xe7o<sup>*</sup>
					<input id="address" type="text" required>
				</label>
				<label title="Porta de conex\xe3o">Porta<sup>*</sup>
					<input id="port" type="text" required>
				</label>
				<label title="Tempo m\xe1ximo de resposta em segundos">Timeout<sup>*</sup>
					<input id="timeout" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#device',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $409d889ae18b953b$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#address'
            },
            types: [
                $3111ab08af8d80d2$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#port'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#timeout'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        }
    ]
};



const $72c9f6cb63809845$var$devices = function() {
    let devices_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_devices, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_device, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                type: data.type,
                address: data.address,
                port: Number(data.port),
                timeout: Number(data.timeout)
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_device, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_device, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Dispositivo',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do dispositivo'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '',
            title: 'Nome do dispositivo'
        },
        {
            index: 4,
            field: 'type',
            label: 'Tipo',
            types: [
                $409d889ae18b953b$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Tipo'
        },
        {
            index: 5,
            field: 'address',
            label: "Endere\xe7o",
            types: [],
            placeholder: '0.0.0.0',
            title: "Endere\xe7o IP do dispositivo"
        },
        {
            index: 6,
            field: 'port',
            label: 'Porta',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0)
            ],
            placeholder: '0',
            title: "Porta de conex\xe3o"
        },
        {
            index: 7,
            field: 'timeout',
            label: 'Timeout',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0)
            ],
            placeholder: '0',
            title: "Tempo m\xe1ximo de resposta em segundos"
        }
    ];
    devices_crud.run('devices', 'Dispositivos', document.getElementById('workarea'), (0, $cf36881544852bc3$export$2e2bcd8739ae039), (0, $8ab7139e29dfa662$export$2e2bcd8739ae039), fieldspecs);
};
var $72c9f6cb63809845$export$2e2bcd8739ae039 = $72c9f6cb63809845$var$devices;




var $1cmSR = parcelRequire("1cmSR");



async function $5a2011f757a8d53a$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: right; }
			.view td:nth-child(7)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Unidade</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">Sigla</th>
					<th data-index="5" data-visible="${this.visible[4]}">Fator</th>
					<th data-index="6" data-visible="${this.visible[5]}">Opera\xe7\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[3]}'>${record.unit}</td>
					<td data-visible='${this.visible[4]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.factor)}</td>
					<td data-visible='${this.visible[5]}'>${this.option($67779c32de42857b$export$2e2bcd8739ae039(), record.operation) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $f36ec300bd03665e$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#_unit #company_id	{ width: 10rem;	}
			#_unit #id			{ width: 5rem; text-align: right;	}
			#_unit #name		{ width: 15rem;	}
			#_unit #unit		{ width: 5rem;	}
			#_unit #factor		{ width: 5rem; text-align: right;	}
			#_unit #operation	{ width: 8rem; 	}
		</style>
		<form id="_unit" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="operations">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da unidade">Unidade
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da unidade">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Sigla da unidade">Sigla<sup>*</sup>
					<input id="unit" type="text" required>
				</label>
				<label title="Fator de multiplica\xe7\xe3o ou divis\xe3o">Fator<sup>*</sup>
					<input id="factor" type="text" required>
				</label>
				<label title="Opera\xe7\xe3o da unidade">Opera\xe7\xe3o<sup>*</sup>
					<input id="operation" type="text" list="operations" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#_unit',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#unit'
            },
            types: [
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#factor'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#operation'
            },
            types: [
                $67779c32de42857b$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $157d0f4971612fc5$var$units = function() {
    let units_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_units, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_unit, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                unit: data.unit,
                factor: Number(data.factor),
                operation: data.operation
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_unit, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_unit, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Unidade',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da unidade'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome da unidade'
        },
        {
            index: 4,
            field: 'unit',
            label: 'Unidade',
            types: [
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Sigla da unidade'
        },
        {
            index: 5,
            field: 'factor',
            label: 'Fator',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: "Fator de multiplica\xe7\xe3o ou divis\xe3o da unidade"
        },
        {
            index: 6,
            field: 'operation',
            label: "Opera\xe7\xe3o",
            types: [
                $67779c32de42857b$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Opera\xe7\xe3o da unidade (multiplica\xe7\xe3o ou divis\xe3o)"
        }
    ];
    units_crud.run('units', 'Unidades', document.getElementById('workarea'), (0, $5a2011f757a8d53a$export$2e2bcd8739ae039), (0, $f36ec300bd03665e$export$2e2bcd8739ae039), fieldspecs);
};
var $157d0f4971612fc5$export$2e2bcd8739ae039 = $157d0f4971612fc5$var$units;




var $1cmSR = parcelRequire("1cmSR");




async function $5f0c9e863466f599$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Classe</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">Seletiva</th>
					<th data-index="5" data-visible="${this.visible[4]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[3]}'>${this.option($16a377ceff31a9ac$export$2e2bcd8739ae039(), record.is_selective)}</td>
					<td data-visible='${this.visible[4]}'>${record.is_disabled ? 'SIM' : 'NAO'}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}





var $f562ed80fb0f5b5d$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#class #company_id	{ width: 10rem;	}
			#class #id			{ width: 5rem; text-align: right;	}
			#class #name		{ width: 25rem;	}
		</style>
		<form id="class" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da classe">Classe
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da classe">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Determina posi\xe7\xf5es poss\xedveis dos produtos?">Seletiva?
					<input id="is_selective" type="checkbox">
				</label>
				<label title="Classifica\xe7\xe3o inativa">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_class_disable" title="Inativar classifica\xe7\xe3o">Inativar</button>
					<button type="button" class="button bn_class_enable" title="Ativar classifica\xe7\xe3o">Ativar</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#class',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const root = ()=>formset.dialog?.getNode?.();
            const getCompanyId = ()=>formset.form.getFieldBySelector('#company_id')?.getValue?.() ?? root()?.querySelector?.('#company_id')?.value;
            const getId = ()=>root()?.querySelector?.('#id')?.value;
            const setDisabled = (v)=>{
                const f = formset.form.getFieldBySelector('#is_disabled');
                if (f) {
                    f.setValue(v ? 1 : 0);
                    f.refresh();
                }
            };
            const doAction = async (payload)=>{
                const company_id = getCompanyId(), id = getId();
                if (!company_id || !id) return;
                const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).patch_class, company_id, id, payload);
                if (resp != null) setDisabled(payload.is_disabled);
                else (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Falha ao atualizar classifica\xe7\xe3o.", 'Classes');
            };
            root()?.addEventListener?.('click', (ev)=>{
                if (ev.target?.closest?.('.bn_class_disable')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: true
                    });
                    return;
                }
                if (ev.target?.closest?.('.bn_class_enable')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: false
                    });
                    return;
                }
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_selective'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $ffea07134e071bfc$var$classes = function() {
    let classes_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        addFilter (params) {
            (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).addFilter.call(this, params);
            if (this.filter && JSON.stringify(this.filter).includes('is_disabled')) params.append('include_disabled', '1');
        },
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_classes, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_class, ...JSON.parse(id));
        },
        async setDisabled (disabled) {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione ao menos uma classifica\xe7\xe3o.", 'Classes');
            const action = disabled ? 'Inativar' : 'Ativar';
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Confirma ${action} ${ids.length} classifica\xe7\xe3o(\xf5es)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).patch_class, company_id, id, {
                        is_disabled: !!disabled
                    });
                    if (resp == null) {
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Falha ao atualizar classifica\xe7\xe3o.", 'Classes');
                        return;
                    }
                }
                this.loadPage();
            });
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                is_selective: data.is_selective == '1',
                is_disabled: data.is_disabled == '1'
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_class, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_class, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Classe',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da classe'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome da classe'
        },
        {
            index: 8,
            field: 'is_selective',
            label: 'Seletiva?',
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Determina posi\xe7\xf5es poss\xedveis dos produtos?"
        },
        {
            index: 5,
            field: 'is_disabled',
            label: 'Inativo',
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Classifica\xe7\xe3o inativa"
        }
    ];
    let operations = [
        {
            hash: '#class-disable',
            label: 'Inativar'
        },
        {
            hash: '#class-enable',
            label: 'Ativar'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#class-disable', classes_crud.setDisabled.bind(classes_crud, true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#class-enable', classes_crud.setDisabled.bind(classes_crud, false));
    classes_crud.run('classes', 'Classes', document.getElementById('workarea'), (0, $5f0c9e863466f599$export$2e2bcd8739ae039), (0, $f562ed80fb0f5b5d$export$2e2bcd8739ae039), fieldspecs, operations, []);
};
var $ffea07134e071bfc$export$2e2bcd8739ae039 = $ffea07134e071bfc$var$classes;




var $1cmSR = parcelRequire("1cmSR");




async function $5ecc6f797889b4f5$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left;	}
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Categoria</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $4208f0a476aca13f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#category #company_id	{ width: 10rem;		}
			#category #id			{ width: 4.5rem; text-align: right;	}
			#category #name			{ width: 10rem;		}
			#category .name 		{ width: 14rem;		}
			#category .length 		{ width: 5rem; text-align: right;	}
			#category .attr-help		{ margin: 0.5rem 0 1rem; padding: 0.75rem; background: var(--form-hint-bg, #f5f5f5); border-radius: 4px; font-size: 0.9rem; line-height: 1.4; }
			#category .attr-help code { padding: 0.1em 0.4em; background: #e0e0e0; border-radius: 3px; font-size: 0.9em; }
			#category .attr-section th small { font-weight: normal; color: #666; display: block; margin-top: 0.2rem; }
		</style>
		<form id="category" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da categoria">Categoria
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da categoria">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="attr-section">
				<p class="attr-help">
					<strong>Estrutura do SKU:</strong> Os atributos definem como o c\xf3digo do produto (SKU) ser\xe1 organizado.
					Cada linha \xe9 um segmento do SKU. O <em>tamanho</em> indica quantos caracteres esse segmento ter\xe1 (1\u{2013}12).
					Use um n\xfamero (ex: 6) ou v\xe1rios separados por v\xedrgula (ex: 5,6,10) quando o segmento puder ter tamanhos diferentes.
					Ex.: <strong>Subst\xe2ncia(3)</strong>, <strong>Concentra\xe7\xe3o(1)</strong>, <strong>Embalagem(1)</strong> \u{2192} SKU como <code>PRD,5,C</code>.
				</p>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Atributo<sup>*</sup><br><small>Nome do segmento (ex: Subst\xe2ncia, Concentra\xe7\xe3o)</small></th>
							<th>Tamanho<sup>*</sup><br><small>Um n\xfamero ou v\xe1rios separados por v\xedrgula (ex: 6 ou 5,6,10)</small></th>
							<th>Opcional<br><small>Pode ficar em branco?</small></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="6">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Nome do atributo exibido no cadastro do produto (ex: Subst\xe2ncia, Fabricante)">
								<input id="name-0" class="name" type="text" required placeholder="ex: Produto">
							</td>
							<td title="Um n\xfamero (ex: 6) ou v\xe1rios separados por v\xedrgula (ex: 5,6,10) para aceitar m\xfaltiplos tamanhos">
								<input id="length-0" class="length" type="text" required placeholder="ex: 6 ou 5,6,10">
							</td>
							<td title="Marcar se este atributo pode ser omitido no SKU">
								<input id="is_optional-0" class="optional" type="checkbox">
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#category',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#name-0'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#length-0'
            },
            types: [
                $6f5d856b9353a912$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_optional-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $7113b1f3aa2dbdf1$var$categories = function() {
    let categories_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_categories, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_category, ...JSON.parse(id));
            // Exibir lengths como "5,6,10" no campo length quando houver múltiplos tamanhos
            if (_record?.attributes) _record.attributes = _record.attributes.map((a)=>({
                    ...a,
                    length: a.lengths && a.lengths.length ? a.lengths.join(',') : String(a.length ?? '')
                }));
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'attributes');
        },
        async saveRecord (data, old_data) {
            data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'attributes');
            const parseLength = (val)=>{
                const s = String(val || '').trim();
                if (!s) return {
                    length: 6,
                    lengths: null
                };
                const parts = s.split(/[,\s]+/).map((p)=>p.trim()).filter(Boolean);
                const nums = [];
                for (const p of parts){
                    const m = p.match(/^(\d+)-(\d+)$/);
                    if (m) {
                        const a = parseInt(m[1], 10), b = parseInt(m[2], 10);
                        for(let i = Math.min(a, b); i <= Math.max(a, b); i++)nums.push(i);
                    } else {
                        const n = parseInt(p, 10);
                        if (!isNaN(n) && n >= 1 && n <= 12) nums.push(n);
                    }
                }
                if (nums.length === 0) return {
                    length: 6,
                    lengths: null
                };
                const unique = [
                    ...new Set(nums)
                ].sort((a, b)=>a - b);
                return {
                    length: unique[0],
                    lengths: unique.length > 1 ? unique : null
                };
            };
            let _record = {
                name: data.name,
                attributes: data.attributes.map((entry, index)=>{
                    const { length: length, lengths: lengths } = parseLength(entry.length);
                    const att = {
                        position: index + 1,
                        name: entry.name,
                        length: length,
                        is_optional: entry.is_optional == '1'
                    };
                    if (lengths) att.lengths = lengths;
                    return att;
                })
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_category, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_category, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Categoria',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da categoria'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome da categoria'
        }
    ];
    categories_crud.run('categories', 'Categorias', document.getElementById('workarea'), (0, $5ecc6f797889b4f5$export$2e2bcd8739ae039), (0, $4208f0a476aca13f$export$2e2bcd8739ae039), fieldspecs);
};
var $7113b1f3aa2dbdf1$export$2e2bcd8739ae039 = $7113b1f3aa2dbdf1$var$categories;




var $1cmSR = parcelRequire("1cmSR");


async function $15cb3ff7d6a1c0bb$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left; max-width: 40rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Fabricante</th>
					<th data-index="3" data-visible="${this.visible[2]}">Apelido</th>
					<th data-index="4" data-visible="${this.visible[3]}">Nome</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.nick}</td>
					<td data-visible='${this.visible[3]}'>${record.name}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $1b5d59a7ca36f0f9$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#manufacturer #company_id	{ width: 10rem;	}
			#manufacturer #id			{ width: 5rem; text-align: right;	}
			#manufacturer #nick			{ width: 10rem;	}
			#manufacturer #name			{ width: 25rem;	}
		</style>
		<form id="manufacturer" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do fabricante">Fabricante
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome curto para o fabricante">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
				<label title="Raz\xe3o social do fabricante">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#manufacturer',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $63ee0a3c4d5a5d51$var$manufacturers = function() {
    let manufacturers_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_manufacturers, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_manufacturer, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                nick: data.nick,
                name: data.name
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_manufacturer, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_manufacturer, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Classe',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do fabricante'
        },
        {
            index: 3,
            field: 'nick',
            label: 'Apelido',
            types: [],
            placeholder: '',
            title: 'Nome curto para o fabricante'
        },
        {
            index: 4,
            field: 'name',
            label: 'Nome',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Raz\xe3o social do fabricante"
        }
    ];
    manufacturers_crud.run('manufacturers', 'Fabricantes', document.getElementById('workarea'), (0, $15cb3ff7d6a1c0bb$export$2e2bcd8739ae039), (0, $1b5d59a7ca36f0f9$export$2e2bcd8739ae039), fieldspecs);
};
var $63ee0a3c4d5a5d51$export$2e2bcd8739ae039 = $63ee0a3c4d5a5d51$var$manufacturers;




var $1cmSR = parcelRequire("1cmSR");







async function $db2166c5ef26f5de$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left;	}
			.view td:nth-child(5)	{ text-align: left; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(8)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; }
			.view td:nth-child(13)	{ text-align: left; }
			.view td:nth-child(14)	{ text-align: center; }
			.view td:nth-child(15)	{ text-align: left; }
			.view td:nth-child(16)	{ text-align: right; }
			.view td:nth-child(17)	{ text-align: right; }
			.view td:nth-child(18)	{ text-align: right; }
			.view td:nth-child(19)	{ text-align: right; }
			.view td:nth-child(20)	{ text-align: right; }
			.view td:nth-child(21)	{ text-align: left; }
			.view td:nth-child(22)	{ text-align: left; }
			/*
			.view td:nth-child(23)	{ text-align: left; }
			.view td:nth-child(24)	{ text-align: left; }
			.view td:nth-child(25)	{ text-align: right; }
			*/
			.view td:nth-child(23)	{ text-align: right; }
			.view td:nth-child(24)	{ text-align: right; }
			.view td:nth-child(25)	{ text-align: right; }
			.view td:nth-child(26)	{ text-align: right; }
			.view td:nth-child(27)	{ text-align: right; }
			.view td:nth-child(28)	{ text-align: right; }
			.view td:nth-child(29)	{ text-align: right; }
			.view td:nth-child(30)	{ text-align: right; }
			.view td:nth-child(31)	{ text-align: center; }
			.view td:nth-child(32)	{ text-align: left; }
			.view td:nth-child(33)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Produto</th>
					<th data-index="3" data-visible="${this.visible[2]}">Categoria</th>
					<th data-index="6" data-visible="${this.visible[3]}">Fabricante</th>
					<th data-index="7" data-visible="${this.visible[4]}">SKU</th>
					<th data-index="9" data-visible="${this.visible[5]}">Nome</th>
					<th data-index="10" data-visible="${this.visible[6]}">Sin\xf4nimos</th>
					<th data-index="11" data-visible="${this.visible[7]}">Descri\xe7\xe3o</th>
					<th data-index="12" data-visible="${this.visible[8]}">Refer\xeancias</th>
					<th data-index="14" data-visible="${this.visible[9]}">Programa</th>
					<th data-index="15" data-visible="${this.visible[10]}">GTIN</th>
					<th data-index="16" data-visible="${this.visible[11]}">NCM</th>
					<th data-index="17" data-visible="${this.visible[12]}">CEST</th>
					<th data-index="18" data-visible="${this.visible[13]}">Origem</th>
					<th data-index="19" data-visible="${this.visible[14]}">Taxa\xe7\xe3o</th>
					<th data-index="20" data-visible="${this.visible[15]}">ICMS</th>
					<th data-index="21" data-visible="${this.visible[16]}">Vida</th>
					<th data-index="22" data-visible="${this.visible[17]}">Estoque M\xedn</th>
					<th data-index="23" data-visible="${this.visible[18]}">Estoque</th>
					<th data-index="24" data-visible="${this.visible[19]}">Valor</th>
					<th data-index="4" data-visible="${this.visible[20]}">Un Compra</th>
					<th data-index="5" data-visible="${this.visible[21]}">Un Venda</th>
					<!--
					<th data-index="32" data-visible="${this.visible[22]}">Anvisa</th>
					<th data-index="33" data-visible="${this.visible[23]}">Justificativa</th>
					<th data-index="34" data-visible="${this.visible[24]}">PMC</th>
					-->
					<th data-index="25" data-visible="${this.visible[22]}">ES Peso</th>
					<th data-index="26" data-visible="${this.visible[23]}">ES Altura</th>
					<th data-index="27" data-visible="${this.visible[24]}">ES Largura</th>
					<th data-index="28" data-visible="${this.visible[25]}">ES Compr</th>
					<th data-index="29" data-visible="${this.visible[26]}">ET Peso</th>
					<th data-index="30" data-visible="${this.visible[27]}">ET Altura</th>
					<th data-index="31" data-visible="${this.visible[28]}">ET Largura</th>
					<th data-index="32" data-visible="${this.visible[29]}">ET Compr</th>
					<th data-index="33" data-visible="${this.visible[30]}">Imagem</th>
					<th data-index="35" data-visible="${this.visible[32]}">Portaria 344</th>
					<th data-index="34" data-visible="${this.visible[31]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.category_id != null ? await this.key('categories', [
            record.company_id,
            record.category_id
        ]) : ''}</td>
					<td data-visible='${this.visible[3]}'>${record.manufacturer_id != null ? await this.key('manufacturers', [
            record.company_id,
            record.manufacturer_id
        ], 'nick') : ''}</td>
					<td data-visible='${this.visible[4]}'>${record.sku.join('-')}</td>
					<td data-visible='${this.visible[5]}'>${record.name}</td>
					<td data-visible='${this.visible[6]}'>${(record.synonyms || []).join(',')}</td>
					<td data-visible='${this.visible[7]}'>${record.description || ''}</td>
					<td data-visible='${this.visible[8]}'>${(record.reference || []).join(',')}</td>
					<td data-visible='${this.visible[9]}'>${record.program_id != null ? await this.key('programs', [
            record.company_id,
            record.program_id
        ]) : ''}</td>
					<td data-visible='${this.visible[10]}'>${this.format($ca1c79f4e173f347$export$2e2bcd8739ae039(), record.gtin)}</td>
					<td data-visible='${this.visible[11]}'>${this.format($8b11f696e7bab70f$export$2e2bcd8739ae039(), record.ncm)}</td>
					<td data-visible='${this.visible[12]}'>${this.format($73c7be81b506e1d3$export$2e2bcd8739ae039(), record.cest)}</td>
					<td data-visible='${this.visible[13]}'>${record.origin}</td>
					<td data-visible='${this.visible[14]}'>${record.taxation || ''}</td>
					<td data-visible='${this.visible[15]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.icms)}</td>
					<td data-visible='${this.visible[16]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2), record.shelf_life)}</td>
					<td data-visible='${this.visible[17]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2), record.minimum_quantity)}</td>
					<td data-visible='${this.visible[18]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2), record.quantity)}</td>
					<td data-visible='${this.visible[19]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.value)}</td>
					<td data-visible='${this.visible[20]}'>${record.purchasing_unit_id != null ? await this.key('units', [
            record.company_id,
            record.purchasing_unit_id
        ]) : ''}</td>
					<td data-visible='${this.visible[21]}'>${record.selling_unit_id != null ? await this.key('units', [
            record.company_id,
            record.selling_unit_id
        ]) : ''}</td>
					<!--
					<td data-visible='${this.visible[22]}'>${record.drug?.anvisa || ''}</td>
					<td data-visible='${this.visible[23]}'>${record.drug?.exemption || ''}</td>
					<td data-visible='${this.visible[24]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.drug?.max_price)}</td>
					-->
					<td data-visible='${this.visible[22]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.secondary_weight)}</td>
					<td data-visible='${this.visible[23]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.secondary_height)}</td>
					<td data-visible='${this.visible[24]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.secondary_width)}</td>
					<td data-visible='${this.visible[25]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.secondary_length)}</td>
					<td data-visible='${this.visible[26]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.master_weight)}</td>
					<td data-visible='${this.visible[27]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.master_height)}</td>
					<td data-visible='${this.visible[28]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.master_width)}</td>
					<td data-visible='${this.visible[29]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.master_length)}</td>
					<td data-visible='${this.visible[30]}'>${record.image ? '&#10003;' : ''}</td>
					<td data-visible='${this.visible[32]}'>${record.is_portaria_344 ? record.portaria_344_list || 'SIM' : ''}</td>
					<td data-visible='${this.visible[31]}'>${record.is_disabled ? 'SIM' : 'NAO'}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




var $1cmSR = parcelRequire("1cmSR");


const $582992a9d521cb7c$var$PRODUCT_HELP_BODY_CLASS = 'product-help-body';
const $582992a9d521cb7c$var$PRODUCT_HELP_DADOS_HTML = `
<div class="${$582992a9d521cb7c$var$PRODUCT_HELP_BODY_CLASS}">
<h4>Empresa</h4>
<p>Empresa (depositante) \xe0 qual o produto pertence. Define escopo de IDs sequenciais, categorias, unidades e demais cadastros filhos.</p>
<h4>Produto</h4>
<p>Identificador num\xe9rico interno do item; preenchido ap\xf3s a primeira grava\xe7\xe3o.</p>
<h4>Categoria e fabricante</h4>
<p>Categoria regras de SKU/taxonomia e classifica\xe7\xe3o comercial. Fabricante (laborat\xf3rio/fornecedor industrial) usado em cadastro e relat\xf3rios.</p>
<h4>Un Compra / Un Venda</h4>
<p>Unidade de medida padr\xe3o na compra e na venda (ex.: CX, UN). Podem coincidir ou n\xe3o conforme o neg\xf3cio.</p>
<h4>SKU e taxonomia</h4>
<p>SKU \xe9 o c\xf3digo interno do produto (tamanho e formato dependem da categoria). Taxonomia complementa a chave de identifica\xe7\xe3o comercial no SIAL.</p>
<h4>Nome, descri\xe7\xe3o, sin\xf4nimos e refer\xeancias</h4>
<p>Nome exibido e buscas; sin\xf4nimos e refer\xeancias ajudam localiza\xe7\xe3o e integra\xe7\xf5es (c\xf3digos externos).</p>
<h4>C\xf3digo cliente</h4>
<p>C\xf3digo do produto na base do cliente (DE/PARA para integra\xe7\xe3o ou confer\xeancia).</p>
<h4>Programa</h4>
<p>V\xednculo opcional a programa (ex.: programas de sa\xfade): usado quando a empresa controla estoque ou pol\xedticas por programa.</p>
<h4>GTIN, NCM, CEST e origem</h4>
<p>GTIN (EAN) do produto ou \u{201C}SEM GTIN\u{201D} quando n\xe3o houver c\xf3digo de barras (campo legado, ainda usado em NF-e e integra\xe7\xf5es). GTIN por n\xedvel de embalagem (P/S/T) e fabricante vinculado ficam em <strong>Cat\xe1logo \u{2192} Embalagens de produto</strong>; os dois podem coexistir durante a migra\xe7\xe3o.</p>
<h4>Medicamentos (Anvisa, justificativa, PMC)</h4>
<p>Campos opcionais para registro/justificativa junto \xe0 Anvisa e pre\xe7o m\xe1ximo ao consumidor, quando aplic\xe1vel ao item.</p>
<h4>Inativo e imagem</h4>
<p>Inativo impede uso operacional normal do cadastro. Imagem associada ao produto (arquivo PNG) para exibi\xe7\xe3o ou documenta\xe7\xe3o.</p>
</div>`;
const $582992a9d521cb7c$var$PRODUCT_HELP_ARMAZENAGEM_HTML = `
<div class="${$582992a9d521cb7c$var$PRODUCT_HELP_BODY_CLASS}">
<h4>Vida (prazo de validade m\xednimo)</h4>
<p>Prazo m\xednimo de validade em dias exigido para o produto em opera\xe7\xf5es que respeitam essa regra (ex.: recebimento ou picking).</p>
<h4>Est M\xednimo, Estoque e Valor</h4>
<p><strong>Est M\xednimo:</strong> refer\xeancia de reposi\xe7\xe3o.</p>
<p><strong>Estoque e Valor</strong> no cadastro s\xe3o campos no registro do <em>produto</em> (tabela <code>products</code>): total e valor agregados para a grade e para c\xe1lculos (ex.: custo m\xe9dio em transa\xe7\xf5es). Eles <strong>n\xe3o</strong> geram carga inicial operacional: n\xe3o criam lote, n\xe3o criam posi\xe7\xe3o e n\xe3o gravam na tabela <code>stocks</code>. O saldo \u{201C}de verdade\u{201D} do armaz\xe9m vem de <strong>entradas</strong> (pedido/confer\xeancia/estocagem), <strong>movimenta\xe7\xf5es</strong> e <strong>invent\xe1rio</strong>. Em opera\xe7\xe3o normal, quantidade e valor do produto s\xe3o atualizados pelo servi\xe7o de <strong>transa\xe7\xf5es</strong> quando h\xe1 entrada ou sa\xedda f\xedsica do armaz\xe9m.</p>
<h4>Portaria 344</h4>
<p>Indica se o item se enquadra na Portaria 344/98 e, se sim, a lista (A1, B1, C1\u{2026}). Afeta tratamento de medicamentos controlados.</p>
<h4>Hierarquia de embalagens (P / S / T)</h4>
<p>Tabela somente leitura das embalagens cadastradas em <strong>Embalagens de produto</strong> (n\xedveis prim\xe1rio, secund\xe1rio, terci\xe1rio). Use <strong>Atualizar lista</strong> para recarregar sem fechar o formul\xe1rio. A empresa precisa ter <strong>Hierarquia de embalagens</strong> ativa para o modelo novo nas opera\xe7\xf5es.</p>
<h4>Dimens\xf5es ES / ET (legado)</h4>
<p>Medidas f\xedsicas gravadas no pr\xf3prio produto: ES = secund\xe1ria, ET = terci\xe1ria (campos <code>master_*</code> na API). Complementam \u{2014} n\xe3o substituem \u{2014} o cadastro de embalagens por n\xedvel.</p>
<h4>Classes</h4>
<p>Associa\xe7\xe3o do produto a classes operacionais/fiscais da empresa. Use as setas para incluir ou remover da lista \u{201C}Classes\u{201D} a partir de \u{201C}Dispon\xedveis\u{201D}.</p>
</div>`;
const $582992a9d521cb7c$var$PRODUCT_HELP_TRIBUTACAO_HTML = `
<div class="${$582992a9d521cb7c$var$PRODUCT_HELP_BODY_CLASS}">
<h4>Mono (monof\xe1sico)</h4>
<p>Indica tributa\xe7\xe3o monof\xe1sica quando aplic\xe1vel ao produto (PIS/COFINS ou ICMS conforme parametriza\xe7\xe3o fiscal do ambiente).</p>
<h4>ST (substitui\xe7\xe3o tribut\xe1ria)</h4>
<p>Marcar quando o item estiver sujeito a ST na opera\xe7\xe3o da empresa.</p>
<h4>Isento</h4>
<p>Indica isen\xe7\xe3o de ICMS para o produto nas regras em que o SIAL utiliza esse flag.</p>
<h4>ICMS</h4>
<p>Al\xedquota ou percentual espec\xedfico de ICMS do produto quando houver tratamento diferenciado em rela\xe7\xe3o \xe0 regra padr\xe3o da empresa/nota.</p>
</div>`;
const $582992a9d521cb7c$var$PRODUCT_HELP_BY_TAB = {
    dados: {
        title: "Ajuda \u2014 Dados do produto",
        html: $582992a9d521cb7c$var$PRODUCT_HELP_DADOS_HTML
    },
    armazenagem: {
        title: "Ajuda \u2014 Armazenagem",
        html: $582992a9d521cb7c$var$PRODUCT_HELP_ARMAZENAGEM_HTML
    },
    tributacao: {
        title: "Ajuda \u2014 Tributa\xe7\xe3o",
        html: $582992a9d521cb7c$var$PRODUCT_HELP_TRIBUTACAO_HTML
    }
};
var $582992a9d521cb7c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#product .form-section { margin-bottom: 1.5rem; }
			#product .form-section-title { font-size: 0.95rem; font-weight: 600; color: #374151; margin-bottom: 0.75rem; padding-bottom: 0.35rem; border-bottom: 1px solid var(--color-border); }
			#product .form-grid { display: grid; gap: 0.75rem 1.25rem; }
			#product .form-grid-2 { grid-template-columns: repeat(2, 1fr); }
			#product .form-grid-3 { grid-template-columns: repeat(3, 1fr); }
			#product .form-grid-4 { grid-template-columns: repeat(4, 1fr); }
			#product .form-grid-5 { grid-template-columns: repeat(5, 1fr); }
			#product .form-grid-6 { grid-template-columns: repeat(6, 1fr); }
			#product label.checkbox-row { display: flex; align-items: center; gap: 0.5rem; min-height: 2.25rem; }
			#product label.checkbox-row input[type="checkbox"] { width: 1.25rem; height: 1.25rem; min-width: 1.25rem; min-height: 1.25rem; margin: 0; cursor: pointer; accent-color: #4f46e5; }
			#product input[type="checkbox"] { width: 1.25rem; height: 1.25rem; min-width: 1.25rem; min-height: 1.25rem; margin: 0; cursor: pointer; accent-color: #4f46e5; }
			#product select { min-height: 2rem; padding: 0.35rem 0.5rem; border-radius: 4px; border: 1px solid var(--color-border); }
			#product .form-actions { display: flex; justify-content: flex-end; gap: 0.5rem; margin-top: 1.25rem; padding-top: 1rem; border-top: 1px solid var(--color-border); flex-shrink: 0; }
			#product .status-group { display: flex; flex-wrap: wrap; align-items: center; gap: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 6px; border: 1px solid var(--color-border); }
			#product #company_id			{ width: 100%; max-width: 10rem;	}
			#product #id					{ width: 100%; max-width: 4.5rem; text-align: right;	}
			#product #category_id			{ width: 100%; max-width: 14rem;	}
			#product #manufacturer_id		{ width: 100%; max-width: 14rem;	}
			#product #purchasing_unit_id	{ width: 100%; max-width: 10rem;	}
			#product #selling_unit_id		{ width: 100%; max-width: 10rem;	}
			#product .sku					{ width: 25%; 		}
			#product .taxons				{ width: 75%; 		}
			#product #image					{ width: 100%; max-width: 20rem; display: inline-block;	}
			#product #name					{ width: 100%; max-width: 35rem;	}
			#product #synonyms	 			{ width: 100%; max-width: 17rem;	}
			#product #reference	 			{ width: 100%; max-width: 17rem;	}
			#product #description	 		{ width: 100%; max-width: 28rem;	}
			#product #gtin	 				{ width: 100%; max-width: 8rem;	}
			#product #ncm	 				{ width: 100%; max-width: 6rem;	}
			#product #cest	 				{ width: 100%; max-width: 6rem;	}
			#product #origin	 			{ width: 100%; max-width: 12rem;	}
			#product #icms	 				{ width: 100%; max-width: 4rem; text-align: right;	}
			#product #shelf_life	 		{ width: 100%; max-width: 3rem; text-align: right;	}
			#product #minimum_quantity 		{ width: 100%; max-width: 5rem; text-align: right;	}
			#product #quantity		 		{ width: 100%; max-width: 5rem; text-align: right;	}
			#product #value			 		{ width: 100%; max-width: 6rem; text-align: right;	}
			#product #drug_anvisa		 	{ width: 100%; max-width: 8rem;	}
			#product #drug_exemption		{ width: 100%; max-width: 10rem;	}
			#product #drug_max_price	 	{ width: 100%; max-width: 5rem; text-align: right;	}
			#product #secondary_weight 		{ width: 100%; max-width: 4rem; text-align: right;	}
			#product #secondary_height 		{ width: 100%; max-width: 4rem; text-align: right;	}
			#product #secondary_width 		{ width: 100%; max-width: 4rem; text-align: right;	}
			#product #secondary_length 		{ width: 100%; max-width: 4rem; text-align: right;	}
			#product #master_weight 		{ width: 100%; max-width: 4rem; text-align: right;	}
			#product #master_height 		{ width: 100%; max-width: 4rem; text-align: right;	}
			#product #master_width 			{ width: 100%; max-width: 4rem; text-align: right;	}
			#product #master_length 		{ width: 100%; max-width: 4rem; text-align: right;	}
			#product #portaria_344_list	{ width: 100%; max-width: 6rem;	}
			#product.form { width: 52rem; max-width: 96vw; height: 85vh; max-height: 680px; overflow: hidden; display: flex; flex-direction: column; resize: none; flex-shrink: 0; }
			#product .form-tabs { display: flex; flex-wrap: wrap; align-items: center; gap: 0.35rem 0.5rem; padding: 0 0 0 0.5rem; background: #f1f5f9; border-radius: 8px 8px 0 0; margin: calc(-1 * var(--space-lg)) calc(-1 * var(--space-xl)) 0; margin-bottom: 0; flex-shrink: 0; }
			#product .form-tab-wrap { display: inline-flex; align-items: center; gap: 0.2rem; margin: 0.25rem 0.35rem 0 0; }
			#product .form-tab { padding: 0.75rem 1.25rem; cursor: pointer; font-weight: 600; font-size: 0.9rem; color: #64748b; background: transparent; border: none; border-radius: 6px; transition: all 0.15s ease; }
			#product .product-tab-help {
				display: inline-flex; align-items: center; justify-content: center;
				width: 1.35rem; height: 1.35rem; padding: 0;
				border: 1px solid #9ca3af; border-radius: 999px;
				background: #f3f4f6; color: #374151;
				font-size: 0.85rem; font-weight: 700; line-height: 1;
				cursor: pointer; flex-shrink: 0;
			}
			#product .product-tab-help:hover { background: #e5e7eb; }
			#product .product-tab-help:focus { outline: 2px solid #2563eb; outline-offset: 2px; }
			#product .form-tab:hover { color: #334155; background: #e2e8f0; }
			#product .form-tab.active { color: #4f46e5; background: white; box-shadow: 0 -1px 3px rgba(0,0,0,0.06); }
			#product .form-tab-panels { flex: 1; min-height: 0; overflow-y: auto; padding: 1rem 0 0; }
			#product .form-tab-panel { display: none; }
			#product .form-tab-panel.active { display: block; }
			#product .product-pkg-hint { font-size: 0.8rem; color: #64748b; line-height: 1.45; max-width: 46rem; margin: 0 0 0.5rem 0; }
			#product .product-pkg-actions { display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem 1rem; margin-top: 0.35rem; }
			#product .product-pkg-actions .button { white-space: nowrap; }
			#product .product-pkg-embed-status { font-size: 0.8rem; color: #64748b; min-height: 1.25rem; margin: 0.25rem 0 0.35rem 0; }
			#product .product-pkg-table-wrap { overflow: auto; max-height: 16rem; border: 1px solid var(--color-border); border-radius: 6px; margin-top: 0.25rem; background: #fff; }
			#product .product-pkg-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; }
			#product .product-pkg-table th, #product .product-pkg-table td { padding: 0.35rem 0.55rem; text-align: left; border-bottom: 1px solid #e2e8f0; vertical-align: top; }
			#product .product-pkg-table th { background: #f1f5f9; font-weight: 600; white-space: nowrap; position: sticky; top: 0; z-index: 1; }
			#product .product-pkg-table tr:last-child td { border-bottom: none; }
			#product .product-pkg-table td.num { text-align: right; font-variant-numeric: tabular-nums; }
			#product .product-pkg-table .cell-mono { font-family: ui-monospace, monospace; font-size: 0.78rem; }
			#product .form-actions .btn-product-success {
				background: linear-gradient(180deg, #4ade80 0%, #22c55e 100%);
				color: #fff; border: 1px solid #15803d; font-weight: 600;
				box-shadow: 0 1px 2px rgba(22, 163, 74, 0.25);
			}
			#product .form-actions .btn-product-success:hover {
				filter: brightness(1.05);
				box-shadow: 0 2px 4px rgba(22, 163, 74, 0.3);
			}
			#product .form-actions .btn-product-danger {
				background: linear-gradient(180deg, #fca5a5 0%, #ef4444 100%);
				color: #fff; border: 1px solid #b91c1c; font-weight: 600;
				box-shadow: 0 1px 2px rgba(220, 38, 38, 0.2);
			}
			#product .form-actions .btn-product-danger:hover {
				filter: brightness(1.05);
				box-shadow: 0 2px 4px rgba(220, 38, 38, 0.28);
			}
		</style>
		<style>
			.product-help-body { max-height: 65vh; overflow-y: auto; text-align: left; }
			.product-help-body h4 {
				margin: 0.85rem 0 0.25rem 0;
				font-size: 0.78rem; font-weight: 700; text-transform: uppercase;
				letter-spacing: 0.03em; color: #1f2937;
			}
			.product-help-body h4:first-child { margin-top: 0; }
			.product-help-body p {
				margin: 0; font-size: 0.875rem; line-height: 1.45; color: #374151;
			}
		</style>
		<form id="product" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="categories"></datalist>
			<datalist id="units"></datalist>
			<datalist id="manufacturers"></datalist>
			<datalist id="origins"></datalist>
			<datalist id="programs"></datalist>

			<div class="form-tabs">
				<div class="form-tab-wrap">
					<button type="button" class="form-tab active" data-tab="dados">Dados do produto</button>
					<button type="button" class="product-tab-help" data-help="dados" title="Ajuda: campos desta aba" aria-label="Ajuda \u{2014} Dados do produto">?</button>
				</div>
				<div class="form-tab-wrap">
					<button type="button" class="form-tab" data-tab="armazenagem">Armazenagem</button>
					<button type="button" class="product-tab-help" data-help="armazenagem" title="Ajuda: campos desta aba" aria-label="Ajuda \u{2014} Armazenagem">?</button>
				</div>
				<div class="form-tab-wrap">
					<button type="button" class="form-tab" data-tab="tributacao">Tributa\xe7\xe3o</button>
					<button type="button" class="product-tab-help" data-help="tributacao" title="Ajuda: campos desta aba" aria-label="Ajuda \u{2014} Tributa\xe7\xe3o">?</button>
				</div>
			</div>
			<div class="form-tab-panels">
				<div id="tab-dados" class="form-tab-panel active">
					<div class="form-section">
						<div class="form-section-title">Dados b\xe1sicos</div>
						<div class="form-grid form-grid-6">
							<label title="Empresa">Empresa<sup>*</sup><input id="company_id" type="text" list="companies" required></label>
							<label title="Identificador do produto">Produto<input id="id" type="text" disabled></label>
							<label title="Categoria">Categoria<sup>*</sup><input id="category_id" type="text" list="categories" required></label>
							<label title="Fabricante">Fabricante<sup>*</sup><input id="manufacturer_id" type="text" list="manufacturers" required></label>
							<label title="Unidade de compra">Un Compra<sup>*</sup><input id="purchasing_unit_id" type="text" list="units" required></label>
							<label title="Unidade de venda">Un Venda<sup>*</sup><input id="selling_unit_id" type="text" list="units" required></label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Identifica\xe7\xe3o e descri\xe7\xe3o</div>
						<div class="fsb">
							<fieldset class="sku"><legend>SKU<sup>*</sup></legend><table><tr><td><input id="sku" type="text" required title="C\xf3digo do produto."></td></tr></table></fieldset>
							<fieldset class="taxons"><legend>Taxonomia<sup>*</sup></legend><table><tr><td><input id="taxons" type="text" required></td></tr></table></fieldset>
						</div>
						<div class="form-grid form-grid-2 mtm">
							<label title="Nome">Nome<sup>*</sup><input id="name" type="text" required></label>
							<label title="Descri\xe7\xe3o">Descri\xe7\xe3o<textarea id="description" rows="2"></textarea></label>
						</div>
						<div class="form-grid form-grid-4 mtm">
							<label title="Sin\xf4nimos">Sin\xf4nimos<input id="synonyms" type="text"></label>
							<label title="Refer\xeancias">Refer\xeancias<input id="reference" type="text"></label>
							<label title="C\xf3digo cliente">C\xf3digo cliente<input id="codigo_cliente" type="text"></label>
							<label title="Programa">Programa<input id="program_id" type="text" list="programs"></label>
						</div>
						<div class="form-grid form-grid-4 mtm">
							<label title="GTIN">GTIN<sup>*</sup><input id="gtin" type="text" required placeholder="SEM GTIN"></label>
							<label title="NCM">NCM<sup>*</sup><input id="ncm" type="text" required></label>
							<label title="CEST">CEST<input id="cest" type="text"></label>
							<label title="Origem">Origem<sup>*</sup><input id="origin" type="text" list="origins" required></label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Medicamentos</div>
						<fieldset>
							<label title="Anvisa">Anvisa<input id="drug_anvisa" type="text"></label>
							<label title="Justificativa ISENTO">Justificativa<input id="drug_exemption" type="text"></label>
							<label title="PMC">PMC<input id="drug_max_price" type="text"></label>
						</fieldset>
					</div>
					<div class="form-section">
						<div class="form-section-title">Status</div>
						<div class="status-group">
							<label class="checkbox-row" title="Inativo"><input id="is_disabled" type="checkbox"> Inativo</label>
							<label class="file"><a id="download" download="image.png">Imagem</a><input id="image" type="file" accept=".png, image/x-png" title="Imagem"></label>
						</div>
					</div>
				</div>
				<div id="tab-armazenagem" class="form-tab-panel">
					<div class="form-section">
						<div class="form-section-title">Estoque e validade</div>
						<div class="form-grid form-grid-4">
							<label title="Validade m\xednima em dias">Vida<sup>*</sup><input id="shelf_life" type="text" required></label>
							<label title="Estoque m\xednimo desejado (refer\xeancia)">Est M\xednimo<input id="minimum_quantity" type="text"></label>
							<label title="Total gravado no cadastro do produto (grade). N\xe3o cria estoque por posi\xe7\xe3o/lote \u{2014} use Entrada / movimenta\xe7\xf5es para carga inicial operacional.">Estoque (cadastro)<input id="quantity" type="text"></label>
							<label title="Valor do estoque">Valor<input id="value" type="text"></label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Portaria 344</div>
						<div class="status-group">
							<label class="checkbox-row" title="Produto sujeito \xe0 Portaria 344/98"><input id="is_portaria_344" type="checkbox"> Portaria 344</label>
							<label title="Lista 344"><select id="portaria_344_list"><option value="">\u{2014}</option><option value="A1">A1</option><option value="A2">A2</option><option value="B1">B1</option><option value="C1">C1</option><option value="C2">C2</option><option value="C3">C3</option><option value="C4">C4</option><option value="C5">C5</option></select></label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Hierarquia de embalagens (P / S / T)</div>
						<p class="product-pkg-hint">Embalagens j\xe1 cadastradas para <strong>este produto</strong> aparecem na tabela abaixo (somente leitura). Para <strong>incluir ou alterar</strong> n\xedveis, c\xf3digo, fator, GTIN etc., use depois <strong>Cat\xe1logo \u{2192} Embalagens de produto</strong> \u{2014} voc\xea n\xe3o precisa sair deste modal s\xf3 para consultar a lista. Ative <strong>Hierarquia de embalagens</strong> na empresa para o modelo valer nas opera\xe7\xf5es.</p>
						<div class="product-pkg-actions">
							<button type="button" class="button bn_refresh_product_packagings" title="Recarregar embalagens da API">Atualizar lista</button>
						</div>
						<div class="product-pkg-embed-status" id="product_packagings_embed_status" aria-live="polite"></div>
						<div class="product-pkg-table-wrap">
							<table class="product-pkg-table">
								<thead>
									<tr>
										<th>ID</th>
										<th>C\xf3digo</th>
										<th>N\xedvel</th>
										<th class="num">Fator</th>
										<th class="num">Cap. terc.</th>
										<th>Fabricante</th>
										<th>GTIN</th>
										<th>Padr\xe3o</th>
										<th>Inativa</th>
									</tr>
								</thead>
								<tbody id="product_packagings_embed_body"></tbody>
							</table>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Dimens\xf5es f\xedsicas legadas (ES / ET)</div>
						<p class="product-pkg-hint">Medidas no cadastro do <strong>produto</strong> (modelo antigo): <strong>ES</strong> = embalagem secund\xe1ria (n\xedvel S), <strong>ET</strong> = embalagem terci\xe1ria (n\xedvel T). No banco/API os campos da terci\xe1ria continuam nomeados <code>master_*</code> por compatibilidade. N\xe3o substituem o cadastro hier\xe1rquico P/S/T em <strong>Embalagens de produto</strong>.</p>
						<div class="fsb">
							<fieldset><legend>Secund\xe1ria (ES)</legend>
								<label title="Peso da embalagem secund\xe1ria (kg)">Peso<input id="secondary_weight" type="text"></label>
								<label title="Altura da embalagem secund\xe1ria (m)">Altura<input id="secondary_height" type="text"></label>
								<label title="Largura da embalagem secund\xe1ria (m)">Largura<input id="secondary_width" type="text"></label>
								<label title="Comprimento da embalagem secund\xe1ria (m)">Compr<input id="secondary_length" type="text"></label>
							</fieldset>
							<fieldset><legend>Terci\xe1ria (ET)</legend>
								<label title="Peso da embalagem terci\xe1ria (kg)">Peso<input id="master_weight" type="text"></label>
								<label title="Altura da embalagem terci\xe1ria (m)">Altura<input id="master_height" type="text"></label>
								<label title="Largura da embalagem terci\xe1ria (m)">Largura<input id="master_width" type="text"></label>
								<label title="Comprimento da embalagem terci\xe1ria (m)">Compr<input id="master_length" type="text"></label>
							</fieldset>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Classifica\xe7\xf5es</div>
						<div class="fsb">
							<label class="keymap">Classes<select id="classes" multiple size="4"></select></label>
							<span class="keymap"><button type="button" class="bn_Left" title="Incluir">&#x1F844;</button><button type="button" class="bn_Right" title="Remover">&#x1F846;</button></span>
							<label class="keymap">Dispon\xedveis<select id="available" multiple size="4"></select></label>
						</div>
					</div>
				</div>
				<div id="tab-tributacao" class="form-tab-panel">
					<div class="form-section">
						<div class="form-section-title">Impostos</div>
						<div class="form-grid form-grid-4">
							<label class="checkbox-row" title="Monof\xe1sico"><input id="is_mono" type="checkbox"> Mono</label>
							<label class="checkbox-row" title="Substituto Tribut\xe1rio"><input id="is_st" type="checkbox"> ST</label>
							<label class="checkbox-row" title="Isento de ICMS"><input id="is_exempt" type="checkbox"> Isento</label>
							<label title="Al\xedquota ICMS">ICMS<input id="icms" type="text"></label>
						</div>
					</div>
				</div>
			</div>
			<div class="form-actions">
				<button type="button" class="button bn_product_disable btn-product-danger" title="Inativar produto">Inativar</button>
				<button type="button" class="button bn_product_enable" title="Ativar produto">Ativar</button>
				<button type="button" class="bn_Escape button">Fechar</button>
				<button type="button" class="bn_Enter button btn-product-success">Salvar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#product',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const root = ()=>formset.dialog?.getNode?.();
            const getId = ()=>root()?.querySelector?.('#id')?.value;
            const getCompanyId = ()=>formset.form.getFieldBySelector('#company_id')?.getValue?.() ?? root()?.querySelector?.('#company_id')?.value;
            const loadEmbeddedPackagings = async ()=>{
                const statusEl = root()?.querySelector('#product_packagings_embed_status');
                const tbody = root()?.querySelector('#product_packagings_embed_body');
                if (!statusEl || !tbody) return;
                const company_id = String(getCompanyId() || '').trim();
                const pid = String(getId() || '').replace(/\s/g, '');
                if (!company_id) {
                    statusEl.textContent = 'Selecione a empresa para carregar embalagens.';
                    tbody.innerHTML = '';
                    return;
                }
                if (!pid || !/^\d+$/.test(pid)) {
                    statusEl.textContent = 'Salve o produto ao menos uma vez para exibir as embalagens (P/S/T) vinculadas a ele.';
                    tbody.innerHTML = '';
                    return;
                }
                statusEl.textContent = "Carregando embalagens\u2026";
                tbody.innerHTML = '';
                const host = (0, $73936c209f170d43$export$ffe95df7b31670e0)();
                const path = `/companies/${encodeURIComponent(company_id)}/products/${encodeURIComponent(pid)}/packagings`;
                const url = host && String(host).trim() ? `${String(host).replace(/\/$/, '')}${path}` : path;
                const esc = (x)=>String(x ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                const lvl = (l)=>({
                        P: "P \u2014 Prim\xe1rio",
                        S: "S \u2014 Secund\xe1rio",
                        T: "T \u2014 Terci\xe1rio"
                    })[l] || esc(l);
                try {
                    const r = await fetch(url, {
                        credentials: 'include'
                    });
                    if (!r.ok) {
                        statusEl.textContent = r.status === 403 ? "Sem permiss\xe3o para listar embalagens." : `N\xe3o foi poss\xedvel carregar (${r.status}).`;
                        return;
                    }
                    const list = await r.json();
                    if (!Array.isArray(list)) {
                        statusEl.textContent = "Resposta inv\xe1lida da API.";
                        return;
                    }
                    if (list.length === 0) {
                        statusEl.textContent = 'Nenhuma embalagem cadastrada para este produto.';
                        return;
                    }
                    statusEl.textContent = `${list.length} embalagem(ns) cadastrada(s).`;
                    const fabLabel = async (mid)=>{
                        if (mid == null || mid === '') return "\u2014";
                        try {
                            const rec = await (0, $1cmSR.default).get('manufacturers', [
                                company_id,
                                Number(mid)
                            ]);
                            if (rec && (rec.nick || rec.name)) return esc(`${rec.id} ${rec.nick || rec.name}`);
                        } catch (e) {}
                        return esc(String(mid));
                    };
                    const rowsHtml = await Promise.all(list.map(async (row)=>{
                        const fab = await fabLabel(row.manufacturer_id);
                        return `
						<tr>
							<td class="num">${esc(row.id)}</td>
							<td><strong>${esc(row.code)}</strong></td>
							<td>${lvl(row.level)}</td>
							<td class="num">${esc(row.factor)}</td>
							<td class="num">${row.tertiary_capacity != null && row.tertiary_capacity !== '' ? esc(row.tertiary_capacity) : "\u2014"}</td>
							<td>${fab}</td>
							<td class="cell-mono">${row.gtin ? esc(row.gtin) : "\u2014"}</td>
							<td>${row.is_default ? 'Sim' : "\u2014"}</td>
							<td>${row.is_disabled ? 'Sim' : "\u2014"}</td>
						</tr>`;
                    }));
                    tbody.innerHTML = rowsHtml.join('');
                } catch (e) {
                    statusEl.textContent = "Falha ao carregar. Verifique a conex\xe3o com a API.";
                    console.warn(e);
                }
            };
            const setDisabled = (v)=>{
                const f = formset.form.getFieldBySelector('#is_disabled');
                if (f) {
                    f.setValue(v ? 1 : 0);
                    f.refresh();
                }
            };
            const doAction = async (payload)=>{
                const company_id = getCompanyId(), id = getId();
                if (!company_id || !id) return;
                const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).patch_product, company_id, id, payload);
                if (resp != null) setDisabled(payload.is_disabled);
                else (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Falha ao atualizar produto.', 'Produtos');
            };
            root()?.addEventListener?.('click', (ev)=>{
                if (ev.target?.closest?.('.bn_product_disable')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: true
                    });
                    return;
                }
                if (ev.target?.closest?.('.bn_product_enable')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: false
                    });
                    return;
                }
                const helpEl = ev.target?.closest?.('.product-tab-help');
                if (helpEl) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    const key = helpEl.getAttribute('data-help');
                    const pack = $582992a9d521cb7c$var$PRODUCT_HELP_BY_TAB[key];
                    if (!pack) return;
                    let mb;
                    mb = (0, $e7f9af3e6f2fd91b$export$2e2bcd8739ae039)({
                        title: pack.title,
                        text: pack.html,
                        buttons: [
                            {
                                label: 'Fechar',
                                cls: 'bn_Enter'
                            }
                        ],
                        callback: ()=>mb.destroy()
                    });
                    return;
                }
                if (ev.target?.closest?.('.bn_refresh_product_packagings')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    loadEmbeddedPackagings();
                    return;
                }
                const tab = ev.target?.closest?.('.form-tab');
                if (!tab) return;
                ev.preventDefault();
                const id = tab.getAttribute('data-tab');
                root()?.querySelectorAll?.('.form-tab').forEach((t)=>t.classList.remove('active'));
                root()?.querySelectorAll?.('.form-tab-panel').forEach((p)=>p.classList.remove('active'));
                tab.classList.add('active');
                const panel = root()?.querySelector?.(`#tab-${id}`);
                if (panel) panel.classList.add('active');
                if (id === 'armazenagem') loadEmbeddedPackagings();
            });
            const syncPortaria344 = ()=>{
                const cb = root()?.querySelector?.('#is_portaria_344');
                const sel = root()?.querySelector?.('#portaria_344_list');
                if (cb && sel) sel.disabled = !(cb.checked || cb.value === '1');
            };
            root()?.addEventListener?.('change', (ev)=>{
                if (ev.target?.matches?.('#is_portaria_344')) syncPortaria344();
            });
            formset.form?.subscribe?.([
                'load',
                'refresh'
            ], syncPortaria344);
            formset.form?.subscribe?.([
                'load',
                'refresh'
            ], ()=>{
                loadEmbeddedPackagings();
            });
            setTimeout(syncPortaria344, 100);
            setTimeout(()=>{
                loadEmbeddedPackagings();
            }, 200);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#category_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('categories')
            ]
        },
        {
            properties: {
                selector: '#purchasing_unit_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('units')
            ]
        },
        {
            properties: {
                selector: '#selling_unit_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('units')
            ]
        },
        {
            properties: {
                selector: '#manufacturer_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('manufacturers', {
                    labels: [
                        'nick'
                    ]
                })
            ]
        },
        //{ properties: { selector: '#sku' }, types: [types.pubsub(), types.observer('category_id'), types.obs_sku('.sku', '.taxons')] },
        //{ properties: { selector: '#sku' }, types: [types.sku(6)] },
        {
            properties: {
                selector: '#sku'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('category_id'),
                $e247330830b80775$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#taxons'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#synonyms'
            },
            types: [
                $ba016d80ddaca15b$export$2e2bcd8739ae039(),
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#description'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#reference'
            },
            types: [
                $ba016d80ddaca15b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#codigo_cliente'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#gtin'
            },
            types: [
                $ca1c79f4e173f347$export$2e2bcd8739ae039(),
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ncm'
            },
            types: [
                $8b11f696e7bab70f$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#cest'
            },
            types: [
                $73c7be81b506e1d3$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#origin'
            },
            types: [
                $8d2518aa0319bc23$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_mono'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_st'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_exempt'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#icms'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#shelf_life'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#minimum_quantity'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#value'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        //{ properties: { selector: '#drug_anvisa' }, types: [types.anvisa(), types.caps()] },
        //{ properties: { selector: '#drug_exemption' }, types: [] },
        //{ properties: { selector: '#drug_max_price' }, types: [types.number(2)] },
        {
            properties: {
                selector: '#secondary_weight'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#secondary_height'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#secondary_width'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#secondary_length'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#master_weight'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#master_height'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#master_width'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#master_length'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#classes'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $b63c535296d208bd$export$2e2bcd8739ae039('classes', '#available', {
                    values: [
                        'company_id',
                        'id'
                    ]
                }),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $820b09dd9a503dcf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#image'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $5e1493eb0305a487$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_portaria_344'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#portaria_344_list'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $3b9ac53687e0fa72$var$products = function() {
    let products_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async addFilter (params) {
            await (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).addFilter.call(this, params);
            if (this.filter && JSON.stringify(this.filter).includes('is_disabled')) params.append('include_disabled', '1');
        },
        editFilter () {
            (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            try {
                this.filter = await (0, $d110a042ff114667$export$94031f41c18e0637)(data, this.fieldspecs);
                this.loadPage(1);
            } catch (e) {
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || 'Erro ao aplicar filtro.', 'Filtro');
                console.error('applyFilter', e);
            }
        },
        insertRecord () {
            this.editRecord({
                gtin: 'SEM GTIN'
            });
        },
        async loadBaseData () {
            await Promise.all([
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_classes, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('classes', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_categories, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('categories', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_units, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('units', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_manufacturers, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('manufacturers', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_programs, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('programs', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('products', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)))
            ]);
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_product, ...JSON.parse(id));
            _record.is_st = _record.taxation?.includes('S');
            _record.is_exempt = _record.taxation?.includes('I');
            _record.is_mono = _record.taxation?.includes('M');
            _record.classes = _record.classes?.map((entry)=>[
                    _record.company_id,
                    entry
                ]);
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'drug');
        },
        async setDisabled (disabled) {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione ao menos um produto.', 'Produtos');
            const action = disabled ? 'Inativar' : 'Ativar';
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Confirma ${action} ${ids.length} produto(s)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).patch_product, company_id, id, {
                        is_disabled: !!disabled
                    });
                    if (resp == null) {
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Falha ao atualizar produto.', 'Produtos');
                        return;
                    }
                }
                this.loadPage();
            });
        },
        async saveRecord (data, old_data) {
            let _record = {
                category_id: Number(data.category_id),
                purchasing_unit_id: Number(data.purchasing_unit_id),
                selling_unit_id: Number(data.selling_unit_id),
                manufacturer_id: Number(data.manufacturer_id),
                sku: [
                    data.sku
                ],
                taxons: [
                    data.taxons
                ],
                name: data.name,
                synonyms: data.synonyms,
                description: data.description,
                reference: data.reference,
                codigo_cliente: data.codigo_cliente && data.codigo_cliente.trim() ? data.codigo_cliente.trim() : null,
                program_id: data.program_id != null && data.program_id !== '' && Number(data.program_id) >= 0 ? Number(data.program_id) : null,
                gtin: data.gtin && data.gtin.trim() ? data.gtin.trim() : 'SEM GTIN',
                ncm: data.ncm,
                cest: data.cest,
                origin: data.origin,
                taxation: (data.is_st == '1' ? 'S' : '') + (data.is_exempt == '1' ? 'I' : '') + (data.is_mono == '1' ? 'M' : ''),
                icms: Number(data.icms),
                shelf_life: Number(data.shelf_life),
                minimum_quantity: Number(data.minimum_quantity),
                quantity: Number(data.quantity),
                value: Number(data.value),
                is_disabled: data.is_disabled == '1',
                is_portaria_344: data.is_portaria_344 == '1',
                portaria_344_list: data.portaria_344_list && data.portaria_344_list.trim() ? data.portaria_344_list.trim() : null,
                secondary_weight: Number(data.secondary_weight),
                secondary_height: Number(data.secondary_height),
                secondary_width: Number(data.secondary_width),
                secondary_length: Number(data.secondary_length),
                master_weight: Number(data.master_weight),
                master_height: Number(data.master_height),
                master_width: Number(data.master_width),
                master_length: Number(data.master_length),
                image: data.image,
                classes: (0, $7c7f18e63e55bfe1$export$98e6a39c04603d36)(data.classes)?.map((entry)=>Number(entry[1]))
            };
            if (data.drug_anvisa) _record['drug'] = {
                anvisa: data.drug_anvisa,
                exemption: data.drug_exemption,
                max_price: Number(data.drug_max_price)
            };
            // Insert: old_data = { gtin: 'SEM GTIN' } (sem id). Update: old_data veio do loadRecord (tem id).
            const isUpdate = old_data && old_data.id != null && old_data.id !== '';
            if (isUpdate) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_product, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_product, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Posi\xe7\xe3o",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do produto'
        },
        {
            index: 3,
            field: 'category_id',
            label: 'Categoria',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Categoria do produto',
            store: 'categories'
        },
        {
            index: 6,
            field: 'manufacturer_id',
            label: 'Fabricante',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Fabricante do produto',
            store: 'manufacturers'
        },
        {
            index: 7,
            field: 'sku',
            label: 'SKU',
            types: [
                $1fc4b4ad289a0aae$export$2e2bcd8739ae039(12)
            ],
            placeholder: '',
            title: "C\xf3digo do produto. Tamanho definido pela categoria. Use apenas A\u2013N, P\u2013Z e 0\u20139 (sem a letra O)."
        },
        {
            index: 9,
            field: 'name',
            label: 'Nome',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome do produto'
        },
        {
            index: 10,
            field: 'synonyms',
            label: "Sin\xf4nimos",
            types: [
                $ba016d80ddaca15b$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nomes alternativos do produto'
        },
        {
            index: 11,
            field: 'description',
            label: "Descri\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Descri\xe7\xe3o do produto"
        },
        {
            index: 12,
            field: 'reference',
            label: "Refer\xeancias",
            types: [
                $ba016d80ddaca15b$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "C\xf3digos de refer\xeancia externos do produto"
        },
        {
            index: 13,
            field: 'codigo_cliente',
            label: "C\xf3d. cliente",
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "C\xf3digo do produto na base do cliente (DE/PARA)"
        },
        {
            index: 14,
            field: 'program_id',
            label: 'Programa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Programa do produto (estoque por programa)',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 15,
            field: 'gtin',
            label: 'GTIN',
            types: [
                $ca1c79f4e173f347$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'N\xfamero do c\xf3digo de barras ou "SEM GTIN"'
        },
        {
            index: 16,
            field: 'ncm',
            label: 'NCM',
            types: [
                $8b11f696e7bab70f$export$2e2bcd8739ae039()
            ],
            placeholder: '00000000',
            title: 'Nomenclatura Comum do Mercosul'
        },
        {
            index: 17,
            field: 'cest',
            label: 'CEST',
            types: [
                $8b11f696e7bab70f$export$2e2bcd8739ae039()
            ],
            placeholder: '00.000.00',
            title: "C\xf3digo Especificador da Substitui\xe7\xe3o Tribut\xe1ria"
        },
        {
            index: 18,
            field: 'origin',
            label: 'Origem',
            types: [
                $8d2518aa0319bc23$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Origem do produto'
        },
        {
            index: 19,
            field: 'taxation',
            label: "Taxa\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Indicadores de taxa\xe7\xe3o do produto"
        },
        {
            index: 20,
            field: 'icms',
            label: 'ICMS',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: "Al\xedquota espec\xedfica de ICMS do produto, se houver"
        },
        {
            index: 21,
            field: 'shelf_life',
            label: 'Vida',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "Prazo de validade m\xednimo do produto em dias"
        },
        {
            index: 22,
            field: 'minimum_quantity',
            label: "Estoque M\xedn",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "Estoque m\xednimo desejado do produto em unidades"
        },
        {
            index: 23,
            field: 'quantity',
            label: 'Estoque',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "Saldo agregado no cadastro (products.quantity). N\xe3o gera estoque WMS por posi\xe7\xe3o; para carga inicial use entrada ao armaz\xe9m."
        },
        {
            index: 24,
            field: 'value',
            label: 'Valor',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Valor atual do estoque do produto'
        },
        {
            index: 4,
            field: 'purchasing_unit_id',
            label: 'Un Compra',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Unidade de compra',
            store: 'units'
        },
        {
            index: 5,
            field: 'selling_unit_id',
            label: 'Un Venda',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Unidade de venda',
            store: 'units'
        },
        //{ index: 32, field: 'anvisa', label: 'Anvisa', types: [], placeholder: '', title: 'Número de registro na Anvisa ou "ISENTO"' },
        //{ index: 33, field: 'exemption', label: 'Justificativa', types: [], placeholder: '', title: 'Justificativa caso seja "ISENTO" de registro na Anvisa' },
        //{ index: 34, field: 'max_price', label: 'PMC', types: [types.number(2)], placeholder: '0,00', title: 'Preço Máximo ao Consumidor' },
        {
            index: 25,
            field: 'secondary_weight',
            label: 'ES Peso',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: "Peso da embalagem secund\xe1ria do produto em quilos"
        },
        {
            index: 26,
            field: 'secondary_height',
            label: 'ES Altura',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: "Altura da embalagem secund\xe1ria do produto em metros"
        },
        {
            index: 27,
            field: 'secondary_width',
            label: 'ES Largura',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: "Largura da embalagem secund\xe1ria do produto em metros"
        },
        {
            index: 28,
            field: 'secondary_length',
            label: 'ES Compr',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: "Comprimento da embalagem secund\xe1ria do produto em metros"
        },
        {
            index: 29,
            field: 'master_weight',
            label: 'ET Peso',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: "Peso da embalagem terci\xe1ria do produto em quilos (campo master_weight)"
        },
        {
            index: 30,
            field: 'master_height',
            label: 'ET Altura',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: "Altura da embalagem terci\xe1ria do produto em metros (campo master_height)"
        },
        {
            index: 31,
            field: 'master_width',
            label: 'ET Largura',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: "Largura da embalagem terci\xe1ria do produto em metros (campo master_width)"
        },
        {
            index: 32,
            field: 'master_length',
            label: 'ET Compr',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: "Comprimento da embalagem terci\xe1ria do produto em metros (campo master_length)"
        },
        {
            index: 33,
            field: 'image',
            label: 'Imagem',
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Indicador de imagem associada ao produto'
        },
        {
            index: 35,
            field: 'is_portaria_344',
            label: 'Portaria 344',
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Produto sujeito \xe0 Portaria 344/98 (lista em portaria_344_list)"
        },
        {
            index: 34,
            field: 'is_disabled',
            label: 'Inativo',
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Produto inativo (n\xe3o listado para entrada)"
        }
    ];
    let operations = [
        {
            hash: '#product-disable',
            label: 'Inativar'
        },
        {
            hash: '#product-enable',
            label: 'Ativar'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#product-disable', products_crud.setDisabled.bind(products_crud, true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#product-enable', products_crud.setDisabled.bind(products_crud, false));
    products_crud.run('products', 'Produtos', document.getElementById('workarea'), (0, $db2166c5ef26f5de$export$2e2bcd8739ae039), (0, $582992a9d521cb7c$export$2e2bcd8739ae039), fieldspecs, operations, []);
};
var $3b9ac53687e0fa72$export$2e2bcd8739ae039 = $3b9ac53687e0fa72$var$products;




var $1cmSR = parcelRequire("1cmSR");


async function $94935258288968c1$export$2e2bcd8739ae039(records) {
    return `
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th>Empresa</th>
					<th>ID</th>
					<th>Produto</th>
					<th>C\xf3digo</th>
					<th>N\xedvel</th>
					<th>Fator</th>
					<th>Cap. Terci\xe1ria</th>
					<th>Fabricante</th>
					<th>GTIN</th>
					<th>Padr\xe3o</th>
					<th>Inativa</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td>${await this.key('companies', record.company_id, 'nick')}</td>
					<td>${record.id}</td>
					<td>${await this.key('products', [
            record.company_id,
            record.product_id
        ], 'name')}</td>
					<td>${record.code || ''}</td>
					<td>${record.level || ''}</td>
					<td>${record.factor ?? ''}</td>
					<td>${record.tertiary_capacity ?? ''}</td>
					<td>${record.manufacturer_id != null && record.manufacturer_id !== '' ? await this.key('manufacturers', [
            record.company_id,
            record.manufacturer_id
        ], 'nick') : "\u2014"}</td>
					<td>${record.gtin || ''}</td>
					<td>${record.is_default ? 'SIM' : 'NAO'}</td>
					<td>${record.is_disabled ? 'SIM' : 'NAO'}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $4513b7495ab4b07e$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#product-packaging .pkg-hint { font-size: 0.78rem; color: #6b7280; margin: 0.15rem 0 0 0; line-height: 1.35; max-width: 42rem; }
			#product-packaging .pkg-check-row { display: flex; flex-wrap: wrap; align-items: center; gap: 1rem 1.25rem; margin-top: 0.35rem; }
			#product-packaging .pkg-check-row label { display: inline-flex; align-items: center; gap: 0.45rem; margin: 0; }
			#product-packaging .pkg-check-row input[type="checkbox"] { width: 1.05rem; height: 1.05rem; margin: 0; }
		</style>
		<form id="product-packaging" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="products"></datalist>
			<datalist id="manufacturers"></datalist>
			<div class="fsb">
				<label>Empresa<sup>*</sup><input id="company_id" type="text" list="companies" required></label>
				<label>ID<input id="id" type="text" disabled></label>
				<label>Produto<sup>*</sup><input id="product_id" type="text" list="products" required></label>
			</div>
			<div class="fsb">
				<label>C\xf3digo<sup>*</sup><input id="code" type="text" placeholder="1X60" required></label>
				<label>N\xedvel<sup>*</sup>
					<select id="level" required>
						<option value="S">Secund\xe1ria</option>
						<option value="T">Terci\xe1ria</option>
						<option value="P">Prim\xe1ria</option>
					</select>
				</label>
				<label>Fator<sup>*</sup><input id="factor" type="text" placeholder="60" required></label>
				<label>Cap. terci\xe1ria<input id="tertiary_capacity" type="text" placeholder="100"></label>
			</div>
			<div class="fsb">
				<label title="Fabricante ao qual este GTIN se refere (opcional; se vazio, usa o fabricante do produto ao salvar)">Fabricante (GTIN)<input id="manufacturer_id" type="text" list="manufacturers" placeholder="Opcional \u{2014} padr\xe3o = produto"></label>
				<label>GTIN<input id="gtin" type="text" placeholder="EAN da embalagem"></label>
				<label title="Conte\xfado ou identificador impresso no QR da etiqueta de embalagem">QR Code (etiqueta)
					<input id="qr_code" type="text" placeholder="Opcional \u{2014} ver texto abaixo" autocomplete="off">
				</label>
			</div>
			<p class="pkg-hint"><strong>GTIN e fabricante:</strong> o cadastro de <strong>produto</strong> ainda pode ter GTIN e fabricante (modelo legado). Eles continuam v\xe1lidos para tributa\xe7\xe3o e integra\xe7\xf5es. Aqui voc\xea amarra o <strong>EAN desta embalagem (P/S/T)</strong> ao fabricante correto quando for diferente ou quando quiser rastreabilidade expl\xedcita. Se deixar fabricante vazio, ao salvar usamos o fabricante do produto. Duplicar GTIN no produto e na embalagem \xe9 esperado na migra\xe7\xe3o; opera\xe7\xf5es com hierarquia de embalagens preferem o GTIN deste cadastro quando a empresa ativa essas op\xe7\xf5es.</p>
			<p class="pkg-hint"><strong>QR Code:</strong> campo opcional para guardar o <em>payload</em> que ser\xe1 codificado no QR da etiqueta de embalagem (ex.: c\xf3digo interno, GTIN+lote, JSON compacto \u{2014} conforme layout acordado). Pode ser preenchido manualmente ou copiado do gerador/impressor de etiquetas; o SIAL armazena o valor para uso em relat\xf3rios, coletor ou futura gera\xe7\xe3o autom\xe1tica de ZPL/PDF.</p>
			<div class="pkg-check-row">
				<label title="Embalagem padr\xe3o do produto para fatores/GTIN"><input id="is_default" type="checkbox"> Padr\xe3o</label>
				<label title="Cadastro inativo (n\xe3o aparece em sele\xe7\xf5es)"><input id="is_disabled" type="checkbox"> Inativa</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#product-packaging',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#manufacturers', 'manufacturers', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#product_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#manufacturer_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('manufacturers', {
                    labels: [
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#code'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#level'
            },
            types: []
        },
        {
            properties: {
                selector: '#factor'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#tertiary_capacity'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#gtin'
            },
            types: [
                $ca1c79f4e173f347$export$2e2bcd8739ae039(),
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#qr_code'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_default'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $7502d76b32eebada$var$product_packagings = function() {
    let product_packagings_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            await Promise.all([
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>data ? (0, $1cmSR.default).set('companies', data) : Promise.resolve()).catch((e)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || e)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, this.queryAll()).then((data)=>data ? (0, $1cmSR.default).set('products', data) : Promise.resolve()).catch((e)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || e)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_manufacturers, this.queryAll()).then((data)=>data ? (0, $1cmSR.default).set('manufacturers', data) : Promise.resolve()).catch((e)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || e)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_product_packagings, this.queryAll()).then((data)=>data ? (0, $1cmSR.default).set('product_packagings', data) : Promise.resolve()).catch((e)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || e))
            ]);
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_product_packagings, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_product_packaging, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                product_id: Number(data.product_id),
                manufacturer_id: data.manufacturer_id !== undefined && data.manufacturer_id !== null && String(data.manufacturer_id).trim() !== '' ? Number(data.manufacturer_id) : null,
                code: data.code,
                level: data.level,
                factor: Number(data.factor),
                tertiary_capacity: data.tertiary_capacity ? Number(data.tertiary_capacity) : null,
                gtin: data.gtin || null,
                qr_code: data.qr_code || null,
                is_default: data.is_default == '1',
                is_disabled: data.is_disabled == '1'
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_product_packaging, data.company_id, data.id, _record);
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_product_packaging, data.company_id, _record);
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'ID',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            index: 3,
            field: 'product_id',
            label: 'Produto',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            store: 'products',
            labels: [
                'name'
            ]
        },
        {
            index: 4,
            field: 'manufacturer_id',
            label: 'Fabricante',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            store: 'manufacturers',
            labels: [
                'nick'
            ]
        },
        {
            index: 5,
            field: 'code',
            label: "C\xf3digo",
            types: []
        },
        {
            index: 6,
            field: 'level',
            label: "N\xedvel",
            types: []
        },
        {
            index: 7,
            field: 'factor',
            label: 'Fator',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            index: 8,
            field: 'tertiary_capacity',
            label: "Cap. Terci\xe1ria",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            index: 9,
            field: 'gtin',
            label: 'GTIN',
            types: [
                $ca1c79f4e173f347$export$2e2bcd8739ae039()
            ]
        },
        {
            index: 10,
            field: 'is_default',
            label: "Padr\xe3o",
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            index: 11,
            field: 'is_disabled',
            label: 'Inativa',
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        }
    ];
    product_packagings_crud.run('product_packagings', 'Embalagens', document.getElementById('workarea'), (0, $94935258288968c1$export$2e2bcd8739ae039), (0, $4513b7495ab4b07e$export$2e2bcd8739ae039), fieldspecs);
};
var $7502d76b32eebada$export$2e2bcd8739ae039 = $7502d76b32eebada$var$product_packagings;




var $1cmSR = parcelRequire("1cmSR");


async function $0a0e6b947d0ef94b$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 15rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Armaz\xe9m</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $da6d10eb63e74ed0$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#warehouse #company_id	{ width: 10rem;	}
			#warehouse #id			{ width: 5rem; text-align: right;	}
			#warehouse #name		{ width: 15rem;	}
		</style>
		<form id="warehouse" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do armaz\xe9m">Armaz\xe9m
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do armaz\xe9m">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#warehouse',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: []
        }
    ]
};



const $47151db783ea97b2$var$warehouses = function() {
    let warehouses_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_warehouses, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_warehouse, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_warehouse, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_warehouse, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Armaz\xe9m",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "Identificador do armaz\xe9m"
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome do armaz\xe9m"
        }
    ];
    warehouses_crud.run('warehouses', "Armaz\xe9ns", document.getElementById('workarea'), (0, $0a0e6b947d0ef94b$export$2e2bcd8739ae039), (0, $da6d10eb63e74ed0$export$2e2bcd8739ae039), fieldspecs);
};
var $47151db783ea97b2$export$2e2bcd8739ae039 = $47151db783ea97b2$var$warehouses;




var $1cmSR = parcelRequire("1cmSR");






async function $83a15d59aff488df$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left;	}
			.view td:nth-child(6)	{ text-align: center; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Armaz\xe9m</th>
					<th data-index="3" data-visible="${this.visible[2]}">Posi\xe7\xe3o</th>
					<th data-index="4" data-visible="${this.visible[3]}">Endere\xe7o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Mix</th>
					<th data-index="6" data-visible="${this.visible[5]}">N\xedvel</th>
					<th data-index="7" data-visible="${this.visible[6]}">Atuante</th>
					<th data-index="8" data-visible="${this.visible[7]}">Staging</th>
					<th data-index="11" data-visible="${this.visible[8]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ])}</td>
					<td data-visible='${this.visible[2]}'>${record.id}</td>
					<td data-visible='${this.visible[3]}'>${record.address.join('-')}</td>
					<td data-visible='${this.visible[4]}'>${this.option($6d521c92c25435df$export$2e2bcd8739ae039(), record.mix)}</td>
					<td data-visible='${this.visible[5]}'>${record.level}</td>
					<td data-visible='${this.visible[6]}'>${this.option($16a377ceff31a9ac$export$2e2bcd8739ae039(), record.in_reach)}</td>
					<td data-visible='${this.visible[7]}'>${this.option($16a377ceff31a9ac$export$2e2bcd8739ae039(), record.is_staging)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($2372640607a5ee0b$export$2e2bcd8739ae039(), record.status) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $295f352aa767e7e5$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#location #company_id		{ width: 10rem;		}
			#location #warehouse_id		{ width: 10rem;		}
			#location #id				{ width: 4rem; text-align: right;	}
			#location #address			{ width: 6rem;		}
			#location #mix				{ width: 12rem; display: inline-block;	}
			#location #level			{ width: 3rem; text-align: right;	}
			#location #updated_by		{ width: 9rem;		}
			#location #supplier_id		{ width: 20rem;		}
			#location #status	 		{ width: 10rem;		}
			#location .company 			{ width: 10rem;		}
			#location .product 			{ width: 32rem;		}
			#location .quantity 		{ width: 4.5rem; text-align: right;	}
		</style>
		<form id="location" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Armaz\xe9m">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
				<label title="Identificador da posi\xe7\xe3o">Posi\xe7\xe3o
					<input id="id" type="text" disabled>
				</label>
				<label title="Endere\xe7o da posi\xe7\xe3o">Endere\xe7o<sup>*</sup>
					<input id="address" type="text" required>
				</label>
				<label title="N\xedvel da posi\xe7\xe3o (1=mais baixo)">N\xedvel<sup>*</sup>
					<input id="level" type="text" value="1" required>
				</label>
				<label title="Posi\xe7\xe3o ao alcance da m\xe3o?">Atuante?
					<input id="in_reach" type="checkbox" checked>
				</label>
				<label title="Posi\xe7\xe3o de descarga de mercadorias?">Staging?
					<input id="is_staging" type="checkbox">
				</label>
				<label title="Status da posi\xe7\xe3o">Status<sup>*</sup>
					<input id="status" type="text" list="location_status" value="0" required>
				</label>
			</div>
			<div class="fsb">
				<label class="keymap">Classes<sup>*</sup>
					<select id="classes" multiple size="4" required>
					</select>
				</label>
				<span class="keymap">
					<button class="bn_Left" title="Incluir classifica\xe7\xf5es selecionadas \xe0 direita"> &#x1F844;</button>
					<button class="bn_Right" title="Remover classifica\xe7\xf5es selecionadas \xe0 esquerda">&#x1F846;</button>
				</span>
				<label class="keymap">Dispon\xedveis
					<select id="available" multiple size="4">
					</select>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Empresa</th>
							<th>Produto</th>
							<th>M\xednimo</th>
							<th>M\xe1ximo</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="4">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Empresa">
								<input id="product_company_id-0" class="company" type="text" list="companies">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products-0">
							</td>
							<td title="Quantidade m\xednima">
								<input id="minimum_quantity-0" class="quantity" type="text">
							</td>
							<td title="Quantidade m\xe1xima">
								<input id="maximum_quantity-0" class="quantity" type="text">
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb fae mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<label title="Misturas permitidas na posi\xe7\xe3o">Mix<sup>*</sup>
						<input id="mix" type="text" list="location_mixes" value="0" required>
					</label>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#location',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#address'
            },
            types: [
                $bba672065f562b52$export$2e2bcd8739ae039(),
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#mix'
            },
            types: [
                $6d521c92c25435df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#level'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#in_reach'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_staging'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $2372640607a5ee0b$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#classes'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $b63c535296d208bd$export$2e2bcd8739ae039('classes', '#available', {
                    values: [
                        'company_id',
                        'id'
                    ]
                }),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $820b09dd9a503dcf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_company_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('product_company_id-0'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#minimum_quantity-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#maximum_quantity-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        }
    ]
};



const $2332a4e102178b91$var$locations = function() {
    let locations_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_classes, this.queryAll()).then((data)=>(0, $1cmSR.default).set('classes', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))); // Required for location limits
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_location, ...JSON.parse(id));
            _record.classes = _record.classes.map((entry)=>[
                    entry.class_company_id,
                    entry.class_id
                ]);
            _record = (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'limits');
            return _record;
        },
        async editFilter () {
            try {
                const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, '?limit=0');
                if (data && Array.isArray(data)) await (0, $1cmSR.default).set('locations', data);
            } catch (_) {}
            (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter, {
                reloadLocations: async (formData)=>{
                    const resolved = await (0, $d110a042ff114667$export$94031f41c18e0637)(formData, this.fieldspecs);
                    const parts = [];
                    const top = 10;
                    for(let i = 0; i < top; i++){
                        const f = resolved[`field-${i}`];
                        const v = resolved[`value-${i}`];
                        if (f === 'company_id' && v) parts.push(`company_id*eq*${v}`);
                        else if (f === 'warehouse_id' && v != null && v !== '') parts.push(`warehouse_id*eq*${v}`);
                    }
                    if (parts.length === 0) return;
                    const params = new URLSearchParams();
                    params.append('filter', parts.join(','));
                    params.append('sort', '4');
                    params.append('limit', '0');
                    const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, '?' + params.toString());
                    if (data && Array.isArray(data)) await (0, $1cmSR.default).set('locations', data);
                }
            });
        },
        async applyFilter (data) {
            this.filter = await (0, $d110a042ff114667$export$94031f41c18e0637)(data, this.fieldspecs);
            this.filterExplicitlyApplied = true;
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, '?limit=0').then((d)=>{
                if (d && Array.isArray(d)) (0, $1cmSR.default).set('locations', d);
            }).catch(()=>{});
            await this.loadPage(1);
        },
        async saveRecord (data, old_data) {
            data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'limits');
            let _record = {
                address: data.address,
                mix: data.mix,
                level: Number(data.level),
                in_reach: data.in_reach == '1',
                is_staging: data.is_staging == '1',
                classes: (0, $7c7f18e63e55bfe1$export$98e6a39c04603d36)(data.classes).map((entry)=>({
                        class_company_id: entry[0],
                        class_id: Number(entry[1])
                    }))
            };
            if (data.limits) _record.limits = data.limits.map((limit)=>({
                    product_company_id: limit.product_company_id,
                    product_id: Number(limit.product_id),
                    minimum_quantity: Number(limit.minimum_quantity),
                    maximum_quantity: Number(limit.maximum_quantity)
                }));
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_location, data.company_id, data.warehouse_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_location, data.company_id, data.warehouse_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Armaz\xe9m",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 3,
            field: 'location_id',
            label: "Posi\xe7\xe3o",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o (armaz\xe9m e endere\xe7o)",
            store: 'locations',
            labels: [
                'address'
            ],
            separator: '-'
        },
        {
            index: 4,
            field: 'address',
            label: "Endere\xe7o",
            types: [
                $bba672065f562b52$export$2e2bcd8739ae039(),
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ],
            placeholder: 'X-Y-Z',
            title: "Endere\xe7o da posi\xe7\xe3o"
        },
        {
            index: 5,
            field: 'mix',
            label: 'Mix',
            types: [
                $6d521c92c25435df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Misturas permitidas na posi\xe7\xe3o"
        },
        {
            index: 6,
            field: 'level',
            label: "N\xedvel",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "N\xedvel da posi\xe7\xe3o"
        },
        {
            index: 7,
            field: 'in_reach',
            label: 'Atuante',
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o ao alcance da m\xe3o?"
        },
        {
            index: 8,
            field: 'is_staging',
            label: 'Staging',
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o de descarga de mercadorias?"
        },
        {
            index: 11,
            field: 'status',
            label: 'Status',
            types: [
                $2372640607a5ee0b$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Status do pedido'
        }
    ];
    locations_crud.run('locations', "Posi\xe7\xf5es", document.getElementById('workarea'), (0, $83a15d59aff488df$export$2e2bcd8739ae039), (0, $295f352aa767e7e5$export$2e2bcd8739ae039), fieldspecs);
};
var $2332a4e102178b91$export$2e2bcd8739ae039 = $2332a4e102178b91$var$locations;




var $1cmSR = parcelRequire("1cmSR");









async function $82e5a54bae0b2474$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(n+4):nth-child(-n+19)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(20)	{ text-align: right; }
			.view td:nth-child(n+22):nth-child(-n+24)	{ text-align: right; }
			.view td:nth-child(25)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Estoque</th>
					<th data-index="12" data-visible="${this.visible[2]}">SKU</th>
					<th data-index="13" data-visible="${this.visible[3]}">Produto</th>
					<th data-index="15" data-visible="${this.visible[4]}">Fabricante</th>
					<th data-index="16" data-visible="${this.visible[5]}">NCM</th>
					<th data-index="17" data-visible="${this.visible[6]}">EAN</th>
					<th data-index="18" data-visible="${this.visible[7]}">Emb.</th>
					<th data-index="19" data-visible="${this.visible[8]}">Fator</th>
					<th data-index="20" data-visible="${this.visible[9]}">QR Emb.</th>
					<th data-index="24" data-visible="${this.visible[10]}">Lote fab.</th>
					<th data-index="26" data-visible="${this.visible[11]}">Validade</th>
					<th data-index="25" data-visible="${this.visible[12]}">Fabrica\xe7\xe3o</th>
					<th data-index="22" data-visible="${this.visible[13]}">Programa</th>
					<th data-index="28" data-visible="${this.visible[14]}">Data Entrada</th>
					<th data-index="27" data-visible="${this.visible[15]}">Entrada Sial</th>
					<th data-index="29" data-visible="${this.visible[16]}">Nota Entrada</th>
					<th data-index="30" data-visible="${this.visible[17]}">Fornecedor</th>
					<th data-index="3" data-visible="${this.visible[18]}">Armaz\xe9m</th>
					<th data-index="4" data-visible="${this.visible[19]}">Posi\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[20]}">Titular</th>
					<th data-index="6" data-visible="${this.visible[21]}">Lote</th>
					<th data-index="7" data-visible="${this.visible[22]}">Dispon\xedvel</th>
					<th data-index="8" data-visible="${this.visible[23]}">Reservado</th>
					<th data-index="9" data-visible="${this.visible[24]}">Bloqueado</th>
					<th data-index="10" data-visible="${this.visible[25]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'> <td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.sku ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${(record.product_name ?? '').toString()}</td>
					<td data-visible='${this.visible[4]}'>${(record.manufacturer_nick ?? '').toString()}</td>
					<td data-visible='${this.visible[5]}'>${(record.ncm ?? '').toString()}</td>
					<td data-visible='${this.visible[6]}'>${(record.gtin ?? '').toString()}</td>
					<td data-visible='${this.visible[7]}'>${(record.packaging_code ?? '').toString()}</td>
					<td data-visible='${this.visible[8]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0), record.packaging_factor) ?? ''}</td>
					<td data-visible='${this.visible[9]}'>${(record.packaging_qr_code ?? '').toString()}</td>
					<td data-visible='${this.visible[10]}'>${(0, $7c7f18e63e55bfe1$export$d7959d098aba6524)(record.lot_number)}</td>
					<td data-visible='${this.visible[11]}'>${record.expiration_date ?? ''}</td>
					<td data-visible='${this.visible[12]}'>${record.manufacture_date ?? ''}</td>
					<td data-visible='${this.visible[13]}'>${(record.program_name ?? '').toString()}</td>
					<td data-visible='${this.visible[14]}'>${this.format($0c9c948f6a5e1eb3$export$2e2bcd8739ae039(), record.input_created_on) ?? ''}</td>
					<td data-visible='${this.visible[15]}'>${record.input_id ?? ''}</td>
					<td data-visible='${this.visible[16]}'>${(record.invoice_number ?? '').toString()}</td>
					<td data-visible='${this.visible[17]}'>${(record.supplier_name ?? '').toString()}</td>
					<td data-visible='${this.visible[18]}'>${await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ])}</td>
					<td data-visible='${this.visible[19]}'>${await this.key('locations', [
            record.company_id,
            record.warehouse_id,
            record.location_id
        ], 'address')}</td>
					<td data-visible='${this.visible[20]}'>${await this.key('companies', record.lot_company_id, 'nick')}</td>
					<td data-visible='${this.visible[21]}'>${record.lot_id}</td>
					<td data-visible='${this.visible[22]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0), record.quantity_available)}</td>
					<td data-visible='${this.visible[23]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0), record.quantity_reserved)}</td>
					<td data-visible='${this.visible[24]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0), record.quantity_unsettled)}</td>
					<td data-visible='${this.visible[25]}'>${this.option($c539c39a88864005$export$2e2bcd8739ae039(), record.status)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




var $c45260a54a668287$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#stock #company_id			{ width: 10rem;		}
			#stock #id					{ width: 5rem; text-align: right;	}
			#stock #warehouse_id		{ width: 10rem;		}
			#stock #location_id			{ width: 10rem;		}
			#stock #lot_company_id		{ width: 10rem;		}
			#stock #lot_id				{ width: 5rem; text-align: right;	}
			#stock #quantity_available	{ width: 5rem; text-align: right;	}
			#stock #quantity_reserved	{ width: 5rem; text-align: right;	}
			#stock #quantity_unsettled	{ width: 5rem; text-align: right;	}
			#stock #status				{ width: 10rem;		}
		</style>
		<form id="stock" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<fieldset class="stock-product-info" title="Dados do produto e lote (somente leitura)">
				<legend>Produto / Lote</legend>
				<div class="fsb">
					<label>SKU <input id="stock_sku" type="text" disabled></label>
					<label>Produto <input id="stock_product_name" type="text" disabled></label>
					<label title="Apelido do fabricante (cadastro)">Fabricante <input id="stock_manufacturer_nick" type="text" disabled></label>
					<label>NCM <input id="stock_ncm" type="text" disabled></label>
					<label>EAN <input id="stock_gtin" type="text" disabled></label>
					<label>Embalagem <input id="stock_packaging_code" type="text" disabled></label>
				</div>
				<div class="fsb">
					<label>Fator Emb. <input id="stock_packaging_factor" type="text" disabled></label>
					<label>QR Emb. <input id="stock_packaging_qr" type="text" disabled></label>
				</div>
				<div class="fsb">
					<label>Lote fabricante <input id="stock_lot_number" type="text" disabled></label>
					<label>Validade <input id="stock_expiration_date" type="text" disabled></label>
					<label>Fabrica\xe7\xe3o <input id="stock_manufacture_date" type="text" disabled></label>
					<label>Programa <input id="stock_program_name" type="text" disabled></label>
					<label>C\xf3d. cliente <input id="stock_codigo_cliente" type="text" disabled></label>
				</div>
				<div class="fsb">
					<label>Data Entrada <input id="stock_input_created_on" type="text" disabled></label>
					<label>Entrada Sial <input id="stock_input_id" type="text" disabled></label>
					<label>Nota Entrada <input id="stock_invoice_number" type="text" disabled></label>
					<label>Fornecedor <input id="stock_supplier_name" type="text" disabled></label>
				</div>
			</fieldset>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Identificador do estoque">Estoque
					<input id="id" type="text" disabled>
				</label>
				<label title="Status do estoque">Status
					<input id="status" type="text" list="stock_status" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Armaz\xe9m do estoque">Armaz\xe9m
					<input id="warehouse_id" type="text" list="warehouses" disabled>
				</label>
				<label title="Posi\xe7\xe3o no armaz\xe9m">Posi\xe7\xe3o
					<input id="location_id" type="text" list="locations" disabled>
				</label>
				<label title="Identificador do lote">Lote
					<input id="lot_id" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Titular do lote">Titular
					<input id="lot_company_id" type="text" list="companies" disabled>
				</label>
				<label title="Quantidade dispon\xedvel do estoque">Dispon\xedvel
					<input id="quantity_available" type="text" disabled>
				</label>
				<label title="Quantidade reservada do estoque">Reservado
					<input id="quantity_reserved" type="text" disabled>
				</label>
				<label title="Quantidade do estoque sob an\xe1lise">Bloqueado
					<input id="quantity_unsettled" type="text" disabled>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#stock',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#stock_sku'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_product_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_manufacturer_nick'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_ncm'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_gtin'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_packaging_code'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_packaging_factor'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_packaging_qr'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_lot_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_expiration_date'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_manufacture_date'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_program_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_codigo_cliente'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_input_created_on'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_input_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_invoice_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_supplier_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#location_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#lot_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#lot_id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_available'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_reserved'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_unsettled'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $c539c39a88864005$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        }
    ]
};



var $6c327e0121057f1c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#move-stock #stock_sku		{ width: 9rem;	}
			#move-stock #lot_company_id	{ width: 10rem;	}
			#move-stock #lot_id			{ width: 10rem;	}
			#move-stock #quantity		{ width: 5rem; text-align: right;	}
			#move-stock #output_id		{ width: 5rem; text-align: right;	}
			#move-stock #reason			{ width: 11rem;	}
			#move-stock .company		{ width: 10rem;	}
			#move-stock .warehouse		{ width: 10rem;	}
			#move-stock .location		{ width: 9rem;	}
			#move-stock .stock			{ width: 8rem;	}
		</style>
		<form id="move-stock" class="form" autocomplete="off">
			<datalist id="move-companies">
			</datalist>
			<datalist id="move-products">
			</datalist>
			<datalist id="source-warehouses">
			</datalist>
			<datalist id="target-warehouses">
			</datalist>
			<datalist id="target-locations">
			</datalist>
			<div class="title">
				Mover Estoque
			</div>
			<div class="fsb mtl">
				<label title="SKU do produto (informa\xe7\xe3o, preenchido ao selecionar estoque)">SKU
					<input id="stock_sku" type="text" list="move-products" placeholder="Ex.: Y8GZ5A ou buscar produto">
				</label>
				<label title="Empresa titular do lote">Titular<sup>*</sup>
					<input id="lot_company_id" type="text" list="move-companies" required>
				</label>
				<label title="Lote (identificador do sistema, somente leitura)">Lote<sup>*</sup>
					<input id="lot_id" type="text" required readonly>
				</label>
				<label title="Quantidade a mover">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
				<label title="Identificador da sa\xedda em caso de reserva">Sa\xedda
					<input id="output_id" type="text">
				</label>
				<label title="Justificativa para a opera\xe7\xe3o">Motivo<sup>*</sup>
					<input id="reason" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa de origem">Origem<sup>*</sup>
					<input id="source_warehouse_company_id" class="company" type="text" list="move-companies" required>
				</label>
				<label title="Armaz\xe9m de origem">Armaz\xe9m<sup>*</sup>
					<input id="source_warehouse_id" class="warehouse" type="text" list="source-warehouses" required>
				</label>
				<label title="Posi\xe7\xe3o de origem (somente leitura)">Posi\xe7\xe3o<sup>*</sup>
					<input id="source_location_id" class="location" type="text" required readonly>
				</label>
				<label title="Saldo de origem">De<sup>*</sup>
					<select id="source_stock" class="stock" required>
						<option value="L">Dispon\xedvel</option>
						<option value="R">Reservado</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa de destino">Destino<sup>*</sup>
					<input id="target_warehouse_company_id" class="company" type="text" list="move-companies" required>
				</label>
				<label title="Armaz\xe9m de destino">Armaz\xe9m<sup>*</sup>
					<input id="target_warehouse_id" class="warehouse" type="text" list="target-warehouses" required>
				</label>
				<label title="Posi\xe7\xe3o de destino">Posi\xe7\xe3o<sup>*</sup>
					<input id="target_location_id" class="location" type="text" list="target-locations" required>
				</label>
				<label title="Saldo de destino">Para<sup>*</sup>
					<select id="target_stock" class="stock" required>
						<option value="L">Dispon\xedvel</option>
						<option value="R">Reservado</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Executar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#move-stock',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#move-companies', 'companies', {
                labels: [
                    'nick'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#lot_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#stock_sku'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('lot_company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ],
                    value: 'sku'
                })
            ]
        },
        {
            properties: {
                selector: '#lot_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#reason'
            },
            types: []
        },
        {
            properties: {
                selector: '#source_warehouse_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#target_warehouse_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#source_warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('source_warehouse_company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#target_warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('target_warehouse_company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#source_location_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#target_location_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039([
                    'target_warehouse_company_id',
                    'target_warehouse_id'
                ]),
                $9a739ce21637de64$export$2e2bcd8739ae039('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'target_warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#source_stock'
            },
            types: [
                $2c79fa51f8e681d4$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#target_stock'
            },
            types: [
                $2c79fa51f8e681d4$export$2e2bcd8739ae039()
            ]
        }
    ]
};




var $66f0ec4106475d51$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#stocks-select-printer #company_id	{ width: 15rem;	}
			#stocks-select-printer #device_id	{ width: 15rem;	}
		</style>
		<form id="stocks-select-printer" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="devices">
			</datalist>
			<div class="title">
				Etiquetas&nbsp;para&nbsp;<span id="count"></span>&nbsp;registros
			</div>
			<div class="mtm">
				<label title="Empresa para sele\xe7\xe3o da impressora">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div>
				<label title="Identificador da impressora">Impressora<sup>*</sup>
					<input id="device_id" type="text" list="devices" required>
				</label>
				<label title="SIAL na AWS: envie ZPL ao agente local que envia para a impressora na rede interna">Usar agente local
					<input id="use_local_agent" type="checkbox" title="SIAL na AWS: envie ZPL ao agente local">
				</label>
			</div>
			<div class="mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Imprimir</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#stocks-select-printer',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#device_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('devices')
            ]
        },
        {
            properties: {
                selector: '#use_local_agent'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



var $822dea3bdf7d9d14$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#stocks-report-form #format { width: 8rem; }
		</style>
		<form id="stocks-report-form" class="form" autocomplete="off">
			<div class="title" id="report-title">Relat\xf3rio</div>
			<div class="mtm">
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
					</select>
				</label>
			</div>
			<div class="mtm">
				<button type="button" id="btn-filters" class="button">Definir filtros</button>
				<span id="filter-summary" class="mll" style="color:var(--color-muted);font-size:0.9em"></span>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class="bn_Escape button">Fechar</button>
					<button class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#stocks-report-form'
    },
    fields: [
        {
            properties: {
                selector: '#format'
            },
            types: []
        }
    ]
};



var $f2e31d0f27d90986$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#stocks-export-csv-form #company_id { width: 15rem; }
			#stocks-export-csv-form #warehouse_id { width: 15rem; }
			#stocks-export-csv-form #program_id { width: 15rem; }
		</style>
		<form id="stocks-export-csv-form" class="form" autocomplete="off">
			<datalist id="companies-export">
			</datalist>
			<datalist id="warehouses-export">
			</datalist>
			<datalist id="programs-export">
			</datalist>
			<div class="title">Exportar Estoque em CSV</div>
			<p class="mts" style="color:var(--color-muted);font-size:0.9em">
				Relat\xf3rio completo por empresa. O arquivo CSV abre no Excel.
			</p>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies-export" required>
				</label>
			</div>
			<div class="mtm">
				<label>Armaz\xe9m (opcional)
					<input id="warehouse_id" type="text" list="warehouses-export">
				</label>
			</div>
			<div class="mtm">
				<label>Programa (opcional)
					<input id="program_id" type="text" list="programs-export">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Exportar CSV</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#stocks-export-csv-form',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies-export', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#warehouses-export', 'warehouses', {
                labels: [
                    'name'
                ]
            });
            formset.loadList('#programs-export', 'programs', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('programs')
            ]
        }
    ]
};



function $b94ca141f2d5964b$var$downloadCsv(base64Content, filename) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: 'text/csv;charset=utf-8'
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'relatorio.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
const $b94ca141f2d5964b$var$stocks = function() {
    let stocks_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        default_columns: '1,2,12,13,15,16,17,18,19,20,21,22,24,26,25,28,27,29,30,3,4,5,6,7,8,9,10',
        insertRecord () {
        // Tela de estoque é somente consulta; criação/alteração é feita por entradas, movimentação e inventário
        },
        async run (module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, options = {}) {
            // Grade de estoques: índices SQL mudaram (coluna Fabricante). Migra setup salvo uma vez.
            try {
                const raw = localStorage.getItem('stocks.setup');
                if (raw) {
                    const s = JSON.parse(raw);
                    if (!s.stocks_grid_v2) {
                        s.columns = this.default_columns;
                        s.stocks_grid_v2 = true;
                        localStorage.setItem('stocks.setup', JSON.stringify(s));
                    }
                }
            } catch (_) {}
            await Object.getPrototypeOf(this).run.call(this, module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, {
                ...options,
                skipInitialLoad: true
            });
            // Ocultar Inserir (tela somente consulta)
            const insertLi = this.target_node?.querySelector?.('li[hash="#insert"]');
            if (insertLi) insertLi.style.display = 'none';
            // Renderizar grade vazia com mensagem até o usuário filtrar
            const grid_node = this.target_node?.querySelector?.('#grid');
            if (grid_node) grid_node.innerHTML = '<p class="mtm" style="color:var(--color-muted)">Clique em <strong>Filtrar</strong> e depois <strong>Aplicar</strong> para carregar os dados (ou aplicar filtros para refinar a busca).</p>';
        },
        async loadBaseData () {
            const q = this.queryAll();
            await Promise.all([
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, q).then((data)=>(0, $1cmSR.default).set('companies', data)).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_warehouses, q).then((data)=>(0, $1cmSR.default).set('warehouses', data)).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, q).then((data)=>(0, $1cmSR.default).set('products', data)).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, q).then((data)=>(0, $1cmSR.default).set('lots', data)).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_programs, q).then((data)=>(0, $1cmSR.default).set('programs', data)).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_devices, q).then((data)=>(0, $1cmSR.default).set('devices', data)).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))
            ]);
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_stocks, query);
        },
        async loadRecord (id) {
            const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_stock, ...JSON.parse(id));
            if (data && typeof data === 'object') {
                // Mapear dados enriquecidos para os campos somente leitura do modal
                data.stock_sku = data.sku ?? '';
                data.stock_product_name = data.product_name ?? '';
                data.stock_ncm = data.ncm ?? '';
                data.stock_gtin = data.gtin ?? '';
                data.stock_packaging_code = data.packaging_code ?? '';
                data.stock_packaging_factor = data.packaging_factor ?? '';
                data.stock_packaging_qr = data.packaging_qr_code ?? '';
                data.stock_lot_number = (0, $7c7f18e63e55bfe1$export$d7959d098aba6524)(data.lot_number) ?? '';
                data.stock_expiration_date = data.expiration_date ?? '';
                data.stock_manufacture_date = data.manufacture_date ?? '';
                data.stock_program_name = data.program_name ?? '';
                data.stock_codigo_cliente = data.codigo_cliente ?? '';
                data.stock_input_created_on = data.input_created_on ? (()=>{
                    const d = new Date(data.input_created_on);
                    return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
                })() : '';
                data.stock_input_id = data.input_id ?? '';
                data.stock_invoice_number = data.invoice_number ?? '';
                data.stock_supplier_name = data.supplier_name ?? '';
                data.stock_manufacturer_nick = data.manufacturer_nick ?? '';
            }
            return data;
        },
        async saveRecord () {
            // Tela de estoque é somente consulta; não persiste alterações por aqui
            return false;
        },
        async editFilter () {
            // MT-596E375: recarregar locations antes de abrir filtro para escopar por empresa/armazém
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter, {
                reloadLocations: async (formData)=>{
                    const resolved = await (0, $d110a042ff114667$export$94031f41c18e0637)(formData, this.fieldspecs);
                    const parts = [];
                    const top = 10;
                    for(let i = 0; i < top; i++){
                        const f = resolved[`field-${i}`];
                        const v = resolved[`value-${i}`];
                        if (f === 'company_id' && v) parts.push(`company_id*eq*${v}`);
                        else if (f === 'warehouse_id' && v != null && v !== '') parts.push(`warehouse_id*eq*${v}`);
                    }
                    if (parts.length === 0) return;
                    const params = new URLSearchParams();
                    params.append('filter', parts.join(','));
                    params.append('sort', '4');
                    params.append('limit', '0');
                    const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, '?' + params.toString());
                    if (data && Array.isArray(data)) (0, $1cmSR.default).set('locations', data);
                }
            });
        },
        async applyFilter (data) {
            this.filter = await (0, $d110a042ff114667$export$94031f41c18e0637)(data, this.fieldspecs);
            this.filterExplicitlyApplied = true;
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            await this.loadPage(1);
        },
        moveStock () {
            const showResult = async (success)=>{
                if (success) {
                    this.loadPage(); // Show updated stocks
                    fs.destroy();
                }
            };
            const sendRequest = async (data)=>{
                let params = {
                    'source_company_id': data.source_warehouse_company_id,
                    'source_warehouse_id': Number(data.source_warehouse_id),
                    'source_location_id': Number(data.source_location_id),
                    'source_stock': data.source_stock,
                    'target_company_id': data.target_warehouse_company_id,
                    'target_warehouse_id': Number(data.target_warehouse_id),
                    'target_location_id': Number(data.target_location_id),
                    'target_stock': data.target_stock,
                    'quantity': Number(data.quantity),
                    'reason': data.reason,
                    'output_id': Number(data.output_id)
                };
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).move_stock, data.lot_company_id, data.lot_id, params).then(showResult);
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $6c327e0121057f1c$export$2e2bcd8739ae039), sendRequest);
            const crud = this;
            const origInit = fs.init.bind(fs);
            fs.init = async function() {
                origInit();
                // Preencher com estoque selecionado na grid
                const selected = await crud.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                if (selected?.length === 1) {
                    const [company_id, stock_id] = selected[0];
                    const stock = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_stock, company_id, stock_id);
                    if (stock) {
                        fs.form.setValues({
                            stock_sku: stock.sku ?? '',
                            lot_company_id: stock.lot_company_id,
                            lot_id: stock.lot_id,
                            quantity: stock.quantity_available ?? 1,
                            source_warehouse_company_id: stock.company_id,
                            source_warehouse_id: stock.warehouse_id,
                            source_location_id: stock.location_id
                        });
                        fs.form.refresh();
                    }
                }
            };
            fs.init();
        },
        reportPayload (filterData, extra = {}) {
            const filterExpr = filterData ? (0, $d110a042ff114667$export$d73ee8ef04f5226a)(filterData) : '';
            const sortVal = this.sort_column * (this.sort_order ? -1 : 1);
            return {
                filter: filterExpr || undefined,
                sort: sortVal,
                ...extra
            };
        },
        openReportModal (title, apiMethod) {
            let reportFilter = null;
            const crud = this;
            const descriptor = {
                ...(0, $822dea3bdf7d9d14$export$2e2bcd8739ae039)
            };
            descriptor.html = descriptor.html.replace('<div class="title" id="report-title">Relat\xf3rio</div>', `<div class="title" id="report-title">${title}</div>`);
            const fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create(descriptor, async (data)=>{
                fs.destroy();
                const payload = crud.reportPayload(reportFilter, {
                    format: data.format
                });
                try {
                    const json = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call(apiMethod, payload);
                    if (json?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(json.pdf);
                    else if (json?.csv) {
                        $b94ca141f2d5964b$var$downloadCsv(json.csv, json.filename || 'relatorio.csv');
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Download iniciado.', 'Sucesso');
                    } else (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Nenhum dado para o relat\xf3rio.", 'Aviso');
                } catch (e) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || String(e), 'Erro');
                }
            });
            fs.init = (()=>{
                Object.getPrototypeOf(fs).init.call(fs);
                const node = fs.dialog?.getNode?.();
                if (node) {
                    const btnFilters = node.querySelector('#btn-filters');
                    const summary = node.querySelector('#filter-summary');
                    const updateSummary = ()=>{
                        summary.textContent = reportFilter ? 'Filtros definidos' : 'Sem filtros (todos os registros)';
                    };
                    btnFilters?.addEventListener('click', async ()=>{
                        (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await crud.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
                        (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(async (data)=>{
                            reportFilter = await (0, $d110a042ff114667$export$94031f41c18e0637)(data, crud.fieldspecs);
                            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await crud.queryFilteredForLocations()).then((d)=>(0, $1cmSR.default).set('locations', d)).catch(()=>{});
                            updateSummary();
                        }, reportFilter, {
                            reloadLocations: async (formData)=>{
                                const resolved = await (0, $d110a042ff114667$export$94031f41c18e0637)(formData, crud.fieldspecs);
                                const parts = [];
                                for(let i = 0; i < 10; i++){
                                    const f = resolved[`field-${i}`];
                                    const v = resolved[`value-${i}`];
                                    if (f === 'company_id' && v) parts.push(`company_id*eq*${v}`);
                                    else if (f === 'warehouse_id' && v != null && v !== '') parts.push(`warehouse_id*eq*${v}`);
                                }
                                if (parts.length === 0) return;
                                const params = new URLSearchParams();
                                params.append('filter', parts.join(','));
                                params.append('sort', '4');
                                params.append('limit', '0');
                                const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, '?' + params.toString());
                                if (data && Array.isArray(data)) (0, $1cmSR.default).set('locations', data);
                            }
                        });
                    });
                    updateSummary();
                }
            })();
        },
        printBySKU () {
            this.openReportModal('Estoque Consolidado por SKU', (0, $73936c209f170d43$export$2e2bcd8739ae039).print_stocks_by_sku);
        },
        printByLot () {
            this.openReportModal('Estoque Consolidado por Lote', (0, $73936c209f170d43$export$2e2bcd8739ae039).print_stocks_by_lot);
        },
        printByLocation () {
            this.openReportModal("Estoque Consolidado por Posi\xe7\xe3o", (0, $73936c209f170d43$export$2e2bcd8739ae039).print_stocks_by_location);
        },
        exportCsv () {
            const fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $f2e31d0f27d90986$export$2e2bcd8739ae039), async (data)=>{
                fs.destroy();
                const payload = {
                    company_id: data.company_id,
                    warehouse_id: data.warehouse_id ? Number(data.warehouse_id) : null,
                    program_id: data.program_id ? Number(data.program_id) : null
                };
                try {
                    const json = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).export_stocks_csv, payload);
                    if (json?.csv) {
                        $b94ca141f2d5964b$var$downloadCsv(json.csv, json.filename || 'estoque.csv');
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Download iniciado.', 'Sucesso');
                    } else (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Nenhum dado para exportar.', 'Aviso');
                } catch (e) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || String(e), 'Erro');
                }
            });
            fs.init();
        },
        printLotLabels () {
            const sendRequest = async (data)=>{
                let payload = this.reportPayload({
                    company_id: data.company_id,
                    device_id: data.device_id
                });
                if (!payload.filter) {
                    let filtered = await this.queryFilteredData();
                    payload.ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(filtered.map((r)=>[
                            r.company_id,
                            r.id
                        ]));
                }
                payload.return_zpl = !!data.use_local_agent;
                const result = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_lot_labels, payload);
                if (result?.zpl) try {
                    await (0, $73936c209f170d43$export$2e2bcd8739ae039).sendZplToAgent(result.zpl, result.printer, result.printer_key);
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Etiquetas enviadas ao agente local.', "Impress\xe3o");
                } catch (e) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || String(e), 'Agente local');
                    return false;
                }
                return result;
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $66f0ec4106475d51$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                document.querySelector(`${fs.form.selector} #count`).innerHTML = this.record_count;
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        }
    });
    // Ordem = colunas da grade (alinhado a js/views/stocks.js). Índice = posição no SELECT SQL_LIST_BY_CREDENTIAL_ENRICHED (src/repos/stocks.py).
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Estoque',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do estoque'
        },
        {
            index: 12,
            field: 'sku',
            label: 'SKU',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'SKU do produto'
        },
        {
            index: 13,
            field: 'product_name',
            label: 'Produto',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome/taxonomia do produto'
        },
        {
            index: 15,
            field: 'manufacturer_nick',
            label: 'Fabricante',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Apelido do fabricante (produto)'
        },
        {
            index: 16,
            field: 'ncm',
            label: 'NCM',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'NCM do produto'
        },
        {
            index: 17,
            field: 'gtin',
            label: 'EAN',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'GTIN/EAN do produto'
        },
        {
            index: 18,
            field: 'codigo_cliente',
            label: "C\xf3d. cliente",
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "C\xf3digo do cliente no produto"
        },
        {
            index: 19,
            field: 'packaging_code',
            label: 'Embalagem',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "C\xf3digo da embalagem padr\xe3o do produto"
        },
        {
            index: 20,
            field: 'packaging_factor',
            label: 'Fator Emb.',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '',
            title: "Fator da embalagem padr\xe3o"
        },
        {
            index: 21,
            field: 'packaging_qr_code',
            label: 'QR Emb.',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "QR code da embalagem padr\xe3o"
        },
        {
            index: 22,
            field: 'program_id',
            label: 'Programa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Programa do lote',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 24,
            field: 'lot_number',
            label: 'Lote fab.',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "N\xfamero do lote fabricante"
        },
        {
            index: 26,
            field: 'expiration_date',
            label: 'Validade',
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Data de validade do lote'
        },
        {
            index: 25,
            field: 'manufacture_date',
            label: "Fabrica\xe7\xe3o",
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Data de fabrica\xe7\xe3o do lote"
        },
        {
            index: 28,
            field: 'input_created_on',
            label: 'Data Entrada',
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Data da entrada referente ao lote'
        },
        {
            index: 27,
            field: 'input_id',
            label: 'Entrada Sial',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '',
            title: "N\xfamero da entrada SIAL referente ao lote"
        },
        {
            index: 29,
            field: 'invoice_number',
            label: 'Nota Entrada',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "N\xfamero da nota de entrada"
        },
        {
            index: 30,
            field: 'supplier_name',
            label: 'Fornecedor',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Fornecedor da entrada'
        },
        {
            index: 3,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Armaz\xe9m do estoque",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 4,
            field: 'location_id',
            label: "Posi\xe7\xe3o",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o no armaz\xe9m",
            store: 'locations',
            labels: [
                'address'
            ],
            separator: '-'
        },
        {
            index: 5,
            field: 'lot_company_id',
            label: 'Titular',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Titular do lote',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 6,
            field: 'lot_id',
            label: 'Lote',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do lote'
        },
        {
            index: 7,
            field: 'quantity_available',
            label: "Dispon\xedvel",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "Quantidade dispon\xedvel"
        },
        {
            index: 8,
            field: 'quantity_reserved',
            label: 'Reservado',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade reservada'
        },
        {
            index: 9,
            field: 'quantity_unsettled',
            label: 'Bloqueado',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "Quantidade sob an\xe1lise"
        },
        {
            index: 10,
            field: 'status',
            label: 'Status',
            types: [
                $c539c39a88864005$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Status do estoque'
        }
    ];
    let operations = [
        {
            hash: '#move-stock',
            label: 'Mover&nbsp;estoque'
        }
    ];
    let reports = [
        {
            hash: '#print-by-sku',
            label: 'Estoque&nbsp;Consolidado&nbsp;por&nbsp;SKU'
        },
        {
            hash: '#print-by-lot',
            label: 'Estoque&nbsp;Consolidado&nbsp;por&nbsp;Lote'
        },
        {
            hash: '#print-by-location',
            label: "Estoque&nbsp;Consolidado&nbsp;por&nbsp;Posi\xe7\xe3o"
        },
        {
            hash: '#export-csv',
            label: "Exportar&nbsp;CSV&nbsp;(Relat\xf3rio&nbsp;Completo)"
        },
        {
            hash: '#lot-labels',
            label: 'Etiquetas&nbsp;de&nbsp;Lotes'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#move-stock', stocks_crud.moveStock.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-by-sku', stocks_crud.printBySKU.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-by-lot', stocks_crud.printByLot.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-by-location', stocks_crud.printByLocation.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-csv', stocks_crud.exportCsv.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#lot-labels', stocks_crud.printLotLabels.bind(stocks_crud));
    stocks_crud.run('stocks', 'Estoques', document.getElementById('workarea'), (0, $82e5a54bae0b2474$export$2e2bcd8739ae039), (0, $c45260a54a668287$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $b94ca141f2d5964b$export$2e2bcd8739ae039 = $b94ca141f2d5964b$var$stocks;




var $1cmSR = parcelRequire("1cmSR");



async function $3f6e738e9ca7ec99$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(5)	{ text-align: right; }
			.view td:nth-child(6)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(12)	{ text-align: right; }
			.view td:nth-child(13)	{ text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Transa\xe7\xe3o</th>
					<th data-index="3" data-visible="${this.visible[2]}">Produto</th>
					<th data-index="4" data-visible="${this.visible[3]}">Lote</th>
					<th data-index="5" data-visible="${this.visible[4]}">Usu\xe1rio</th>
					<th data-index="6" data-visible="${this.visible[5]}">Data/Hora</th>
					<th data-index="7" data-visible="${this.visible[6]}">Origem Tipo</th>
					<th data-index="8" data-visible="${this.visible[7]}">Destino Tipo</th>
					<th data-index="9" data-visible="${this.visible[8]}">Origem</th>
					<th data-index="10" data-visible="${this.visible[9]}">Destino</th>
					<th data-index="11" data-visible="${this.visible[10]}">Quantidade</th>
					<th data-index="12" data-visible="${this.visible[11]}">Valor</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${await this.key('products', [
            record.company_id,
            record.product_id
        ])}</td>
					<td data-visible='${this.visible[3]}'>${record.lot_id}</td>
					<td data-visible='${this.visible[4]}'>${await this.key('users', record.user_id)}</td>
					<td data-visible='${this.visible[5]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.date_time)}</td>
					<td data-visible='${this.visible[6]}'>${this.option($bdd84d0eadfe1c66$export$2e2bcd8739ae039(), record.source_type)}</td>
					<td data-visible='${this.visible[7]}'>${this.option($bdd84d0eadfe1c66$export$2e2bcd8739ae039(), record.target_type)}</td>
					<td data-visible='${this.visible[8]}'>${record.source}</td>
					<td data-visible='${this.visible[9]}'>${record.target}</td>
					<td data-visible='${this.visible[10]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0), record.quantity)}</td>
					<td data-visible='${this.visible[11]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.value)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




var $5bf775e5b7c2d7dd$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#transaction #company_id	{ width: 10rem;		}
			#transaction #id			{ width: 6rem; text-align: right;	}
			#transaction #user_id		{ width: 10rem;		}
			#transaction #date_time		{ width: 10rem;		}
			#transaction #product_id	{ width: 32rem; 	}
			#transaction #lot_id		{ width: 10rem;		}
			#transaction #quantity		{ width: 10rem; text-align: right;	}
			#transaction #value			{ width: 10rem; text-align: right;	}
			#transaction #source_type	{ width: 8rem;		}
			#transaction #target_type	{ width: 8rem;		}
			#transaction #source		{ width: 24rem;	}
			#transaction #target		{ width: 24rem;	}
		</style>
		<form id="transaction" class="form" autocomplete="off">
			<datalist id="users">
			</datalist>
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="lots">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da transa\xe7\xe3o">Transa\xe7\xe3o
					<input id="id" type="text" disabled>
				</label>
				<label title="Usu\xe1rio autor da transa\xe7\xe3o">Usu\xe1rio
					<input id="user_id" type="text" list="users" disabled>
				</label>
				<label title="Data e hora da transa\xe7\xe3o">Data/Hora
					<input id="date_time" type="text" disabled>
				</label>
				<label title="Excluir esta transa\xe7\xe3o">Desabilitar
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<label title="Produto movimentado">Produto<sup>*</sup>
					<input id="product_id" type="text" list="products" required>
				</label>
				<label title="Lote movimentado">Lote<sup>*</sup>
					<input id="lot_id" type="text" list="lots" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Tipo de origem">Origem Tipo<sup>*</sup>
					<input id="source_type" type="text" list="transaction_types" required>
				</label>
				<label title="Origem da movimenta\xe7\xe3o">Origem<sup>*</sup>
					<input id="source" type="text" required>
				</label>
				<label title="Quantidade movimentada">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Tipo de destino">Destino Tipo<sup>*</sup>
					<input id="target_type" type="text" list="transaction_types" required>
				</label>
				<label title="Destino da movimenta\xe7\xe3o">Destino<sup>*</sup>
					<input id="target" type="text" required>
				</label>
				<label title="Pre\xe7o de custo total do lote movimentado">Valor<sup>*</sup>
					<input id="value" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#transaction',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#users', 'users');
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#product_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('product_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('lots', {
                    labels: [
                        'lot_number'
                    ],
                    key: 'company_id',
                    range: 1
                })
            ]
        },
        {
            properties: {
                selector: '#user_id'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#date_time'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#source_type'
            },
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#target_type'
            },
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#source'
            },
            types: [
                $1c8685a0a35fdb02$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#target'
            },
            types: [
                $1c8685a0a35fdb02$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#value'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $d95b661ee91ff067$var$transactions = function() {
    let transactions_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, this.queryAll()).then((data)=>(0, $1cmSR.default).set('lots', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_transactions, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_transaction, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                product_id: Number(data.product_id),
                lot_id: Number(data.lot_id),
                source_type: data.source_type,
                target_type: data.target_type,
                source: JSON.parse(data.source),
                target: JSON.parse(data.target),
                quantity: Number(data.quantity),
                value: Number(data.value)
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_transaction, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_transaction, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Transa\xe7\xe3o",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "Identificador da transa\xe7\xe3o"
        },
        {
            index: 3,
            field: 'product_id',
            label: 'Produto',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Produto',
            store: 'products',
            labels: [
                'name'
            ]
        },
        {
            index: 4,
            field: 'lot_id',
            label: 'Lote',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do lote'
        },
        {
            index: 5,
            field: 'user_id',
            label: "Usu\xe1rio",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Usu\xe1rio",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 6,
            field: 'date_time',
            label: 'Data/Hora',
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da transa\xe7\xe3o"
        },
        {
            index: 7,
            field: 'source_type',
            label: 'Tipo Origem',
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Tipo de origem'
        },
        {
            index: 8,
            field: 'target_type',
            label: 'Tipo Destino',
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Tipo de destino'
        },
        {
            index: 9,
            field: 'source',
            label: 'Origem',
            types: [],
            placeholder: '',
            title: "Identifica\xe7\xe3o da origem"
        },
        {
            index: 10,
            field: 'target',
            label: 'Destino',
            types: [],
            placeholder: '',
            title: "Identifica\xe7\xe3o do destino"
        },
        {
            index: 11,
            field: 'quantity',
            label: 'Quantidade',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade'
        },
        {
            index: 12,
            field: 'value',
            label: 'Valor',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Valor'
        }
    ];
    transactions_crud.run('transactions', "Transa\xe7\xf5es", document.getElementById('workarea'), (0, $3f6e738e9ca7ec99$export$2e2bcd8739ae039), (0, $5bf775e5b7c2d7dd$export$2e2bcd8739ae039), fieldspecs);
};
var $d95b661ee91ff067$export$2e2bcd8739ae039 = $d95b661ee91ff067$var$transactions;




var $1cmSR = parcelRequire("1cmSR");







async function $88a2283db056a470$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: left; max-right: 10rem; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Armaz\xe9m</th>
					<th data-index="3" data-visible="${this.visible[2]}">Ressuprimento</th>
					<th data-index="4" data-visible="${this.visible[3]}">Cria\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Conclus\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ])}</td>
					<td data-visible='${this.visible[2]}'>${record.id}</td>
					<td data-visible='${this.visible[3]}'>${this.format(types.datetime(), record.created_on)}</td>
					<td data-visible='${this.visible[4]}'>${this.format(types.datetime(), record.completed_on) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $abe6840daea06ec9$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#replenishment #company_id		{ width: 12rem;		}
			#replenishment #warehouse_id	{ width: 12rem;		}
			#replenishment #id				{ width: 8rem; text-align: right;	}
			#replenishment #created_on		{ width: 12rem;		}
			#replenishment #completed_on	{ width: 12rem;		}
			#replenishment .location 		{ width: 7rem;		}
			#replenishment .lot_company 	{ width: 8rem; 		}
			#replenishment .product		 	{ width: 20rem;		}
			#replenishment .lot 			{ width: 4.5rem; text-align: right;	}
			#replenishment .quantity		{ width: 4.5rem; text-align: right;	}
		</style>
		<form id="replenishment" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Armaz\xe9m do ressuprimento">Armaz\xe9m
					<input id="warehouse_id" type="text" list="warehouses" disabled>
				</label>
				<label title="Identificador do ressuprimento">Ressuprimento
					<input id="id" type="text" disabled>
				</label>
				<label title="Data e hora de cria\xe7\xe3o do ressuprimento">Cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Data e hora de conclus\xe3o do ressuprimento">Conclus\xe3o
					<input id="completed_on" type="text" disabled>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<!--
							<th></th>
							-->
							<th>Origem</th>
							<th>Destino</th>
							<th>Titular</th>
							<th>Produto</th>
							<th>Lote</th>
							<th>Req</th>
							<th>Mov<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<!--
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							-->
							<td title="Posi\xe7\xe3o de origem">
								<input id="from_location_id-0" class="location" type="text" list="locations" disabled>
							</td>
							<td title="Posi\xe7\xe3o de destino">
								<input id="to_location_id-0" class="location" type="text" list="locations" disabled>
							</td>
							<td title="Empresa titular do lote">
								<input id="lot_company_id-0" class="lot_company" type="text" list="companies" disabled>
							</td>
							<td title="Produto a mover">
								<input id="product_id-0" class="product" list="products-0" type="text" disabled>
							</td>
							<td title="N\xfamero do lote a mover">
								<input id="lot_id-0" class="lot" type="text" disabled>
							</td>
							<td title="Quantidade requerida">
								<input id="quantity_needed-0" class="quantity" type="text" disabled>
							</td>
							<td title="Quantidade movida">
								<input id="quantity_moved-0" class="quantity" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#replenishment',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#completed_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        //{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
        {
            properties: {
                selector: '#from_location_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#to_location_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#lot_company_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('lot_company_id-0'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_id-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_needed-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_moved-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        }
    ]
};



var $697f32a542e4bc7b$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#replenishment #company_id		{ width: 13rem;	}
			#replenishment #warehouse_id	{ width: 13rem; }
		</style>
		<form id="replenishment" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<div class="title">
				Gerar Novo Ressuprimento
			</div>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Armaz\xe9m">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#replenishment',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        }
    ]
};



const $3120de0fc186b19b$var$replenishments = function() {
    let replenishments_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_replenishments, query);
        },
        insertRecord () {
            this.createReplenishment();
        },
        async editFilter () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = data;
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            this.loadPage(1);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_replenishment, ...JSON.parse(id));
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'items');
        },
        async saveRecord (data, old_data) {
            data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'items');
            let _record = {
                items: data.items.map((item)=>({
                        from_location_id: Number(item.from_location_id),
                        to_location_id: Number(item.to_location_id),
                        lot_company_id: item.lot_company_id,
                        lot_id: Number(item.lot_id),
                        product_id: Number(item.product_id),
                        quantity_needed: Number(item.quantity_needed),
                        quantity_moved: Number(item.quantity_moved)
                    }))
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_replenishment, data.company_id, data.warehouse_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_replenishment, data.company_id, data.warehouse_id, _record);
        },
        createReplenishment () {
            const showResult = (resp)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(resp.id ? 'Ressuprimento criado' : "N\xe3o h\xe1 posi\xe7\xf5es a ressuprir", 'Resultado');
                this.loadPage(); // Required to show new record
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_replenishment, data.company_id, data.warehouse_id).then(showResult);
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $697f32a542e4bc7b$export$2e2bcd8739ae039), sendRequest);
            fs.init();
        },
        closeReplenishments () {
            const showResult = (resp)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(resp.count ? `Ressuprimentos finalizados: ${resp.count}` : 'Nenhum ressuprimento a finalizar', 'Resultado');
                this.loadPage(); // Required to show the closing date/time
            };
            const sendRequest = async (data)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'warehouse_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).close_replenishments, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Encerrar ${this.getCount()} ressuprimentos?`, 'Baixar Ressuprimentos', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printReplenishmentOrders () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'warehouse_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_replenishment_orders, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Gerar ordem para ${this.getCount()} ressuprimentos?`, 'Ordem de Ressuprimento', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Armaz\xe9m do estoque",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 3,
            field: 'id',
            label: 'Ressuprimento',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do ressuprimento'
        },
        {
            index: 4,
            field: 'created_on',
            label: "Cria\xe7\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de cria\xe7\xe3o do ressuprimento"
        },
        {
            index: 5,
            field: 'completed_on',
            label: "Conclus\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de conclus\xe3o do ressuprimento"
        }
    ];
    let operations = [
        {
            hash: '#close-replenishments',
            label: 'Baixar&nbsp;Ressuprimentos'
        }
    ];
    let reports = [
        {
            hash: '#print-orders',
            label: 'Ordem&nbsp;de&nbsp;Ressuprimento'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#close-replenishments', replenishments_crud.closeReplenishments.bind(replenishments_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-orders', replenishments_crud.printReplenishmentOrders.bind(replenishments_crud));
    replenishments_crud.run('replenishments', 'Ressuprimentos', document.getElementById('workarea'), (0, $88a2283db056a470$export$2e2bcd8739ae039), (0, $abe6840daea06ec9$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $3120de0fc186b19b$export$2e2bcd8739ae039 = $3120de0fc186b19b$var$replenishments;




var $1cmSR = parcelRequire("1cmSR");








async function $3998031699728e70$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: left; max-right: 10rem; }
			.view td:nth-child(4)	{ text-align: center; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: left; max-right: 30rem; }
			.view td:nth-child(7)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Armaz\xe9m</th>
					<th data-index="3" data-visible="${this.visible[2]}">In\xedcio</th>
					<th data-index="4" data-visible="${this.visible[3]}">Conclus\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Nome</th>
					<th data-index="6" data-visible="${this.visible[5]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ])}</td>
					<td data-visible='${this.visible[2]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.started_on)}</td>
					<td data-visible='${this.visible[3]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.completed_on) || ''}</td>
					<td data-visible='${this.visible[4]}'>${record.name}</td>
					<td data-visible='${this.visible[5]}'>${this.option($d0f482af46bfd35e$export$2e2bcd8739ae039(), record.status) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $12161210e1d7d0de$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#inventory #company_id		{ width: 10rem;		}
			#inventory #warehouse_id	{ width: 10rem;		}
			#inventory #started_on		{ width: 9rem;		}
			#inventory #completed_on	{ width: 9rem;		}
			#inventory #name			{ width: 12rem;		}
		</style>
		<form id="inventory" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Armaz\xe9m do invent\xe1rio">Armaz\xe9m
					<input id="warehouse_id" type="text" list="warehouses" disabled>
				</label>
				<label title="Data e hora de in\xedcio do invent\xe1rio">In\xedcio
					<input id="started_on" type="text" disabled>
				</label>
				<label title="Data e hora de conclus\xe3o do invent\xe1rio">Conclus\xe3o
					<input id="completed_on" type="text" disabled>
				</label>
				<label title="Nome do invent\xe1rio">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="mtm">
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#inventory',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#started_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#completed_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        }
    ]
};



var $929b3fd1ed29d520$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#inventory #company_id		{ width: 100%; }
			#inventory #warehouse_id	{ width: 100%; }
			#inventory #name			{ width: 100%; }
		</style>
		<form id="inventory" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<div class="title">
				Iniciar Invent\xe1rio
			</div>
			<div class="mtl fsb">
				<label title="Empresa a inventariar">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Armaz\xe9m a inventariar">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome do invent\xe1rio">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Iniciar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#inventory',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        }
    ]
};



var $fae6769a9f648e2c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#inventory-check #location_id		{ width: 5rem; }
			#inventory-check #lot_company_id	{ width: 10rem; }
			#inventory-check #lot_id			{ width: 5rem; text-align: right; }
			#inventory-check #quantity			{ width: 5rem; text-align: right; }
		</style>
		<form id="inventory-check" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="locations">
			</datalist>
			<div class="title">
				Confer\xeancia Manual
			</div>
			<input id="company_id" type="hidden">
			<input id="warehouse_id" type="hidden">
			<input id="inventory_id" type="hidden">
			<div class="mtl fsb">
				<label title="Posi\xe7\xe3o inventariada">Posi\xe7\xe3o<sup>*</sup>
					<input id="location_id" type="text" list="locations" required>
				</label>
				<label title="Empresa titular do lote">Empresa<sup>*</sup>
					<input id="lot_company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do lote">Lote<sup>*</sup>
					<input id="lot_id" type="text" required>
				</label>
				<label title="Quantidade inventariada">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Salvar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#inventory-check',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#locations', 'locations', {
                labels: [
                    'address'
                ],
                separator: '-',
                key: 'warehouse_id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#inventory_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#location_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#lot_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#lot_id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        }
    ]
};



const $c89615e12aaa973d$var$inventories = function() {
    let inventories_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, this.queryAll()).then((data)=>(0, $1cmSR.default).set('lots', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_inventories, query);
        },
        insertRecord () {
            this.createInventory();
        },
        async editFilter () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = data;
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            this.loadPage(1);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_inventory, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_inventory, data.company_id, data.warehouse_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_inventory, data.company_id, data.warehouse_id, _record);
        },
        createInventory () {
            const showResult = (resp)=>{
                this.loadPage(); // Required to show new record
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                let record = {
                    name: data.name
                };
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_inventory, data.company_id, data.warehouse_id, record).then(showResult);
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $929b3fd1ed29d520$export$2e2bcd8739ae039), sendRequest);
            fs.init();
        },
        async checkInventory () {
            const sendRequest = async (data)=>{
                let record = {
                    location_id: data.location_id,
                    lot_company_id: data.lot_company_id,
                    lot_id: data.lot_id,
                    quantity: Number(data.quantity)
                };
                return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).check_inventory_item, data.company_id, data.warehouse_id, data.inventory_id, record);
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'warehouse_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione um invent\xe1rio", "Confer\xeancia Manual");
            (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $fae6769a9f648e2c$export$2e2bcd8739ae039), sendRequest, {
                'company_id': ids[0][0],
                'warehouse_id': ids[0][1],
                'inventory_id': ids[0][2]
            });
        },
        async cancelInventory () {
            const showResult = (resp)=>{
                this.loadPage(); // Required to show the closing date/time
            };
            const sendRequest = async (company_id, warehouse_id, inventory_id)=>{
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).cancel_inventory, company_id, warehouse_id, inventory_id).then(showResult);
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'warehouse_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione um invent\xe1rio para cancelar", "Cancelar Invent\xe1rio");
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Cancelar invent\xe1rio selecionado?`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest(ids[0][0], ids[0][1], ids[0][2]);
            });
        },
        async closeInventory () {
            const showResult = (resp)=>{
                this.loadPage(); // Required to show the closing date/time
            };
            const sendRequest = async (company_id, warehouse_id, inventory_id)=>{
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).close_inventory, company_id, warehouse_id, inventory_id).then(showResult);
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'warehouse_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione um invent\xe1rio para encerrar", "Encerrar Invent\xe1rio");
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Encerrar invent\xe1rio selecionado?`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest(ids[0][0], ids[0][1], ids[0][2]);
            });
        },
        async printPending () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async (company_id, warehouse_id, inventory_id)=>{
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_inventory_pending, company_id, warehouse_id, inventory_id).then(showResult);
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'warehouse_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione um invent\xe1rio para imprimir", "Relat\xf3rio de Pend\xeancias");
            sendRequest(ids[0][0], ids[0][1], ids[0][2]);
        },
        async printDeviation () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async (company_id, warehouse_id, inventory_id)=>{
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_inventory_deviation, company_id, warehouse_id, inventory_id).then(showResult);
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'warehouse_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione um invent\xe1rio para imprimir", "Relat\xf3rio de Diverg\xeancias");
            sendRequest(ids[0][0], ids[0][1], ids[0][2]);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Armaz\xe9m do estoque",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 4,
            field: 'started_on',
            label: "In\xedcio",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de in\xedcio do invent\xe1rio"
        },
        {
            index: 5,
            field: 'completed_on',
            label: "Conclus\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de conclus\xe3o do invent\xe1rio"
        },
        {
            index: 6,
            field: 'name',
            label: 'Nome',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Nome do invent\xe1rio"
        },
        {
            index: 7,
            field: 'status',
            label: 'Status',
            types: [
                $d0f482af46bfd35e$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Status do invent\xe1rio"
        }
    ];
    let operations = [
        {
            hash: '#check-inventory',
            label: "Confer\xeancia&nbsp;Manual"
        },
        {
            hash: '#cancel-inventory',
            label: "Cancelar&nbsp;Invent\xe1rio"
        },
        {
            hash: '#close-inventory',
            label: "Encerrar&nbsp;Invent\xe1rio"
        }
    ];
    let reports = [
        {
            hash: '#print-pending',
            label: "Relat\xf3rio&nbsp;de&nbsp;Pend\xeancias"
        },
        {
            hash: '#print-deviation',
            label: "Relat\xf3rio&nbsp;de&nbsp;Diverg\xeancias"
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#check-inventory', inventories_crud.checkInventory.bind(inventories_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#cancel-inventory', inventories_crud.cancelInventory.bind(inventories_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#close-inventory', inventories_crud.closeInventory.bind(inventories_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-pending', inventories_crud.printPending.bind(inventories_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-deviation', inventories_crud.printDeviation.bind(inventories_crud));
    inventories_crud.run('inventories', "Invent\xe1rios", document.getElementById('workarea'), (0, $3998031699728e70$export$2e2bcd8739ae039), (0, $12161210e1d7d0de$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $c89615e12aaa973d$export$2e2bcd8739ae039 = $c89615e12aaa973d$var$inventories;




var $1cmSR = parcelRequire("1cmSR");







async function $175c09b2e159b26a$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: right; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(16)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(17)	{ text-align: left; max-width: 16rem; }
			.view td:nth-child(18)	{ text-align: center; }
			.view td:nth-child(19)	{ text-align: left; }
			.view td:nth-child(20)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[2]}">Refer\xeancia</th>
					<th data-index="4" data-visible="${this.visible[3]}">Data Cria\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Criado Por</th>
					<th data-index="6" data-visible="${this.visible[5]}">Data Altera\xe7\xe3o</th>
					<th data-index="7" data-visible="${this.visible[6]}">Alterado Por</th>
					<th data-index="8" data-visible="${this.visible[7]}">Fornecedor&nbsp;/&nbsp;Cliente</th>
					<th data-index="9" data-visible="${this.visible[8]}">Transportador</th>
					<th data-index="10" data-visible="${this.visible[9]}">Programa</th>
					<th data-index="11" data-visible="${this.visible[10]}">Tipo Frete</th>
					<th data-index="12" data-visible="${this.visible[11]}">Valor Frete</th>
					<th data-index="13" data-visible="${this.visible[12]}">% Desconto</th>
					<th data-index="14" data-visible="${this.visible[13]}">Valor</th>
					<th data-index="15" data-visible="${this.visible[14]}">Observa\xe7\xf5es</th>
					<th data-index="16" data-visible="${this.visible[15]}">N\xba&nbsp;empenho</th>
					<th data-index="17" data-visible="${this.visible[16]}">Tipo&nbsp;recebimento</th>
					<th data-index="18" data-visible="${this.visible[17]}">Devolu\xe7\xe3o</th>
					<th data-index="19" data-visible="${this.visible[18]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.created_on)}</td>
					<td data-visible='${this.visible[4]}'>${await this.key('users', record.created_by)}</td>
					<td data-visible='${this.visible[5]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.updated_on) || ''}</td>
					<td data-visible='${this.visible[6]}'>${await this.key('users', record.updated_by) || ''}</td>
					<td data-visible='${this.visible[7]}'>${await this.key(record.is_return ? 'customers' : 'suppliers', [
            record.company_id,
            record.is_return ? record.customer_id : record.supplier_id
        ], 'nick') || ''}</td>
					<td data-visible='${this.visible[8]}'>${await this.key('carriers', [
            record.company_id,
            record.carrier_id
        ], 'nick') || ''}</td>
					<td data-visible='${this.visible[9]}'>${await this.key('programs', record.program_id ? [
            record.company_id,
            record.program_id
        ] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[10]}'>${this.option($b537c438f09757c4$export$2e2bcd8739ae039(), record.freight_type) || ''}</td>
					<td data-visible='${this.visible[11]}'>${record.freight_value ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.freight_value) : ''}</td>
					<td data-visible='${this.visible[12]}'>${record.discount ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.discount) : ''}</td>
					<td data-visible='${this.visible[13]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.value)}</td>
					<td data-visible='${this.visible[14]}'>${record.notes || ''}</td>
					<td data-visible='${this.visible[15]}'>${record.empenho_number || ''}</td>
					<td data-visible='${this.visible[16]}'>${await (async ()=>{
            if (record.receipt_type_id == null || record.receipt_type_id === '') return '';
            const k = [
                record.company_id,
                record.receipt_type_id
            ];
            const c = await this.key('receipt_types', k, 'code');
            const d = await this.key('receipt_types', k, 'description');
            return [
                c,
                d
            ].filter(Boolean).join(" \u2014 ");
        })()}</td>
					<td data-visible='${this.visible[17]}'>${this.option($16a377ceff31a9ac$export$2e2bcd8739ae039(), record.is_return)}</td>
					<td data-visible='${this.visible[18]}'>${this.option($79f43e37b9b6ec01$export$2e2bcd8739ae039(), record.status) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $c50c847760b2fc91$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#order #company_id		{ width: 10rem;		}
			#order #id				{ width: 4.5rem; text-align: right;	}
			#order #reference		{ width: 6rem; 		}
			#order #empenho_number	{ width: 11rem; }
			#order #receipt_type_id	{ width: 22rem; }
			#order #created_on		{ width: 9rem;		}
			#order #created_by		{ width: 8rem;		}
			#order #updated_on		{ width: 9rem;		}
			#order #updated_by		{ width: 8rem;		}
			#order #supplier_id,
			#order #customer_id		{ width: 20rem;		}
			#order #carrier_id		{ width: 14rem;		}
			#order #freight_type	{ width: 10rem;		}
			#order #freight_value 	{ width: 5rem; text-align: right; 	}
			#order #discount 		{ width: 5rem; text-align: right;	}
			#order #status	 		{ width: 8rem;		}
			#order .product 		{ width: 40rem;		}
			#order .unit 			{ width: 8.5rem;	}
			#order .quantity 		{ width: 6rem; text-align: right;	}
			#order .price 			{ width: 8rem; text-align: right;	}
			#order .notes			{ width: 100%;		}
		</style>
		<form id="order" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="suppliers">
			</datalist>
			<datalist id="customers">
			</datalist>
			<datalist id="carriers">
			</datalist>
			<datalist id="programs">
			</datalist>
			<datalist id="receipt_types">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="units">
			</datalist>
			<datalist id="users">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do pedido">Pedido
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo de refer\xeancia externa">Refer\xeancia
					<input id="reference" type="text">
				</label>
				<label title="Data e hora de cria\xe7\xe3o do pedido">Data Cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Usu\xe1rio criador do pedido">Criado Por
					<input id="created_by" type="text" list="users" disabled>
				</label>
				<label title="Data e hora de altera\xe7\xe3o do pedido">Data Altera\xe7\xe3o
					<input id="updated_on" type="text" disabled>
				</label>
				<label title="\xdaltimo usu\xe1rio a alterar o pedido">Alterado Por
					<input id="updated_by" type="text" list="users" disabled>
				</label>
				<label title="Este pedido \xe9 uma devolu\xe7\xe3o?">Devolu\xe7\xe3o
					<input id="is_return" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<span id="wrap_supplier_party">
					<label title="Fornecedor do pedido">Fornecedor<sup>*</sup>
						<input id="supplier_id" type="text" list="suppliers" required>
					</label>
				</span>
				<span id="wrap_customer_party" style="display:none">
					<label title="Cliente que devolve (devolu\xe7\xe3o)">Cliente (devolu\xe7\xe3o)<sup>*</sup>
						<input id="customer_id" type="text" list="customers">
					</label>
				</span>
				<label title="Transportador do pedido">Transportador
					<input id="carrier_id" type="text" list="carriers">
				</label>
				<label title="Programa sugerido para a entrada">Programa
					<input id="program_id" type="text" list="programs">
				</label>
				<label title="N\xfamero do empenho (Ano + NE + n\xfamero, ex.: 2025NE02173)">N\xba empenho
					<input id="empenho_number" type="text" placeholder="2025NE02173" maxlength="32">
				</label>
				<label title="Tipo de recebimento (cadastro Tipos de Recebimento)">Tipo recebimento
					<input id="receipt_type_id" type="text" list="receipt_types">
				</label>
				<label title="Tipo de frete">Tipo Frete
					<input id="freight_type" type="text" list="freight_types">
				</label>
				<label title="Valor do frete">Valor Frete
					<input id="freight_value" type="text">
				</label>
				<label title="Desconto sobre o valor do pedido">% Desconto
					<input id="discount" type="text">
				</label>
				<label title="Status do pedido">Status<sup>*</sup>
					<input id="status" type="text" list="order_status" value="10" required>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>Unidade<sup>*</sup></th>
							<th>Qtde<sup>*</sup></th>
							<th>Pre\xe7o Unit<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="Unidade de venda">
								<input id="unit_id-0" class="unit" type="text" list="units" required>
							</td>
							<td title="Quantidade">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
							<td title="Pre\xe7o unit\xe1rio do produto">
								<input id="unit_price-0" class="price" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<label class="notes" title="Observa\xe7\xf5es sobre o pedido">Observa\xe7\xf5es
					<textarea id="notes" rows="4"></textarea>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#order',
        partyVisibilitySync (formRoot) {
            if (!formRoot) return;
            const ret = formRoot.querySelector('#is_return');
            const ws = formRoot.querySelector('#wrap_supplier_party');
            const wc = formRoot.querySelector('#wrap_customer_party');
            const sup = formRoot.querySelector('#supplier_id');
            const cust = formRoot.querySelector('#customer_id');
            const on = !!(ret && ret.checked);
            if (ws) ws.style.display = on ? 'none' : '';
            if (wc) wc.style.display = on ? '' : 'none';
            if (sup) sup.required = !on;
            if (cust) cust.required = on;
        },
        afterEditSetValues (fs) {
            const root = fs?.dialog?.getNode()?.querySelector(this.selector);
            this.partyVisibilitySync(root);
        },
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#users', 'users');
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ],
                value: 'id'
            });
            formset.loadList('#receipt_types', 'receipt_types', {
                labels: [
                    'code',
                    'description'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
            const root = document.querySelector(this.selector);
            if (root) {
                const ret = root.querySelector('#is_return');
                const sup = root.querySelector('#supplier_id');
                const cust = root.querySelector('#customer_id');
                const sync = ()=>{
                    const on = !!(ret && ret.checked);
                    this.partyVisibilitySync(root);
                    if (on && sup) sup.value = '';
                    if (!on && cust) cust.value = '';
                };
                if (ret) ret.addEventListener('change', sync);
                this.partyVisibilitySync(root);
            }
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#reference'
            },
            types: [
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#created_by'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#updated_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#updated_by'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#supplier_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('suppliers', {
                    labels: [
                        'cnpj',
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#customer_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('customers', {
                    labels: [
                        'cnpj',
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#carrier_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('carriers', {
                    labels: [
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#empenho_number'
            },
            types: [
                $c1695650808e6a21$export$2e2bcd8739ae039(),
                $01514eb1e21db7c4$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#receipt_type_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('receipt_types', {
                    labels: [
                        'code',
                        'description'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#freight_type'
            },
            types: [
                $b537c438f09757c4$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#freight_value'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#discount'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#notes'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_return'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $79f43e37b9b6ec01$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ],
                    filter: (r)=>!r.is_disabled
                })
            ]
        },
        {
            properties: {
                selector: '#unit_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039([
                    'company_id',
                    'product_id-0'
                ]),
                $f7ae7d91f57919c4$export$2e2bcd8739ae039(1)
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#unit_price-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        }
    ]
};



var $7586a89680f71d54$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input-order-upload #company_id { width: 100%; }
			#input-order-upload #supplier_id { width: 100%; }
			#input-order-upload #program_id { width: 100%; }
			#input-order-upload #file { width: 100%; }
		</style>
		<form id="input-order-upload" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="suppliers"></datalist>
			<datalist id="programs"></datalist>
			<div class="title">Upload de planilha para pedido de entrada</div>
			<p class="mts">Planilha com colunas: <strong>SKU</strong>, <strong>Quantidade</strong> e opcionalmente <strong>Pre\xe7o</strong> ou <strong>Vlr</strong>.</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Fornecedor">Fornecedor<sup>*</sup>
					<input id="supplier_id" type="text" list="suppliers" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Programa">Programa
					<input id="program_id" type="text" list="programs">
				</label>
			</div>
			<div class="fsb">
				<label title="Arquivo CSV ou XLSX">Arquivo<sup>*</sup>
					<input id="file" type="file" accept=".csv,.xlsx" required>
				</label>
			</div>
			<div class="mtm">
				<a id="download-template" href="#" class="link">Baixar modelo da planilha</a>
			</div>
			<div class="mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Processar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#input-order-upload',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#suppliers', 'suppliers', {
                labels: [
                    'cnpj',
                    'nick'
                ]
            });
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init?.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#supplier_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('suppliers')
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('programs')
            ]
        },
        {
            properties: {
                selector: '#file'
            },
            types: []
        }
    ]
};


/**
 * View do resultado do upload de planilha para pedido.
 * Exibe: pedido criado, SKU não encontrado, Lote não encontrado, sem estoque, pendentes.
 */ var $3dc30afed7448525$export$2e2bcd8739ae039 = (result, orderType = 'output')=>{
    const { order_id: order_id, sku_nao_encontrado: sku_nao_encontrado = [], lote_nao_encontrado: lote_nao_encontrado = [], sem_estoque: sem_estoque = [], pendentes: pendentes = [] } = result || {};
    const parts = [];
    if (order_id) parts.push(`<p class="mts"><strong>Pedido #${order_id}</strong> criado.</p>`);
    else if (orderType === 'output' && (sku_nao_encontrado?.length || lote_nao_encontrado?.length || sem_estoque?.length || pendentes?.length)) parts.push(`<p class="mts">Nenhum item p\xf4de ser inclu\xeddo no pedido (todos SKU n\xe3o encontrados, lote n\xe3o encontrado ou sem estoque).</p>`);
    else if (orderType === 'input' && sku_nao_encontrado?.length) parts.push(`<p class="mts">Nenhum item p\xf4de ser inclu\xeddo no pedido (todos SKU n\xe3o encontrados).</p>`);
    if (sku_nao_encontrado?.length) {
        parts.push(`<p class="mtm"><strong>SKU n\xe3o encontrado</strong>:</p>`);
        parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Quantidade</th><th>Lote</th><th>Vlr</th></tr></thead><tbody>`);
        sku_nao_encontrado.forEach((r)=>parts.push(`<tr><td>${r.sku || ''}</td><td>${r.quantidade ?? ''}</td><td>${r.lote ?? ''}</td><td>${r.vlr ?? ''}</td></tr>`));
        parts.push(`</tbody></table>`);
    }
    if (orderType === 'output' && lote_nao_encontrado?.length) {
        parts.push(`<p class="mtm"><strong>Lote n\xe3o encontrado</strong>:</p>`);
        parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Lote</th><th>Quantidade</th><th>Vlr</th></tr></thead><tbody>`);
        lote_nao_encontrado.forEach((r)=>parts.push(`<tr><td>${r.sku || ''}</td><td>${r.lote ?? ''}</td><td>${r.quantidade ?? ''}</td><td>${r.vlr ?? ''}</td></tr>`));
        parts.push(`</tbody></table>`);
    }
    if (sem_estoque?.length) {
        parts.push(`<p class="mtm"><strong>Sem estoque</strong>:</p>`);
        parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Lote</th><th>Solicitado</th><th>Atendido</th><th>Pendente</th></tr></thead><tbody>`);
        sem_estoque.forEach((r)=>parts.push(`<tr><td>${r.sku || ''}</td><td>${r.lote ?? ''}</td><td>${r.solicitado ?? ''}</td><td>${r.atendido ?? 0}</td><td>${r.pendente ?? ''}</td></tr>`));
        parts.push(`</tbody></table>`);
    }
    if (pendentes?.length) {
        parts.push(`<p class="mtm"><strong>Pendente</strong> (parcial):</p>`);
        parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Lote</th><th>Solicitado</th><th>Atendido</th><th>Pendente</th></tr></thead><tbody>`);
        pendentes.forEach((r)=>parts.push(`<tr><td>${r.sku || ''}</td><td>${r.lote ?? ''}</td><td>${r.solicitado ?? ''}</td><td>${r.atendido ?? ''}</td><td>${r.pendente ?? ''}</td></tr>`));
        parts.push(`</tbody></table>`);
    }
    return parts.join('') || '<p class="mts">Processamento conclu\xeddo.</p>';
};




const $41d7c55d2e4dc43d$var$inputOrders = function() {
    let input_orders_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_receipt_types, this.queryAll()).then((data)=>(0, $1cmSR.default).set('receipt_types', data).catch(()=>{}));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_suppliers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('suppliers', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_customers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customers', data).catch(()=>{}));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_carriers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('carriers', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_units, this.queryAll()).then((data)=>(0, $1cmSR.default).set('units', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_input_orders, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_input_order, ...JSON.parse(id));
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'items');
        },
        async saveRecord (data, old_data) {
            data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'items');
            const isReturn = data.is_return == '1';
            let _record = {
                reference: data.reference,
                supplier_id: isReturn ? null : Number(data.supplier_id),
                customer_id: isReturn ? Number(data.customer_id) : null,
                carrier_id: Number(data.carrier_id),
                program_id: data.program_id != null && data.program_id !== '' ? Number(data.program_id) : null,
                freight_type: data.freight_type,
                freight_value: Number(data.freight_value),
                discount: Number(data.discount),
                notes: data.notes?.trim(),
                empenho_number: data.empenho_number && String(data.empenho_number).trim() ? String(data.empenho_number).trim().replace(/\s+/g, '') : null,
                receipt_type_id: data.receipt_type_id != null && data.receipt_type_id !== '' ? Number(data.receipt_type_id) : null,
                is_return: isReturn,
                status: Number(data.status),
                items: (data.items || []).filter((item)=>item && item.product_id != null && item.product_id !== '' && Number(item.product_id) > 0).map((item)=>({
                        product_id: Number(item.product_id),
                        unit_id: Number(item.unit_id),
                        quantity: Number(item.quantity),
                        unit_price: Number(item.unit_price)
                    }))
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_input_order, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_input_order, data.company_id, _record);
        },
        editFilter () {
            (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = await (0, $d110a042ff114667$export$94031f41c18e0637)(data, this.fieldspecs);
            this.loadPage(1);
        },
        uploadFromSpreadsheet () {
            const showResult = (result)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)((0, $3dc30afed7448525$export$2e2bcd8739ae039)(result, 'input'), 'Resultado do upload');
                this.loadPage();
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                const formNode = document.querySelector((0, $7586a89680f71d54$export$2e2bcd8739ae039).form.selector);
                const fileInput = formNode?.querySelector('#file');
                const file = fileInput?.files?.[0];
                if (!file) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione um arquivo CSV ou XLSX.');
                    return;
                }
                const company_id = data.company_id;
                if (!company_id) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione a empresa.');
                    return;
                }
                const fd = new FormData();
                fd.append('file', file);
                fd.append('supplier_id', data.supplier_id);
                fd.append('program_id', data.program_id || '');
                const result = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).upload_input_order, company_id, fd);
                if (result) showResult(result);
            };
            const setupTemplateLink = (fs)=>{
                const link = fs.dialog.getNode().querySelector('#download-template');
                if (link) link.onclick = async (e)=>{
                    e.preventDefault();
                    const company_id = fs.form.getValues().company_id;
                    if (!company_id) {
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione a empresa para baixar o modelo.');
                        return;
                    }
                    const csv = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).order_upload_template, company_id);
                    if (csv && typeof csv === 'string') {
                        const blob = new Blob([
                            csv
                        ], {
                            type: 'text/csv;charset=utf-8'
                        });
                        const a = document.createElement('a');
                        a.href = URL.createObjectURL(blob);
                        a.download = 'modelo_pedido_upload.csv';
                        a.click();
                        URL.revokeObjectURL(a.href);
                    }
                };
            };
            const fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $7586a89680f71d54$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                Object.getPrototypeOf(fs).init.call(fs);
                setupTemplateLink(fs);
            })();
        },
        printOrderDocument () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_input_order_document, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Gerar documento de ${this.getCount()} pedido(s)?`, 'Documento de Pedido de Entrada', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Pedido',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do pedido'
        },
        {
            index: 3,
            field: 'reference',
            label: "Refer\xeancia",
            types: [],
            placeholder: '',
            title: "C\xf3digo de refer\xeancia externa do pedido"
        },
        {
            index: 4,
            field: 'created_on',
            label: "Data Cria\xe7\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de cria\xe7\xe3o do pedido"
        },
        {
            index: 5,
            field: 'created_by',
            label: 'Criado Por',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Usu\xe1rio criador do pedido",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 6,
            field: 'updated_on',
            label: "Data Altera\xe7\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da \xfaltima atualiza\xe7\xe3o do pedido"
        },
        {
            index: 7,
            field: 'updated_by',
            label: 'Alterado Por',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "\xdaltimo usu\xe1rio a atualizar o pedido",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 8,
            field: 'supplier_id',
            label: 'Fornecedor',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Fornecedor',
            store: 'suppliers',
            labels: [
                'nick'
            ]
        },
        {
            index: 9,
            field: 'carrier_id',
            label: 'Transportador',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Transportador',
            store: 'carriers',
            labels: [
                'nick'
            ]
        },
        {
            index: 10,
            field: 'program_id',
            label: 'Programa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Programa sugerido para a entrada',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 11,
            field: 'freight_type',
            label: 'Tipo Frete',
            types: [
                $b537c438f09757c4$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Tipo de frete'
        },
        {
            index: 12,
            field: 'freight_value',
            label: 'Valor Frete',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Valor do frete'
        },
        {
            index: 13,
            field: 'discount',
            label: '% Desconto',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Percentual de desconto'
        },
        {
            index: 14,
            field: 'value',
            label: 'Valor',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Valor do pedido'
        },
        {
            index: 15,
            field: 'notes',
            label: "Observa\xe7\xf5es",
            types: [],
            placeholder: '',
            title: "Observa\xe7\xf5es do pedido"
        },
        {
            index: 16,
            field: 'empenho_number',
            label: "N\xba empenho",
            types: [],
            placeholder: '2025NE02173',
            title: "N\xfamero do empenho (AAAA+NE+n\xfamero)"
        },
        {
            index: 17,
            field: 'receipt_type_id',
            label: 'Tipo recebimento',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Tipo de recebimento',
            store: 'receipt_types',
            labels: [
                'code',
                'description'
            ]
        },
        {
            index: 18,
            field: 'is_return',
            label: "Devolu\xe7\xe3o",
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Indicador de devolu\xe7\xe3o"
        },
        {
            index: 19,
            field: 'status',
            label: 'Status',
            types: [
                $79f43e37b9b6ec01$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Status do pedido'
        }
    ];
    let operations = [
        {
            hash: '#upload',
            label: 'Upload&nbsp;planilha'
        }
    ];
    let reports = [
        {
            hash: '#print-order-doc',
            label: 'Documento&nbsp;do&nbsp;Pedido'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#upload', input_orders_crud.uploadFromSpreadsheet.bind(input_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-order-doc', input_orders_crud.printOrderDocument.bind(input_orders_crud));
    input_orders_crud.run('input_orders', 'Pedidos&nbsp;Entrada', document.getElementById('workarea'), (0, $175c09b2e159b26a$export$2e2bcd8739ae039), (0, $c50c847760b2fc91$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $41d7c55d2e4dc43d$export$2e2bcd8739ae039 = $41d7c55d2e4dc43d$var$inputOrders;




var $1cmSR = parcelRequire("1cmSR");









async function $86c74365004cd66c$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; }
			.view td:nth-child(13)	{ text-align: left; }
			.view td:nth-child(14)	{ text-align: left; }
			.view td:nth-child(15)	{ text-align: right; }
			.view td:nth-child(16)	{ text-align: right; }
			.view td:nth-child(17)	{ text-align: right; }
			.view td:nth-child(18)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(19)	{ text-align: left; }
			.view td:nth-child(20)	{ text-align: center; }
			.view td:nth-child(21)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[2]}">Refer\xeancia</th>
					<th data-index="4" data-visible="${this.visible[3]}">Data Cria\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Criado Por</th>
					<th data-index="6" data-visible="${this.visible[5]}">Data Altera\xe7\xe3o</th>
					<th data-index="7" data-visible="${this.visible[6]}">Alterado Por</th>
					<th data-index="8" data-visible="${this.visible[7]}">Cliente</th>
					<th data-index="9" data-visible="${this.visible[8]}">Transportador</th>
					<th data-index="10" data-visible="${this.visible[9]}">Programa</th>
					<th data-index="11" data-visible="${this.visible[10]}">Atendimento</th>
					<th data-index="12" data-visible="${this.visible[11]}">Pagamento</th>
					<th data-index="13" data-visible="${this.visible[12]}">Condi\xe7\xe3o</th>
					<th data-index="14" data-visible="${this.visible[13]}">Tipo Frete</th>
					<th data-index="15" data-visible="${this.visible[14]}">Valor Frete</th>
					<th data-index="16" data-visible="${this.visible[15]}">% Desconto</th>
					<th data-index="17" data-visible="${this.visible[16]}">Valor</th>
					<th data-index="18" data-visible="${this.visible[17]}">Observa\xe7\xf5es</th>
					<th data-index="19" data-visible="${this.visible[18]}">Devolu\xe7\xe3o</th>
					<th data-index="20" data-visible="${this.visible[19]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.created_on)}</td>
					<td data-visible='${this.visible[4]}'>${await this.key('users', record.created_by)}</td>
					<td data-visible='${this.visible[5]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.updated_on) || ''}</td>
					<td data-visible='${this.visible[6]}'>${await this.key('users', record.updated_by) || ''}</td>
					<td data-visible='${this.visible[7]}'>${await this.key('customers', [
            record.company_id,
            record.customer_id
        ], 'nick') || ''}</td>
					<td data-visible='${this.visible[8]}'>${await this.key('carriers', [
            record.company_id,
            record.carrier_id
        ], 'nick') || ''}</td>
					<td data-visible='${this.visible[9]}'>${await this.key('programs', record.program_id ? [
            record.company_id,
            record.program_id
        ] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[10]}'>${this.option($3f600b215d7c6f7e$export$2e2bcd8739ae039(), record.service_channel)}</td>
					<td data-visible='${this.visible[11]}'>${this.option($4fdbc437e912097f$export$2e2bcd8739ae039(), record.payment_method)}</td>
					<td data-visible='${this.visible[12]}'>${await this.key('payment_terms', [
            record.company_id,
            record.payment_term_id
        ]) || ''}</td>
					<td data-visible='${this.visible[13]}'>${this.option($b537c438f09757c4$export$2e2bcd8739ae039(), record.freight_type) || ''}</td>
					<td data-visible='${this.visible[14]}'>${record.freight_value ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.freight_value) : ''}</td>
					<td data-visible='${this.visible[15]}'>${record.discount != null ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.discount) : ''}</td>
					<td data-visible='${this.visible[16]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.value)}</td>
					<td data-visible='${this.visible[17]}'>${record.notes || ''}</td>
					<td data-visible='${this.visible[18]}'>${this.option($16a377ceff31a9ac$export$2e2bcd8739ae039(), record.is_return)}</td>
					<td data-visible='${this.visible[19]}'>${this.option($05cf4050e889bf62$export$2e2bcd8739ae039(), record.status) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $3df4715102edd156$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#order #company_id		{ width: 10rem;		}
			#order #id				{ width: 5rem; text-align: right;	}
			#order #reference		{ width: 8rem; 		}
			#order #created_on		{ width: 10rem;		}
			#order #created_by		{ width: 10rem;		}
			#order #updated_on		{ width: 10rem;		}
			#order #updated_by		{ width: 10rem;		}
			#order #customer_id		{ width: 20rem;		}
			#order #carrier_id		{ width: 14rem;		}
			#order #program_id		{ width: 12rem;		}
			#order #service_channel	{ width: 10rem;		}
			#order #payment_method	{ width: 10rem;		}
			#order #payment_term_id	{ width: 8rem;		}
			#order #freight_type	{ width: 10rem;		}
			#order #freight_value 	{ width: 5rem; text-align: right; 	}
			#order #discount 		{ width: 4rem; text-align: right;	}
			#order #status	 		{ width: 10rem;		}
			#order .product 		{ width: 48rem;		}
			#order .lot 			{ width: 10rem;		}
			#order .unit 			{ width: 7rem;		}
			#order .quantity 		{ width: 4.5rem; text-align: right;	}
			#order .discount 		{ width: 4rem; text-align: right; 	}
			#order .price 			{ width: 6.5rem; text-align: right;	}
			#order .notes			{ width: 100%;		}
		</style>
		<form id="order" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="customers">
			</datalist>
			<datalist id="carriers">
			</datalist>
			<datalist id="programs">
			</datalist>
			<datalist id="payment_terms">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="units">
			</datalist>
			<datalist id="users">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do pedido">Pedido
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo de refer\xeancia externa">Refer\xeancia
					<input id="reference" type="text">
				</label>
				<label title="Data e hora de cria\xe7\xe3o do pedido">Data Cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Usu\xe1rio criador do pedido">Criado Por
					<input id="created_by" type="text" list="users" disabled>
				</label>
				<label title="Data e hora de altera\xe7\xe3o do pedido">Data Altera\xe7\xe3o
					<input id="updated_on" type="text" disabled>
				</label>
				<label title="\xdaltimo usu\xe1rio a alterar o pedido">Alterado Por
					<input id="updated_by" type="text" list="users" disabled>
				</label>
				<label title="Status do pedido">Status<sup>*</sup>
					<input id="status" type="text" list="order_status" value="10" required>
				</label>
				<label title="Este pedido \xe9 uma devolu\xe7\xe3o?">Devolu\xe7\xe3o
					<input id="is_return" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<label title="Cliente do pedido">Cliente<sup>*</sup>
					<input id="customer_id" type="text" list="customers" required>
				</label>
				<label title="Canal de atendimento do cliente">Atendimento<sup>*</sup>
					<input id="service_channel" type="text" list="service_channels" required>
				</label>
				<label title="Forma de pagamento">Pagamento<sup>*</sup>
					<input id="payment_method" type="text" list="payment_methods" required>
				</label>
				<label title="Condi\xe7\xe3o de pagamento">Condi\xe7\xe3o<sup>*</sup>
					<input id="payment_term_id" type="text" list="payment_terms" required>
				</label>
				<label title="Transportador do pedido">Transportador
					<input id="carrier_id" type="text" list="carriers">
				</label>
				<label title="Programa (estrutura de estoque a considerar)">Programa
					<input id="program_id" type="text" list="programs">
				</label>
				<label title="Tipo de frete">Tipo Frete
					<input id="freight_type" type="text" list="freight_types">
				</label>
				<label title="Valor do frete">Valor Frete
					<input id="freight_value" type="text">
				</label>
				<label title="Desconto sobre o valor do pedido">% Desc
					<input id="discount" type="text">
				</label>
			</div>
			<div class="fsb">
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>Lote</th>
							<th>Unidade<sup>*</sup></th>
							<th>Qtde<sup>*</sup></th>
							<th>% Desc</th>
							<th>Pre\xe7o Un<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="Lote do produto">
								<input id="lot_id-0" class="lot" type="text" list="lots-0">
							</td>
							<td title="Unidade de venda">
								<input id="unit_id-0" class="unit" type="text" list="units" required>
							</td>
							<td title="Quantidade">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
							<td title="Desconto adicional sobre o valor deste item">
								<input id="discount-0" class="discount" type="text">
							</td>
							<td title="Pre\xe7o unit\xe1rio do produto">
								<input id="unit_price-0" class="price" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<label class="notes" title="Observa\xe7\xf5es sobre o pedido">Observa\xe7\xf5es
					<textarea id="notes" rows="4"></textarea>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#order',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ]
            });
            formset.loadList('#users', 'users');
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#reference'
            },
            types: [
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#created_by'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#updated_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#updated_by'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#customer_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('customers', {
                    labels: [
                        'cnpj',
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#carrier_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('carriers', {
                    labels: [
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#service_channel'
            },
            types: [
                $3f600b215d7c6f7e$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#payment_method'
            },
            types: [
                $4fdbc437e912097f$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#payment_term_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039([
                    'company_id',
                    'customer_id'
                ]),
                $a3bd40443322c074$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#freight_type'
            },
            types: [
                $b537c438f09757c4$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#freight_value'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#discount'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('customer_id'),
                $89a9d177dbffd6c2$export$2e2bcd8739ae039(),
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#notes'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_return'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $05cf4050e889bf62$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('product_id-0'),
                $9a739ce21637de64$export$2e2bcd8739ae039('lots', {
                    labels: [
                        'lot_number'
                    ],
                    key: 'company_id',
                    range: 1
                })
            ]
        },
        {
            properties: {
                selector: '#unit_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039([
                    'company_id',
                    'product_id-0'
                ]),
                $f7ae7d91f57919c4$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('product_id-0'),
                $d0e5a3fdd77559d6$export$2e2bcd8739ae039(),
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#discount-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#unit_price-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039([
                    'product_id-0',
                    'customer_id'
                ]),
                $72c559d121507028$export$2e2bcd8739ae039(),
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(4)
            ]
        }
    ]
};



var $1cmSR = parcelRequire("1cmSR");
var $dbf2976f1c084be6$export$2e2bcd8739ae039 = async (results)=>{
    if (!results || typeof results !== 'object') return "<p>Nenhum resultado dispon\xedvel.</p>";
    const rows = [];
    for (const company_id of Object.keys(results)){
        const company_nick = (await (0, $1cmSR.default).get('companies', company_id))?.nick ?? company_id;
        for (const order_id of Object.keys(results[company_id] || {})){
            const rec = results[company_id][order_id];
            const items = rec?.items ?? [];
            rows.push(`
				<tr><td class="tal" colspan="2"><strong>${company_nick}</strong></td></tr>
				<tr><td class="tal" style="width: 140px;">Cliente</td><td class="tal">${escapeHtml(rec?.customer_nick ?? '')}</td></tr>
				<tr><td class="tal">Pedido</td><td class="tal">${order_id}</td></tr>
				<tr><td class="tal">Transportador</td><td class="tal">${escapeHtml(rec?.carrier_nick ?? '')}</td></tr>
				<tr><td class="tal">Programa</td><td class="tal">${escapeHtml(rec?.program_name ?? '')}</td></tr>
				<tr><td class="tal">% total de atendimento</td><td class="tal"><strong>${rec?.fulfillment ?? 0}%</strong></td></tr>
				<tr><td class="tal">Posi\xe7\xf5es atendidas</td><td class="tal">${rec?.positions_count ?? 0}</td></tr>
				<tr><td class="tal" colspan="2" style="padding-top: var(--space-md);">${rec?.status ?? ''}</td></tr>
				${items.length > 0 ? `
				<tr><td colspan="2" style="padding-top: var(--space-sm);">
					<table class="stats-items" style="width: 100%; border-collapse: collapse; font-size: 0.9em;">
						<thead><tr>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">SKU</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Nome</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Lote Fabricante</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Unidade</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Solicitado</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Atendido</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">%</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Posi\xe7\xe3o</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Embalagem sugerida</th>
						</tr></thead>
						<tbody>
						${items.map((it)=>`
							<tr>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.sku)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.product_name)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.lot_number)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.unit_symbol)}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.quantity_ordered ?? 0}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.quantity_supplied ?? 0}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.fulfillment_pct ?? 0}%</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.position ?? ''}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.packaging_plan || '')}</td>
							</tr>
						`).join('')}
						</tbody>
					</table>
				</td></tr>
				` : ''}
			`);
        }
    }
    function escapeHtml(s) {
        if (s == null) return '';
        const t = document.createElement('div');
        t.textContent = String(s);
        return t.innerHTML;
    }
    return `<style>
		#stats { width: 100%; border-collapse: collapse; }
		#stats td { padding: var(--space-sm); }
		.stats-items th, .stats-items td { font-weight: normal; }
	</style>
	<table id="stats">${rows.join('')}</table>`;
};



var $92e29c504550aca2$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#create-outputs #company_id		{ width: 100%; }
			#create-outputs #warehouse_id	{ width: 100%; }
		</style>
		<form id="create-outputs" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<div class="title">
				Selecione o armaz\xe9m de origem
			</div>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Armaz\xe9m">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
			</div>
			<div class="ckb">
				<label title="Incluir itens com validade vencida na busca?">
					<input id="include_expired" type="checkbox" class="dib">&nbsp;Incluir&nbsp;expirados
				</label>
				<label title="Reservar estoques ou apenas estimar percentuais de atendimento?">
					Reservar&nbsp;estoques&nbsp;<input id="reserve_flag" type="checkbox" class="dib">
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar <span id="count"></span> sa\xeddas</button>
			</div>
		</form>
	`,
    form: {
        selector: '#create-outputs',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#include_expired'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#reserve_flag'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



var $1a09accc903138ab$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#output-order-upload #company_id { width: 100%; }
			#output-order-upload #customer_id { width: 100%; }
			#output-order-upload #program_id { width: 100%; }
			#output-order-upload #file { width: 100%; }
		</style>
		<form id="output-order-upload" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="customers"></datalist>
			<datalist id="programs"></datalist>
			<div class="title">Upload de planilha para pedido de sa\xedda</div>
			<p class="mts">Planilha com colunas: <strong>SKU</strong>, <strong>Quantidade</strong> e opcionalmente <strong>Lote</strong>, <strong>Pre\xe7o</strong> ou <strong>Vlr</strong>.</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Cliente">Cliente<sup>*</sup>
					<input id="customer_id" type="text" list="customers" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Programa">Programa
					<input id="program_id" type="text" list="programs">
				</label>
			</div>
			<div class="fsb">
				<label title="Arquivo CSV ou XLSX">Arquivo<sup>*</sup>
					<input id="file" type="file" accept=".csv,.xlsx" required>
				</label>
			</div>
			<div class="mtm">
				<a id="download-template" href="#" class="link">Baixar modelo da planilha</a>
			</div>
			<div class="mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Processar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#output-order-upload',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#customers', 'customers', {
                labels: [
                    'cnpj',
                    'nick'
                ]
            });
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init?.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#customer_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('customers')
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('programs')
            ]
        },
        {
            properties: {
                selector: '#file'
            },
            types: []
        }
    ]
};



var $0193384d45a66173$export$2e2bcd8739ae039 = {
    html: `
		<form id="output-orders-print-pending-form" class="form" autocomplete="off">
			<p class="fss">Escolha o formato do Relat\xf3rio de Pend\xeancias.</p>
			<div class="fsb mtm">
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="xlsx">Excel</option>
						<option value="csv">CSV</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Gerar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#output-orders-print-pending-form'
    },
    fields: [
        {
            properties: {
                selector: '#format'
            },
            types: []
        }
    ]
};



function $b31c53df218c817e$var$downloadFile(base64Content, filename, mimeType) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mimeType
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    a.click();
    URL.revokeObjectURL(url);
}
const $b31c53df218c817e$var$outputOrders = function() {
    let output_orders_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_units, this.queryAll()).then((data)=>(0, $1cmSR.default).set('units', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, this.queryAll()).then((data)=>(0, $1cmSR.default).set('lots', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_price_lists, this.queryAll()).then((data)=>(0, $1cmSR.default).set('price_lists', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_payment_terms, this.queryAll()).then((data)=>(0, $1cmSR.default).set('payment_terms', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_customers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customers', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_carriers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('carriers', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_output_orders, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_output_order, ...JSON.parse(id));
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'items');
        },
        async saveRecord (data, old_data) {
            data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'items');
            let _record = {
                reference: data.reference,
                customer_id: Number(data.customer_id),
                carrier_id: Number(data.carrier_id),
                program_id: data.program_id != null && data.program_id !== '' ? Number(data.program_id) : null,
                service_channel: data.service_channel,
                payment_method: data.payment_method,
                payment_term_id: (data.payment_method === '90' || data.payment_method === 90) && (data.payment_term_id == null || data.payment_term_id === '') ? null : Number(data.payment_term_id),
                freight_type: data.freight_type,
                freight_value: Number(data.freight_value),
                discount: data.discount != null && data.discount !== '' ? Number(data.discount) : null,
                notes: data.notes?.trim(),
                is_return: data.is_return == '1',
                status: Number(data.status),
                items: (data.items || []).filter((item)=>item.product_id != null && item.product_id !== '' && !isNaN(Number(item.product_id))).map((item)=>({
                        product_id: Number(item.product_id),
                        lot_id: item.lot_id != null && item.lot_id !== '' && !isNaN(Number(item.lot_id)) && Number(item.lot_id) >= 0 ? Number(item.lot_id) : null,
                        unit_id: Number(item.unit_id),
                        quantity: Number(item.quantity),
                        discount: item.discount != null && item.discount !== '' ? Number(item.discount) : null,
                        unit_price: Number(item.unit_price)
                    }))
            };
            let resp;
            if (old_data) {
                // Alerta ao marcar como Concluído (40) quando ainda há pendências: altera como o pedido é informado no BI
                if (Number(data.status) === 40) {
                    const pending = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_pending_output_items, data.company_id, data.id);
                    if (Array.isArray(pending) && pending.some((item)=>(item.quantity_needed || 0) > 0)) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Este pedido n\xe3o foi totalmente atendido. Marcar como Conclu\xeddo altera o formato como o pedido \xe9 informado no BI.", "Aten\xe7\xe3o");
                }
                resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_output_order, data.company_id, data.id, _record);
            } else resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_output_order, data.company_id, _record);
            if (resp?.duplicate_reference) {
                const { id: orderId, company_nick: company_nick } = resp.duplicate_reference;
                const tenant = company_nick ? ` (empresa ${company_nick})` : '';
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`J\xe1 existe o pedido de sa\xedda n\xba ${orderId}${tenant} com essa refer\xeancia. Verifique se n\xe3o \xe9 duplicado.`, "Aten\xe7\xe3o");
            }
            return resp;
        },
        editFilter () {
            (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = await (0, $d110a042ff114667$export$94031f41c18e0637)(data, this.fieldspecs);
            this.loadPage(1);
        },
        createOutputs () {
            const showResult = async (results)=>{
                if (results == null || results === undefined) return; // Erro já tratado pelo http/notify
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(await (0, $dbf2976f1c084be6$export$2e2bcd8739ae039)(results), 'Resultados');
                this.loadPage(); // Show updated order status
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                let params = {
                    'warehouse_company_id': data.company_id,
                    'warehouse_id': Number(data.warehouse_id),
                    'reserve_flag': Boolean(data?.reserve_flag),
                    'include_expired': Boolean(data?.include_expired),
                    'ids': await this.getSelectedIds([
                        'company_id',
                        'id'
                    ])
                };
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).create_outputs, params);
                if (resp != null) await showResult(resp);
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $92e29c504550aca2$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                document.querySelector(`${fs.form.selector} #count`).innerHTML = this.getCount();
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        uploadFromSpreadsheet () {
            const showResult = (result)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)((0, $3dc30afed7448525$export$2e2bcd8739ae039)(result, 'output'), 'Resultado do upload');
                this.loadPage();
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                const formNode = document.querySelector((0, $1a09accc903138ab$export$2e2bcd8739ae039).form.selector);
                const fileInput = formNode?.querySelector('#file');
                const file = fileInput?.files?.[0];
                if (!file) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione um arquivo CSV ou XLSX.');
                    return;
                }
                const company_id = data.company_id;
                if (!company_id) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione a empresa.');
                    return;
                }
                const fd = new FormData();
                fd.append('file', file);
                fd.append('customer_id', data.customer_id);
                fd.append('program_id', data.program_id || '');
                const result = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).upload_output_order, company_id, fd);
                if (result) showResult(result);
            };
            const setupTemplateLink = (fs)=>{
                const link = fs.dialog.getNode().querySelector('#download-template');
                if (link) link.onclick = async (e)=>{
                    e.preventDefault();
                    const company_id = fs.form.getValues().company_id;
                    if (!company_id) {
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione a empresa para baixar o modelo.');
                        return;
                    }
                    const csv = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).order_upload_template, company_id);
                    if (csv && typeof csv === 'string') {
                        const blob = new Blob([
                            csv
                        ], {
                            type: 'text/csv;charset=utf-8'
                        });
                        const a = document.createElement('a');
                        a.href = URL.createObjectURL(blob);
                        a.download = 'modelo_pedido_upload.csv';
                        a.click();
                        URL.revokeObjectURL(a.href);
                    }
                };
            };
            const fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $1a09accc903138ab$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                Object.getPrototypeOf(fs).init.call(fs);
                setupTemplateLink(fs);
            })();
        },
        async printPendingOrders () {
            const crud = this;
            const ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(await crud.getSelectedIds([
                'company_id',
                'id'
            ]));
            const count = Object.values(ids).reduce((s, arr)=>s + (arr?.length || 0), 0);
            if (!count) {
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione ao menos um pedido para gerar o relat\xf3rio.", "Relat\xf3rio de Pend\xeancias");
                return;
            }
            (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $0193384d45a66173$export$2e2bcd8739ae039), async (data)=>{
                try {
                    const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_pending_output_orders, {
                        ids: ids,
                        format: data.format || 'pdf'
                    });
                    crud.clearGridSelection();
                    if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                    else if (resp?.csv) {
                        $b31c53df218c817e$var$downloadFile(resp.csv, resp.filename || 'pendencias.csv', 'text/csv;charset=utf-8');
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Download iniciado.', 'Sucesso');
                    } else if (resp?.xlsx) {
                        $b31c53df218c817e$var$downloadFile(resp.xlsx, resp.filename || 'pendencias.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Download iniciado.', 'Sucesso');
                    } else (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Nenhum dado para o relat\xf3rio.", 'Aviso');
                } catch (e) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || String(e), 'Erro');
                }
            }, {}, false);
        },
        printOrderDocument () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_output_order_document, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Gerar espelho de ${this.getCount()} pedido(s)?`, 'Espelho de Pedido', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Pedido',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do pedido'
        },
        {
            index: 3,
            field: 'reference',
            label: "Refer\xeancia",
            types: [],
            placeholder: '',
            title: "C\xf3digo de refer\xeancia externa do pedido"
        },
        {
            index: 4,
            field: 'created_on',
            label: "Data Cria\xe7\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de cria\xe7\xe3o do pedido"
        },
        {
            index: 5,
            field: 'created_by',
            label: 'Criado Por',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Autor da cria\xe7\xe3o do pedido",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 6,
            field: 'updated_on',
            label: "Data Altera\xe7\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da \xfaltima atualiza\xe7\xe3o do pedido"
        },
        {
            index: 7,
            field: 'updated_by',
            label: 'Alterado Por',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Autor da \xfaltima atualiza\xe7\xe3o do pedido",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 8,
            field: 'customer_id',
            label: 'Cliente',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Cliente',
            store: 'customers',
            labels: [
                'nick'
            ]
        },
        {
            index: 9,
            field: 'carrier_id',
            label: 'Transportador',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Transportador',
            store: 'carriers',
            labels: [
                'nick'
            ]
        },
        {
            index: 10,
            field: 'program_id',
            label: 'Programa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Programa (estrutura de estoque)',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 11,
            field: 'service_channel',
            label: 'Atendimento',
            types: [
                $3f600b215d7c6f7e$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Canal de atendimento'
        },
        {
            index: 12,
            field: 'payment_method',
            label: 'Pagamento',
            types: [
                $4fdbc437e912097f$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Forma de pagamento'
        },
        {
            index: 13,
            field: 'payment_term_id',
            label: "Condi\xe7\xe3o",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Condi\xe7\xe3o de pagamento",
            store: 'payment_terms',
            labels: [
                'name'
            ]
        },
        {
            index: 14,
            field: 'freight_type',
            label: 'Tipo Frete',
            types: [
                $b537c438f09757c4$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Tipo de frete'
        },
        {
            index: 15,
            field: 'freight_value',
            label: 'Valor Frete',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Valor do frete'
        },
        {
            index: 16,
            field: 'discount',
            label: '% Desconto',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Percentual de desconto'
        },
        {
            index: 17,
            field: 'value',
            label: 'Valor',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Valor do pedido'
        },
        {
            index: 18,
            field: 'notes',
            label: "Observa\xe7\xf5es",
            types: [],
            placeholder: '',
            title: "Observa\xe7\xf5es do pedido"
        },
        {
            index: 19,
            field: 'is_return',
            label: "Devolu\xe7\xe3o",
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Indicador de devolu\xe7\xe3o"
        },
        {
            index: 20,
            field: 'status',
            label: 'Status',
            types: [
                $05cf4050e889bf62$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Status do pedido'
        }
    ];
    let operations = [
        {
            hash: '#create-outputs',
            label: "Gerar&nbsp;sa\xeddas"
        },
        {
            hash: '#upload',
            label: 'Upload&nbsp;planilha'
        }
    ];
    let reports = [
        {
            hash: '#print-pending',
            label: "Relat\xf3rio&nbsp;de&nbsp;Pend\xeancias"
        },
        {
            hash: '#print-order-doc',
            label: 'Espelho&nbsp;de&nbsp;Pedido'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-outputs', output_orders_crud.createOutputs.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#upload', output_orders_crud.uploadFromSpreadsheet.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-pending', output_orders_crud.printPendingOrders.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-order-doc', output_orders_crud.printOrderDocument.bind(output_orders_crud));
    output_orders_crud.run('output_orders', "Pedidos&nbsp;Sa\xedda", document.getElementById('workarea'), (0, $86c74365004cd66c$export$2e2bcd8739ae039), (0, $3df4715102edd156$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $b31c53df218c817e$export$2e2bcd8739ae039 = $b31c53df218c817e$var$outputOrders;




var $1cmSR = parcelRequire("1cmSR");









async function $44077aa73868f7f8$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: center; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: center; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: left; }
			.view td:nth-child(16)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Entrada</th>
					<th data-index="4" data-visible="${this.visible[2]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[3]}">Origem</th>
					<th data-index="10" data-visible="${this.visible[4]}">Nota</th>
					<th data-index="11" data-visible="${this.visible[5]}">XML</th>
					<th data-index="5" data-visible="${this.visible[6]}">Cria\xe7\xe3o</th>
					<th data-index="6" data-visible="${this.visible[7]}">Recebimento</th>
					<th data-index="7" data-visible="${this.visible[8]}">Destinat\xe1ria</th>
					<th data-index="8" data-visible="${this.visible[9]}">Armaz\xe9m</th>
					<th data-index="15" data-visible="${this.visible[10]}">Programa</th>
					<th data-index="9" data-visible="${this.visible[11]}">Posi\xe7\xe3o</th>
					<th data-index="12" data-visible="${this.visible[12]}">Volumes</th>
					<th data-index="13" data-visible="${this.visible[13]}">Peso</th>
					<th data-index="14" data-visible="${this.visible[14]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.order_id}</td>
					<td data-visible='${this.visible[3]}'>${this.option($e3d776cc66101a71$export$2e2bcd8739ae039(), record.order_type)}</td>
					<td data-visible='${this.visible[4]}'>${record.invoice_number || ''}</td>
					<td data-visible='${this.visible[5]}'>${record.invoice_xml ? '&#10003;' : ''}</td>
					<td data-visible='${this.visible[6]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.created_on) || ''}</td>
					<td data-visible='${this.visible[7]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.received_on) || ''}</td>
					<td data-visible='${this.visible[8]}'>${await this.key('companies', record.warehouse_company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[9]}'>${await this.key('warehouses', [
            record.warehouse_company_id,
            record.warehouse_id
        ]) || ''}</td>
					<td data-visible='${this.visible[10]}'>${await this.key('programs', record.program_id ? [
            record.company_id,
            record.program_id
        ] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[11]}'>${await this.key('locations', [
            record.warehouse_company_id,
            record.warehouse_id,
            record.location_id
        ], 'address') || ''}</td>
					<td data-visible='${this.visible[12]}'>${record.volumes ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0), record.volumes) : ''}</td>
					<td data-visible='${this.visible[13]}'>${record.weight ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.weight) : ''}</td>
					<td data-visible='${this.visible[14]}'>${this.option($2d17d508d4f555c6$export$2e2bcd8739ae039(), record.status) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}
 //<td data-visible='${this.visible[10]}'>${(await this.key('locations', [record.warehouse_company_id, record.warehouse_id, record.location_id], 'address'))?.join('-') || ''}</td>





var $54d2d9a3c0d3ddd6$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input #company_id				{ width: 10rem;		}
			#input #id						{ width: 5rem; text-align: right;	}
			#input #order_id				{ width: 5rem; text-align: right;	}
			#input #order_type				{ width: 7rem; 		}
			#input #created_on				{ width: 9rem;		}
			#input #received_on				{ width: 9rem;		}
			#input #warehouse_company_id	{ width: 10rem;		}
			#input #warehouse_id			{ width: 10rem;		}
			#input #location_id				{ width: 5rem;		}
			#input #program_id				{ width: 10rem;		}
			#input #invoice_number			{ width: 7.5rem;	}
			#input #invoice_xml				{ width: 13rem;		}
			#input #volumes					{ width: 5rem; text-align: right;	}
			#input #weight					{ width: 5rem; text-align: right;	}
			#input #status	 				{ width: 10rem;		}
			#input .product 				{ width: 38rem;		}
			#input .unit 					{ width: 7rem;		}
			#input .quantity 				{ width: 4.5rem; text-align: right;	}
			#input .price 					{ width: 6.5rem; text-align: right;	}
		</style>
		<form id="input" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="units">
			</datalist>
			<datalist id="programs">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da entrada">Entrada
					<input id="id" type="text" disabled>
				</label>
				<label title="N\xfamero do pedido vinculado">Pedido<sup>*</sup>
					<input id="order_id" type="text" required>
				</label>
				<label title="Tipo do pedido vinculado">Tipo<sup>*</sup>
					<input id="order_type" type="text" list="order_types" value="I" required>
				</label>
				<label title="Data e hora de cria\xe7\xe3o da entrada">Cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Data e hora de recebimento da mercadoria">Recebimento
					<input id="received_on" type="text" disabled>
				</label>
				<label title="Status da entrada">Status<sup>*</sup>
					<input id="status" type="text" list="input_status" value="10" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa do armaz\xe9m de recebimento">Destino
					<input id="warehouse_company_id" type="text" list="companies">
				</label>
				<label title="Armaz\xe9m de recebimento">Armaz\xe9m
					<input id="warehouse_id" type="text" list="warehouses">
				</label>
				<label title="Posi\xe7\xe3o de recebimento no armaz\xe9m">Posi\xe7\xe3o
					<input id="location_id" type="text" list="locations">
				</label>
				<label title="Programa da entrada (todos os lotes desta entrada ficar\xe3o nesse programa)">Programa
					<input id="program_id" type="text" list="programs">
				</label>
				<label title="N\xfamero da nota fiscal">Nota Fiscal
					<input id="invoice_number" type="text">
				</label>
				<label class="file" ><a id="download" download="invoice.xml">XML</a>
					<input id="invoice_xml" type="file" accept=".xml, text/xml" title="Importar XML da nota fiscal">
				</label>
				<label title="N\xfamero de volumes">Volumes
					<input id="volumes" type="text">
				</label>
				<label title="Peso total dos volumes">Peso
					<input id="weight" type="text">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>Unidade<sup>*</sup></th>
							<th>Qtde<sup>*</sup></th>
							<th>Pre\xe7o Unit<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products">
							</td>
							<td title="Unidade de compra">
								<input id="unit_id-0" class="unit" type="text" list="units" required>
							</td>
							<td title="Quantidade">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
							<td title="Pre\xe7o unit\xe1rio de compra">
								<input id="unit_price-0" class="price" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#input',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            this.getFieldByName('order_id').subscribe([
                'change'
            ], this.checkCondition.bind(formset), false); // once = false
            this.getFieldByName('order_type').subscribe([
                'change'
            ], this.checkCondition.bind(formset), false); // once = false
            this.getFieldByName('invoice_xml').subscribe([
                'change'
            ], this.enableDownload.bind(formset), false); // once = false
            document.querySelector('#invoice_xml').addEventListener('change', this.fillItemsFromXML.bind(formset));
            Object.getPrototypeOf(this).init.call(this);
        },
        checkCondition (ev, publisher, value) {
            let company_id = this.form.getFieldByName('company_id').getValue();
            let order_id = this.form.getFieldByName('order_id').getValue();
            let order_type = this.form.getFieldByName('order_type').getValue();
            let key = String([
                company_id,
                order_type,
                order_id
            ]);
            if (company_id < 0 || order_type < 0 || !order_id || key == this.last_key) return;
            let is_edit = this.form.getFieldByName('id').getValue();
            if (!is_edit || is_edit && this.last_key) this.form.fillItems.call(this, company_id, order_type, order_id);
            this.last_key = key;
        },
        async fillItems (company_id, order_type, order_id) {
            let items;
            switch(order_type){
                case 'I':
                    items = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_pending_input_items, company_id, order_id);
                    break;
                case 'O':
                    let order = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_output_order, company_id, order_id);
                    items = order.items;
                    break;
            }
            if (items) {
                this.clearAllRows();
                let record = (0, $814061363397c8d7$export$bffa455ba8c619a6)({
                    'items': items
                }, 'items');
                this.appendRows((0, $814061363397c8d7$export$5eff2b09abd87cc4)(record) - this.getEnabledRowsIndices().length + 1);
                this.form.setValues(record);
                this.form.refresh();
            }
        },
        enableDownload (ev, publisher, value) {
            if (value) {
                let anchor = document.querySelector('#download');
                anchor.setAttribute('href', `data:text/xml;base64,${value}`);
                anchor.removeAttribute('disabled');
            }
        },
        fillItemsFromXML (ev) {
            let reader = new FileReader();
            reader.onloadend = async ()=>{
                let data = {
                    'company_id': this.form.getFieldByName('company_id').getValue(),
                    'order_type': this.form.getFieldByName('order_type').getValue(),
                    'order_id': this.form.getFieldByName('order_id').getValue(),
                    'file': reader.result.slice(reader.result.indexOf(',') + 1)
                };
                let result = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).import_xml, data);
                this.form.setValues((0, $814061363397c8d7$export$bffa455ba8c619a6)(result, 'items'));
                this.form.refresh();
            };
            reader.readAsDataURL(ev.target.files[0]);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_type'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $e3d776cc66101a71$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#received_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#location_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#invoice_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#invoice_xml'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $5e1493eb0305a487$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#volumes'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#weight'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $2d17d508d4f555c6$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#unit_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039([
                    'company_id',
                    'product_id-0'
                ]),
                $f7ae7d91f57919c4$export$2e2bcd8739ae039(1)
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#unit_price-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(4)
            ]
        }
    ]
};




var $1370eb70a282d012$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#inventory #company_id				{ width: 13rem;		}
			#inventory #input_id				{ width: 5rem; text-align: right;	}
			#inventory #warehouse_company_id	{ width: 13rem;		}
			#inventory #warehouse_id			{ width: 13rem;		}
			#inventory #location_id				{ width: 7.5rem;	}
			#inventory .product					{ width: 18rem;		}
			#inventory .packaging_gtin			{ width: 11rem;	}
			#inventory .packaging				{ width: 14rem;		}
			#inventory .lot						{ width: 8rem;		}
			#inventory .date					{ width: 7rem;		}
			#inventory .quantity				{ width: 4.5rem; text-align: right;	}
			#inventory .status					{ width: 8rem;		}
		</style>
		<form id="inventory" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="programs">
			</datalist>
			<div class="title">
				Confer\xeancia&nbsp;de&nbsp;Entrada
			</div>
			<div class="fsb mtm">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Identificador da entrada">Entrada
					<input id="input_id" type="text" disabled>
				</label>
				<label title="Empresa do armaz\xe9m de recebimento">Destino<sup>*</sup>
					<input id="warehouse_company_id" type="text" list="companies" required>
				</label>
				<label title="Armaz\xe9m de recebimento">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
				<label title="Posi\xe7\xe3o de recebimento no armaz\xe9m">Posi\xe7\xe3o<sup>*</sup>
					<input id="location_id" type="text" list="locations" required>
				</label>
				<label title="Programa da entrada (todos os produtos desta entrada ficar\xe3o nesse programa)">Programa<sup>*</sup>
					<input id="program_id" type="text" list="programs" required>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>GTIN emb.</th>
							<th>Embalagem</th>
							<th>Lote<sup>*</sup></th>
							<th>Data Fab<sup>*</sup></th>
							<th>Data Val<sup>*</sup></th>
							<th>Qtde<sup>*</sup></th>
							<th>Bloquear</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<input id="id-0" type="hidden">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="GTIN da embalagem (bip no coletor preenche embalagem)">
								<input id="packaging_gtin-0" class="packaging_gtin" type="text" placeholder="Bipar">
							</td>
							<td title="Embalagem do produto (cadastro)">
								<input id="product_packaging_id-0" class="packaging" type="text" list="packagings-0">
							</td>
							<td title="Numera\xe7\xe3o do lote">
								<input id="lot_number-0" class="lot" type="text" required>
							</td>
							<td title="Data de fabrica\xe7\xe3o">
								<input id="manufacture_date-0" class="date" type="text" required>
							</td>
							<td title="Data de validade">
								<input id="expiration_date-0" class="date" type="text" required>
							</td>
							<td title="Quantidade">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
							<td title="Direcionar lote para quarentena?">
								<input id="is_blocked-0" type="checkbox">
							</td>
							<input id="status-0" type="hidden">
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#inventory',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#warehouse_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#location_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#packaging_gtin-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $ca1c79f4e173f347$export$2e2bcd8739ae039(),
                $78c0baa046d6948e$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_packaging_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('product_id-0'),
                $de971e0b3c51812e$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#lot_number-0'
            },
            types: [
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#manufacture_date-0'
            },
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#expiration_date-0'
            },
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#is_blocked-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#status-0'
            },
            types: []
        }
    ]
};




var $2e208f3196f713a1$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#putaway #company_id			{ width: 11rem;		}
			#putaway #input_id				{ width: 5rem; text-align: right;	}
			#putaway #warehouse_company_id	{ width: 11rem;		}
			#putaway #warehouse_id			{ width: 11rem;		}
			#putaway .lot_id				{ width: 5rem; text-align: right;	}
			#putaway .lot					{ width: 9rem;		}
			#putaway .sku					{ width: 9rem;		}
			#putaway .product_name			{ width: 16rem;		}
			#putaway .expiration_date		{ width: 7rem;		}
			#putaway .location				{ width: 8rem;		}
			#putaway .quantity				{ width: 4.5rem; text-align: right;	}
			#putaway .putaway-hint {
				font-size: 0.85rem;
				color: #444;
				max-width: 52rem;
				margin: 0.35rem 0 0.75rem 0;
				line-height: 1.35;
			}
		</style>
		<form id="putaway" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<div class="title">
				Endere\xe7amento&nbsp;de&nbsp;Lotes
			</div>
			<p class="putaway-hint">
				Linhas v\xeam da confer\xeancia (estoque na posi\xe7\xe3o de recebimento da entrada). Preencha <strong>Posi\xe7\xe3o</strong> com o endere\xe7o final.
				Para <strong>dividir</strong> o mesmo lote em v\xe1rios endere\xe7os, use o bot\xe3o <strong>+</strong>: repita o mesmo Id Lote e distribua as quantidades (a soma por SKU deve fechar com o pedido).
			</p>
			<div class="fsb mtm">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Identificador da entrada">Entrada
					<input id="input_id" type="text" disabled>
				</label>
				<label title="Empresa do armaz\xe9m de recebimento">Destino<sup>*</sup>
					<input id="warehouse_company_id" type="text" list="companies" disabled>
				</label>
				<label title="Armaz\xe9m de recebimento">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" disabled>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Id Lote<sup>*</sup></th>
							<th>Lote</th>
							<th>SKU</th>
							<th>Produto</th>
							<th>Validade</th>
							<th>Posi\xe7\xe3o destino<sup>*</sup></th>
							<th>Qtde<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<!-- <input id="id-0" type="hidden"> -->
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Identificador do lote">
								<input id="lot_id-0" class="lot_id" type="text" required>
							</td>
							<td title="Numera\xe7\xe3o do lote">
								<input id="lot_number-0" class="lot" type="text" disabled>
							</td>
							<td title="SKU do produto">
								<input id="sku-0" class="sku" type="text" disabled>
							</td>
							<td title="Nome do produto">
								<input id="product_name-0" class="product_name" type="text" disabled>
							</td>
							<td title="Validade do lote">
								<input id="expiration_date-0" class="expiration_date" type="text" disabled>
							</td>
							<td title="Endere\xe7o final no armaz\xe9m">
								<input id="location_id-0" class="location" list="locations" type="text" required>
							</td>
							<td title="Quantidade depositada na posi\xe7\xe3o">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#putaway',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#warehouse_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        //{ properties: { selector: '#id-0' }, types: [] },
        {
            properties: {
                selector: '#lot_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#lot_number-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('lot_id-0'),
                $d799b5dade42e782$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#sku-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_name-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#expiration_date-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#location_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        }
    ]
};



const $bbd1a845e6487967$var$PURPOSE_OPTIONS_OUTPUT = `
						<option value="1" selected>Venda de mercadoria</option>
						<option value="2">Devolu\xe7\xe3o de compra ou venda</option>
						<option value="3">Baixa de estoque</option>
						<option value="4">Remessa em bonifica\xe7\xe3o</option>
						<option value="5">Remessa de amostra gr\xe1tis</option>
						<option value="6">Remessa por conta e ordem de terceiros</option>`;
/** Mesmos valores (1–6) enviados à API; rótulos e CFOP para io_type I no backend. */ const $bbd1a845e6487967$var$PURPOSE_OPTIONS_INPUT = `
						<option value="1" selected>Compra ou recebimento para comercializa\xe7\xe3o</option>
						<option value="2">Devolu\xe7\xe3o de compra ou venda</option>
						<option value="3">Outra entrada (baixa / n\xe3o especificada \u{2014} CFOP 1949/2949)</option>
						<option value="4">Bonifica\xe7\xe3o, doa\xe7\xe3o ou brinde (entrada \u{2014} CFOP 1949/2949)</option>
						<option value="5">Amostra gr\xe1tis (entrada \u{2014} CFOP 1949/2949)</option>
						<option value="6">Por conta e ordem de terceiros (entrada \u{2014} CFOP 1949/2949)</option>`;
function $bbd1a845e6487967$export$2e2bcd8739ae039(isInput) {
    const purposeBlock = isInput ? $bbd1a845e6487967$var$PURPOSE_OPTIONS_INPUT : $bbd1a845e6487967$var$PURPOSE_OPTIONS_OUTPUT;
    return {
        html: `
		<style>
			#create-invoices .purpose	{ width: 100%;	}
			#create-invoices #info		{ width: 30rem;	}
			#create-invoices #include
			{
				display: inline-block;
			}
		</style>
		<form id="create-invoices" class="form" autocomplete="off">
			<div class="title">
				Gerar notas para <span id="count"></span> <span id="io-noun">sa\xeddas</span>
			</div>
			<div class="mtl">
				<label class="purpose" title="Finalidade da emiss\xe3o (define o CFOP)">Finalidade
					<select id="purpose" required>
						${purposeBlock}
					</select>
				</label>
			</div>
			<div>
				<label title="Informa\xe7\xf5es complementares de interesse do contribuinte">Informa\xe7\xf5es Complementares
					<textarea id="info" rows="6"></textarea>
				</label>
			</div>
			<div class="tal">
				<label title="Incluir observa\xe7\xf5es dos pedidos nas informa\xe7\xf5es complementares das notas">
					<input id="include" type="checkbox" checked>
					Incluir observa\xe7\xf5es dos pedidos
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar</button>
			</div>
		</form>
	`,
        form: {
            selector: '#create-invoices',
            init (formset) {
                formset.form.eraseValues();
                Object.getPrototypeOf(this).init.call(this);
            }
        },
        fields: [
            {
                properties: {
                    selector: '#purpose'
                },
                types: [
                    $2c79fa51f8e681d4$export$2e2bcd8739ae039()
                ]
            },
            {
                properties: {
                    selector: '#info'
                },
                types: [
                    $ed60b42a52adaca6$export$2e2bcd8739ae039()
                ]
            },
            {
                properties: {
                    selector: '#include'
                },
                types: [
                    $410b568e9a67c35a$export$2e2bcd8739ae039()
                ]
            }
        ]
    };
}




var $eb194eabe879d7c6$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input-labels #company_id	{ width: 14rem;		}
			#input-labels #device_id	{ width: 30rem;		}
			#input-labels .product		{ width: 20rem;		}
			#input-labels .lot			{ width: 8rem;		}
			#input-labels .date			{ width: 7rem;		}
			#input-labels .labels		{ width: 4.5rem; text-align: right;	}
		</style>
		<form id="input-labels" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="devices">
			</datalist>
			<div class="title">
				Etiquetas&nbsp;de&nbsp;Lotes
			</div>
			<div class="fsb mtm">
				<input id="company_id" type="hidden">
				<input id="input_id" type="hidden">
				<label title="Empresa para sele\xe7\xe3o da impressora">Empresa<sup>*</sup>
					<input id="device_company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da impressora">Impressora<sup>*</sup>
					<input id="device_id" type="text" list="devices" required>
				</label>
				<label title="SIAL na AWS: envie ZPL ao agente local que envia para a impressora na rede interna">Usar agente local
					<input id="use_local_agent" type="checkbox" title="SIAL na AWS: envie ZPL ao agente local">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<!--
							<th></th>
							-->
							<th>Produto</th>
							<th>Lote</th>
							<th>Fabrica\xe7\xe3o</th>
							<th>Validade</th>
							<th>Etiquetas<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<input id="id-0" type="hidden">
							<!--
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							-->
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" disabled>
							</td>
							<td title="Numera\xe7\xe3o do lote">
								<input id="lot_number-0" class="lot" type="text" disabled>
							</td>
							<td title="Data de fabrica\xe7\xe3o">
								<input id="manufacture_date-0" class="date" type="text" disabled>
							</td>
							<td title="Data de validade">
								<input id="expiration_date-0" class="date" type="text" disabled>
							</td>
							<td title="Etiquetas">
								<input id="labels-0" class="labels" type="number" min="0" max="99" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Imprimir</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#input-labels',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#device_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#use_local_agent'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#device_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('device_company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('devices')
            ]
        },
        //{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
        {
            properties: {
                selector: '#id-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_number-0'
            },
            types: [
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#manufacture_date-0'
            },
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#expiration_date-0'
            },
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#labels-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        }
    ]
};



var $c9f6850858a9a613$export$2e2bcd8739ae039 = {
    html: `
		<style>
		</style>
		<form id="reverse-input" class="form" autocomplete="off">
			<div class="title">
				Estorno de entrada
			</div>
			<div class="mtl">
				<input id="company_id" type="hidden">
				<input id="input_id" type="hidden">
				<label title="Selecione status abaixo do atual para revers\xe3o das opera\xe7\xf5es">Status desejado:
					<input id="status" type="text" list="input_status" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Estornar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#reverse-input',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $2d17d508d4f555c6$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $ee2c059f60a8fc19$var$inputs = function() {
    let inputs_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_units, this.queryAll()).then((data)=>(0, $1cmSR.default).set('units', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, this.queryAll()).then((data)=>(0, $1cmSR.default).set('lots', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_devices, this.queryAll()).then((data)=>(0, $1cmSR.default).set('devices', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_inputs, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_input, ...JSON.parse(id));
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'items');
        },
        async editFilter () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter, {
                reloadLocations: async (formData)=>{
                    const resolved = await (0, $d110a042ff114667$export$94031f41c18e0637)(formData, this.fieldspecs);
                    const parts = [];
                    for(let i = 0; i < 10; i++){
                        const f = resolved[`field-${i}`];
                        const v = resolved[`value-${i}`];
                        if (f === 'company_id' && v) parts.push(`company_id*eq*${v}`);
                        else if (f === 'warehouse_id' && v != null && v !== '') parts.push(`warehouse_id*eq*${v}`);
                        else if (f === 'warehouse_company_id' && v) parts.push(`company_id*eq*${v}`);
                    }
                    if (parts.length === 0) return;
                    const params = new URLSearchParams();
                    params.append('filter', parts.join(','));
                    params.append('sort', '4');
                    params.append('limit', '0');
                    const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, '?' + params.toString());
                    if (data && Array.isArray(data)) (0, $1cmSR.default).set('locations', data);
                }
            });
        },
        async applyFilter (data) {
            this.filter = await (0, $d110a042ff114667$export$94031f41c18e0637)(data, this.fieldspecs);
            this.filterExplicitlyApplied = true;
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            await this.loadPage(1);
        },
        async saveRecord (data, old_data) {
            data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'items');
            let _record = {
                order_type: data.order_type,
                order_id: Number(data.order_id),
                warehouse_company_id: data.warehouse_company_id,
                warehouse_id: Number(data.warehouse_id),
                location_id: Number(data.location_id),
                program_id: data.program_id != null && data.program_id !== '' && Number(data.program_id) >= 0 ? Number(data.program_id) : null,
                invoice_number: data.invoice_number,
                invoice_xml: data.invoice_xml,
                volumes: Number(data.volumes),
                weight: Number(data.weight),
                status: Number(data.status),
                items: data.items.filter((item)=>item && item.product_id != null && item.product_id !== '' && Number(item.product_id) > 0).map((item)=>({
                        product_id: Number(item.product_id),
                        unit_id: Number(item.unit_id),
                        quantity: Number(item.quantity),
                        unit_price: Number(item.unit_price)
                    }))
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_input, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_input, data.company_id, _record);
        },
        async inventory () {
            const sendRequest = async (data)=>{
                data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'lots');
                let _record = {
                    warehouse_company_id: data.warehouse_company_id,
                    warehouse_id: Number(data.warehouse_id),
                    location_id: Number(data.location_id),
                    program_id: data.program_id != null && data.program_id !== '' ? Number(data.program_id) : null,
                    lots: data.lots.map((lot)=>{
                        const pp = lot.product_packaging_id;
                        const packaging_id = pp != null && pp !== '' && Number(pp) > 0 ? Number(pp) : null;
                        const rawId = lot.id;
                        const lotId = rawId != null && rawId !== '' ? Number(rawId) : null;
                        return {
                            id: Number.isFinite(lotId) && lotId > 0 ? lotId : null,
                            product_id: Number(lot.product_id),
                            product_packaging_id: packaging_id,
                            lot_number: lot.lot_number,
                            manufacture_date: lot.manufacture_date,
                            expiration_date: lot.expiration_date,
                            quantity: Number(lot.quantity),
                            status: Number(lot.status),
                            is_blocked: lot.is_blocked == '1' // Can be: undefined, '0', '1'
                        };
                    })
                };
                if (await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).inventory_input, data.company_id, data.input_id, _record)) {
                    (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, this.queryAll()).then((data)=>(0, $1cmSR.default).set('lots', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))); // Get new lots
                    this.loadPage(); // Show updated input status
                    return true;
                }
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione apenas uma entrada para confer\xeancia", "Confer\xeancia de Entrada");
            let input = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_input, ids[0][0], ids[0][1]);
            // Alinhado a entities/input_.py: inventory() exige status >= ST_RECEIVED (30); >= ST_VERIFIED (50) já concluiu.
            const INPUT_ST_RECEIVED = 30;
            const INPUT_ST_VERIFIED = 50;
            const st = Number(input.status);
            if (st < INPUT_ST_RECEIVED) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Conclua o recebimento desta entrada antes da confer\xeancia (status "Recebida" ou superior, por exemplo ap\xf3s registrar data de recebimento na edi\xe7\xe3o da entrada).', "Confer\xeancia de Entrada");
            if (st >= INPUT_ST_VERIFIED) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Esta entrada j\xe1 foi conferida.", "Confer\xeancia de Entrada");
            let lots = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, `?filter=company_id*eq*${input.company_id},input_id*eq*${input.id}&limit=0`);
            let _record = {
                'company_id': input.company_id,
                'input_id': input.id,
                'warehouse_company_id': input.warehouse_company_id,
                'warehouse_id': input.warehouse_id,
                'location_id': input.location_id,
                'program_id': input.program_id ?? '',
                'lots': lots.map((lot)=>{
                    lot.is_blocked = Boolean(lot.status & 8);
                    return lot;
                })
            };
            await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
            (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $1370eb70a282d012$export$2e2bcd8739ae039), sendRequest, (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'lots'));
        },
        async putAway () {
            const fmtExp = (d)=>{
                if (d == null || d === '') return '';
                const s = String(d);
                return s.length >= 10 ? s.slice(0, 10) : s;
            };
            /** Uma linha por lote na posição de recebimento; quantidades somadas se houver mais de um stock_id. */ const buildPutawayRows = (stocks, input)=>{
                const stagingId = Number(input.location_id);
                let cand = (stocks || []).filter((s)=>Number(s.location_id) === stagingId && Number(s.quantity_available) > 0);
                if (cand.length === 0) cand = (stocks || []).filter((s)=>Number(s.quantity_available) > 0);
                const byLot = new Map();
                for (const s of cand){
                    const lid = Number(s.lot_id);
                    if (!byLot.has(lid)) byLot.set(lid, {
                        lot_id: lid,
                        lot_number: s.lot_number || '',
                        sku: s.sku || '',
                        product_name: s.product_name || '',
                        expiration_date: fmtExp(s.expiration_date),
                        location_id: '',
                        quantity: 0
                    });
                    const row = byLot.get(lid);
                    row.quantity += Number(s.quantity_available || 0);
                    if (!row.lot_number && s.lot_number) row.lot_number = s.lot_number;
                    if (!row.sku && s.sku) row.sku = s.sku;
                    if (!row.product_name && s.product_name) row.product_name = s.product_name;
                    if (!row.expiration_date && s.expiration_date) row.expiration_date = fmtExp(s.expiration_date);
                }
                return [
                    ...byLot.values()
                ];
            };
            const sendRequest = async (data)=>{
                data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'puts');
                const puts = (data.puts || []).filter((put)=>put && put.lot_id != null && put.lot_id !== '' && put.location_id != null && put.location_id !== '' && Number(put.quantity) > 0).map((put)=>({
                        lot_id: Number(put.lot_id),
                        location_id: Number(put.location_id),
                        quantity: Number(put.quantity)
                    }));
                if (puts.length === 0) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Informe ao menos uma linha com posi\xe7\xe3o de destino e quantidade.", "Endere\xe7amento de Lotes");
                    return false;
                }
                const _record = {
                    puts: puts
                };
                if (await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).putaway_input, data.company_id, data.input_id, _record)) {
                    this.loadPage();
                    return true;
                }
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione apenas uma entrada para endere\xe7amento", "Endere\xe7amento de Lotes");
            let input = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_input, ids[0][0], ids[0][1]);
            let stocks = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_stocks_by_input, input.company_id, input.id);
            const putawayRows = buildPutawayRows(stocks, input);
            if (putawayRows.length === 0) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("N\xe3o h\xe1 estoque dispon\xedvel na posi\xe7\xe3o de recebimento desta entrada. Conclua a confer\xeancia ou verifique a posi\xe7\xe3o da entrada.", "Endere\xe7amento de Lotes");
            let _record = {
                'company_id': input.company_id,
                'input_id': input.id,
                'warehouse_company_id': input.warehouse_company_id,
                'warehouse_id': input.warehouse_id,
                'stocks': putawayRows
            };
            (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $2e208f3196f713a1$export$2e2bcd8739ae039), sendRequest, (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'stocks'));
        },
        printInputs () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(resp.message, 'Listagem de Entradas');
            };
            const sendRequest = async ()=>{
                let ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_inputs, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} entradas no relat\xf3rio?`, 'Listagem de Entradas', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printInputSKUs () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(resp.message, 'Cruzamento de Nota Fiscal');
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_input_skus, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} entradas na listagem?`, 'Listagem de Nota Fiscal', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printXML () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(resp.message, 'Espelho da Nota Fiscal');
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_input_xml, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Gerar espelho da nota de ${this.getCount()} entradas?`, 'Espelho da Nota Fiscal', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printPutAwayOrder () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(resp.message, "Ordem de Endere\xe7amento");
            };
            const sendRequest = async ()=>{
                let ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_putaway, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} entradas no relat\xf3rio?`, "Ordem de Endere\xe7amento", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        async printLabels () {
            const sendRequest = async (data)=>{
                data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'lots');
                let _record = {
                    device_company_id: data.device_company_id,
                    device_id: Number(data.device_id),
                    return_zpl: !!data.use_local_agent,
                    lots: data.lots.map((lot)=>({
                            lot_id: Number(lot.id),
                            labels: Number(lot.labels)
                        }))
                };
                const result = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_input_labels, data.company_id, data.input_id, _record);
                if (result?.zpl) try {
                    await (0, $73936c209f170d43$export$2e2bcd8739ae039).sendZplToAgent(result.zpl, result.printer, result.printer_key);
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Etiquetas enviadas ao agente local.', "Impress\xe3o");
                } catch (e) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || String(e), 'Agente local');
                    return false;
                }
                return result;
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione apenas uma entrada para impress\xe3o", 'Etiquetas de Lotes');
            let input = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_input, ids[0][0], ids[0][1]);
            let lots = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, `?filter=company_id*eq*${input.company_id},input_id*eq*${input.id}&limit=0`);
            let _record = {
                'company_id': input.company_id,
                'input_id': input.id,
                'lots': lots.map((lot)=>{
                    lot.labels = 1;
                    return lot;
                })
            };
            (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $eb194eabe879d7c6$export$2e2bcd8739ae039), sendRequest, (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'lots'));
        },
        printCosts () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(resp.message, "Relat\xf3rio de Custos");
            };
            const sendRequest = async ()=>{
                let ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_input_costs, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} entradas no relat\xf3rio?`, "Relat\xf3rio de Custos", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printConference () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(resp.message, "Confer\xeancia");
            };
            const sendRequest = async ()=>{
                let ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_input_conference, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} entradas no relat\xf3rio de confer\xeancia?`, "Relat\xf3rio de Confer\xeancia", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printDetails () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(resp.message, 'Entrada detalhada');
            };
            const sendRequest = async ()=>{
                let ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_input_details, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} entradas no relat\xf3rio detalhado?`, 'Entrada Detalhada', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        createInvoices () {
            const showResult = (resp)=>{
                this.clearGridSelection();
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Notas criadas: ${resp?.count || 0}`, 'Resultado');
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).create_invoices, Object.assign(data, {
                    'io_type': 'I',
                    'ids': ids
                })).then(showResult);
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $bbd1a845e6487967$export$2e2bcd8739ae039)(true), sendRequest);
            fs.init = (()=>{
                const n = this.getCount();
                document.querySelector(`${fs.form.selector} #count`).innerHTML = n;
                const noun = document.querySelector(`${fs.form.selector} #io-noun`);
                if (noun) noun.textContent = n === 1 ? 'entrada' : 'entradas';
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        async reverseInput () {
            const sendRequest = async (data)=>{
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).reverse_input, data.company_id, data.input_id, {
                    status: Number(data.status)
                });
                if (resp) this.loadPage(); // Show updated status
                return resp;
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione apenas uma entrada para estornar', 'Estorno de Entrada');
            (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $c9f6850858a9a613$export$2e2bcd8739ae039), sendRequest, {
                company_id: ids[0][0],
                input_id: ids[0][1]
            });
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Entrada',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da entrada'
        },
        {
            index: 4,
            field: 'order_id',
            label: 'Pedido',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero do pedido vinculado"
        },
        {
            index: 3,
            field: 'order_type',
            label: 'Origem',
            types: [
                $e3d776cc66101a71$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Origem do pedido vinculado'
        },
        {
            index: 10,
            field: 'invoice_number',
            label: 'Nota',
            types: [],
            placeholder: '',
            title: "N\xfamero da nota fiscal"
        },
        {
            index: 11,
            field: 'invoice_xml',
            label: 'XML',
            types: [],
            placeholder: '',
            title: 'XML da nota fiscal'
        },
        {
            index: 5,
            field: 'created_on',
            label: "Cria\xe7\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da cria\xe7\xe3o da entrada"
        },
        {
            index: 6,
            field: 'received_on',
            label: 'Recebimento',
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: 'Data e hora de recebimento da mercadoria'
        },
        {
            index: 7,
            field: 'warehouse_company_id',
            label: "Destinat\xe1ria",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Empresa do armaz\xe9m de recebimento",
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 8,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Armaz\xe9m de recebimento",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 15,
            field: 'program_id',
            label: 'Programa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Programa da entrada',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 9,
            field: 'location_id',
            label: "Posi\xe7\xe3o",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o no armaz\xe9m",
            store: 'locations',
            labels: [
                'address'
            ],
            separator: '-'
        },
        {
            index: 12,
            field: 'volumes',
            label: 'Volumes',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero de volumes"
        },
        {
            index: 13,
            field: 'weight',
            label: 'Peso',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: 'Peso total dos volumes'
        },
        {
            index: 14,
            field: 'status',
            label: 'Status',
            types: [
                $2d17d508d4f555c6$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Status da entrada'
        }
    ];
    let operations = [
        {
            hash: '#inventory-input',
            label: "Confer\xeancia&nbsp;de&nbsp;Entrada"
        },
        {
            hash: '#submit-putaway',
            label: "Endere\xe7amento&nbsp;de&nbsp;Lotes"
        },
        {
            hash: '#create-invoices',
            label: 'Gerar&nbsp;Notas&nbsp;Fiscais'
        },
        {
            hash: '#reverse-input',
            label: 'Estornar&nbsp;Entrada'
        }
    ];
    let reports = [
        {
            hash: '#print-inputs',
            label: 'Listagem&nbsp;de&nbsp;Entradas'
        },
        {
            hash: '#print-skus',
            label: 'Cruzamento&nbsp;de&nbsp;Nota&nbsp;Fiscal'
        },
        {
            hash: '#print-xml',
            label: 'Espelho&nbsp;da&nbsp;Nota&nbsp;Fiscal'
        },
        {
            hash: '#print-putaway',
            label: "Ordem&nbsp;de&nbsp;Endere\xe7amento"
        },
        {
            hash: '#print-labels',
            label: 'Etiquetas&nbsp;de&nbsp;Lotes'
        },
        {
            hash: '#print-costs',
            label: "Relat\xf3rio&nbsp;de&nbsp;Custos"
        },
        {
            hash: '#print-conference',
            label: "Relat\xf3rio&nbsp;de&nbsp;Confer\xeancia"
        },
        {
            hash: '#print-details',
            label: 'Entrada&nbsp;Detalhada'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-input', inputs_crud.inventory.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#submit-putaway', inputs_crud.putAway.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-invoices', inputs_crud.createInvoices.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#reverse-input', inputs_crud.reverseInput.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-inputs', inputs_crud.printInputs.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-skus', inputs_crud.printInputSKUs.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-xml', inputs_crud.printXML.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-putaway', inputs_crud.printPutAwayOrder.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-labels', inputs_crud.printLabels.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-costs', inputs_crud.printCosts.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-conference', inputs_crud.printConference.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-details', inputs_crud.printDetails.bind(inputs_crud));
    inputs_crud.run('inputs', 'Entradas', document.getElementById('workarea'), (0, $44077aa73868f7f8$export$2e2bcd8739ae039), (0, $54d2d9a3c0d3ddd6$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $ee2c059f60a8fc19$export$2e2bcd8739ae039 = $ee2c059f60a8fc19$var$inputs;




var $1cmSR = parcelRequire("1cmSR");




async function $7620a66f512a3069$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: right; }
			.view td:nth-child(11)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Lote</th>
					<th data-index="3" data-visible="${this.visible[2]}">Entrada</th>
					<th data-index="4" data-visible="${this.visible[3]}">Produto</th>
					<th data-index="5" data-visible="${this.visible[4]}">Programa</th>
					<th data-index="6" data-visible="${this.visible[5]}">Numera\xe7\xe3o</th>
					<th data-index="7" data-visible="${this.visible[6]}">Fabrica\xe7\xe3o</th>
					<th data-index="8" data-visible="${this.visible[7]}">Validade</th>
					<th data-index="9" data-visible="${this.visible[8]}">Quantidade</th>
					<th data-index="10" data-visible="${this.visible[9]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.input_id}</td>
					<td data-visible='${this.visible[3]}'>${await this.key('products', [
            record.company_id,
            record.product_id
        ])}</td>
					<td data-visible='${this.visible[4]}'>${record.program_id != null ? await this.key('programs', [
            record.company_id,
            record.program_id
        ]) || record.program_id : "\u2014"}</td>
					<td data-visible='${this.visible[5]}'>${(0, $7c7f18e63e55bfe1$export$d7959d098aba6524)(record.lot_number)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($0c9c948f6a5e1eb3$export$2e2bcd8739ae039(), record.manufacture_date)}</td>
					<td data-visible='${this.visible[7]}'>${this.format($0c9c948f6a5e1eb3$export$2e2bcd8739ae039(), record.expiration_date)}</td>
					<td data-visible='${this.visible[8]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0), record.quantity)}</td>
					<td data-visible='${this.visible[9]}'>${this.option($84a270a7f3d1546a$export$2e2bcd8739ae039(), record.status) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $64c577998e25bd04$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#lot #company_id		{ width: 10rem;		}
			#lot #id				{ width: 5rem; text-align: right;	}
			#lot #input_id			{ width: 5rem; text-align: right;	}
			#lot #product_id		{ width: 20rem;		}
			#lot #lot_number		{ width: 10rem;		}
			#lot #manufacture_date	{ width: 7rem;		}
			#lot #expiration_date	{ width: 7rem;		}
			#lot #quantity			{ width: 5rem; text-align: right;	}
			#lot #status			{ width: 10rem;		}
		</style>
		<form id="lot" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="products">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do lote">Lote
					<input id="id" type="text" disabled>
				</label>
				<label title="N\xfamero da entrada">Entrada<sup>*</sup>
					<input id="input_id" type="text" required>
				</label>
				<label title="Produto">Produto<sup>*</sup>
					<input id="product_id" type="text" list="products" required>
				</label>
			</div>
			<div>
				<label title="Numera\xe7\xe3o do lote">Numera\xe7\xe3o<sup>*</sup>
					<input id="lot_number" type="text" required>
				</label>
				<label title="Data de fabrica\xe7\xe3o">Fabrica\xe7\xe3o<sup>*</sup>
					<input id="manufacture_date" type="text" required>
				</label>
				<label title="Data de validade">Validade<sup>*</sup>
					<input id="expiration_date" type="text" required>
				</label>
				<label title="Quantidade">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
				<label title="Status do lote">Status<sup>*</sup>
					<input id="status" type="text" list="lot_status" value="10" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#lot',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#product_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#manufacture_date'
            },
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#expiration_date'
            },
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $84a270a7f3d1546a$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $a9f17bf16ff5b79a$var$lots = function() {
    let lots_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_lot, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                input_id: Number(data.input_id),
                product_id: Number(data.product_id),
                lot_number: data.lot_number,
                manufacture_date: data.manufacture_date,
                expiration_date: data.expiration_date,
                quantity: Number(data.quantity),
                status: Number(data.status)
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_lot, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_lot, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Lote',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do lote'
        },
        {
            index: 3,
            field: 'input_id',
            label: 'Entrada',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero da entrada de lote"
        },
        {
            index: 4,
            field: 'product_id',
            label: 'Produto',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Produto',
            store: 'products',
            labels: [
                'name'
            ]
        },
        {
            index: 5,
            field: 'program_id',
            label: 'Programa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Programa (somente leitura)',
            store: 'programs',
            labels: [
                'name'
            ],
            readOnly: true
        },
        {
            index: 6,
            field: 'lot_number',
            label: "Numera\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Numera\xe7\xe3o do lote"
        },
        {
            index: 7,
            field: 'manufacture_date',
            label: "Fabrica\xe7\xe3o",
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa',
            title: "Data de fabrica\xe7\xe3o do lote"
        },
        {
            index: 8,
            field: 'expiration_date',
            label: 'Validade',
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa',
            title: 'Data de validade do lote'
        },
        {
            index: 9,
            field: 'quantity',
            label: 'Quantidade',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade do lote'
        },
        {
            index: 10,
            field: 'status',
            label: 'Status',
            types: [
                $84a270a7f3d1546a$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Status do lote'
        }
    ];
    lots_crud.run('lots', 'Lotes', document.getElementById('workarea'), (0, $7620a66f512a3069$export$2e2bcd8739ae039), (0, $64c577998e25bd04$export$2e2bcd8739ae039), fieldspecs);
};
var $a9f17bf16ff5b79a$export$2e2bcd8739ae039 = $a9f17bf16ff5b79a$var$lots;




var $1cmSR = parcelRequire("1cmSR");









async function $8263a0b89abdc114$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(6)	{ text-align: center; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: right; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: right; }
			.view td:nth-child(16)	{ text-align: left; }
			.view td:nth-child(17)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Sa\xedda</th>
					<th data-index="4" data-visible="${this.visible[2]}">Pedido</th>
					<th data-index="16" data-visible="${this.visible[3]}">Refer\xeancia</th>
					<th data-index="15" data-visible="${this.visible[4]}">Programa</th>
					<th data-index="3" data-visible="${this.visible[5]}">Origem</th>
					<th data-index="5" data-visible="${this.visible[6]}">Cria\xe7\xe3o</th>
					<th data-index="6" data-visible="${this.visible[7]}">Expedi\xe7\xe3o</th>
					<th data-index="7" data-visible="${this.visible[8]}">Remetente</th>
					<th data-index="8" data-visible="${this.visible[9]}">Armaz\xe9m</th>
					<th data-index="9" data-visible="${this.visible[10]}">Tipo Volumes</th>
					<th data-index="10" data-visible="${this.visible[11]}">Volumes</th>
					<th data-index="11" data-visible="${this.visible[12]}">Peso</th>
					<th data-index="12" data-visible="${this.visible[13]}">Custo Total</th>
					<th data-index="13" data-visible="${this.visible[14]}">Pre\xe7o Total</th>
					<th data-index="14" data-visible="${this.visible[15]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.order_id}</td>
					<td data-visible='${this.visible[3]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[4]}'>${await this.key('programs', record.program_id ? [
            record.company_id,
            record.program_id
        ] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[5]}'>${this.option($e3d776cc66101a71$export$2e2bcd8739ae039(), record.order_type)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.created_on)}</td>
					<td data-visible='${this.visible[7]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.expedited_on) || ''}</td>
					<td data-visible='${this.visible[8]}'>${await this.key('companies', record.warehouse_company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[9]}'>${await this.key('warehouses', [
            record.warehouse_company_id,
            record.warehouse_id
        ]) || ''}</td>
					<td data-visible='${this.visible[10]}'>${this.option($a3e4f853566e7a28$export$2e2bcd8739ae039(), record.volume_type) || ''}</td>
					<td data-visible='${this.visible[11]}'>${record.volumes ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(0), record.volumes) : ''}</td>
					<td data-visible='${this.visible[12]}'>${record.weight ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(3), record.weight) : ''}</td>
					<td data-visible='${this.visible[13]}'>${record.total_cost ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.total_cost) : ''}</td>
					<td data-visible='${this.visible[14]}'>${record.total_price ? this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.total_price) : ''}</td>
					<td data-visible='${this.visible[15]}'>${this.option($f08968bc7ef228cb$export$2e2bcd8739ae039(), record.status) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}





var $6c379cd70cdf065a$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#output #company_id				{ width: 10rem;		}
			#output #id						{ width: 5.5rem; text-align: right;	}
			#output #order_id				{ width: 5.5rem; text-align: right;	}
			#output #order_type				{ width: 10rem;		}
			#output #warehouse_company_id 	{ width: 10rem;		}
			#output #warehouse_id			{ width: 10rem;		}
			#output #created_on				{ width: 10rem;		}
			#output #expedited_on			{ width: 10rem;		}
			#output #volume_type			{ width: 10rem;		}
			#output #volumes				{ width: 5rem; text-align: right;	}
			#output #weight					{ width: 6rem; text-align: right;	}
			#output #status	 				{ width: 10rem;		}
			#output .location 				{ width: 5rem;		}
			#output .product 				{ width: 25rem;		}
			#output .lot 					{ width: 8rem;		}
			#output .quantity 				{ width: 4.5rem; text-align: right;	}
			#output .discount 				{ width: 4rem; text-align: right; 	}
			#output .price 					{ width: 6.5rem; text-align: right;	}
		</style>
		<form id="output" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="programs">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da sa\xedda">Sa\xedda
					<input id="id" type="text" disabled>
				</label>
				<label title="N\xfamero do pedido vinculado">Pedido<sup>*</sup>
					<input id="order_id" type="text" required>
				</label>
				<label title="Tipo do pedido vinculado">Tipo<sup>*</sup>
					<input id="order_type" type="text" list="order_types" value="I" disabled>
				</label>
				<label title="Programa da sa\xedda (do pedido)">Programa
					<input id="program_id" type="text" list="programs" disabled>
				</label>
				<label title="Refer\xeancia do pedido">Refer\xeancia
					<input id="reference" type="text" disabled>
				</label>
				<label title="Data e hora de cria\xe7\xe3o da sa\xedda">Cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Data e hora de expedi\xe7\xe3o da sa\xedda">Expedi\xe7\xe3o
					<input id="expedited_on" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa do armaz\xe9m de coleta">Remetente<sup>*</sup>
					<input id="warehouse_company_id" type="text" list="companies" required>
				</label>
				<label title="Armaz\xe9m de coleta">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
				<label title="Tipo de volumes">Tipo Volumes
					<input id="volume_type" type="text" list="volume_types" value="C">
				</label>
				<label title="N\xfamero de volumes">Volumes
					<input id="volumes" type="text">
				</label>
				<label title="Peso total dos volumes">Peso
					<input id="weight" type="text">
				</label>
				<label title="Status da sa\xedda">Status<sup>*</sup>
					<input id="status" type="text" list="output_status" value="10" required>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Posi\xe7\xe3o<sup>*</sup></th>
							<th>Produto<sup>*</sup></th>
							<th>Lote<sup>*</sup></th>
							<th>Qt Req<sup>*</sup></th>
							<th>Qt Forn</th>
							<th>% Desc</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Posi\xe7\xe3o de coleta no armaz\xe9m">
								<input id="location_id-0" class="location" type="text" list="locations" required>
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="Lote do produto">
								<input id="lot_id-0" class="lot" type="text" list="lots-0" required>
							</td>
							<td title="Quantidade pendente para envio">
								<input id="quantity_required-0" class="quantity" type="text" required>
							</td>
							<td title="Quantidade fornecida nesta sa\xedda">
								<input id="quantity_supplied-0" class="quantity" type="text">
							</td>
							<td title="Desconto atribu\xeddo ao produto">
								<input id="discount-0" class="discount" type="text" disabled>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#output',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ],
                value: 'id'
            });
            this.getFieldByName('company_id').subscribe([
                'change'
            ], this.checkCondition.bind(formset), false); // once = false
            this.getFieldByName('order_id').subscribe([
                'change'
            ], this.checkCondition.bind(formset), false); // once = false
            Object.getPrototypeOf(this).init.call(this);
        },
        checkCondition (ev, publisher, value) {
            let company_id = this.form.getFieldByName('company_id').getValue();
            let order_id = this.form.getFieldByName('order_id').getValue();
            let key = String([
                company_id,
                order_id
            ]);
            if (typeof company_id != 'string' || !order_id || key == this.last_key) return;
            let is_edit = this.form.getFieldByName('id').getValue();
            if (!is_edit || is_edit && this.last_key) this.form.fillItems.call(this, company_id, order_id);
            this.last_key = key;
        },
        async fillItems (company_id, order_id) {
            let record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_input_order, company_id, order_id);
            if (!record) return;
            record.items = record.items.map((item)=>{
                item.quantity_required = item.quantity;
                return item;
            });
            record = (0, $814061363397c8d7$export$bffa455ba8c619a6)(record, 'items');
            this.clearAllRows();
            this.appendRows((0, $814061363397c8d7$export$5eff2b09abd87cc4)(record) - this.getEnabledRowsIndices().length + 1);
            this.form.setValues(record);
            this.form.refresh();
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_type'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $e3d776cc66101a71$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#reference'
            },
            types: []
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#expedited_on'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('warehouses')
            ]
        },
        {
            properties: {
                selector: '#volume_type'
            },
            types: [
                $a3e4f853566e7a28$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#volumes'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#weight'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $f08968bc7ef228cb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#location_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('warehouse_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('product_id-0'),
                $9a739ce21637de64$export$2e2bcd8739ae039('lots', {
                    labels: [
                        'lot_number'
                    ],
                    key: 'company_id',
                    range: 1
                })
            ]
        },
        {
            properties: {
                selector: '#quantity_required-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_supplied-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#discount-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        }
    ]
};




var $a074d6080f330759$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#import #company_id	{ width: 10rem;	}
			#import #output_id	{ width: 5rem; text-align: right;	}
			#import #file		{ width: 15.5rem;	}
		</style>
		<form id="import" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="title">
				Importar Pick List
			</div>
			<div class="mtl">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="N\xfamero da sa\xedda">Sa\xedda<sup>*</sup>
					<input id="output_id" type="text" required>
				</label>
			</div>
			<div>
				<label class="file" title="Planilha contendo picking list">Arquivo
					<input id="file" type="file" accept=".xlsx, application/vnd.ms-excel" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Importar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#import',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#file'
            },
            types: [
                $5e1493eb0305a487$export$2e2bcd8739ae039()
            ]
        }
    ]
};




var $b50b0cd1ea086803$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#output-labels #company_id	{ width: 14rem;		}
			#output-labels #device_id	{ width: 25rem;		}
			#output-labels .company		{ width: 8rem;		}
			#output-labels .output		{ width: 4rem; text-align: right;	}
			#output-labels .order_id	{ width: 4rem; text-align: right;	}
			#output-labels .order_type	{ width: 5rem;		}
			#output-labels .name		{ width: 14rem;		}
			#output-labels .volume		{ width: 3rem; text-align: right;	}
		</style>
		<form id="output-labels" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="devices">
			</datalist>
			<div class="title">
				Etiquetas&nbsp;de&nbsp;Volumes
			</div>
			<div class="fsb mtm">
				<input id="company_id" type="hidden">
				<input id="output_id" type="hidden">
				<label title="Empresa para sele\xe7\xe3o da impressora">Empresa<sup>*</sup>
					<input id="device_company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da impressora">Impressora<sup>*</sup>
					<input id="device_id" type="text" list="devices" required>
				</label>
				<label title="SIAL na AWS: envie ZPL ao agente local que envia para a impressora na rede interna">Usar agente local
					<input id="use_local_agent" type="checkbox" title="SIAL na AWS: envie ZPL ao agente local">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<!--
							<th></th>
							-->
							<th>Empresa</th>
							<th>Sa\xedda</th>
							<th>Pedido</th>
							<th>Origem</th>
							<th>Cliente/Fornecedor</th>
							<th>Vol Ini<sup>*</sup></th>
							<th>Vol Fin<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<input id="id-0" type="hidden">
							<!--
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							-->
							<td title="Empresa titular da sa\xedda">
								<input id="company_id-0" class="company" type="text" list="companies" disabled>
							</td>
							<td title="Identificador da sa\xedda">
								<input id="output_id-0" class="output" type="text" disabled>
							</td>
							<td title="Identificador do pedido">
								<input id="order_id-0" class="order_id" type="text" disabled>
							</td>
							<td title="Origem do pedido">
								<input id="order_type-0" class="order_type" type="text" disabled>
							</td>
							<td title="Nome do cliente ou fornecedor">
								<input id="name-0" class="name" type="text" disabled>
							</td>
							<td title="Volume inicial a imprimir">
								<input id="first_volume-0" class="volume" type="number" min="0" max="99" required>
							</td>
							<td title="Volume final a imprimir">
								<input id="last_volume-0" class="volume" type="number" min="0" max="99" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Imprimir</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#output-labels',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            // Definir minimos e máximos dos volumes com base nos dados recebidos?
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#device_company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#use_local_agent'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#device_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('device_company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('devices')
            ]
        },
        //{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
        {
            properties: {
                selector: '#id-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#company_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#output_id-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_id-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_type-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $e3d776cc66101a71$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#name-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#first_volume-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#last_volume-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        }
    ]
};



var $1cmSR = parcelRequire("1cmSR");
var $8930cf174b3182ba$export$2e2bcd8739ae039 = async (results)=>`<style>
	#results 
	{ 
		width: 100%; 
		border-collapse: collapse; 
	}
	#results td 
	{ 
		border: 1px solid lightgray;
		padding: var(--space-sm); 
	}
</style>
<table id="results" style="width: 100%;">` + (await Promise.all(Object.keys(results).map(async (company_id)=>`<tr>` + `<td class="tac" colspan="3">${(await (0, $1cmSR.default).get('companies', company_id)).nick}</td>` + `</tr>` + Object.keys(results[company_id]).map((output)=>`<tr>` + `<td class="tal">Sa\xedda&nbsp;${output}</td>` + `<td class="tal">${results[company_id][output]['status']}</td>` + `</tr>`).join('')))).join('') + `</table>`;



var $b86df1d299d2d5ba$export$2e2bcd8739ae039 = {
    html: `
		<style>
		</style>
		<form id="reverse-output" class="form" autocomplete="off">
			<div class="title">
				Estorno de sa\xedda
			</div>
			<div class="mtl">
				<input id="company_id" type="hidden">
				<input id="output_id" type="hidden">
				<label title="Selecione status abaixo do atual para revers\xe3o das opera\xe7\xf5es">Status desejado:
					<input id="status" type="text" list="output_status" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Estornar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#reverse-output',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $f08968bc7ef228cb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $9bfec621929b0c49$var$outputs = function() {
    let outputs_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_lots, this.queryAll()).then((data)=>(0, $1cmSR.default).set('lots', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_devices, this.queryAll()).then((data)=>(0, $1cmSR.default).set('devices', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_outputs, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_output, ...JSON.parse(id));
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'items');
        },
        editRecord (data) {
            (0, $814061363397c8d7$export$2e2bcd8739ae039).edit(this.record_form, this.saveRecordWrapper.bind(this), data, false); // false = turn off autorow for this module
        },
        async editFilter () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            (0, $d110a042ff114667$export$2e2bcd8739ae039).edit(this.applyFilter.bind(this), this.filter, {
                reloadLocations: async (formData)=>{
                    const resolved = await (0, $d110a042ff114667$export$94031f41c18e0637)(formData, this.fieldspecs);
                    const parts = [];
                    for(let i = 0; i < 10; i++){
                        const f = resolved[`field-${i}`];
                        const v = resolved[`value-${i}`];
                        if (f === 'company_id' && v) parts.push(`company_id*eq*${v}`);
                        else if (f === 'warehouse_id' && v != null && v !== '') parts.push(`warehouse_id*eq*${v}`);
                        else if (f === 'warehouse_company_id' && v) parts.push(`company_id*eq*${v}`);
                    }
                    if (parts.length === 0) return;
                    const params = new URLSearchParams();
                    params.append('filter', parts.join(','));
                    params.append('sort', '4');
                    params.append('limit', '0');
                    const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, '?' + params.toString());
                    if (data && Array.isArray(data)) (0, $1cmSR.default).set('locations', data);
                }
            });
        },
        async applyFilter (data) {
            this.filter = await (0, $d110a042ff114667$export$94031f41c18e0637)(data, this.fieldspecs);
            this.filterExplicitlyApplied = true;
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            await this.loadPage(1);
        },
        async saveRecord (data, old_data) {
            data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'items');
            if (!data.items) return;
            let _record = {
                order_type: data.order_type,
                order_id: Number(data.order_id),
                warehouse_company_id: data.warehouse_company_id,
                warehouse_id: Number(data.warehouse_id),
                volume_type: data.volume_type ?? null,
                volumes: Number(data.volumes),
                weight: Number(data.weight),
                status: Number(data.status),
                items: data.items.filter((item)=>item && item.product_id != null && item.product_id !== '' && Number(item.product_id) > 0).map((item)=>({
                        location_id: Number(item.location_id),
                        product_id: Number(item.product_id),
                        lot_id: item.lot_id > 0 ? Number(item.lot_id) : null,
                        quantity_required: Number(item.quantity_required),
                        quantity_supplied: Number(item.quantity_supplied),
                        discount: Number(item.discount),
                        unit_cost: 0,
                        unit_price: 0
                    }))
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_output, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_output, data.company_id, _record);
        },
        cancelOutputs () {
            const showResult = async (results)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(await (0, $8930cf174b3182ba$export$2e2bcd8739ae039)(results), 'Resultados');
                this.loadPage();
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).cancel_outputs, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Cancelar reservas de ${this.getCount()} sa\xeddas?`, "Cancelar Sa\xeddas", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        createInvoices () {
            const showResult = (resp)=>{
                this.clearGridSelection();
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Notas criadas: ${resp?.count || 0}`, 'Resultado');
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).create_invoices, Object.assign(data, {
                    'io_type': 'O',
                    'ids': ids
                })).then(showResult);
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $bbd1a845e6487967$export$2e2bcd8739ae039)(false), sendRequest);
            fs.init = (()=>{
                const n = this.getCount();
                document.querySelector(`${fs.form.selector} #count`).innerHTML = n;
                const noun = document.querySelector(`${fs.form.selector} #io-noun`);
                if (noun) noun.textContent = n === 1 ? "sa\xedda" : "sa\xeddas";
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        closeOutputs () {
            const showResult = async (results)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(await (0, $8930cf174b3182ba$export$2e2bcd8739ae039)(results), 'Resultados');
                this.loadPage();
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).close_outputs, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Dar baixa de ${this.getCount()} sa\xeddas?`, 'Baixar Estoques', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printPickControl () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_pick_control, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} sa\xeddas no relat\xf3rio?`, 'Controle de Picking', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printPalletsOverturn () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_pallets_overturn, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} sa\xeddas no relat\xf3rio?`, 'Derrubada de Pallets', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printPickLists () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_picklists, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} sa\xeddas no relat\xf3rio?`, 'Pick List', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printAvisoRemessa () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_aviso_remessa, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} sa\xeddas no Aviso de Remessa?`, 'Aviso de Remessa', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printConference () {
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_conference, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} sa\xeddas no relat\xf3rio de confer\xeancia?`, "Confer\xeancia de Sa\xedda", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        async printLabels () {
            const sendRequest = async (data)=>{
                data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'outputs');
                let _record = {
                    device_company_id: data.device_company_id,
                    device_id: Number(data.device_id),
                    return_zpl: !!data.use_local_agent,
                    outputs: data.outputs.map((output)=>({
                            company_id: output.company_id,
                            output_id: Number(output.output_id),
                            first_volume: Number(output.first_volume),
                            last_volume: Number(output.last_volume)
                        }))
                };
                const result = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_output_labels, _record);
                if (result?.zpl) try {
                    await (0, $73936c209f170d43$export$2e2bcd8739ae039).sendZplToAgent(result.zpl, result.printer, result.printer_key);
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Etiquetas enviadas ao agente local.', "Impress\xe3o");
                } catch (e) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || String(e), 'Agente local');
                    return false;
                }
                return result;
            };
            const editVolumes = async (data)=>{
                this.clearGridSelection();
                let _record = {
                    'orders': data
                };
                (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $b50b0cd1ea086803$export$2e2bcd8739ae039), sendRequest, (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'orders'));
            };
            const getVolumes = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_output_volumes, {
                    'ids': ids
                }).then(editVolumes);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Incluir ${this.getCount()} sa\xeddas na impress\xe3o?`, 'Etiquetas de Volumes', (answer)=>{
                if (answer == 'Y') getVolumes();
            });
        },
        async reverseOutput () {
            const sendRequest = async (data)=>{
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).reverse_output, data.company_id, data.output_id, {
                    status: Number(data.status)
                });
                if (resp) this.loadPage(); // Show updated status
                return resp;
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione apenas uma sa\xedda para estornar", "Estorno de Sa\xedda");
            (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $b86df1d299d2d5ba$export$2e2bcd8739ae039), sendRequest, {
                company_id: ids[0][0],
                output_id: ids[0][1]
            });
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Sa\xedda",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "Identificador da sa\xedda"
        },
        {
            index: 4,
            field: 'order_id',
            label: 'Pedido',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero do pedido vinculado"
        },
        {
            index: 15,
            field: 'program_id',
            label: 'Programa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Programa da sa\xedda",
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 16,
            field: 'reference',
            label: "Refer\xeancia",
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Refer\xeancia do pedido"
        },
        {
            index: 3,
            field: 'order_type',
            label: 'Origem',
            types: [
                $e3d776cc66101a71$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Origem do pedido vinculado'
        },
        {
            index: 5,
            field: 'created_on',
            label: "Cria\xe7\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da cria\xe7\xe3o da sa\xedda"
        },
        {
            index: 6,
            field: 'expedited_on',
            label: "Expedi\xe7\xe3o",
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de expedi\xe7\xe3o da sa\xedda"
        },
        {
            index: 7,
            field: 'warehouse_company_id',
            label: 'Remetente',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Empresa do armaz\xe9m de coleta",
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 8,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Armaz\xe9m de coleta",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 9,
            field: 'volume_type',
            label: 'Tipo Volume',
            types: [
                $a3e4f853566e7a28$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Tipo de volume'
        },
        {
            index: 10,
            field: 'volumes',
            label: 'Volumes',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero de volumes"
        },
        {
            index: 11,
            field: 'weight',
            label: 'Peso',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(3)
            ],
            placeholder: '0,000',
            title: 'Peso total dos volumes'
        },
        {
            index: 12,
            field: 'total_cost',
            label: 'Custo Total',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: "Custo total da sa\xedda"
        },
        {
            index: 13,
            field: 'total_price',
            label: "Pre\xe7o Total",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: "Pre\xe7o total da sa\xedda"
        },
        {
            index: 14,
            field: 'status',
            label: 'Status',
            types: [
                $f08968bc7ef228cb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Status da sa\xedda"
        }
    ];
    let operations = [
        {
            hash: '#cancel-outputs',
            label: 'Cancelar&nbsp;Reservas'
        },
        {
            hash: '#create-invoices',
            label: 'Gerar&nbsp;notas&nbsp;fiscais'
        },
        {
            hash: '#close-outputs',
            label: 'Baixar&nbsp;Estoques'
        },
        {
            hash: '#reverse-output',
            label: "Estornar&nbsp;Sa\xedda"
        }
    ];
    let reports = [
        {
            hash: '#print-control',
            label: 'Controle&nbsp;de&nbsp;Picking'
        },
        {
            hash: '#print-pallets',
            label: 'Derrubada&nbsp;de&nbsp;Pallets'
        },
        {
            hash: '#print-picklists',
            label: 'Pick&nbsp;Lists'
        },
        {
            hash: '#print-ar',
            label: 'Aviso&nbsp;de&nbsp;Remessa'
        },
        {
            hash: '#print-conference',
            label: "Confer\xeancia&nbsp;de&nbsp;Sa\xedda"
        },
        {
            hash: '#print-labels',
            label: 'Etiquetas&nbsp;de&nbsp;Volumes'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#cancel-outputs', outputs_crud.cancelOutputs.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-invoices', outputs_crud.createInvoices.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#close-outputs', outputs_crud.closeOutputs.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#reverse-output', outputs_crud.reverseOutput.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-control', outputs_crud.printPickControl.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-pallets', outputs_crud.printPalletsOverturn.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-picklists', outputs_crud.printPickLists.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-ar', outputs_crud.printAvisoRemessa.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-conference', outputs_crud.printConference.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-labels', outputs_crud.printLabels.bind(outputs_crud));
    outputs_crud.run('outputs', "Sa\xeddas", document.getElementById('workarea'), (0, $8263a0b89abdc114$export$2e2bcd8739ae039), (0, $6c379cd70cdf065a$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $9bfec621929b0c49$export$2e2bcd8739ae039 = $9bfec621929b0c49$var$outputs;




var $1cmSR = parcelRequire("1cmSR");






async function $561045a268ce7b0e$export$2e2bcd8739ae039(records) {
    const dataId = (r)=>r._source === 'customer' ? JSON.stringify([
            r.company_id,
            r.id,
            'customer'
        ]) : JSON.stringify([
            r.company_id,
            r.id
        ]);
    const listCol = (r)=>r._source === 'customer' ? r.lista_display || r.name : r.id;
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: right; }
			.view td:nth-child(6)	{ text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Lista</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="5" data-visible="${this.visible[4]}">Qtd SKUs</th>
					<th data-index="4" data-visible="${this.visible[3]}">% Desconto</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${dataId(record)}'>
					<td><input type="checkbox"${this.isChecked(dataId(record))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${listCol(record)}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[4]}'>${record.sku_count ?? ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format($25a74ef8f667cbaa$export$2e2bcd8739ae039(2), record.avg_discount ?? record.discount)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $d8f38d8e6e0f5615$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#price-list #company_id		{ width: 10rem;	}
			#price-list #customer_id		{ width: 15rem;	}
			#price-list #id				{ width: 4.5rem; text-align: right;	}
			#price-list #name			{ width: 25rem;	}
			#price-list #discount		{ width: 4.5rem; text-align: right;	}
			#price-list .product 		{ width: 35rem; }
			#price-list .discount		{ width: 4.5rem; text-align: right;	}
			#price-list .unit_price		{ width: 4.5rem; text-align: right;	}
		</style>
		<form id="price-list" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="customers"></datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Cliente (tabela por cliente)">Cliente
					<input id="customer_id" type="text" list="customers">
				</label>
				<label title="Identificador da lista de pre\xe7os">Lista
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da lista de pre\xe7os">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Desconto geral sobre o pedido">% Desc
					<input id="discount" type="text">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>% Desc</th>
							<th>Pre\xe7o<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="Desconto espec\xedfico sobre o item">
								<input id="discount-0" class="discount" type="text">
							</td>
							<td title="Pre\xe7o unit\xe1rio do produto">
								<input id="unit_price-0" class="unit_price" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#price-list',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#customers', 'customers', {
                labels: [
                    'name',
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#customer_id'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#discount'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $49ffe7e2640e6c04$export$2e2bcd8739ae039('company_id'),
                $9a739ce21637de64$export$2e2bcd8739ae039('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#discount-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#unit_price-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        }
    ]
};



const $5f8cf8bc5abf9d48$var$price_lists = function() {
    let price_lists_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_customers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customers', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            const q = (query || '').includes('?') ? `${query}&combined=1` : `${query || ''}?combined=1`;
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_price_lists, q);
        },
        async loadRecord (id) {
            const arr = JSON.parse(id);
            if (arr[2] === 'customer') return null;
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_price_list, arr[0], arr[1]);
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'prices');
        },
        async saveRecord (data, old_data) {
            data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'prices');
            let _record = {
                name: data.name,
                discount: Number(data.discount),
                prices: data.prices.map((entry)=>({
                        product_id: Number(entry.product_id),
                        discount: Number(entry.discount),
                        unit_price: Number(entry.unit_price)
                    }))
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_price_list, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_price_list, data.company_id, _record);
        },
        handleEvents (ev) {
            let submenu, header, record;
            if (submenu = (0, $7c7f18e63e55bfe1$export$92a42bc44568c07)(ev.target, 'hash')) (0, $a020c0121b2250d6$export$2e2bcd8739ae039).route(submenu.getAttribute('hash'));
            else if (header = (0, $7c7f18e63e55bfe1$export$92a42bc44568c07)(ev.target, 'data-index')) this.sortPage(header.getAttribute('data-index'));
            else if (record = (0, $7c7f18e63e55bfe1$export$92a42bc44568c07)(ev.target, 'data-id')) {
                ev.stopPropagation(); // Evita que handlers de outros cruds na workarea (ex: grupos) tratem o clique
                try {
                    const id = JSON.parse(record.getAttribute('data-id'));
                    if (id[2] === 'customer') {
                        $5f8cf8bc5abf9d48$var$_showCustomerPriceDetail(id[0], id[1], this);
                        return;
                    }
                } catch (_) {}
                this.loadRecord(record.getAttribute('data-id')).then((data)=>data != null && this.editRecord.call(this, data));
            }
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Lista',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da lista'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome da lista'
        },
        {
            index: 4,
            field: 'avg_discount',
            label: '% Desconto',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: "M\xe9dia percentual de desconto"
        },
        {
            index: 5,
            field: 'sku_count',
            label: 'Qtd SKUs',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade de SKUs'
        }
    ];
    const workarea = document.getElementById('workarea');
    workarea.innerHTML = '';
    const wrapper = document.createElement('div');
    wrapper.className = 'price-lists-wrapper';
    const panel = document.createElement('div');
    panel.className = 'customer-prices-panel fsb fac mtm mbm';
    panel.innerHTML = `
		<fieldset class="customer-prices-fieldset">
			<legend>Tabela de pre\xe7o por cliente</legend>
			<label>Empresa <input id="cp_company_id" type="text" list="cp_companies"></label>
			<label>Cliente <input id="cp_customer_id" type="text" list="cp_customers"></label>
			<datalist id="cp_companies"></datalist>
			<datalist id="cp_customers"></datalist>
			<button type="button" class="bn_cp_download button">Baixar modelo CSV</button>
			<button type="button" class="bn_cp_import button">Importar CSV</button>
			<input type="file" id="cp_file_input" accept=".csv" style="display:none">
		</fieldset>
	`;
    wrapper.appendChild(panel);
    const crudContainer = document.createElement('div');
    wrapper.appendChild(crudContainer);
    workarea.appendChild(wrapper);
    let operations = [
        {
            hash: '#apagar-tabela',
            label: 'Apagar&nbsp;tabela'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#apagar-tabela', ()=>$5f8cf8bc5abf9d48$var$_apagarTabela(price_lists_crud));
    price_lists_crud.run('price_lists', "Listas de Pre\xe7os", crudContainer, (0, $561045a268ce7b0e$export$2e2bcd8739ae039), (0, $d8f38d8e6e0f5615$export$2e2bcd8739ae039), fieldspecs, operations).then(()=>{
        $5f8cf8bc5abf9d48$var$_setupCustomerPrices(panel, price_lists_crud);
    }).catch((e)=>{
        console.error('price-lists run:', e);
    });
};
async function $5f8cf8bc5abf9d48$var$_showCustomerPriceDetail(companyId, customerId, crudRef) {
    const [pricesResp, companiesResp, customersResp] = await Promise.all([
        (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).customer_prices_list, companyId, customerId),
        (0, $1cmSR.default).list('companies').catch(()=>[]),
        (0, $1cmSR.default).list('customers').catch(()=>[])
    ]);
    const rows = Array.isArray(pricesResp) ? pricesResp : [];
    const prices = rows.map((r)=>({
            product_id: r.product_id,
            discount: r.discount ?? 0,
            unit_price: r.unit_price
        }));
    const data = {
        company_id: companyId,
        id: customerId,
        customer_id: customerId,
        name: 'Tabela por cliente',
        discount: '',
        prices: prices
    };
    const flat = (0, $814061363397c8d7$export$bffa455ba8c619a6)(data, 'prices');
    const fs = (0, $814061363397c8d7$export$2e2bcd8739ae039).edit((0, $d8f38d8e6e0f5615$export$2e2bcd8739ae039), async (updated_data, old_data)=>{
        if (!old_data?.customer_id) return false;
        const deep = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(updated_data, 'prices');
        const headerVal = deep.discount;
        const headerFilled = headerVal != null && String(headerVal).trim() !== '' && !isNaN(Number(headerVal));
        const headerDiscount = headerFilled ? Math.min(100, Math.max(0, Math.round(Number(headerVal) * 100) / 100)) : null;
        const clampDiscount = (v)=>Math.min(100, Math.max(0, Math.round((v || 0) * 100) / 100));
        const pr = (deep.prices || []).map((p)=>{
            const rawItem = p.discount != null && String(p.discount).trim() !== '' && !isNaN(Number(p.discount)) ? Number(p.discount) : null;
            const itemDiscount = headerFilled ? headerDiscount : rawItem !== null ? clampDiscount(rawItem) : 0;
            return {
                product_id: Number(p.product_id),
                unit_id: p.unit_id != null ? Number(p.unit_id) : undefined,
                unit_price: Number(p.unit_price),
                discount: itemDiscount
            };
        }).filter((p)=>p.product_id && !isNaN(p.unit_price));
        const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).customer_prices_replace, companyId, customerId, pr);
        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`${resp?.count ?? 0} pre\xe7o(s) salvo(s).`);
        await crudRef.loadPage();
        return true;
    }, flat);
    setTimeout(()=>{
        const n = document.querySelector('#price-list');
        if (n) {
            const ec = n.querySelector('#company_id');
            const cc = n.querySelector('#customer_id');
            if (ec) ec.disabled = true;
            if (cc) cc.disabled = true;
        }
    }, 150);
}
async function $5f8cf8bc5abf9d48$var$_apagarTabela(crudRef) {
    const selection = crudRef.getSelection();
    const customerIds = selection.filter((a)=>Array.isArray(a) && a[2] === 'customer');
    if (!customerIds.length) {
        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione tabela(s) por cliente para apagar.');
        return;
    }
    (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Apagar ${customerIds.length} tabela(s) de pre\xe7o por cliente?`, 'Confirmar', async (key)=>{
        if (key !== 'Y') return;
        for (const [companyId, customerId] of customerIds)await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).customer_prices_delete, companyId, customerId);
        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Tabela(s) apagada(s).');
        await crudRef.loadPage();
    });
}

async function $5f8cf8bc5abf9d48$var$_setupCustomerPrices(panel, crudRef) {
    const db = (await Promise.resolve((parcelRequire("1cmSR")))).default;
    const inpCompany = panel.querySelector('#cp_company_id');
    const inpCustomer = panel.querySelector('#cp_customer_id');
    const dlCompanies = panel.querySelector('#cp_companies');
    const dlCustomers = panel.querySelector('#cp_customers');
    const fileInput = panel.querySelector('#cp_file_input');
    if (!inpCompany || !inpCustomer || !fileInput) return;
    let companies = [];
    try {
        companies = await db.list('companies') || [];
    } catch (_) {}
    companies = Array.isArray(companies) ? companies : [];
    dlCompanies.innerHTML = companies.map((c)=>`<option value="${c.id || ''}">${c.nick || c.name || c.id || ''}</option>`).join('');
    function resolveCompanyId(val) {
        if (!val) return null;
        const c = companies.find((x)=>x.id === val || x.nick === val || x.name && x.name.includes && x.name.includes(val));
        return c?.id || null;
    }
    function getCompanyCustomerIds() {
        const companyId = resolveCompanyId(inpCompany.value);
        let customerId = inpCustomer.value?.trim();
        if (customerId && /^\d+$/.test(customerId)) customerId = parseInt(customerId, 10);
        else {
            const opt = Array.from(inpCustomer.list?.options || []).find((o)=>o.value === customerId || o.textContent && o.textContent.trim() === customerId);
            if (opt) customerId = parseInt(opt.value, 10);
        }
        return [
            companyId,
            customerId
        ];
    }
    inpCompany.addEventListener('change', async ()=>{
        const companyId = resolveCompanyId(inpCompany.value);
        if (!companyId) {
            dlCustomers.innerHTML = '';
            inpCustomer.value = '';
            crudRef.filter = {};
        } else {
            const q = `?filter=company_id*eq*${companyId}&limit=0`;
            const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_customers, q);
            if (resp && Array.isArray(resp)) {
                db.set('customers', resp);
                dlCustomers.innerHTML = resp.map((c)=>`<option value="${c.id}" data-company="${c.company_id}">${c.nick || c.name || c.id}</option>`).join('');
            }
            inpCustomer.value = '';
            crudRef.filter = {
                'field-0': 'company_id',
                'value-0': companyId,
                'operator-0': 'eq'
            };
        }
        await crudRef.loadPage(1);
    });
    panel.querySelector('.bn_cp_download')?.addEventListener('click', async ()=>{
        const [companyId, customerId] = getCompanyCustomerIds();
        if (!companyId || !customerId) {
            (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione Empresa e Cliente.');
            return;
        }
        const csv = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).customer_prices_template, companyId, customerId);
        if (typeof csv !== 'string') return;
        const blob = new Blob([
            csv
        ], {
            type: 'text/csv;charset=utf-8'
        });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'tabela_preco_cliente.csv';
        a.click();
        URL.revokeObjectURL(a.href);
        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Modelo CSV baixado.');
    });
    panel.querySelector('.bn_cp_import')?.addEventListener('click', ()=>fileInput.click());
    fileInput.addEventListener('change', async (e)=>{
        const file = e.target.files?.[0];
        if (!file) return;
        const [companyId, customerId] = getCompanyCustomerIds();
        if (!companyId || !customerId) {
            (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione Empresa e Cliente.');
            fileInput.value = '';
            return;
        }
        const csv = await file.text();
        const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).customer_prices_import, companyId, customerId, csv);
        if (resp) {
            (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`${resp.count || 0} pre\xe7o(s) importado(s).`);
            await crudRef.loadPage();
        }
        fileInput.value = '';
    });
}
var $5f8cf8bc5abf9d48$export$2e2bcd8739ae039 = $5f8cf8bc5abf9d48$var$price_lists;




var $1cmSR = parcelRequire("1cmSR");



async function $0cec2748ac32fa3b$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 30rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Condi\xe7\xe3o</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}





var $d1603a6d78788fea$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#term #company_id	{ width: 10rem;		}
			#term #id			{ width: 4.5rem; text-align: right;	}
			#term #name		 	{ width: 10rem; 	}
			#term .days 		{ width: 14rem; text-align: right;	}
			#term .percentage 	{ width: 10rem; text-align: right;	}
		</style>
		<form id="term" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da condi\xe7\xe3o">Condi\xe7\xe3o
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da condi\xe7\xe3o">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Dias<sup>*</sup></th>
							<th>Percentual<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="4">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Dias at\xe9 o vencimento">
								<input id="days-0" class="days" type="text" required>
							</td>
							<td title="Percentual do total devido na data">
								<input id="percentage-0" class="percentage" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#term',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: []
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#days-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#percentage-0'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        }
    ]
};



const $e5cbae575b333663$var$payment_terms = function() {
    let payment_terms_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_payment_terms, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_payment_term, ...JSON.parse(id));
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'installments');
        },
        editRecord (data) {
            (0, $814061363397c8d7$export$2e2bcd8739ae039).edit(this.record_form, this.saveRecordWrapper.bind(this), data);
        },
        async saveRecord (data, old_data) {
            data = (0, $814061363397c8d7$export$a6d6ddd317ec07a4)(data, 'installments');
            let _record = {
                name: data.name,
                installments: data.installments.map((installment)=>({
                        days: Number(installment.days),
                        percentage: Number(installment.percentage)
                    }))
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_payment_term, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_payment_term, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Sa\xedda",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "Identificador da condi\xe7\xe3o de pagamento"
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome da condi\xe7\xe3o de pagamento"
        }
    ];
    payment_terms_crud.run('payment_terms', "Condi\xe7\xf5es&nbsp;Pagamento", document.getElementById('workarea'), (0, $0cec2748ac32fa3b$export$2e2bcd8739ae039), (0, $d1603a6d78788fea$export$2e2bcd8739ae039), fieldspecs);
};
var $e5cbae575b333663$export$2e2bcd8739ae039 = $e5cbae575b333663$var$payment_terms;




var $1cmSR = parcelRequire("1cmSR");



async function $5d73bb38edf16993$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(6)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">CFOP</th>
					<th data-index="3" data-visible="${this.visible[2]}">C\xf3digo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Descri\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Venda</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.code}</td>
					<td data-visible='${this.visible[3]}'>${record.description}</td>
					<td data-visible='${this.visible[4]}'>${record.venda ? 'Sim' : "N\xe3o"}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




var $91ad1c97f3a51d7e$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#cfop #company_id		{ width: 10rem;		}
			#cfop #id				{ width: 4rem; text-align: right;	}
			#cfop #code				{ width: 5rem;		}
			#cfop #description		{ width: 35rem;		}
			#cfop #venda			{ width: 4rem;		}
			#cfop #icms				{ width: 4rem;		}
			#cfop #ipi				{ width: 4rem;		}
			#cfop #pis				{ width: 4rem;		}
			#cfop #cofins			{ width: 4rem;		}
			#cfop #operacao			{ width: 4rem;		}
			#cfop #destino			{ width: 4rem;		}
			#cfop #finalidade		{ width: 4rem;		}
		</style>
		<form id="cfop" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do CFOP">CFOP
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo (4 d\xedgitos)">C\xf3digo<sup>*</sup>
					<input id="code" type="text" placeholder="5102" required maxlength="4">
				</label>
				<label title="Descri\xe7\xe3o">Descri\xe7\xe3o<sup>*</sup>
					<input id="description" type="text" required>
				</label>
				<label title="Opera\xe7\xe3o de venda?">Venda
					<input id="venda" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<label title="CST ICMS">ICMS<sup>*</sup>
					<input id="icms" type="text" placeholder="00" required>
				</label>
				<label title="CST IPI">IPI
					<input id="ipi" type="text" placeholder="">
				</label>
				<label title="CST PIS">PIS
					<input id="pis" type="text" placeholder="">
				</label>
				<label title="CST COFINS">COFINS
					<input id="cofins" type="text" placeholder="">
				</label>
				<label title="Opera\xe7\xe3o">Opera\xe7\xe3o
					<input id="operacao" type="text" placeholder="">
				</label>
				<label title="Destino">Destino
					<input id="destino" type="text" placeholder="">
				</label>
				<label title="Finalidade">Finalidade
					<input id="finalidade" type="text" placeholder="">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#cfop',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#code'
            },
            types: []
        },
        {
            properties: {
                selector: '#description'
            },
            types: []
        },
        {
            properties: {
                selector: '#venda'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#icms'
            },
            types: []
        },
        {
            properties: {
                selector: '#ipi'
            },
            types: []
        },
        {
            properties: {
                selector: '#pis'
            },
            types: []
        },
        {
            properties: {
                selector: '#cofins'
            },
            types: []
        },
        {
            properties: {
                selector: '#operacao'
            },
            types: []
        },
        {
            properties: {
                selector: '#destino'
            },
            types: []
        },
        {
            properties: {
                selector: '#finalidade'
            },
            types: []
        }
    ]
};



const $d5d475eb438dd51e$var$cfops = function() {
    let cfops_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_cfops, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_cfop, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                code: String(data.code).trim(),
                description: String(data.description).trim(),
                venda: !!data.venda,
                icms: String(data.icms || '').trim(),
                ipi: data.ipi ? String(data.ipi).trim() : null,
                pis: data.pis ? String(data.pis).trim() : null,
                cofins: data.cofins ? String(data.cofins).trim() : null,
                operacao: data.operacao ? String(data.operacao).trim() : null,
                destino: data.destino ? String(data.destino).trim() : null,
                finalidade: data.finalidade ? String(data.finalidade).trim() : null
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_cfop, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_cfop, data.company_id, _record);
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'CFOP',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do CFOP'
        },
        {
            index: 3,
            field: 'code',
            label: "C\xf3digo",
            types: [],
            placeholder: '5102',
            title: "C\xf3digo CFOP (4 d\xedgitos)"
        },
        {
            index: 4,
            field: 'description',
            label: "Descri\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Descri\xe7\xe3o"
        },
        {
            index: 5,
            field: 'venda',
            label: 'Venda',
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Opera\xe7\xe3o de venda"
        }
    ];
    cfops_crud.run('cfops', 'CFOPs', document.getElementById('workarea'), (0, $5d73bb38edf16993$export$2e2bcd8739ae039), (0, $91ad1c97f3a51d7e$export$2e2bcd8739ae039), fieldspecs);
};
var $d5d475eb438dd51e$export$2e2bcd8739ae039 = $d5d475eb438dd51e$var$cfops;




var $1cmSR = parcelRequire("1cmSR");




async function $e6f60a5193f12519$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(6)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Programa</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">C\xf3digo</th>
					<th data-index="5" data-visible="${this.visible[4]}">Padr\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.name ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${(record.code ?? '').toString()}</td>
					<td data-visible='${this.visible[4]}'>${record.is_default ? 'Sim' : "N\xe3o"}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}





var $eee431dd3ba3bb8f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#program #company_id		{ width: 10rem;		}
			#program #id				{ width: 5rem; text-align: right;	}
			#program #name				{ width: 25rem;		}
			#program #code				{ width: 10rem;		}
			#program #is_default		{ width: 4rem;		}
		</style>
		<form id="program" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do programa">Programa
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do programa">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="C\xf3digo (opcional)">C\xf3digo
					<input id="code" type="text" placeholder="PADRAO">
				</label>
				<label title="Programa padr\xe3o da empresa">Padr\xe3o
					<input id="is_default" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_program_delete" title="Excluir programa">Excluir</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#program',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const root = ()=>formset.dialog?.getNode?.();
            const getCompanyId = ()=>formset.form.getFieldBySelector('#company_id')?.getValue?.() ?? root()?.querySelector?.('#company_id')?.value;
            const getId = ()=>root()?.querySelector?.('#id')?.value;
            const deleteProgram = async ()=>{
                const company_id = getCompanyId(), id = getId();
                if (!company_id || !id) return;
                (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)("Excluir este programa? S\xf3 \xe9 poss\xedvel excluir programas sem registros vinculados (produtos, lotes, pedidos, entradas).", 'Excluir', async (answer)=>{
                    if (answer !== 'Y') return;
                    const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).delete_program, company_id, id);
                    if (resp !== undefined) {
                        formset.destroy();
                        document.dispatchEvent(new CustomEvent('programs:reload'));
                    }
                });
            };
            root()?.addEventListener?.('click', (ev)=>{
                if (ev.target?.closest?.('.bn_program_delete')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    deleteProgram();
                    return;
                }
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: []
        },
        {
            properties: {
                selector: '#code'
            },
            types: []
        },
        {
            properties: {
                selector: '#is_default'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $e7e1d1109d9bcdea$var$programs = function() {
    let programs_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async deleteProgram () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione ao menos um programa.', 'Programas');
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Excluir ${ids.length} programa(s)? S\xf3 \xe9 poss\xedvel excluir programas sem registros vinculados (produtos, lotes, pedidos, entradas).`, 'Excluir', async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).delete_program, company_id, id);
                    if (resp === undefined) return;
                }
                this.reloadPage();
            });
        },
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_programs, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_program, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: String(data.name || '').trim(),
                code: data.code && data.code.trim() ? data.code.trim() : null,
                is_default: !!data.is_default
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_program, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_program, data.company_id, _record);
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Programa',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do programa'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: 'Nome do programa'
        },
        {
            index: 4,
            field: 'code',
            label: "C\xf3digo",
            types: [],
            placeholder: 'PADRAO',
            title: "C\xf3digo (opcional)"
        },
        {
            index: 5,
            field: 'is_default',
            label: "Padr\xe3o",
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Programa padr\xe3o da empresa"
        }
    ];
    let operations = [
        {
            hash: '#program-delete',
            label: 'Excluir'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#program-delete', programs_crud.deleteProgram.bind(programs_crud));
    document.addEventListener('programs:reload', ()=>programs_crud.reloadPage());
    programs_crud.run('programs', 'Programas', document.getElementById('workarea'), (0, $e6f60a5193f12519$export$2e2bcd8739ae039), (0, $eee431dd3ba3bb8f$export$2e2bcd8739ae039), fieldspecs, operations);
};
var $e7e1d1109d9bcdea$export$2e2bcd8739ae039 = $e7e1d1109d9bcdea$var$programs;




var $1cmSR = parcelRequire("1cmSR");



async function $d52df07a3dbea82f$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view td:nth-child(3) { text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Id</th>
					<th data-index="3" data-visible="${this.visible[2]}">C\xf3digo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Descri\xe7\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.code ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${(record.description ?? '').toString()}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $c90b1d5127c69154$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#receipt_type #company_id	{ width: 10rem; }
			#receipt_type #id			{ width: 5rem; text-align: right; }
			#receipt_type #code		{ width: 8rem; }
			#receipt_type #description	{ width: 28rem; }
		</style>
		<form id="receipt_type" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador interno">C\xf3digo interno
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo do tipo (ex.: 71)">C\xf3digo<sup>*</sup>
					<input id="code" type="text" required maxlength="32">
				</label>
				<label title="Descri\xe7\xe3o">Descri\xe7\xe3o<sup>*</sup>
					<input id="description" type="text" required maxlength="120">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#receipt_type',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#code'
            },
            types: [
                $c1695650808e6a21$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#description'
            },
            types: []
        }
    ]
};


const $fddcf708043881a5$var$receiptTypes = function() {
    const rt_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((e)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_receipt_types, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_receipt_type, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            const _record = {
                code: String(data.code || '').trim(),
                description: String(data.description || '').trim()
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_receipt_type, data.company_id, data.id, _record);
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_receipt_type, data.company_id, _record);
        },
        async deleteSelected () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)('Selecione ao menos um registro.', 'Tipos de recebimento');
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Excluir ${ids.length} tipo(s)? S\xf3 \xe9 poss\xedvel excluir tipos sem pedidos de entrada vinculados.`, 'Excluir', async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).delete_receipt_type, company_id, id);
                    if (resp === undefined) return;
                }
                this.reloadPage();
            });
        }
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#receipt-type-delete', rt_crud.deleteSelected.bind(rt_crud));
    const fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Id',
            types: [],
            placeholder: '',
            title: 'Identificador'
        },
        {
            index: 3,
            field: 'code',
            label: "C\xf3digo",
            types: [],
            placeholder: '',
            title: "C\xf3digo"
        },
        {
            index: 4,
            field: 'description',
            label: "Descri\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Descri\xe7\xe3o"
        }
    ];
    const operations = [
        {
            hash: '#receipt-type-delete',
            label: 'Excluir'
        }
    ];
    rt_crud.run('receipt_types', 'Tipos&nbsp;de&nbsp;Recebimento', document.getElementById('workarea'), (0, $d52df07a3dbea82f$export$2e2bcd8739ae039), (0, $c90b1d5127c69154$export$2e2bcd8739ae039), fieldspecs, operations);
};
var $fddcf708043881a5$export$2e2bcd8739ae039 = $fddcf708043881a5$var$receiptTypes;




var $1cmSR = parcelRequire("1cmSR");








async function $2aa875d7e8eae51f$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: center; }
			.view td:nth-child(7)	{ text-align: right; }
			.view td:nth-child(8)	{ text-align: right; }
			.view td:nth-child(9)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(12)	{ text-align: left; }
			.view td:nth-child(13)	{ text-align: center; }
			.view td:nth-child(14)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(15)	{ text-align: center; }
			.view td:nth-child(16)	{ text-align: left; max-width: 18rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Nota</th>
					<th data-index="3" data-visible="${this.visible[2]}">E/S</th>
					<th data-index="4" data-visible="${this.visible[3]}">Origem</th>
					<th data-index="5" data-visible="${this.visible[4]}">CFOP</th>
					<th data-index="6" data-visible="${this.visible[5]}">Seguro</th>
					<th data-index="7" data-visible="${this.visible[6]}">Despesas</th>
					<th data-index="8" data-visible="${this.visible[7]}">Informa\xe7\xf5es</th>
					<th data-index="9" data-visible="${this.visible[8]}">Chave</th>
					<th data-index="10" data-visible="${this.visible[9]}">Referenciada</th>
					<th data-index="12" data-visible="${this.visible[10]}">Anota\xe7\xe3o</th>
					<th data-index="13" data-visible="${this.visible[11]}">C\xf3digo</th>
					<th data-index="14" data-visible="${this.visible[12]}">Mensagem</th>
					<th data-index="15" data-visible="${this.visible[13]}">Data/Hora</th>
					<th data-index="16" data-visible="${this.visible[14]}">Inutilizada</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.io_id}</td>
					<td data-visible='${this.visible[3]}'>${this.option($759a03b3eb0eafb9$export$2e2bcd8739ae039(), record.io_type)}</td>
					<td data-visible='${this.visible[4]}'>${record.cfop}</td>
					<td data-visible='${this.visible[5]}'>${record.insurance ? this.number(record.insurance, 2) : ''}</td>
					<td data-visible='${this.visible[6]}'>${record.expenses ? this.number(record.expenses, 2) : ''}</td>
					<td data-visible='${this.visible[7]}'>${record.info || ''}</td>
					<td data-visible='${this.visible[8]}'>${record.key || ''}</td>
					<td data-visible='${this.visible[9]}'>${record.ref_key || ''}</td>
					<td data-visible='${this.visible[10]}'>${record.notes || ''}</td>
					<td data-visible='${this.visible[11]}'>${record.last_code || ''}</td>
					<td data-visible='${this.visible[12]}'>${record.last_text || ''}</td>
					<td data-visible='${this.visible[13]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.last_datetime) || ''}</td>
					<td data-visible='${this.visible[14]}'>${record.inutilizacao_protocolo || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $091512228dc59c17$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#invoice #company_id		{ width: 10rem;		}
			#invoice #id				{ width: 5rem; text-align: right;	}
			#invoice #io_id				{ width: 5rem; text-align: right;	}
			#invoice #io_type			{ width: 8rem; 		}
			#invoice #cfop				{ width: 30rem;		}
			#invoice #insurance			{ width: 5rem; text-align: right;	}
			#invoice #expenses			{ width: 5rem; text-align: right;	}
			#invoice .info		 		{ width: 70%;		}
			#invoice .note		 		{ width: 29%;		}
			#invoice .type 				{ width: 10rem;		}
			#invoice .number 			{ width: 10rem; text-align: center;	}
			#invoice .code 				{ width: 4rem; text-align: center;	}
			#invoice .message 			{ width: 20rem;		}
			#invoice .datetime 			{ width: 10rem; text-align: center;	}
			#invoice #ref_key			{ width: 30rem;		}
		</style>
		<form id="invoice" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="N\xfamero da nota fiscal">Nota
					<input id="id" type="text" disabled>
				</label>
				<label title="N\xfamero da entrada/sa\xedda vinculada">E/S<sup>*</sup>
					<input id="io_id" type="text" required>
				</label>
				<label title="Tipo do movimento vinculado">Tipo<sup>*</sup>
					<input id="io_type" type="text" list="io_types" value="O" disabled>
				</label>
				<label title="C\xf3digo Fiscal de Opera\xe7\xf5es e Presta\xe7\xf5es">CFOP<sup>*</sup>
					<input id="cfop" type="text" list="cfops" required>
				</label>
				<label title="Valor do seguro">Seguro
					<input id="insurance" type="text">
				</label>
				<label title="Outras despesas acess\xf3rias">Despesas
					<input id="expenses" type="text">
				</label>
			</div>
			<div class="fsb">
				<label class="info" title="Informa\xe7\xf5es complementares de interesse do contribuinte">Informa\xe7\xf5es Complementares
					<textarea id="info" rows="8"></textarea>
				</label>
				<label class="note" title="Corre\xe7\xe3o ou justificativa de cancelamento">Anota\xe7\xe3o
					<textarea id="note" rows="8"></textarea>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Tipo</th>
							<th>Protocolo</th>
							<th>C\xf3digo</th>
							<th>Mensagem</th>
							<th>Data/Hora</th>
							<th>Conting\xeancia</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox" disabled>
							</td>
							<td title="Tipo de protocolo">
								<select id="type-0" class="type" disabled>
									<option value="1">Autoriza\xe7\xe3o</option>
									<option value="2">Corre\xe7\xe3o</option>
									<option value="3">Cancelamento</option>
									<option value="4">Inutiliza\xe7\xe3o</option>
								</select>
							</td>
							<td title="N\xfamero do protocolo">
								<input id="number-0" class="number" type="text" disabled>
							</td>
							<td title="C\xf3digo de retorno">
								<input id="result_code-0" class="code" type="text" disabled>
							</td>
							<td title="Mensagem de retorno">
								<input id="result_text-0" class="message" type="text" disabled>
							</td>
							<td title="Data/hora do retorno">
								<input id="result_datetime-0" class="datetime" type="text" disabled>
							</td>
							<td title="Uso de ambiente de conting\xeancia">
								<input id="contingency-0" class="contingency" type="checkbox" disabled>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<label title="Chave da nota fiscal referenciada em devolu\xe7\xf5es">Nota Referenciada
						<input id="ref_key" type="text">
					</label>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#invoice',
        afterEditSetValues (fs) {
            setTimeout(()=>{
                const io = fs.form.getFieldBySelector('#io_type');
                if (io && typeof io.publish === 'function') io.publish('change', io, io.getValue());
            }, 50);
        },
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_type'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $759a03b3eb0eafb9$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#cfop'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039(),
                $f361d28f145f8e93$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ref_key'
            },
            types: [
                $f4ad198ec68f02f5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#insurance'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#expenses'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ]
        },
        {
            properties: {
                selector: '#info'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#note'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $410b568e9a67c35a$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#type-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#number-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#result_code-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#result_text-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#result_datetime-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#contingency-0'
            },
            types: []
        }
    ]
};



var $dd161bc297361199$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#create-lots .type	{ width: 100%;	}
			#create-lots #note	{ width: 30rem;	}
		</style>
		<form id="create-lots" class="form" autocomplete="off">
			<div class="title">
				Gerar lotes para <span id="count"></span> notas
			</div>
			<div class="mtl">
				<label class="type" title="Finalidade do lote">Tipo de lote
					<select id="type" required>
						<option value="-1"></option>
						<option value="1">Autoriza\xe7\xe3o</option>
						<option value="2">Corre\xe7\xe3o</option>
						<option value="3">Cancelamento</option>
					</select>
				</label>
			</div>
			<div>
				<label>Corre\xe7\xe3o ou justificativa do cancelamento
					<textarea id="note" rows="4"></textarea>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#create-lots',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#type'
            },
            types: [
                $2c79fa51f8e681d4$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#note'
            },
            types: []
        }
    ]
};



var $50ee6dc3eb293ba0$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#inutilizar-nf .serie,
			#inutilizar-nf #nNFIni,
			#inutilizar-nf #nNFFin	{ width: 6rem;	}
			#inutilizar-nf #xJust	{ width: 100%; min-height: 4rem; }
		</style>
		<form id="inutilizar-nf" class="form" autocomplete="off">
			<div class="title">Inutilizar numera\xe7\xe3o de NF-e</div>
			<div class="mtl">
				<label>Empresa
					<input id="company_id" list="inutilizar-companies" required placeholder="Selecione a empresa">
					<datalist id="inutilizar-companies"></datalist>
				</label>
			</div>
			<div class="mtl">
				<label>S\xe9rie
					<input id="serie" type="number" min="0" max="999" required placeholder="Ex: 2">
				</label>
			</div>
			<div class="mtl">
				<label>Nota inicial
					<input id="nNFIni" type="number" min="1" required placeholder="Ex: 8529">
				</label>
			</div>
			<div class="mtl">
				<label>Nota final
					<input id="nNFFin" type="number" min="1" required placeholder="Ex: 8537">
				</label>
			</div>
			<div class="mtl">
				<label>Justificativa (m\xedn. 15 caracteres)
					<textarea id="xJust" rows="3" required minlength="15" placeholder="Ex: Salto na sequ\xeancia devido \xe0 emiss\xe3o por script de venda de ativo imobilizado"></textarea>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Inutilizar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#inutilizar-nf',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#inutilizar-companies', 'companies', {
                labels: [
                    'nick'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#serie'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#nNFIni'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 0)
            ]
        },
        {
            properties: {
                selector: '#nNFFin'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 0)
            ]
        },
        {
            properties: {
                selector: '#xJust'
            },
            types: []
        }
    ]
};



var $708b7eb6d2224859$export$2e2bcd8739ae039 = {
    html: `
		<form id="iqvia-report-form" class="form" autocomplete="off">
			<div class="title">Relat\xf3rio IQVIA \u{2014} Vendas e Devolu\xe7\xf5es</div>
			<div class="mtl">
				<label>Empresa
					<input id="company_id" list="iqvia-companies" required placeholder="Selecione a empresa">
					<datalist id="iqvia-companies"></datalist>
				</label>
			</div>
			<div class="mtl">
				<label>Data in\xedcio
					<input id="date_from" type="text" required placeholder="dd/mm/aaaa">
				</label>
			</div>
			<div class="mtl">
				<label>Data fim (opcional)
					<input id="date_to" type="text" placeholder="dd/mm/aaaa">
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Fechar</button>
				<button class='bn_Enter button'>Imprimir</button>
			</div>
		</form>
	`,
    form: {
        selector: '#iqvia-report-form',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#iqvia-companies', 'companies', {
                labels: [
                    'nick'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#date_from'
            },
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#date_to'
            },
            types: [
                $0c9c948f6a5e1eb3$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $e8c0107621152558$var$invoices = function() {
    let invoices_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_cfops, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cfops', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_invoices, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_invoice, ...JSON.parse(id));
            return (0, $814061363397c8d7$export$bffa455ba8c619a6)(_record, 'protocols');
        },
        async saveRecord (data, old_data) {
            let _record = {
                io_type: data.io_type,
                io_id: Number(data.io_id),
                cfop: data.cfop,
                insurance: Number(data.insurance),
                expenses: Number(data.expenses),
                info: data.info?.trim(),
                note: data.note?.trim(),
                ref_key: data.ref_key
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_invoice, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_invoice, data.company_id, _record);
        },
        updateXML () {
            const showResult = (resp)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Notas atualizadas: ${resp?.count || 0}`, 'Resultado');
                this.loadPage();
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_invoices_xml, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Atualizar XML de ${this.getCount()} notas?`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        createLots () {
            const showResult = (resp)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Lotes criados: ${resp?.count || 0}`, 'Resultado');
                this.loadPage(); // Required on corrections and cancelations
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let lots = (0, $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a)(ids);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).create_invoice_lots, Object.assign(data, {
                    'lots': lots
                })).then(showResult);
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $dd161bc297361199$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                document.querySelector(`${fs.form.selector} #count`).innerHTML = this.getCount();
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        createArchive () {
            const showResult = (resp)=>{
                this.clearGridSelection();
                if (resp) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`<a href="data:application/x-zip-compressed;base64,${resp.zip}" download="invoices.zip">Clique aqui para obter o arquivo</a>`, 'Download');
            };
            const sendRequest = async (data)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).create_archive, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Baixar XML e DANFE de ${this.getCount()} notas?`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        inutilizarNF () {
            const showResult = (data)=>{
                if (data?.ok) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Inutiliza\xe7\xe3o homologada. Protocolo: ${data.protocolo || ''}`, 'Resultado');
                else if (data) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`${data?.mensagem || 'Erro'} (${data?.codigo || ''})`, 'Erro');
                fs.destroy();
                this.loadPage();
            };
            const sendRequest = async (data)=>{
                const body = {
                    company_id: data.company_id,
                    serie: Number(data.serie),
                    nNFIni: Number(data.nNFIni),
                    nNFFin: Number(data.nNFFin),
                    xJust: data.xJust?.trim()
                };
                const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).inutilizar_invoices, body);
                if (resp) showResult(resp);
                else {
                    fs.destroy();
                    this.loadPage();
                }
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $50ee6dc3eb293ba0$export$2e2bcd8739ae039), sendRequest);
            fs.init();
        },
        printIqvia () {
            const sendRequest = async (data)=>{
                fs.destroy();
                try {
                    const payload = {
                        company_id: data.company_id,
                        date_from: data.date_from
                    };
                    if (data.date_to && String(data.date_to).trim()) payload.date_to = data.date_to;
                    const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).print_iqvia, payload);
                    if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                    else (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Nenhum dado para o relat\xf3rio.", 'Aviso');
                } catch (e) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e?.message || String(e), 'Erro');
                }
            };
            let fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $708b7eb6d2224859$export$2e2bcd8739ae039), sendRequest);
            fs.init();
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Nota',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero da nota fiscal"
        },
        {
            index: 3,
            field: 'io_id',
            label: 'E/S',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero da entrada/sa\xedda vinculada"
        },
        {
            index: 4,
            field: 'io_type',
            label: 'Origem',
            types: [
                $759a03b3eb0eafb9$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Origem da entrada/sa\xedda vinculada"
        },
        {
            index: 5,
            field: 'cfop',
            label: 'CFOP',
            types: [
                $c064992517a328df$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "C\xf3digo Fiscal de Opera\xe7\xf5es e Presta\xe7\xf5es"
        },
        {
            index: 6,
            field: 'insurance',
            label: 'Seguro',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: 'Valor do seguro'
        },
        {
            index: 7,
            field: 'expenses',
            label: 'Despesas',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(2)
            ],
            placeholder: '0,00',
            title: "Valor das despesas acess\xf3rias"
        },
        {
            index: 8,
            field: 'info',
            label: "Informa\xe7\xf5es",
            types: [],
            placeholder: '',
            title: "Informa\xe7\xf5es complementares"
        },
        {
            index: 9,
            field: 'key',
            label: 'Chave',
            types: [
                $f4ad198ec68f02f5$export$2e2bcd8739ae039()
            ],
            placeholder: '0000 0000 0000 0000 0000 0000 0000 0000 0000 0000',
            title: 'Chave da nota fiscal'
        },
        {
            index: 10,
            field: 'ref_key',
            label: 'Referenciada',
            types: [
                $f4ad198ec68f02f5$export$2e2bcd8739ae039()
            ],
            placeholder: '0000 0000 0000 0000 0000 0000 0000 0000 0000 0000',
            title: 'Chave da nota referenciada'
        },
        {
            index: 12,
            field: 'note',
            label: "Anota\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Anota\xe7\xf5es de corre\xe7\xf5es ou cancelamento"
        },
        {
            index: 13,
            field: 'last_code',
            label: "C\xf3digo",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "C\xf3digo de retorno da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 14,
            field: 'last_text',
            label: 'Mensagem',
            types: [],
            placeholder: '',
            title: "Mensagem de retorno da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 15,
            field: 'last_datetime',
            label: 'Data/Hora',
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 16,
            field: 'inutilizacao_protocolo',
            label: 'Inutilizada',
            types: [],
            placeholder: '',
            title: "Protocolo da inutiliza\xe7\xe3o na SEFAZ (vazio se n\xe3o inutilizada)"
        }
    ];
    let operations = [
        {
            hash: '#update-xml',
            label: 'Atualizar&nbsp;XML'
        },
        {
            hash: '#create-lots',
            label: 'Gerar&nbsp;lotes&nbsp;de&nbsp;notas'
        },
        {
            hash: '#create-archive',
            label: 'Baixar&nbsp;XML&nbsp;e&nbsp;DANFE'
        },
        {
            hash: '#inutilizar-nf',
            label: 'Inutilizar&nbsp;NF'
        }
    ];
    let reports = [
        {
            hash: '#print-iqvia',
            label: "Relat\xf3rio&nbsp;IQVIA"
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#update-xml', invoices_crud.updateXML.bind(invoices_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-lots', invoices_crud.createLots.bind(invoices_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-archive', invoices_crud.createArchive.bind(invoices_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inutilizar-nf', invoices_crud.inutilizarNF.bind(invoices_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-iqvia', invoices_crud.printIqvia.bind(invoices_crud));
    invoices_crud.run('invoices', 'Notas&nbsp;Fiscais', document.getElementById('workarea'), (0, $2aa875d7e8eae51f$export$2e2bcd8739ae039), (0, $091512228dc59c17$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $e8c0107621152558$export$2e2bcd8739ae039 = $e8c0107621152558$var$invoices;




var $1cmSR = parcelRequire("1cmSR");




async function $708f028c2d9a84ab$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: center; }
			.view td:nth-child(7)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Lote</th>
					<th data-index="4" data-visible="${this.visible[2]}">Tipo</th>
					<th data-index="6" data-visible="${this.visible[3]}">Recibo</th>
					<th data-index="8" data-visible="${this.visible[4]}">C\xf3digo</th>
					<th data-index="9" data-visible="${this.visible[5]}">Mensagem</th>
					<th data-index="10" data-visible="${this.visible[6]}">Data/Hora</th>
					<th data-index="5" data-visible="${this.visible[7]}">Estado</th>
					<th data-index="3" data-visible="${this.visible[8]}">Ambiente</th>
					<th data-index="12" data-visible="${this.visible[9]}">Conting\xeancia</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${this.option($b23279d219d3efdd$export$2e2bcd8739ae039(), record.type)}</td>
					<td data-visible='${this.visible[3]}'>${record.receipt || ''}</td>
					<td data-visible='${this.visible[4]}'>${record.result_code || ''}</td>
					<td data-visible='${this.visible[5]}'>${record.result_text || ''}</td>
					<td data-visible='${this.visible[6]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.result_datetime) || ''}</td>
					<td data-visible='${this.visible[7]}'>${this.option($2b0e90bfecbeac43$export$2e2bcd8739ae039(), record.state)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($730d3c6719ff7827$export$2e2bcd8739ae039(), record.environment)}</td>
					<td data-visible='${this.visible[9]}'>${this.option($16a377ceff31a9ac$export$2e2bcd8739ae039(), record.in_contingency)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $88d370256d2b3a0d$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#invoice-lot #company_id	{ width: 10rem;	}
			#invoice-lot #id			{ width: 5rem; text-align: right;	}
			#invoice-lot #type			{ width: 14rem;	}
			#invoice-lot #invoices		{ width: 30rem;	}
		</style>
		<form id="invoice-lot" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do lote">Lote
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de lote">Tipo<sup>*</sup>
					<select id="type" required>
						<option value="-1"></option>
						<option value="1">Autoriza\xe7\xe3o</option>
						<option value="2">Corre\xe7\xe3o</option>
						<option value="3">Cancelamento</option>
					</select>
				</label>
			</div>
			<div>
				<label title="N\xfameros das notas">Notas
					<textarea id="invoices" rows="6"></textarea>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Fechar</button>
				<button class='bn_Enter button'>Salvar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#invoice-lot',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $4e674a4925cd65bb$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $2c79fa51f8e681d4$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#invoices'
            },
            types: [
                $691b0d282e4cd0d9$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $c15275aa38f8683d$var$invoiceLots = function() {
    let invoice_lots_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_invoice_lots, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_invoice_lot, ...JSON.parse(id));
            _record['invoices'] = _record['invoices'].map((invoice)=>String(invoice)).join(' ');
            return _record;
        },
        async saveRecord (data, old_data) {
            let _record = {
                type: data.type,
                invoices: data.invoices.split(' ').map((invoice)=>Number(invoice))
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_invoice_lot, data.company_id, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_invoice_lot, data.company_id, _record);
        },
        sendLots () {
            const showResult = (resp)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Lotes transmitidos: ${resp?.count || 0}`, 'Resultado');
                this.loadPage();
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).send_invoice_lots, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Transmitir ${this.getCount()} lotes para a Sefaz?`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        queryLots () {
            const showResult = (resp)=>{
                (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Lotes consultados: ${resp?.count || 0}`, 'Resultado');
                this.loadPage();
            };
            const sendRequest = async (data)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).query_invoice_lots, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Consultar ${this.getCount()} lotes com a Sefaz?`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Lote',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do lote'
        },
        {
            index: 4,
            field: 'type',
            label: 'Tipo',
            types: [
                $b23279d219d3efdd$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Tipo de lote'
        },
        {
            index: 6,
            field: 'receipt',
            label: 'Recibo',
            types: [
                $44e90f12875d728e$export$2e2bcd8739ae039()
            ],
            placeholder: '0',
            title: "N\xfamero do recibo do lote"
        },
        {
            index: 8,
            field: 'result_code',
            label: "C\xf3digo",
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: "C\xf3digo de retorno da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 9,
            field: 'result_text',
            label: 'Mensagem',
            types: [],
            placeholder: '',
            title: "Mensagem de retorno da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 10,
            field: 'result_datetime',
            label: 'Data/Hora',
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 5,
            field: 'state',
            label: 'Estado',
            types: [
                $2b0e90bfecbeac43$export$2e2bcd8739ae039,
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Unidade Federativa'
        },
        {
            index: 3,
            field: 'environment',
            label: 'Ambiente',
            types: [
                $730d3c6719ff7827$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Ambiente de envio'
        },
        {
            index: 12,
            field: 'in_contingency',
            label: "Conting\xeancia",
            types: [
                $16a377ceff31a9ac$export$2e2bcd8739ae039(),
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Envio em conting\xeancia"
        }
    ];
    let operations = [
        {
            hash: '#send-lots',
            label: 'Transmitir&nbsp;lotes&nbsp;para&nbsp;Sefaz'
        },
        {
            hash: '#query-lots',
            label: 'Consultar&nbsp;lotes&nbsp;pendentes'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#send-lots', invoice_lots_crud.sendLots.bind(invoice_lots_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#query-lots', invoice_lots_crud.queryLots.bind(invoice_lots_crud));
    invoice_lots_crud.run('invoice_lots', 'Lotes&nbsp;Notas', document.getElementById('workarea'), (0, $708f028c2d9a84ab$export$2e2bcd8739ae039), (0, $88d370256d2b3a0d$export$2e2bcd8739ae039), fieldspecs, operations);
};
var $c15275aa38f8683d$export$2e2bcd8739ae039 = $c15275aa38f8683d$var$invoiceLots;




var $1cmSR = parcelRequire("1cmSR");


async function $e903493e9845218c$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; }
			.view td:nth-child(3)	{ text-align: left; max-width: 20rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Grupo</th>
					<th data-index="2" data-visible="${this.visible[1]}">Nome</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${record.name}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




var $1cmSR = parcelRequire("1cmSR");

/**
 * Grupos de endpoints por função para o modal de permissões de Grupos.
 * Cada grupo contém padrões (substrings) do path do endpoint.
 * Ao clicar no grupo, todos os endpoints cujo path contém algum padrão são adicionados.
 */ var $1fac238c462a9741$export$2e2bcd8739ae039 = [
    {
        label: "Sa\xeddas",
        patterns: [
            '/outputs',
            '/output-orders'
        ]
    },
    {
        label: 'Entradas',
        patterns: [
            '/inputs',
            '/input-orders'
        ]
    },
    {
        label: 'Estoques',
        patterns: [
            '/stocks'
        ]
    },
    {
        label: 'Pedidos de Entrada',
        patterns: [
            '/input-orders',
            '/companies/input-orders',
            '/receipt-types'
        ]
    },
    {
        label: "Pedidos de Sa\xedda",
        patterns: [
            '/output-orders'
        ]
    },
    {
        label: "Cat\xe1logo",
        patterns: [
            '/products',
            '/packagings',
            '/categories',
            '/manufacturers',
            '/units',
            '/classes'
        ]
    },
    {
        label: 'Armazenamento',
        patterns: [
            '/warehouses',
            '/locations',
            '/lots',
            '/inventories',
            '/replenishments',
            '/devices'
        ]
    },
    {
        label: 'Comercial',
        patterns: [
            '/customers',
            '/payment-terms',
            '/price-lists',
            '/cfops',
            '/customer-prices'
        ]
    },
    {
        label: 'Faturamento',
        patterns: [
            '/invoices',
            '/invoice-lots'
        ]
    },
    {
        label: "Organiza\xe7\xe3o",
        patterns: [
            '/suppliers',
            '/carriers'
        ]
    },
    {
        label: 'Sistema',
        patterns: [
            '/groups',
            '/users',
            '/companies',
            '/endpoints',
            '/states',
            '/cities',
            '/logs',
            '/version',
            '/import-center',
            '/integration-events'
        ]
    },
    {
        label: "Transa\xe7\xf5es",
        patterns: [
            '/transactions'
        ]
    }
];


var $d82290fc064f7de6$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#group-form-wrapper { min-width: 52rem; max-width: 90vw; }
			#group #id { width: 20rem; }
			#group #name { width: 20rem; }
			#group .endpoints-section { display: flex; gap: var(--space-md); align-items: flex-start; margin-bottom: var(--space-md); }
			#group .endpoints-keymap { flex: 1; display: flex; gap: var(--space-sm); align-items: stretch; }
			#group .endpoints-keymap .keymap:not(:has(button)) { min-width: 14rem; }
			#group .endpoints-keymap select { min-height: 12rem; }
			#group .endpoint-search { margin-bottom: var(--space-sm); }
			#group .endpoint-search input { width: 100%; max-width: 24rem; }
			#group .function-groups { display: flex; flex-wrap: wrap; gap: var(--space-xs); margin-bottom: var(--space-md); }
			#group .function-groups button { font-size: 0.85em; padding: 0.25rem 0.5rem; }
			#group .function-groups-title { font-size: 0.9em; color: var(--color-muted); margin-bottom: 0.25rem; }
			#group .keymap-transfer { display: flex; flex-direction: column; gap: 0.25rem; justify-content: center; }
			#group .keymap-transfer button { min-width: 2.25rem; min-height: 2rem; font-size: 1.1rem; font-weight: bold; padding: 0.25rem; }
		</style>
		<div id="group-form-wrapper">
		<form id="group" class="form" autocomplete="off">
			<div class="fsb">
				<label title="Identificador do grupo">Grupo
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do grupo">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="endpoints-section">
				<div>
					<div class="function-groups-title">Por fun\xe7\xe3o (adicionar todos de uma vez)</div>
					<div class="function-groups" id="function-groups"></div>
					<div class="endpoint-search">
						<label>Buscar endpoints
							<input id="endpoint_search" type="text" placeholder="Digite para filtrar...">
						</label>
					</div>
					<div class="fsb endpoints-keymap">
						<label class="keymap">Endpoints<sup>*</sup>
							<select id="endpoints" multiple size="8" required>
							</select>
						</label>
						<span class="keymap keymap-transfer">
							<button class="bn_Left" title="Incluir endpoints selecionados">&#8592; Incluir</button>
							<button class="bn_Right" title="Remover endpoints selecionados">Remover &#8594;</button>
						</span>
						<label class="keymap">Dispon\xedveis
							<select id="available_endpoints" multiple size="8">
							</select>
						</label>
					</div>
				</div>
			</div>
			<div class="fsb">
				<label class="keymap">Empresas<sup>*</sup>
					<select id="companies" multiple size="6" required>
					</select>
				</label>
				<span class="keymap keymap-transfer">
					<button class="bn_Left" title="Incluir empresas">&#8592; Incluir</button>
					<button class="bn_Right" title="Remover empresas">Remover &#8594;</button>
				</span>
				<label class="keymap">Dispon\xedveis
					<select id="available_companies" multiple size="6">
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
		</div>
	`,
    form: {
        selector: '#group',
        init (formset) {
            Object.getPrototypeOf(this).init.call(this);
            const form = formset.form;
            const root = formset.dialog?.getNode?.();
            if (!root) return;
            const searchInput = root.querySelector('#endpoint_search');
            const availableSelect = root.querySelector('#available_endpoints');
            const leftBtn = root.querySelector('.bn_Left');
            const fnGroupsEl = root.querySelector('#function-groups');
            (0, $1fac238c462a9741$export$2e2bcd8739ae039).forEach((fg)=>{
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'button';
                btn.textContent = fg.label;
                btn.title = `Adicionar todos os endpoints de ${fg.label}`;
                btn.addEventListener('click', async ()=>{
                    const all = await (0, $1cmSR.default).list('endpoints') || [];
                    const selected = form.getFieldBySelector('#endpoints')?.getValue?.() || [];
                    const selectedSet = new Set(selected.map(String));
                    const matches = all.filter((ep)=>{
                        const path = (ep.endpoint || '').toLowerCase();
                        return fg.patterns.some((p)=>path.includes(p.toLowerCase())) && !selectedSet.has(String(ep.id));
                    });
                    if (matches.length === 0) return;
                    const matchIds = new Set(matches.map((m)=>String(m.id)));
                    Array.from(availableSelect.options).forEach((opt)=>{
                        const parsed = (0, $7c7f18e63e55bfe1$export$98e6a39c04603d36)(opt.value);
                        const optId = Array.isArray(parsed) ? parsed[0] : parsed;
                        if (matchIds.has(String(optId))) opt.selected = true;
                    });
                    leftBtn?.click();
                });
                fnGroupsEl?.appendChild(btn);
            });
            searchInput?.addEventListener('input', ()=>{
                const q = (searchInput.value || '').toLowerCase().trim();
                Array.from(availableSelect.options).forEach((opt)=>{
                    opt.style.display = !q || opt.textContent.toLowerCase().includes(q) ? '' : 'none';
                });
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#id'
            },
            types: []
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#endpoints'
            },
            types: [
                $b63c535296d208bd$export$2e2bcd8739ae039('endpoints', '#available_endpoints', {
                    labels: [
                        'name',
                        'method'
                    ]
                }),
                $374af83299fa0b20$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#companies'
            },
            types: [
                $b63c535296d208bd$export$2e2bcd8739ae039('all_companies', '#available_companies', {
                    labels: [
                        'nick'
                    ]
                }),
                $374af83299fa0b20$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $f9ccb4979589756b$var$groups = function() {
    let groups_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            const [endpoints, companies] = await Promise.all([
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_endpoints, this.queryAll()),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_all_companies, this.queryAll())
            ]);
            if (endpoints) await (0, $1cmSR.default).set('endpoints', endpoints).catch((e)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e));
            if (companies) await (0, $1cmSR.default).set('all_companies', companies).catch((e)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_groups, query);
        },
        async loadRecord (id) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_group, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                endpoints: data.endpoints,
                companies: data.companies
            };
            if (old_data) return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_group, data.id, _record);
            else return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_group, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: 'Grupo',
            types: [],
            placeholder: '',
            title: 'Identificador do grupo'
        },
        {
            index: 2,
            field: 'name',
            label: 'Nome',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Nome do grupo'
        }
    ];
    groups_crud.run('groups', 'Grupos', document.getElementById('workarea'), (0, $e903493e9845218c$export$2e2bcd8739ae039), (0, $d82290fc064f7de6$export$2e2bcd8739ae039), fieldspecs);
};
var $f9ccb4979589756b$export$2e2bcd8739ae039 = $f9ccb4979589756b$var$groups;




var $1cmSR = parcelRequire("1cmSR");




async function $6c2838c21d5bc54c$export$2e2bcd8739ae039(records) {
    function statusLabel(record) {
        if (record.is_disabled) return 'Inativo';
        if (record.is_blocked) return 'Bloqueado';
        return 'Ativo';
    }
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; }
			.view td:nth-child(3)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left;	}
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Usu\xe1rio</th>
					<th data-index="2" data-visible="${this.visible[1]}">Nome</th>
					<th data-index="3" data-visible="${this.visible[2]}">Email</th>
					<th data-index="4" data-visible="${this.visible[3]}">Fone</th>
					<th data-index="5" data-visible="${this.visible[4]}">Username</th>
					<th data-index="6" data-visible="${this.visible[5]}">Status</th>
					<th data-index="7" data-visible="${this.visible[6]}">Bloqueado</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${record.name}</td>
					<td data-visible='${this.visible[2]}'>${record.email || ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format($e576b042880c33f1$export$2e2bcd8739ae039(), record.phone)}</td>
					<td data-visible='${this.visible[4]}'>${record.username}</td>
					<td data-visible='${this.visible[5]}'>${statusLabel(record)}</td>
					<td data-visible='${this.visible[6]}'>${record.is_blocked ? 'SIM' : 'NAO'}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}





function $de5ba539ecb71508$var$lockoutExpirationIso() {
    const d = new Date();
    d.setDate(d.getDate() + 30);
    return d.toISOString();
}
var $de5ba539ecb71508$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#user #id				{ width: 20rem;		}
			#user #name				{ width: 20rem;		}
			#user #email			{ width: 20rem;		}
			#user #phone			{ width: 10rem;		}
			#user #username			{ width: 10rem; 	}
			#user #user_status		{ width: 10rem;		}
		</style>
		<form id="user" class="form" autocomplete="off">
			<div class="fsb">
				<label title="Status do usu\xe1rio no sistema">Status
					<input id="user_status" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Identificador do usu\xe1rio">Usu\xe1rio
					<input id="id" type="text" disabled>
				</label>
				<label title="Usu\xe1rio de acesso ao sistema">Username<sup>*</sup>
					<input id="username" type="text" required>
				</label>
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
			</div>
			<div class="fsb">
				<label title="Nome do usu\xe1rio">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label class="keymap">Grupos<sup>*</sup>
					<select id="groups" multiple size="4" required>
					</select>
				</label>
				<span class="keymap">
					<button class="bn_Left" title="Incluir grupos selecionados \xe0 direita"> &#x1F844;</button>
					<button class="bn_Right" title="Remover grupos selecionados \xe0 esquerda">&#x1F846;</button>
				</span>
				<label class="keymap">Dispon\xedveis
					<select id="available" multiple size="4">
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_user_disable" title="Impede login at\xe9 reativar">Inativar</button>
					<button type="button" class="button bn_user_enable" title="Permite login novamente">Ativar</button>
					<button type="button" class="button bn_user_block" title="Bloqueia login temporariamente">Bloquear</button>
					<button type="button" class="button bn_user_unblock" title="Remove bloqueio">Desbloquear</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#user',
        init (formset) {
            const root = ()=>formset.dialog?.getNode?.();
            const formEl = ()=>root()?.querySelector?.('#user');
            const getId = ()=>formEl()?.querySelector?.('#id')?.value;
            const setStatus = (s)=>{
                const el = formEl()?.querySelector?.('#user_status');
                if (el) el.value = s;
            };
            const doAction = async (payload, statusLabel)=>{
                const id = getId();
                if (!id) return;
                const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_user, id, payload);
                // http retorna true ou body em sucesso; undefined em falha (nunca retorna Response)
                if (resp != null) setStatus(statusLabel);
                else (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Falha ao atualizar usu\xe1rio.", "Usu\xe1rios");
            };
            // Delegação no dialog para garantir que o clique dispare o PATCH (evita interceptação pelo dialog)
            const dialogNode = root();
            if (dialogNode) dialogNode.addEventListener('click', (ev)=>{
                const t = ev.target?.closest?.('.bn_user_disable');
                if (t) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: true
                    }, 'Inativo');
                    return;
                }
                const e = ev.target?.closest?.('.bn_user_enable');
                if (e) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: false
                    }, 'Ativo');
                    return;
                }
                const b = ev.target?.closest?.('.bn_user_block');
                if (b) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        lockout_expiration: $de5ba539ecb71508$var$lockoutExpirationIso()
                    }, 'Bloqueado');
                    return;
                }
                const u = ev.target?.closest?.('.bn_user_unblock');
                if (u) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        lockout_expiration: null
                    }, 'Ativo');
                    return;
                }
            });
            Object.getPrototypeOf(this).init?.call(this, formset);
        }
    },
    fields: [
        {
            properties: {
                selector: '#user_status'
            },
            types: []
        },
        {
            properties: {
                selector: '#id'
            },
            types: []
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#email'
            },
            types: [
                $ff6c02d4f0df8745$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#username'
            },
            types: [
                $8a6cf87eb88dd049$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#groups'
            },
            types: [
                $b63c535296d208bd$export$2e2bcd8739ae039('groups', '#available'),
                $374af83299fa0b20$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $fd46b4f29c53dd9f$var$LOCKOUT_DAYS = 30;
function $fd46b4f29c53dd9f$var$lockoutExpirationIso() {
    const d = new Date();
    d.setDate(d.getDate() + $fd46b4f29c53dd9f$var$LOCKOUT_DAYS);
    return d.toISOString();
}
const $fd46b4f29c53dd9f$var$users = function() {
    let users_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_groups, this.queryAll()).then((data)=>(0, $1cmSR.default).set('groups', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_users, query);
        },
        async loadRecord (id) {
            const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_user, ...JSON.parse(id));
            if (data && typeof data === 'object') data.user_status = data.is_disabled ? 'Inativo' : data.is_blocked ? 'Bloqueado' : 'Ativo';
            return data;
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                email: data.email,
                phone: data.phone,
                username: data.username,
                groups: data.groups
            };
            if (old_data) {
                // Preservar is_disabled e lockout_expiration do servidor (bloqueio/inativo alterados na ficha)
                const current = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_user, data.id);
                if (current && typeof current === 'object') {
                    if ('is_disabled' in current) _record.is_disabled = current.is_disabled;
                    if ('lockout_expiration' in current) _record.lockout_expiration = current.lockout_expiration;
                }
                return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_user, data.id, _record);
            }
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).insert_user, _record);
        },
        async setDisabled (disabled) {
            const ids = await this.getSelectedIds([
                'id'
            ]);
            if (!ids.length) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione ao menos um usu\xe1rio.", "Usu\xe1rios");
            const action = disabled ? 'Inativar' : 'Ativar';
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Confirma ${action} ${ids.length} usu\xe1rio(s)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                for (const [id] of ids){
                    const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_user, id, {
                        is_disabled: !!disabled
                    });
                    if (resp == null) {
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Falha ao atualizar usu\xe1rio.", "Usu\xe1rios");
                        return;
                    }
                }
                this.loadPage();
            });
        },
        async setBlocked (blocked) {
            const ids = await this.getSelectedIds([
                'id'
            ]);
            if (!ids.length) return (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Selecione ao menos um usu\xe1rio.", "Usu\xe1rios");
            const action = blocked ? 'Bloquear' : 'Desbloquear';
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)(`Confirma ${action} ${ids.length} usu\xe1rio(s)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                const payload = blocked ? {
                    lockout_expiration: $fd46b4f29c53dd9f$var$lockoutExpirationIso()
                } : {
                    lockout_expiration: null
                };
                for (const [id] of ids){
                    const resp = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).update_user, id, payload);
                    if (resp == null) {
                        (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Falha ao atualizar usu\xe1rio.", "Usu\xe1rios");
                        return;
                    }
                }
                this.loadPage();
            });
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: "Usu\xe1rio",
            types: [],
            placeholder: '',
            title: "Identificador do usu\xe1rio"
        },
        {
            index: 2,
            field: 'name',
            label: 'Nome',
            types: [
                $5263fa1d5ed7aac5$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Nome do usu\xe1rio"
        },
        {
            index: 3,
            field: 'email',
            label: 'Email',
            types: [
                $ff6c02d4f0df8745$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Email para reset de senha'
        },
        {
            index: 4,
            field: 'phone',
            label: 'Fone',
            types: [
                $e576b042880c33f1$export$2e2bcd8739ae039()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone de contato'
        },
        {
            index: 5,
            field: 'username',
            label: 'Username',
            types: [
                $8a6cf87eb88dd049$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Nome de usu\xe1rio para acesso ao sistema"
        },
        {
            index: 6,
            field: 'user_status',
            label: 'Status',
            types: [],
            placeholder: '',
            title: "Status do usu\xe1rio"
        },
        {
            index: 7,
            field: 'is_blocked',
            label: 'Bloqueado',
            types: [],
            placeholder: '',
            title: "Usu\xe1rio bloqueado (SIM/NAO)"
        }
    ];
    let operations = [
        {
            hash: '#user-disable',
            label: 'Inativar'
        },
        {
            hash: '#user-enable',
            label: 'Ativar'
        },
        {
            hash: '#user-block',
            label: 'Bloquear'
        },
        {
            hash: '#user-unblock',
            label: 'Desbloquear'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#user-disable', users_crud.setDisabled.bind(users_crud, true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#user-enable', users_crud.setDisabled.bind(users_crud, false));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#user-block', users_crud.setBlocked.bind(users_crud, true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#user-unblock', users_crud.setBlocked.bind(users_crud, false));
    users_crud.run('users', "Usu\xe1rios", document.getElementById('workarea'), (0, $6c2838c21d5bc54c$export$2e2bcd8739ae039), (0, $de5ba539ecb71508$export$2e2bcd8739ae039), fieldspecs, operations, []);
};
var $fd46b4f29c53dd9f$export$2e2bcd8739ae039 = $fd46b4f29c53dd9f$var$users;




var $1cmSR = parcelRequire("1cmSR");



async function $ca63d0d98a968fdb$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: right; }
			.view td:nth-child(3)	{ text-align: center; }
			.view td:nth-child(4)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(7)	{ text-align: left; max-width: 5rem; }
			.view td:nth-child(8)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(9)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Evento</th>
					<th data-index="2" data-visible="${this.visible[1]}">Data/Hora</th>
					<th data-index="3" data-visible="${this.visible[2]}">Usu\xe1rio</th>
					<th data-index="4" data-visible="${this.visible[3]}">Origem</th>
					<th data-index="5" data-visible="${this.visible[4]}">Agente</th>
					<th data-index="6" data-visible="${this.visible[5]}">M\xe9todo</th>
					<th data-index="7" data-visible="${this.visible[6]}">URL</th>
					<th data-index="8" data-visible="${this.visible[7]}">Dados</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${record.id}'>
					<td><input type="checkbox"${this.isChecked(record.id)}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.date_time)}</td>
					<td data-visible='${this.visible[2]}'>${await this.key('users', record.user_id) || ''}</td>
					<td data-visible='${this.visible[3]}'>${record.origin}</td>
					<td data-visible='${this.visible[4]}'>${record.agent}</td>
					<td data-visible='${this.visible[5]}'>${record.method}</td>
					<td data-visible='${this.visible[6]}'>${record.path}</td>
					<td data-visible='${this.visible[7]}'>${record.body ? '&#10003;' : ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $8d14789de03340ac$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#log #id		{ width: 6rem; text-align: right;	}
			#log #date_time	{ width: 10rem;	}
			#log #user_id	{ width: 12rem;	}
			#log #origin	{ width: 6rem;	}
			#log #method	{ width: 5rem;	}
			#log .agent		{ width: 100%;	}
			#log .path		{ width: 100%;	}
			#log .body		{ width: 100%;	}
		</style>
		<form id="log" class="form" autocomplete="off">
			<datalist id="users">
			</datalist>
			<div class="fsb">
				<label title="Identificador do evento">Evento
					<input id="id" type="text" disabled>
				</label>
				<label title="Data e hora do registro">Data/Hora
					<input id="date_time" type="text" disabled>
				</label>
				<label title="Usu\xe1rio">Usu\xe1rio
					<input id="user_id" type="text" list="users" disabled>
				</label>
				<label title="Endere\xe7o IP de Origem">Origem
					<input id="origin" type="text" disabled>
				</label>
				<label title="M\xe9todo HTTP">M\xe9todo
					<input id="method" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="agent" title="User-Agent">Agente
					<input id="agent" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="path" title="Caminho">URL
					<input id="path" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="body" title="Corpo da requisi\xe7\xe3o">Dados
					<textarea id="body" rows="8" disabled></textarea>
				</label>
			</div>
			<div class="tar">
				<button class='bn_Escape button'>Fechar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#log',
        init (formset) {
            formset.loadList('#users', 'users');
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#date_time'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#user_id'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#origin'
            },
            types: []
        },
        {
            properties: {
                selector: '#agent'
            },
            types: []
        },
        {
            properties: {
                selector: '#method'
            },
            types: []
        },
        {
            properties: {
                selector: '#path'
            },
            types: []
        },
        {
            properties: {
                selector: '#body'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        }
    ]
};



const $307409da5029dbc2$var$auditLogs = function() {
    let audit_logs_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)));
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_logs, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_log, id);
            _record['body'] = _record['body'] ? JSON.stringify(_record['body']) : '';
            return _record;
        },
        async saveRecord (data, old_data) {}
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: 'Evento',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do evento'
        },
        {
            index: 2,
            field: 'date_time',
            label: 'Data/Hora',
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: 'Data e hora de registro'
        },
        {
            index: 3,
            field: 'user_id',
            label: "Usu\xe1rio",
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Usu\xe1rio",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 4,
            field: 'origin',
            label: 'Origem',
            types: [],
            placeholder: '0.0.0.0',
            title: 'IP de origem'
        },
        {
            index: 5,
            field: 'agent',
            label: 'Agente',
            types: [],
            placeholder: '',
            title: 'User-Agent'
        },
        {
            index: 6,
            field: 'method',
            label: "M\xe9todo",
            types: [],
            placeholder: '',
            title: "M\xe9todo HTTP"
        },
        {
            index: 7,
            field: 'path',
            label: 'URL',
            types: [],
            placeholder: '',
            title: 'URL'
        },
        {
            index: 8,
            field: 'body',
            label: 'Dados',
            types: [],
            placeholder: '',
            title: "Corpo da requisi\xe7\xe3o"
        }
    ];
    audit_logs_crud.run('audit_logs', 'Eventos', document.getElementById('workarea'), (0, $ca63d0d98a968fdb$export$2e2bcd8739ae039), (0, $8d14789de03340ac$export$2e2bcd8739ae039), fieldspecs);
};
var $307409da5029dbc2$export$2e2bcd8739ae039 = $307409da5029dbc2$var$auditLogs;




var $1cmSR = parcelRequire("1cmSR");






function $25a9432000c4705b$var$esc(s) {
    if (s == null || s === '') return '';
    const t = String(s);
    return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $25a9432000c4705b$var$_dirPt(d) {
    if (d === 'inbound') return 'Entrada';
    if (d === 'outbound') return "Sa\xedda";
    return d ? String(d) : "\u2014";
}
/** Cabeçalho SESSP (TechHub/IBL) — ativado pela API quando INTEGRATION_CENTRAL_BANNER=sessp */ function $25a9432000c4705b$var$_healthBannerSesspHtml(summary) {
    const agg = summary.banner_aggregates != null ? summary.banner_aggregates : summary.aggregates || [];
    const lines = agg.length ? agg.map((a)=>{
        const key = (a.integration_key || '').toLowerCase() === 'techhub_ibl' ? "TechHub \u2014 IBL" : $25a9432000c4705b$var$esc(a.integration_key || "\u2014");
        const fails = a.fail_period ?? 0;
        const last = a.last_at != null ? $25a9432000c4705b$var$esc(String(a.last_at)) : "\u2014";
        const failTxt = fails === 0 ? "nenhuma falha no per\xedodo" : `${fails} falha(s) no per\xedodo`;
        return `<div style="margin-top:0.2rem;">\u{2022} <strong>${key}</strong> \u{2014} ${$25a9432000c4705b$var$_dirPt(a.direction)}: \xfaltimo evento <code style="font-size:0.85em;">${last}</code> \xb7 ${failTxt}</div>`;
    }).join('') : `<div style="margin-top:0.25rem;color:var(--color-muted,#444);">Nenhum evento da integra\xe7\xe3o TechHub neste per\xedodo.</div>`;
    const notes = (summary.notes || []).map((n)=>`<div style="margin-top:0.25rem;">${$25a9432000c4705b$var$esc(n)}</div>`).join('');
    return `
		<div class="integration-health-banner" style="margin:0.5rem 0 1rem;padding:0.75rem 1rem;border:1px solid var(--color-border,#ccc);border-radius:6px;background:var(--color-panel,#f9f9f9);font-size:0.9rem;">
			<div style="font-weight:bold;margin-bottom:0.35rem;">Integra\xe7\xe3o SESSP \u{2014} TechHub / IBL</div>
			<div style="color:var(--color-muted,#444);font-size:0.88rem;">Resumo das \xfaltimas <strong>${$25a9432000c4705b$var$esc(String(summary.period_hours ?? 24))}</strong> horas (integra\xe7\xe3o com o middleware da IBL).</div>
			${lines}
			<div style="margin-top:0.45rem;font-size:0.82rem;color:var(--color-muted,#555);">Em <strong>PRD</strong> o servidor deve rodar o cron <code>cron/tick</code> (pull + fila + status) \u{2014} ver <code>doc/server/TECHHUB-IBL-CRON-SESSP-AWS.md</code>. Em <strong>QA</strong> use o menu: <strong>Buscar faturas na IBL</strong> (pull), depois <strong>Processar fila TechHub</strong> e, se precisar, <strong>Enviar status \xe0 IBL</strong>.</div>
			<div style="margin-top:0.5rem;font-size:0.82rem;color:var(--color-muted,#666);border-top:1px solid var(--color-border,#ddd);padding-top:0.45rem;">
				${notes}
			</div>
		</div>`;
}
function $25a9432000c4705b$var$_healthBannerHtml(summary) {
    if (!summary) return '';
    if (summary.banner_mode === 'sessp') return $25a9432000c4705b$var$_healthBannerSesspHtml(summary);
    const p = summary.runner?.protheus;
    const st = p?.status || "\u2014";
    const stClass = st === 'ok' ? 'integration-health-ok' : st === 'stale' ? 'integration-health-warn' : 'integration-health-bad';
    const rows = (summary.aggregates || []).map((a)=>`${a.integration_key} ${a.direction || "\u2014"}: \xfaltimo ${a.last_at || "\u2014"} (${a.fail_period ?? 0} falhas no per\xedodo)`).join(" \xb7 ");
    return `
		<div class="integration-health-banner" style="margin:0.5rem 0 1rem;padding:0.75rem 1rem;border:1px solid var(--color-border,#ccc);border-radius:6px;background:var(--color-panel,#f9f9f9);font-size:0.9rem;">
			<div style="font-weight:bold;margin-bottom:0.35rem;">Sa\xfade das integra\xe7\xf5es</div>
			<div><strong>Conector Protheus</strong> \u{2014} <span class="${stClass}">${$25a9432000c4705b$var$esc(st)}</span>${p?.last_heartbeat_at ? ` \xb7 \xfaltimo heartbeat: ${$25a9432000c4705b$var$esc(String(p.last_heartbeat_at))}` : ''}</div>
			<div style="margin-top:0.25rem;"><strong>Espelho inbound (API)</strong> \u{2014} ${summary.mirror_inbound_enabled ? 'ativo' : 'desligado (env)'}</div>
			<div style="margin-top:0.35rem;color:var(--color-muted,#444);">${$25a9432000c4705b$var$esc(rows || "Sem eventos no per\xedodo.")}</div>
			<div style="margin-top:0.45rem;font-size:0.82rem;color:var(--color-muted,#666);">${$25a9432000c4705b$var$esc((summary.notes || []).join(' '))}</div>
			${p?.hint ? `<div style="margin-top:0.35rem;font-size:0.82rem;">${$25a9432000c4705b$var$esc(p.hint)}</div>` : ''}
		</div>
		<style>
			.integration-health-ok { color: #0a6e0a; font-weight: 600; }
			.integration-health-warn { color: #a65f00; font-weight: 600; }
			.integration-health-bad { color: #b00020; font-weight: 600; }
		</style>`;
}
async function $25a9432000c4705b$export$2e2bcd8739ae039(records) {
    let banner = '';
    try {
        const base = (0, $73936c209f170d43$export$ffe95df7b31670e0)();
        const r = await fetch(`${base}/integration-events/summary?hours=24&stale_minutes=12`, {
            credentials: 'include'
        });
        if (r.ok) banner = $25a9432000c4705b$var$_healthBannerHtml(await r.json());
    } catch (e) {}
    return banner + `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: right; }
			.view td:nth-child(3)	{ text-align: center; }
			.view td:nth-child(4)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(5)	{ text-align: center; max-width: 5rem; }
			.view td:nth-child(6)	{ text-align: center; max-width: 5rem; }
			.view td:nth-child(7)	{ text-align: left; max-width: 24rem; }
			.view td:nth-child(8)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 16rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(12)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(13)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(14)	{ text-align: left; max-width: 8rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Evento</th>
					<th data-index="2" data-visible="${this.visible[1]}">Data/Hora</th>
					<th data-index="3" data-visible="${this.visible[2]}">Empresa</th>
					<th data-index="4" data-visible="${this.visible[3]}">Integra\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Dire\xe7\xe3o</th>
					<th data-index="6" data-visible="${this.visible[5]}">Status</th>
					<th data-index="7" data-visible="${this.visible[6]}">Resumo</th>
					<th data-index="8" data-visible="${this.visible[7]}">Tipo</th>
					<th data-index="9" data-visible="${this.visible[8]}">ID entidade</th>
					<th data-index="10" data-visible="${this.visible[9]}">Erro</th>
					<th data-index="11" data-visible="${this.visible[10]}">Correla\xe7\xe3o</th>
					<th data-index="12" data-visible="${this.visible[11]}">Origem</th>
					<th data-index="13" data-visible="${this.visible[12]}">Registrado por</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${record.id}'>
					<td><input type="checkbox"${this.isChecked(record.id)}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${this.format($6592b17c40023188$export$2e2bcd8739ae039(), record.date_time)}</td>
					<td data-visible='${this.visible[2]}'>${await this.key('companies', record.company_id) || ''}</td>
					<td data-visible='${this.visible[3]}'>${$25a9432000c4705b$var$esc(record.integration_key)}</td>
					<td data-visible='${this.visible[4]}'>${$25a9432000c4705b$var$esc(record.direction)}</td>
					<td data-visible='${this.visible[5]}'>${$25a9432000c4705b$var$esc(record.status)}</td>
					<td data-visible='${this.visible[6]}'>${$25a9432000c4705b$var$esc(record.summary)}</td>
					<td data-visible='${this.visible[7]}'>${$25a9432000c4705b$var$esc(record.entity_type)}</td>
					<td data-visible='${this.visible[8]}'>${$25a9432000c4705b$var$esc(record.entity_id)}</td>
					<td data-visible='${this.visible[9]}'>${$25a9432000c4705b$var$esc(record.error_message)}</td>
					<td data-visible='${this.visible[10]}'>${$25a9432000c4705b$var$esc(record.correlation_id)}</td>
					<td data-visible='${this.visible[11]}'>${$25a9432000c4705b$var$esc(record.source)}</td>
					<td data-visible='${this.visible[12]}'>${await this.key('users', record.recorded_by) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $a91ff1aa595c2c0c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#integration_event #id		{ width: 6rem; text-align: right;	}
			#integration_event #date_time	{ width: 10rem;	}
			#integration_event #company_id	{ width: 12rem;	}
			#integration_event #integration_key	{ width: 14rem;	}
			#integration_event #direction	{ width: 8rem;	}
			#integration_event #status	{ width: 8rem;	}
			#integration_event .summary	{ width: 100%;	}
			#integration_event #entity_type	{ width: 12rem;	}
			#integration_event #entity_id	{ width: 14rem;	}
			#integration_event .error_message	{ width: 100%;	}
			#integration_event #correlation_id	{ width: 20rem;	}
			#integration_event #source	{ width: 14rem;	}
			#integration_event #recorded_by	{ width: 12rem;	}
			#integration_event .payload	{ width: 100%;	}
		</style>
		<form id="integration_event" class="form" autocomplete="off">
			<datalist id="iev_companies">
			</datalist>
			<datalist id="iev_users">
			</datalist>
			<div class="fsb">
				<label title="Identificador">Evento
					<input id="id" type="text" disabled>
				</label>
				<label title="Data e hora">Data/Hora
					<input id="date_time" type="text" disabled>
				</label>
				<label title="Empresa">Empresa
					<input id="company_id" type="text" list="iev_companies" disabled>
				</label>
				<label title="Chave da integra\xe7\xe3o">Integra\xe7\xe3o
					<input id="integration_key" type="text" disabled>
				</label>
				<label title="Dire\xe7\xe3o">Dire\xe7\xe3o
					<input id="direction" type="text" disabled>
				</label>
				<label title="Status">Status
					<input id="status" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="summary" title="Resumo">Resumo
					<input id="summary" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Tipo da entidade">Tipo entidade
					<input id="entity_type" type="text" disabled>
				</label>
				<label title="ID da entidade">ID entidade
					<input id="entity_id" type="text" disabled>
				</label>
				<label title="UUID de correla\xe7\xe3o">Correla\xe7\xe3o
					<input id="correlation_id" type="text" disabled>
				</label>
				<label title="Origem">Origem
					<input id="source" type="text" disabled>
				</label>
				<label title="Usu\xe1rio">Registrado por
					<input id="recorded_by" type="text" list="iev_users" disabled>
				</label>
			</div>
			<div>
				<label class="error_message" title="Mensagem de erro">Erro
					<textarea id="error_message" rows="3" disabled></textarea>
				</label>
			</div>
			<div>
				<label class="payload" title="Request (JSON)">Request
					<textarea id="request_payload" rows="6" disabled></textarea>
				</label>
			</div>
			<div>
				<label class="payload" title="Response (JSON)">Response
					<textarea id="response_payload" rows="6" disabled></textarea>
				</label>
			</div>
			<div>
				<label class="payload" title="Stack trace">Stack
					<textarea id="error_stack" rows="6" disabled></textarea>
				</label>
			</div>
			<div class="tar">
				<button class='bn_Escape button'>Fechar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#integration_event',
        init (formset) {
            formset.loadList('#iev_companies', 'companies');
            formset.loadList('#iev_users', 'users');
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#id'
            },
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ]
        },
        {
            properties: {
                selector: '#date_time'
            },
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#integration_key'
            },
            types: []
        },
        {
            properties: {
                selector: '#direction'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: []
        },
        {
            properties: {
                selector: '#summary'
            },
            types: []
        },
        {
            properties: {
                selector: '#entity_type'
            },
            types: []
        },
        {
            properties: {
                selector: '#entity_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#correlation_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#source'
            },
            types: []
        },
        {
            properties: {
                selector: '#recorded_by'
            },
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#error_message'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#request_payload'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#response_payload'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#error_stack'
            },
            types: [
                $ed60b42a52adaca6$export$2e2bcd8739ae039()
            ]
        }
    ]
};


var $5ec9602c4a2efd0c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#techhub-pull-form #tp_company_id	{ width: 22rem; }
			#techhub-pull-form #tp_cd_local_origem	{ width: 10rem; }
		</style>
		<form id="techhub-pull-form" class="form" autocomplete="off">
			<div class="title">Buscar faturas na IBL (local espec\xedfico)</div>
			<p class="mtm" style="max-width:36rem;font-size:0.9rem;color:var(--color-muted,#555);">
				Informe a empresa e o <strong>c\xf3digo do local de origem</strong> (ex.: 3006), como no GET
				<code>/faturas/integrado</code>. \xdatil em QA sem mapeamento cadastrado.
			</p>
			<div class="mtl">
				<label title="Empresa">Empresa
					<input id="tp_company_id" type="text" list="techhub_pull_companies" required placeholder="UUID ou apelido">
				</label>
				<label title="C\xf3digo local de origem na IBL">cd_local_origem
					<input id="tp_cd_local_origem" type="number" required min="0" step="1" placeholder="3006">
				</label>
			</div>
			<datalist id="techhub_pull_companies"></datalist>
			<div class="mtm">
				<button class='bn_Escape button' type="button">Cancelar</button>
				<button class='bn_Enter button' type="submit">Buscar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#techhub-pull-form',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#tp_company_id'
            },
            types: [],
            placeholder: '',
            title: 'Empresa'
        },
        {
            properties: {
                selector: '#tp_cd_local_origem'
            },
            types: [],
            placeholder: '3006',
            title: 'cd_local_origem'
        }
    ]
};



const $0a73b38866ec3649$var$integrationEvents = function() {
    let integration_events_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            await Promise.all([
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data)).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error)),
                (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data)).catch((error)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(error))
            ]);
        },
        async queryData (query) {
            return await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).list_integration_events, query);
        },
        async loadRecord (id) {
            let _record = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).select_integration_event, id);
            _record.request_payload = _record.request_payload ? JSON.stringify(_record.request_payload, null, 2) : '';
            _record.response_payload = _record.response_payload ? JSON.stringify(_record.response_payload, null, 2) : '';
            return _record;
        },
        async saveRecord () {},
        techhubProcessQueue () {
            const run = async ()=>{
                const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).post_integration_events_techhub_process, 200);
                if (data) {
                    let msg = `Fila TechHub: retirados ${data.picked ?? "\u2014"}, ok ${data.success ?? 0}, parcial ${data.partial ?? 0}, falha ${data.failure ?? 0}.`;
                    const sample = data.errors_sample && data.errors_sample[0];
                    if (sample && sample.error) msg += ` Ex.: inbox ${sample.inbox_id}: ${String(sample.error).slice(0, 280)}`;
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(msg, 'Resultado');
                }
                this.loadPage();
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)("Processar at\xe9 200 itens pendentes na fila TechHub (inbox)? Em produ\xe7\xe3o isso costuma rodar por cron no servidor; em QA use esta a\xe7\xe3o para validar com o cliente.", "Confirma\xe7\xe3o", (answer)=>{
                if (answer === 'Y') run();
            });
        },
        techhubFlushStatus () {
            const run = async ()=>{
                const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).post_integration_events_techhub_flush_status, 200);
                if (data) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Status IBL: retirados ${data.picked ?? "\u2014"}, enviados ${data.sent ?? 0}, falha ${data.failure ?? 0}.`, 'Resultado');
                this.loadPage();
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)("Enviar at\xe9 200 atualiza\xe7\xf5es de status pendentes para a API da IBL?", "Confirma\xe7\xe3o", (answer)=>{
                if (answer === 'Y') run();
            });
        },
        techhubPullBulk () {
            const run = async ()=>{
                const data = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).post_integration_events_techhub_pull, {});
                if (data) {
                    const nerr = data.errors && data.errors.length ? data.errors.length : 0;
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Pull (mapeamentos): ${data.targets ?? "\u2014"} local(is), ${data.total_fetched ?? 0} fatura(s) na API, ${data.total_enqueued ?? 0} na fila.${nerr ? ` Erros em ${nerr} local(is).` : ''}`, 'Resultado');
                }
                this.loadPage();
            };
            (0, $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8)('Consultar a IBL (GET /faturas/integrado) para cada mapeamento ativo das suas empresas e enfileirar na inbox?', "Confirma\xe7\xe3o", (answer)=>{
                if (answer === 'Y') run();
            });
        },
        techhubPullSingle () {
            let fs;
            const submit = async (data)=>{
                const company_id = String(data.tp_company_id || '').trim();
                const raw = data.tp_cd_local_origem;
                const cd_local_origem = parseInt(String(raw !== undefined && raw !== null ? raw : '').trim(), 10);
                if (!company_id || Number.isNaN(cd_local_origem)) {
                    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Informe empresa (UUID) e cd_local_origem (n\xfamero, ex.: 3006).", "Aten\xe7\xe3o");
                    return;
                }
                const out = await (0, $73936c209f170d43$export$2e2bcd8739ae039).call((0, $73936c209f170d43$export$2e2bcd8739ae039).post_integration_events_techhub_pull, {
                    company_id: company_id,
                    cd_local_origem: cd_local_origem
                });
                if (out && out.mode === 'single' && out.result) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(`Pull: ${out.result.fetched} fatura(s) lida(s), ${out.result.enqueued} na fila.`, 'Resultado');
                else if (out) (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)("Pull conclu\xeddo.", 'Resultado');
                fs.destroy();
                this.loadPage();
            };
            (0, $1cmSR.default).list('companies').then((rows)=>{
                fs = (0, $c643adc13e6018a8$export$2e2bcd8739ae039).create((0, $5ec9602c4a2efd0c$export$2e2bcd8739ae039), submit);
                fs.init();
                const dl = fs.dialog.getNode().querySelector('#techhub_pull_companies');
                if (dl) dl.innerHTML = (rows || []).map((c)=>{
                    const id = String(c.id || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
                    const lab = String(c.nick || c.name || c.id || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
                    return `<option value="${id}" label="${lab}"></option>`;
                }).join('');
            }).catch((e)=>(0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(e.message || String(e), 'Falha'));
        }
    });
    // Índices = ordem do SELECT leve em repos/integration_events (SQL_BASE_SELECT_LIGHT)
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: 'Evento',
            types: [
                $25a74ef8f667cbaa$export$2e2bcd8739ae039(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador'
        },
        {
            index: 2,
            field: 'date_time',
            label: 'Data/Hora',
            types: [
                $6592b17c40023188$export$2e2bcd8739ae039()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: 'Data e hora'
        },
        {
            index: 3,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 4,
            field: 'integration_key',
            label: "Integra\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Chave da integra\xe7\xe3o"
        },
        {
            index: 5,
            field: 'direction',
            label: "Dire\xe7\xe3o",
            types: [],
            placeholder: '',
            title: 'inbound / outbound'
        },
        {
            index: 6,
            field: 'status',
            label: 'Status',
            types: [],
            placeholder: '',
            title: 'success / failure / partial'
        },
        {
            index: 7,
            field: 'summary',
            label: 'Resumo',
            types: [],
            placeholder: '',
            title: 'Resumo'
        },
        {
            index: 8,
            field: 'entity_type',
            label: 'Tipo entidade',
            types: [],
            placeholder: '',
            title: 'Tipo da entidade'
        },
        {
            index: 9,
            field: 'entity_id',
            label: 'ID entidade',
            types: [],
            placeholder: '',
            title: 'Identificador da entidade'
        },
        {
            index: 10,
            field: 'error_message',
            label: 'Erro',
            types: [],
            placeholder: '',
            title: 'Mensagem de erro'
        },
        {
            index: 11,
            field: 'correlation_id',
            label: "Correla\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "UUID de correla\xe7\xe3o"
        },
        {
            index: 12,
            field: 'source',
            label: 'Origem',
            types: [],
            placeholder: '',
            title: 'Origem do registro'
        },
        {
            index: 13,
            field: 'recorded_by',
            label: 'Registrado por',
            types: [
                $728b723a7139bbbf$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Usu\xe1rio",
            store: 'users',
            labels: [
                'name'
            ]
        }
    ];
    integration_events_crud.run('integration_events', "Eventos de integra\xe7\xe3o", document.getElementById('workarea'), (0, $25a9432000c4705b$export$2e2bcd8739ae039), (0, $a91ff1aa595c2c0c$export$2e2bcd8739ae039), fieldspecs, [
        {
            hash: '#techhub-pull-bulk',
            label: 'Buscar faturas na IBL (mapeamentos)'
        },
        {
            hash: '#techhub-pull-single',
            label: 'Buscar faturas (empresa e local)'
        },
        {
            hash: '#techhub-process',
            label: 'Processar fila TechHub'
        },
        {
            hash: '#techhub-flush-status',
            label: "Enviar status \xe0 IBL"
        }
    ], []);
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#techhub-pull-bulk', integration_events_crud.techhubPullBulk.bind(integration_events_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#techhub-pull-single', integration_events_crud.techhubPullSingle.bind(integration_events_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#techhub-process', integration_events_crud.techhubProcessQueue.bind(integration_events_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#techhub-flush-status', integration_events_crud.techhubFlushStatus.bind(integration_events_crud));
};
var $0a73b38866ec3649$export$2e2bcd8739ae039 = $0a73b38866ec3649$var$integrationEvents;


/**
 * Central de Importação - Sistema > Central de Importação
 * Fluxo: 1) Selecionar entidade, 2) Upload e validação, 3) Importação
 * Layout alinhado ao sistema (msgbox, notify, ajuda ? como cadastro de produto)
 */ 

const $4858a4427bfed1ff$var$IMPORT_HELP_CLASS = 'import-help-body';
const $4858a4427bfed1ff$var$IMPORT_HELP_1 = `
<div class="${$4858a4427bfed1ff$var$IMPORT_HELP_CLASS}">
<h4>Vis\xe3o geral</h4>
<p>A central carrega da API a lista de tipos de cadastro que podem ser importados por planilha. O fluxo \xe9: <strong>escolher entidade</strong> \u{2192} <strong>enviar arquivo</strong> \u{2192} <strong>validar</strong> \u{2192} <strong>importar</strong> s\xf3 as linhas aprovadas.</p>
<h4>Organiza\xe7\xe3o</h4>
<p>Cadastros ligados \xe0 empresa depositante (ex.: fornecedores, clientes, transportadores), conforme habilitado no servidor.</p>
<h4>Cat\xe1logo</h4>
<p>Itens de cat\xe1logo (ex.: produtos, categorias, unidades), conforme a configura\xe7\xe3o de importa\xe7\xe3o.</p>
<h4>Armazenamento</h4>
<p>Dados de armaz\xe9m/estoque quando expostos para importa\xe7\xe3o em massa.</p>
<p><strong>Permiss\xf5es:</strong> seu grupo de usu\xe1rio precisa ter os endpoints da central de importa\xe7\xe3o liberados; caso contr\xe1rio a lista pode vir vazia ou a API retorna erro.</p>
</div>`;
const $4858a4427bfed1ff$var$IMPORT_HELP_2 = `
<div class="${$4858a4427bfed1ff$var$IMPORT_HELP_CLASS}">
<h4>Arquivo</h4>
<p>Formatos aceitos: <strong>CSV</strong> ou <strong>XLSX</strong>. A primeira linha deve conter os cabe\xe7alhos exatamente como no modelo.</p>
<h4>Colunas esperadas</h4>
<p>A tela mostra a lista de colunas obrigat\xf3rias/opcionais para a entidade escolhida. Desvios de nome ou ordem podem gerar erro na valida\xe7\xe3o.</p>
<h4>Baixar modelo</h4>
<p>Use o link <strong>Baixar modelo da planilha</strong> para obter um CSV de exemplo com os cabe\xe7alhos corretos.</p>
<h4>Validar</h4>
<p>O bot\xe3o <strong>Validar</strong> envia o arquivo ao servidor <strong>sem gravar</strong> ainda: voc\xea v\xea erros por linha e quantas linhas est\xe3o prontas para importar.</p>
</div>`;
const $4858a4427bfed1ff$var$IMPORT_HELP_3 = `
<div class="${$4858a4427bfed1ff$var$IMPORT_HELP_CLASS}">
<h4>Resultado da valida\xe7\xe3o</h4>
<p>Se houver erros, cada item indica a <strong>linha</strong>, o <strong>campo</strong> (quando aplic\xe1vel) e a <strong>mensagem</strong>. Corrija o arquivo e volte \xe0 etapa anterior para reenviar.</p>
<h4>Linhas v\xe1lidas</h4>
<p>Somente as linhas sem bloqueio entram em <strong>rows_valid</strong>. O bot\xe3o <strong>Importar</strong> s\xf3 aparece quando existe ao menos uma linha v\xe1lida.</p>
<h4>Voltar</h4>
<p>Retorna \xe0 sele\xe7\xe3o de entidade e descarta o arquivo atual da mem\xf3ria do assistente (n\xe3o altera o que j\xe1 foi gravado no banco em importa\xe7\xf5es anteriores).</p>
</div>`;
const $4858a4427bfed1ff$var$IMPORT_HELP_4 = `
<div class="${$4858a4427bfed1ff$var$IMPORT_HELP_CLASS}">
<h4>Importa\xe7\xe3o conclu\xedda</h4>
<p>O n\xfamero exibido \xe9 a quantidade de registros gravados com sucesso nesta execu\xe7\xe3o.</p>
<h4>Falhas parciais</h4>
<p>Se algumas linhas falharem no insert, elas aparecem listadas com linha e mensagem. As demais podem ter sido gravadas normalmente.</p>
<h4>Nova importa\xe7\xe3o</h4>
<p>Reinicia o fluxo na primeira tela para outro arquivo ou outra entidade.</p>
</div>`;
const $4858a4427bfed1ff$var$IMPORT_HELP_BY_STEP = {
    1: {
        title: "Ajuda \u2014 Central de Importa\xe7\xe3o (passo 1)",
        html: $4858a4427bfed1ff$var$IMPORT_HELP_1
    },
    2: {
        title: "Ajuda \u2014 Envio e valida\xe7\xe3o do arquivo",
        html: $4858a4427bfed1ff$var$IMPORT_HELP_2
    },
    3: {
        title: "Ajuda \u2014 Resultado da valida\xe7\xe3o",
        html: $4858a4427bfed1ff$var$IMPORT_HELP_3
    },
    4: {
        title: "Ajuda \u2014 Ap\xf3s importar",
        html: $4858a4427bfed1ff$var$IMPORT_HELP_4
    }
};
function $4858a4427bfed1ff$var$openImportHelp(step) {
    const pack = $4858a4427bfed1ff$var$IMPORT_HELP_BY_STEP[step];
    if (!pack) return;
    let mb;
    mb = (0, $e7f9af3e6f2fd91b$export$2e2bcd8739ae039)({
        title: pack.title,
        text: pack.html,
        buttons: [
            {
                label: 'Fechar',
                cls: 'bn_Enter'
            }
        ],
        callback: ()=>mb.destroy()
    });
}
const $4858a4427bfed1ff$var$CATEGORIAS = {
    "organiza\xe7\xe3o": "Organiza\xe7\xe3o",
    "cat\xe1logo": "Cat\xe1logo",
    armazenamento: 'Armazenamento'
};
let $4858a4427bfed1ff$var$entities = {};
let $4858a4427bfed1ff$var$selectedEntity = null;
let $4858a4427bfed1ff$var$validationResult = null;
function $4858a4427bfed1ff$var$$(sel, ctx = document) {
    return ctx.querySelector(sel);
}
function $4858a4427bfed1ff$var$renderEntitySelector(container) {
    const groups = {};
    for (const [key, schema] of Object.entries($4858a4427bfed1ff$var$entities)){
        const cat = schema.category || 'outros';
        if (!groups[cat]) groups[cat] = [];
        groups[cat].push({
            key: key,
            ...schema
        });
    }
    const order = [
        "organiza\xe7\xe3o",
        "cat\xe1logo",
        'armazenamento'
    ];
    let html = '<div class="import-entity-list">';
    for (const cat of order){
        if (!groups[cat]) continue;
        html += `<div class="import-category mtm">`;
        html += `<div class="import-cat-title">${$4858a4427bfed1ff$var$CATEGORIAS[cat] || cat}</div>`;
        html += '<div class="import-cat-items">';
        for (const e of groups[cat])html += `<button type="button" data-entity="${e.key}" class="import-entity-btn button">${e.label}</button>`;
        html += '</div></div>';
    }
    html += '</div>';
    container.innerHTML = html;
}
function $4858a4427bfed1ff$var$renderStep1(container) {
    container.innerHTML = `
		<div class="msgbox import-step" data-step="1">
			<div class="import-title-row">
				<div class="title">Central de Importa\xe7\xe3o</div>
				<button type="button" class="import-help-btn" data-import-help="1" title="Ajuda desta etapa" aria-label="Ajuda passo 1">?</button>
			</div>
			<p class="mts">Selecione o tipo de cadastro para importar:</p>
			<div id="import-entity-list"></div>
		</div>`;
    $4858a4427bfed1ff$var$renderEntitySelector($4858a4427bfed1ff$var$$('#import-entity-list', container));
}
function $4858a4427bfed1ff$var$renderStep2(container, entityKey) {
    const schema = $4858a4427bfed1ff$var$entities[entityKey];
    const cols = (schema?.cols || []).join(', ');
    container.innerHTML = `
		<div class="form import-step" data-step="2">
			<div class="import-title-row">
				<div class="title">Importar ${schema?.label || entityKey}</div>
				<button type="button" class="import-help-btn" data-import-help="2" title="Ajuda desta etapa" aria-label="Ajuda passo 2">?</button>
			</div>
			<p class="mts">Colunas esperadas: <strong>${cols}</strong></p>
			<div class="mtl fsb">
				<label>Arquivo (CSV ou XLSX)<sup>*</sup>
					<input id="import-file" type="file" accept=".csv,.xlsx" required>
				</label>
			</div>
			<div class="mtm">
				<a id="import-download-template" href="#" class="link">Baixar modelo da planilha</a>
			</div>
			<div class="mtm fsb import-actions">
				<button type="button" id="import-back" class="button import-btn-muted">Voltar</button>
				<button type="button" id="import-validate" class="button import-btn-success">Validar</button>
			</div>
		</div>`;
}
function $4858a4427bfed1ff$var$renderStep3(container, result) {
    const ok = result?.ok === true;
    const errors = result?.errors || [];
    const rowsValid = result?.rows_valid || [];
    const total = result?.total || 0;
    let errorsHtml = '';
    if (errors.length > 0) {
        errorsHtml = '<div class="import-errors mtm"><strong>Problemas encontrados:</strong><ul>';
        for (const e of errors.slice(0, 20))errorsHtml += `<li>Linha ${e.linha}: ${e.campo ? e.campo + " \u2013 " : ''}${e.mensagem}</li>`;
        if (errors.length > 20) errorsHtml += `<li>... e mais ${errors.length - 20} erro(s)</li>`;
        errorsHtml += '</ul></div>';
    }
    let successHtml = '';
    if (ok && rowsValid.length > 0) successHtml = `<div class="import-success mts"><strong>Valida\xe7\xe3o OK.</strong> ${rowsValid.length} de ${total} linha(s) prontas para importar.</div>`;
    else if (ok && rowsValid.length === 0) successHtml = '<div class="import-warning mts">Nenhuma linha v\xe1lida encontrada.</div>';
    container.innerHTML = `
		<div class="msgbox import-step" data-step="3">
			<div class="import-title-row">
				<div class="title">Resultado da valida\xe7\xe3o</div>
				<button type="button" class="import-help-btn" data-import-help="3" title="Ajuda desta etapa" aria-label="Ajuda passo 3">?</button>
			</div>
			${successHtml}
			${errorsHtml}
			<div class="mtm fsb import-actions">
				<button type="button" id="import-back2" class="button import-btn-muted">Voltar</button>
				${ok && rowsValid.length > 0 ? '<button type="button" id="import-do" class="button import-btn-success">Importar</button>' : ''}
			</div>
		</div>`;
}
function $4858a4427bfed1ff$var$renderStep4(container, result) {
    const imported = result?.imported || 0;
    const failed = result?.failed || [];
    let failedHtml = '';
    if (failed.length > 0) {
        failedHtml = '<div class="import-errors mtm"><strong>Falhas:</strong><ul>';
        for (const f of failed.slice(0, 10))failedHtml += `<li>Linha ${f.linha}: ${f.mensagem}</li>`;
        if (failed.length > 10) failedHtml += `<li>... e mais ${failed.length - 10}</li>`;
        failedHtml += '</ul></div>';
    }
    container.innerHTML = `
		<div class="msgbox import-step" data-step="4">
			<div class="import-title-row">
				<div class="title">Importa\xe7\xe3o conclu\xedda</div>
				<button type="button" class="import-help-btn" data-import-help="4" title="Ajuda desta etapa" aria-label="Ajuda passo 4">?</button>
			</div>
			<div class="import-success mts"><strong>${imported}</strong> registro(s) importado(s) com sucesso.</div>
			${failedHtml}
			<div class="mtm import-actions">
				<button type="button" id="import-new" class="button import-btn-success">Nova importa\xe7\xe3o</button>
			</div>
		</div>`;
}
async function $4858a4427bfed1ff$var$loadEntities() {
    const r = await (0, $73936c209f170d43$export$2e2bcd8739ae039).import_center_entities();
    if (!r.ok) throw new Error('Erro ao carregar entidades');
    $4858a4427bfed1ff$var$entities = await r.json();
}
async function $4858a4427bfed1ff$var$downloadTemplate(entityKey) {
    const r = await (0, $73936c209f170d43$export$2e2bcd8739ae039).import_center_template(entityKey);
    if (!r.ok) throw new Error('Erro ao baixar modelo');
    const blob = await r.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `modelo_${entityKey}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
}
async function $4858a4427bfed1ff$var$validate(entityKey, file) {
    const fd = new FormData();
    fd.append('entity_key', entityKey);
    fd.append('file', file);
    const r = await (0, $73936c209f170d43$export$2e2bcd8739ae039).import_center_validate(fd);
    if (!r.ok) {
        const text = await r.text();
        throw new Error(text || "Erro na valida\xe7\xe3o");
    }
    return r.json();
}
async function $4858a4427bfed1ff$var$doImport(entityKey, rowsValid) {
    const r = await (0, $73936c209f170d43$export$2e2bcd8739ae039).import_center_import({
        entity_key: entityKey,
        rows_valid: rowsValid
    });
    if (!r.ok) {
        const text = await r.text();
        throw new Error(text || "Erro na importa\xe7\xe3o");
    }
    return r.json();
}
function $4858a4427bfed1ff$var$showError(msg) {
    (0, $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b)(String(msg || 'Erro'), "Central de Importa\xe7\xe3o");
}
const $4858a4427bfed1ff$var$import_center = async function() {
    const workarea = document.getElementById('workarea');
    if (!workarea) return;
    const styles = `
		#import-center-wrap {
			display: flex;
			justify-content: center;
			align-items: flex-start;
			padding: var(--space-lg);
			min-height: 100%;
			background-color: var(--color-secondary);
		}
		#import-center { max-width: 42rem; width: 100%; }
		#import-center .import-title-row {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 0.75rem;
			flex-wrap: wrap;
		}
		#import-center .import-title-row .title { margin: 0; flex: 1; min-width: 0; }
		#import-center .import-help-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 1.35rem;
			height: 1.35rem;
			padding: 0;
			border: 1px solid #9ca3af;
			border-radius: 999px;
			background: #f3f4f6;
			color: #374151;
			font-size: 0.85rem;
			font-weight: 700;
			line-height: 1;
			cursor: pointer;
			flex-shrink: 0;
		}
		#import-center .import-help-btn:hover { background: #e5e7eb; }
		#import-center .import-help-btn:focus { outline: 2px solid #2563eb; outline-offset: 2px; }
		#import-center .import-actions { justify-content: flex-end; gap: 0.5rem; flex-wrap: wrap; }
		#import-center .import-btn-success {
			background: linear-gradient(180deg, #4ade80 0%, #22c55e 100%);
			color: #fff;
			border: 1px solid #15803d;
			font-weight: 600;
			box-shadow: 0 1px 2px rgba(22, 163, 74, 0.25);
		}
		#import-center .import-btn-success:hover {
			filter: brightness(1.05);
			box-shadow: 0 2px 4px rgba(22, 163, 74, 0.3);
		}
		#import-center .import-btn-muted {
			background: #f8fafc;
			color: #334155;
			border: 1px solid var(--color-border);
			font-weight: 500;
		}
		#import-center .import-btn-muted:hover { background: #f1f5f9; }
		#import-center .import-cat-title {
			font-weight: 600;
			margin-bottom: var(--space-sm);
			color: var(--color-text);
		}
		#import-center .import-cat-items {
			display: flex;
			flex-wrap: wrap;
			gap: var(--space-sm);
		}
		#import-center .import-entity-btn {
			display: inline-block;
			text-align: center;
			margin: 0;
			text-decoration: none;
		}
		#import-center .import-errors {
			color: var(--color-error);
			padding: var(--space-sm);
			background-color: var(--color-secondary);
			border: 1px solid var(--color-border);
			border-radius: 4px;
		}
		#import-center .import-errors ul { margin: var(--space-sm) 0 0; padding-left: var(--space-lg); }
		#import-center .import-success {
			color: #0a6b0a;
			padding: var(--space-sm);
			background-color: #f0f9f0;
			border: 1px solid #c8e6c8;
			border-radius: 4px;
		}
		#import-center .import-warning {
			color: #8a6d00;
			padding: var(--space-sm);
			background-color: #fffbe6;
			border: 1px solid #e6d68a;
			border-radius: 4px;
		}
	`;
    const helpBodyStyles = `
		.import-help-body { max-height: 65vh; overflow-y: auto; text-align: left; }
		.import-help-body h4 {
			margin: 0.85rem 0 0.25rem 0;
			font-size: 0.78rem;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.03em;
			color: #1f2937;
		}
		.import-help-body h4:first-child { margin-top: 0; }
		.import-help-body p {
			margin: 0;
			font-size: 0.875rem;
			line-height: 1.45;
			color: #374151;
		}
	`;
    workarea.innerHTML = `<style>${styles}</style><style>${helpBodyStyles}</style><div id="import-center-wrap"><div id="import-center"></div></div>`;
    const container = $4858a4427bfed1ff$var$$('#import-center');
    try {
        await $4858a4427bfed1ff$var$loadEntities();
    } catch (e) {
        $4858a4427bfed1ff$var$showError(e.message);
        return;
    }
    container.addEventListener('click', async (ev)=>{
        const helpBtn = ev.target.closest('.import-help-btn');
        if (helpBtn) {
            ev.preventDefault();
            const step = Number(helpBtn.getAttribute('data-import-help') || '0');
            if (step >= 1 && step <= 4) $4858a4427bfed1ff$var$openImportHelp(step);
            return;
        }
        const entityBtn = ev.target.closest('.import-entity-btn');
        if (entityBtn) {
            ev.preventDefault();
            $4858a4427bfed1ff$var$selectedEntity = entityBtn.dataset.entity;
            $4858a4427bfed1ff$var$renderStep2(container, $4858a4427bfed1ff$var$selectedEntity);
            $4858a4427bfed1ff$var$$('#import-file').value = '';
            return;
        }
        if (ev.target.id === 'import-download-template') {
            ev.preventDefault();
            try {
                await $4858a4427bfed1ff$var$downloadTemplate($4858a4427bfed1ff$var$selectedEntity);
            } catch (e) {
                $4858a4427bfed1ff$var$showError(e.message);
            }
            return;
        }
        if (ev.target.id === 'import-back' || ev.target.id === 'import-back2') {
            $4858a4427bfed1ff$var$renderStep1(container);
            $4858a4427bfed1ff$var$selectedEntity = null;
            $4858a4427bfed1ff$var$validationResult = null;
            return;
        }
        if (ev.target.id === 'import-validate') {
            const fileInput = $4858a4427bfed1ff$var$$('#import-file');
            const file = fileInput?.files?.[0];
            if (!file) {
                $4858a4427bfed1ff$var$showError('Selecione um arquivo.');
                return;
            }
            try {
                $4858a4427bfed1ff$var$validationResult = await $4858a4427bfed1ff$var$validate($4858a4427bfed1ff$var$selectedEntity, file);
                $4858a4427bfed1ff$var$renderStep3(container, $4858a4427bfed1ff$var$validationResult);
            } catch (e) {
                $4858a4427bfed1ff$var$showError(e.message);
            }
            return;
        }
        if (ev.target.id === 'import-do') {
            const rows = $4858a4427bfed1ff$var$validationResult?.rows_valid || [];
            if (rows.length === 0) return;
            try {
                const result = await $4858a4427bfed1ff$var$doImport($4858a4427bfed1ff$var$selectedEntity, rows);
                $4858a4427bfed1ff$var$renderStep4(container, result);
            } catch (e) {
                $4858a4427bfed1ff$var$showError(e.message);
            }
            return;
        }
        if (ev.target.id === 'import-new') {
            $4858a4427bfed1ff$var$renderStep1(container);
            $4858a4427bfed1ff$var$selectedEntity = null;
            $4858a4427bfed1ff$var$validationResult = null;
            return;
        }
    });
    $4858a4427bfed1ff$var$renderStep1(container);
};
var $4858a4427bfed1ff$export$2e2bcd8739ae039 = $4858a4427bfed1ff$var$import_center;


(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#companies', (0, $4e09ec6288da1fd7$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#suppliers', (0, $b8958290655d6aea$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#customers', (0, $814cf36e1b964bdf$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#carriers', (0, $bf6317b83db2cd5d$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#devices', (0, $72c9f6cb63809845$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#units', (0, $157d0f4971612fc5$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#classes', (0, $ffea07134e071bfc$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#categories', (0, $7113b1f3aa2dbdf1$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#manufacturers', (0, $63ee0a3c4d5a5d51$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#products', (0, $3b9ac53687e0fa72$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#product-packagings', (0, $7502d76b32eebada$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#warehouses', (0, $47151db783ea97b2$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#locations', (0, $2332a4e102178b91$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#stocks', (0, $b94ca141f2d5964b$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#transactions', (0, $d95b661ee91ff067$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#replenishments', (0, $3120de0fc186b19b$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventories', (0, $c89615e12aaa973d$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-orders', (0, $41d7c55d2e4dc43d$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#output-orders', (0, $b31c53df218c817e$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inputs', (0, $ee2c059f60a8fc19$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#lots', (0, $a9f17bf16ff5b79a$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#outputs', (0, $9bfec621929b0c49$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#price-lists', (0, $5f8cf8bc5abf9d48$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#payment-terms', (0, $e5cbae575b333663$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#cfops', (0, $d5d475eb438dd51e$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#programs', (0, $e7e1d1109d9bcdea$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#invoices', (0, $e8c0107621152558$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#invoice-lots', (0, $c15275aa38f8683d$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#groups', (0, $f9ccb4979589756b$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#users', (0, $fd46b4f29c53dd9f$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#logs', (0, $307409da5029dbc2$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#integration-events', (0, $0a73b38866ec3649$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#logout', (0, $ef33fadb70b8678b$export$2e2bcd8739ae039).logout);
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#about', (0, $754162cf0396517c$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#import-center', (0, $4858a4427bfed1ff$export$2e2bcd8739ae039));
const $77ac944da51b7354$var$loadShell = function() {
    (0, $1cmSR.default).define([
        {
            store: 'endpoints',
            keys: [
                'id',
                'name'
            ]
        },
        {
            store: 'groups',
            keys: [
                'id',
                'name'
            ]
        },
        {
            store: 'users',
            keys: [
                'id',
                'username'
            ]
        },
        {
            store: 'cities',
            keys: [
                'id',
                [
                    'state',
                    'city'
                ],
                'state'
            ]
        },
        {
            store: 'companies',
            keys: [
                'id',
                'name'
            ]
        },
        {
            store: 'all_companies',
            keys: [
                'id',
                'name'
            ]
        },
        {
            store: 'warehouses',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'locations',
            keys: [
                [
                    'company_id',
                    'warehouse_id',
                    'id'
                ],
                [
                    'company_id',
                    'warehouse_id',
                    'address'
                ]
            ]
        },
        {
            store: 'units',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'classes',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'categories',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'manufacturers',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'programs',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'receipt_types',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'code'
                ]
            ]
        },
        {
            store: 'products',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'product_packagings',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'product_id'
                ]
            ]
        },
        {
            store: 'lots',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'product_id'
                ]
            ]
        },
        {
            store: 'payment_terms',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'price_lists',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'suppliers',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'nick'
                ]
            ]
        },
        {
            store: 'customers',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'nick'
                ]
            ]
        },
        {
            store: 'carriers',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'nick'
                ]
            ]
        },
        {
            store: 'devices',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'cfops',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'code'
                ]
            ]
        }
    ], 'sial', 4);
    let name = sessionStorage.username.split('.').map((name)=>name[0].toLocaleUpperCase() + name.slice(1)); // Always first.last
    document.body.innerHTML = (0, $a6c3e59798a8ecf3$export$2e2bcd8739ae039)(`${name[0]} ${name[1] || ''}`);
    document.querySelector('.menu').addEventListener('click', (ev)=>{
        location.hash = ''; // Must be reset so the router can detect a change
        location.hash = ev.target.getAttribute('hash');
    });
    if (!sessionStorage.reset) {
        (0, $1cmSR.default).init();
        sessionStorage.setItem('reset', 'true');
    }
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).init();
};
if (!sessionStorage.username) (0, $ef33fadb70b8678b$export$2e2bcd8739ae039).login($77ac944da51b7354$var$loadShell);
else $77ac944da51b7354$var$loadShell();


//# sourceMappingURL=SIAL_DEV.1aa216f8.js.map
